import React, { useState, useEffect, useContext, createContext, useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation, useParams, useSearchParams, Link } from 'react-router-dom';

const API = 'https://api.civicbot.centricitygis.com';
const AuthContext = createContext(null);

// ─── EMAIL SIGNATURE ──────────────────────────────────────────────────────────
const CENTRICITY_LOGO_DATA_URI = 'data:image/png;base64,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';
const SIG_SEPARATOR = '\n\n-- \n';
// Strip AI closing block ("Best,\n[name]", "Regards,\nname", etc.) — we own the closing
function stripAiClosing(body) {
  return body
    .replace(/\n+(?:Best|Sincerely|Regards|Kind regards|Warm regards|Thanks|Thank you|Cheers)[,.]?[^\n]*(?:\n[\s\S]*)?$/i, '')
    .replace(/\n+[A-Z][a-zA-Z'-]+(?: [A-Z][a-zA-Z'-]+)+\s*$/, '') // strip trailing standalone "Proper Name" line
    .trimEnd();
}
function buildTextSig(u) {
  return `\n\nBest,${SIG_SEPARATOR}${u?.name || 'Your Name'}${u?.phone ? '\n' + u.phone : ''}\nCentricity GIS\n${u?.email || ''}\nhttps://CivicBot.CentricityGIS.com`;
}
function buildHtmlSig(u) {
  return `<hr style="border:none;border-top:1px solid #e2e8f0;margin:24px 0 16px">` +
    `<table cellpadding="0" cellspacing="0" style="font-family:Arial,sans-serif;font-size:14px;color:#1e293b">` +
    `<tr><td style="vertical-align:middle;line-height:1.7">` +
    `<strong style="font-size:15px">${u?.name || ''}</strong><br>` +
    `${u?.phone ? u.phone + '<br>' : ''}` +
    `Centricity GIS<br>` +
    `<a href="mailto:${u?.email || ''}" style="color:#2563eb;text-decoration:none">${u?.email || ''}</a>` +
    `</td></tr>` +
    `<tr><td style="padding-top:12px">` +
    `<table cellpadding="0" cellspacing="0"><tr>` +
    `<td style="padding-right:10px;vertical-align:middle">` +
    `<table cellpadding="0" cellspacing="0" style="background-color:#1e3a5f;width:40px;height:40px"><tr><td style="text-align:center;vertical-align:bottom;padding-bottom:7px">` +
    `<table cellpadding="0" cellspacing="1" style="display:inline-table;border-collapse:separate"><tr>` +
    `<td style="width:5px;height:15px;background-color:white;vertical-align:bottom"></td>` +
    `<td style="width:5px;height:20px;background-color:white;vertical-align:bottom"></td>` +
    `<td style="width:5px;height:25px;background-color:white;vertical-align:bottom"></td>` +
    `<td style="width:4px;height:18px;background-color:#3b82f6;vertical-align:bottom"></td>` +
    `</tr></table>` +
    `</td></tr></table>` +
    `</td>` +
    `<td style="vertical-align:middle">` +
    `<div style="font-size:16px;font-weight:800;color:#1e3a5f;line-height:1">CivicBot</div>` +
    `<div style="font-size:10px;color:#64748b;letter-spacing:0.8px;text-transform:uppercase">by Centricity GIS</div>` +
    `<a href="https://CivicBot.CentricityGIS.com" style="font-size:11px;color:#2563eb;text-decoration:none">CivicBot.CentricityGIS.com</a>` +
    `</td></tr></table>` +
    `</td></tr></table>`;
}

// ─── HELPERS ──────────────────────────────────────────────────────────────────

function apiHeaders(token) {
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

function daysUntil(dateStr) {
  if (!dateStr) return null;
  return Math.ceil((new Date(dateStr) - Date.now()) / (1000 * 60 * 60 * 24));
}

function formatDate(dateStr) {
  if (!dateStr) return '—';
  // SQLite datetime('now') -> "YYYY-MM-DD HH:MM:SS" (UTC, no tz suffix).
  // Append 'Z' so the Date constructor treats it as UTC, then render in the
  // browser's local timezone (no explicit timeZone option = local).
  const normalized = dateStr.includes('T') ? dateStr : (dateStr.length >= 10 ? dateStr.replace(' ', 'T') + 'Z' : dateStr);
  return new Date(normalized).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
function formatDateTime(dateStr) {
  if (!dateStr) return '—';
  // SQLite datetime('now') returns "YYYY-MM-DD HH:MM:SS" with no timezone suffix.
  // Appending 'Z' tells the Date constructor it's UTC so toLocaleString converts to local time.
  const normalized = dateStr.includes('T') ? dateStr : dateStr.replace(' ', 'T') + 'Z';
  return new Date(normalized).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true });
}

function formatCurrency(n) {
  if (n == null) return '—';
  return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

function trialBadge(trialEndsAt, billingStatus) {
  if (billingStatus === 'active') return { label: 'Active', color: '#16a34a', bg: '#dcfce7' };
  if (billingStatus === 'past_due') return { label: 'Past Due', color: '#dc2626', bg: '#fee2e2' };
  if (billingStatus === 'canceled') return { label: 'Canceled', color: '#6b7280', bg: '#f3f4f6' };
  const days = daysUntil(trialEndsAt);
  if (days === null) return { label: 'No Trial', color: '#6b7280', bg: '#f3f4f6' };
  if (days < 0) return { label: `Expired ${Math.abs(days)}d ago`, color: '#dc2626', bg: '#fee2e2' };
  if (days <= 7) return { label: `${days}d left`, color: '#dc2626', bg: '#fee2e2' };
  if (days <= 14) return { label: `${days}d left`, color: '#d97706', bg: '#fef3c7' };
  return { label: `${days}d left`, color: '#16a34a', bg: '#dcfce7' };
}

const STAGES = [
  { key: 'prospect', label: 'Prospect' },
  { key: 'contacted', label: 'Contacted' },
  { key: 'demo_booked', label: 'Demo Booked' },
  { key: 'trial_active', label: 'Trial Active' },
  { key: 'nurturing', label: 'Nurturing' },
  { key: 'negotiating', label: 'Negotiating' },
  { key: 'closed_won', label: 'Closed Won' },
  { key: 'closed_lost', label: 'Closed Lost' },
];

const STAGE_COLORS = {
  prospect: '#6b7280', contacted: '#3b82f6', demo_booked: '#8b5cf6',
  trial_active: '#f59e0b', nurturing: '#06b6d4', negotiating: '#f97316',
  closed_won: '#16a34a', closed_lost: '#dc2626'
};

const ACTIVITY_TYPES = ['call', 'email', 'meeting', 'note', 'demo', 'follow_up'];

// Pipeline stages in order (closed_lost is a branch, not in the linear rail)
const PIPELINE_RAIL = STAGES.filter(s => s.key !== 'closed_lost');

// ─── AI EMAIL GENERATOR ───────────────────────────────────────────────────────
const EMAIL_CONTEXTS = [
  { key: 'cold_intro',    label: '❄️ Cold Intro' },
  { key: 'follow_up',     label: '🔁 Follow-Up' },
  { key: 'demo_ask',      label: '📅 Demo Ask' },
  { key: 'trial_checkin', label: '⚡ Trial Check-In' },
  { key: 'close',         label: '💰 Close' },
  { key: 'upsell',        label: '🔼 Upsell' },
  { key: 'objection',     label: '🛡 Objection' },
];

const EMAIL_SAMPLE_PROMPTS = {
  cold_intro: [
    { icon: '🏗', label: 'Cityworks City', text: 'The city uses Cityworks. Emphasize the native SR → work order integration — no double-entry, no phone transcription errors.' },
    { icon: '📞', label: 'High Call Volume', text: 'Lead with the $3.39/call Pew Research stat. Calculate their estimated annual phone handling cost based on population.' },
    { icon: '🤝', label: 'Conference / Event Met', text: 'Reference briefly meeting at a GIS or municipal conference. Keep it warm and personal.' },
    { icon: '🏙', label: 'Small City — Staff Stretched', text: 'Small city with limited staff. Every deflected call saves real time. Frame CivicBot as freeing up staff for higher-value work.' },
  ],
  follow_up: [
    { icon: '🔇', label: 'No Response ×2', text: 'This is the third touchpoint. Keep it very short — 3 sentences max. Ask only one question: is this a priority for them this quarter?' },
    { icon: '📵', label: 'Called + No Answer', text: 'Already tried calling and no answer. Mention that in the email. Keep it low-pressure — just looking for a yes or no.' },
  ],
  demo_ask: [
    { icon: '🖥', label: 'Live Demo Offer', text: 'Specifically offer a 15-minute screen share showing the widget live. Mention you can show how Lincoln, CA is using it right now.' },
    { icon: '🏗', label: 'Cityworks-Specific Demo', text: 'Offer to demo specifically the Cityworks integration — resident submits SR, it appears as a work order inside CW in real time.' },
  ],
  trial_checkin: [
    { icon: '📊', label: 'Day 3–5 Value Recap', text: 'City has been on trial for 5 days. Highlight SR submissions as displaced phone calls. Use $3.39/call to quantify value received so far.' },
    { icon: '📣', label: 'Low SR Volume — Promo Tips', text: 'Trial is active but SR volume is low. Help them think about how to promote the widget to residents — website header, social post, city newsletter.' },
  ],
  close: [
    { icon: '⚡', label: 'Day 6 Speed Close', text: 'This is the Day 6 close email. Be transparent that today or tomorrow is the last day for the best pricing. Ask directly if there are open questions preventing them from moving forward.' },
    { icon: '💬', label: 'Address Hesitation', text: "They seem interested but haven't committed. Ask directly: what would need to be true for you to move forward this week? Make it easy to respond." },
  ],
  upsell: [
    { icon: '🌐', label: 'After 3 Weeks Live', text: 'City has been live for 3 weeks and is happy with CivicBot. Introduce CivicBot Answers as Phase 2. Emphasize it uses their own website content — no AI hallucinations on city policy.' },
    { icon: '📋', label: 'Staff Fields Repetitive Questions', text: "The contact mentioned staff fields the same resident questions daily. Frame Answers as eliminating that entire category of call." },
  ],
  objection: [
    { icon: '💵', label: 'Budget Objection', text: "Contact said they don't have budget right now. Reframe CivicBot as a cost reducer not a new expense. Calculate their existing 311 phone cost vs. the annual plan price." },
    { icon: '🔒', label: 'IT / Security Approval Needed', text: 'Decision maker needs IT approval. Write a short email to the IT director covering security (Azure-hosted, no PII stored, HTTPS), simplicity (one script tag), and support model.' },
    { icon: '🏆', label: '"We Already Have Something"', text: "They claim to have an existing solution. Ask: is it resident-facing on your website? Does it integrate with Cityworks? Does it handle AI Q&A? Most internal tools still rely on a phone call to initiate." },
  ],
};

// ─── EMAIL COMPOSER LIBRARY DATA ─────────────────────────────────────────────
const SUBJECT_LINES_LIB = [
  "AI 311 for small cities—$150/month",
  "Your citizens are Googling answers instead of calling you",
  "Free demo: AI that answers your city website questions",
  "Small city, smart AI—no IT headaches",
  "Cut phone support time in half",
  "AI chatbot for [City Name]—under $200/month",
  "Your competitors are adding AI citizen services",
  "Why small cities are switching to AI 311",
  "Instant answers for your citizens—no IT budget needed",
  "AI that trains itself on your city website",
  "Stop answering the same questions over and over",
  "Service requests on autopilot",
  "Your city's new secret weapon: AI support",
  "Demo inside—AI 311 chatbot for small towns",
  "Fewer phone calls, happier residents, lower costs",
  "AI citizen service that actually fits small city budgets",
  "Can I show you something quick—AI for your city",
  "Your citizens expect instant answers now",
  "Small city advantage: affordable AI support",
  "Save ten hours a week with AI",
  "AI handles it so your team doesn't have to",
  "Two minute demo—see AI in action for your city",
  "Budget friendly AI 311—no setup required",
  "Trending now: small cities using AI chatbots",
  "One question: what would you do with ten extra hours a week",
];

const EMAIL_TEMPLATES_LIB = [
  {
    label: "Budget Hook",
    subject: "AI 311 for [City Name]—under $200/month",
    body: "Hi [First Name],\n\nWe're helping small cities like [City Name] transform citizen engagement without breaking the budget. CivicBot is an AI-powered 311 chatbot that handles service requests and answers questions pulled directly from your city website—saving your team hours each week.\n\nMost small cities pay us between $150–$200 a month. Your citizens get instant answers. You get fewer manual support tickets and better data on what people actually need.\n\nWould love to show you a quick demo tailored to [City Name]'s size and services.",
  },
  {
    label: "Staff Workload",
    subject: "Cut phone support time in half",
    body: "Hi [First Name],\n\nHere's the reality: your small city team is stretched thin answering the same questions over and over. CivicBot fixes that by letting AI answer them automatically—trained on your own city website and processes.\n\nAt $150–$200/month, you're investing in fewer phone calls, faster response times, and happier residents. It's the kind of tech that makes small-city operations actually sustainable.\n\nWant to see how it works for a city your size?",
  },
  {
    label: "Fiscal Responsibility",
    subject: "AI Service Bot That Won't Drain Your Budget",
    body: "Hi [First Name],\n\nSmall cities shouldn't have to choose between modern citizen services and fiscal responsibility. CivicBot brings AI-powered 311 automation to [City Name] at a price that makes sense: around $150–$200 per month.\n\nWe handle service requests, answer FAQs, and route complex issues to your team—all while your citizens get instant support instead of waiting on hold.\n\nLet's talk about what this looks like for [City Name].",
  },
  {
    label: "No IT Headaches",
    subject: "Small city, smart AI—no IT headaches",
    body: "Hi [First Name],\n\nYour citizens expect fast answers. Your budget is tight. CivicBot solves both: an AI chatbot that handles 311 requests and website-based Q&A for $150–$200 a month.\n\nWe've built this specifically for municipalities [City Name]'s size. No enterprise bloat. No surprise fees. Just a tool that actually works and actually saves money.\n\nCurious how it would work for [City Name]?",
  },
  {
    label: "Big AI, Small Price",
    subject: "Small city, big AI citizen service",
    body: "Hi [First Name],\n\nAI doesn't have to be expensive. CivicBot brings smart 311 and automated Q&A to [City Name] at $150–$200/month—and it trains itself on your city's own website and knowledge base.\n\nYour team gets fewer repetitive tickets. Your citizens get instant answers. You stay in budget.\n\nWorth a conversation?",
  },
];

// Derive a sensible default template name from a subject line.
// Strips {{vars}}, [bracketed placeholders], emojis, "Re:" prefix, trailing
// punctuation, and truncates to 50 chars.
function suggestTemplateName(subject) {
  if (!subject) return 'AI Generated Template';
  let s = String(subject);
  s = s.replace(/\{\{[^}]+\}\}/g, '').replace(/\[[^\]]+\]/g, '');
  s = s.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '');
  s = s.replace(/^\s*Re:\s*/i, '');
  s = s.replace(/[—–-]+/g, ' ').replace(/\s{2,}/g, ' ').trim();
  s = s.replace(/[.,;:!?]+$/, '').trim();
  if (s.length > 50) s = s.slice(0, 47).trim() + '...';
  return s || 'AI Generated Template';
}

const AI_PROMPTS_LIB = [
  { label: "Prompt 1 — Friendly & Budget-Focused", prompt: "Generate a short, friendly outreach email to a small city (population 1,000–5,000) about implementing an AI-powered 311 chatbot and FAQ bot. Emphasize budget-friendly pricing (under $200/month), reduced staff workload, and improved citizen satisfaction. Use a conversational tone. Include a clear CTA inviting them to view a live demo. For [City Name]." },
  { label: "Prompt 2 — Under 150 Words, Demo CTA", prompt: "Write a sales email under 150 words targeting a small municipality looking to modernize citizen services. Pitch an AI chatbot that handles service requests and answers questions from the city website. Focus on cost savings and citizen experience. End with a demo invite. City: [City Name]." },
  { label: "Prompt 3 — No IT Setup Angle", prompt: "Create an outreach email for small-budget cities interested in AI-powered 311 services. Highlight: no IT setup required, under $200/month, trains on existing city website content, reduces phone support volume. Make it sound achievable and low-risk. City: [City Name]." },
  { label: "Prompt 4 — Address Budget Fear", prompt: "Draft a subject line and email body for a small city that wants AI citizen services but worries about cost. Address that concern directly. Explain that CivicBot costs $150–$200/month and pays for itself through reduced staff overtime and faster issue resolution. Confident but approachable tone. City: [City Name]." },
  { label: "Prompt 5 — Cold Outreach with FOMO", prompt: "Write cold outreach email about an AI 311 solution for small cities. Position as a low-cost AI partner for municipalities. Mention: fewer phone calls, instant citizen answers, data dashboard showing service trends. Include mild urgency without being pushy. City: [City Name]." },
];

const STAT_BLOCKS_LIB = [
  { stat: "50%", label: "Staff workload reduction", tip: "Use when speaking to city admins about team capacity" },
  { stat: "80%", label: "Faster citizen response time", tip: "Use in follow-ups emphasizing service quality" },
  { stat: "$0.50–$2", label: "AI cost per interaction vs $8–$15 live agent", tip: "Use for ROI / budget objection handling" },
  { stat: "24/7", label: "Always-on service, no hold times", tip: "Use in subject lines and opening hooks" },
  { stat: "$2K/yr", label: "Less than one part-time month", tip: "Use for small city budget conversations" },
  { stat: "37", label: "Municipalities served by one chatbot deployment", tip: "Use to show scalability proof" },
];

const SNIPPETS_LIB = [
  { label: "Snippet A — Staff Workload", text: "Cities using AI for 311 and citizen Q&A are cutting staff workload by up to 50%—not by reducing headcount, but by letting AI handle repetitive questions so your team can focus on work that actually needs a human. That's what CivicBot does for cities like [City Name], at around $200 a month." },
  { label: "Snippet B — Cost Per Interaction", text: "AI chatbots now handle thousands of citizen interactions per month in cities across the country. Cost per interaction: as low as $0.50 versus $8–$15 for a live agent. For a city [City Name]'s size, that math gets compelling fast." },
  { label: "Snippet C — Small Cities Adopting", text: "Small cities are no longer sitting on the sidelines of the AI wave. Cities with populations similar to [City Name] are already deploying AI citizen service tools—and the ones that move early are building constituent trust and operational efficiency that takes years for laggard cities to catch up to." },
  { label: "Snippet D — ROI / Budget", text: "At $2,000 a year, CivicBot costs less than a single part-time employee for one month—and it works around the clock, never calls in sick, and answers citizen questions in seconds." },
  { label: "Snippet E — No IT Setup", text: "One of the biggest misconceptions small cities have about AI is that it requires an IT department or a long setup process. CivicBot trains itself on your existing city website—no custom data entry, no technical setup. Most cities are live within a week." },
];

const EMAIL_SEQ_GUIDE = [
  { day: 'Day 0', color: '#2563eb', bg: '#dbeafe', text: 'Initial outreach — Budget/ROI angle' },
  { day: 'Day 3', color: '#7c3aed', bg: '#ede9fe', text: 'Follow-up #1 — Staff workload angle' },
  { day: 'Day 7', color: '#0891b2', bg: '#cffafe', text: 'Follow-up #2 — Add a stat or social proof' },
  { day: 'Day 14', color: '#d97706', bg: '#fef3c7', text: 'Final touch — Soft close or demo CTA' },
];

const TIMING_TIPS_LIB = [
  { title: 'IT / Technology', times: 'Tue 10am · Wed 2pm · Thu 9am', note: 'Clear inbox early, post-standup availability' },
  { title: 'Directors / Executives', times: 'Tue 8am · Wed 7am · Thu 4pm', note: 'Pre-meeting window, end-of-day review' },
  { title: 'Public Works / GIS', times: 'Mon 7am · Tue 3pm · Thu 10am', note: 'Field ops check email early, after fieldwork wraps' },
  { title: 'Clerks / Admin', times: 'Wed 10am · Fri 9am · Tue 2pm', note: 'Mid-week catch-up, wrap-up review, post-lunch peak' },
  { title: 'General / Unknown', times: 'Tue 10am · Wed 9am · Thu 2pm', note: 'Best general open rate window, peak mid-week' },
];

function subLeadVars(text, lead, user) {
  const contactName = lead?.contact_name || '';
  const firstName = contactName.split(' ')[0] || contactName;
  const rawCity = lead?.city_name || '';
  const cityName = rawCity.replace(/^(?:City|Town|Village|Township|Borough|County|District)\s+of\s+/i, '').trim() || rawCity;
  return (text || '')
    .replace(/\[City Name\]/gi, cityName || '[City Name]')
    .replace(/\[First Name\]/gi, firstName || '[First Name]')
    .replace(/\[Contact Name\]/gi, contactName || '[Contact Name]')
    .replace(/\[Your Name\]/gi, user?.name || '[Your Name]');
}

// ─── TOOLTIP ─────────────────────────────────────────────────────────────────
function Tooltip({ text, children }) {
  const [vis, setVis] = React.useState(false);
  const [coords, setCoords] = React.useState({ top: 0, left: 0 });
  const anchorRef = React.useRef(null);

  function handleEnter() {
    if (anchorRef.current) {
      const r = anchorRef.current.getBoundingClientRect();
      setCoords({ top: r.top - 8, left: r.left + r.width / 2 });
    }
    setVis(true);
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      <span ref={anchorRef} onMouseEnter={handleEnter} onMouseLeave={() => setVis(false)} style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
        {children}
      </span>
      {vis && (
        <span style={{ position: 'fixed', top: coords.top, left: coords.left, transform: 'translate(-50%, -100%)', background: '#1e293b', color: '#fff', fontSize: 12, padding: '7px 11px', borderRadius: 7, whiteSpace: 'pre-wrap', maxWidth: 260, zIndex: 99999, lineHeight: 1.5, boxShadow: '0 4px 16px rgba(0,0,0,0.3)', pointerEvents: 'none' }}>
          {text}
          <span style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', width: 0, height: 0, borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderTop: '6px solid #1e293b' }} />
        </span>
      )}
    </span>
  );
}
function InfoTip({ text, light }) {
  return (
    <Tooltip text={text}>
      <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 15, height: 15, borderRadius: '50%', background: light ? 'rgba(255,255,255,0.35)' : '#94a3b8', color: '#fff', fontSize: 9, fontWeight: 700, marginLeft: 5, flexShrink: 0, lineHeight: 1 }}>i</span>
    </Tooltip>
  );
}

function StageProgress({ currentStage, onStageClick }) {
  const currentIdx = PIPELINE_RAIL.findIndex(s => s.key === currentStage);
  const isLost = currentStage === 'closed_lost';
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', overflowX: 'auto', paddingBottom: 4, gap: 0 }}>
        {PIPELINE_RAIL.map((stage, i) => {
          const isActive = stage.key === currentStage && !isLost;
          const isDone = !isLost && currentIdx > i;
          const color = STAGE_COLORS[stage.key];
          return (
            <React.Fragment key={stage.key}>
              <div onClick={() => !isActive && onStageClick && onStageClick(stage.key)}
                title={onStageClick && !isActive ? `Move to ${stage.label}` : stage.label}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: onStageClick && !isActive ? 'pointer' : 'default', minWidth: 64, flex: 1 }}>
                <div style={{
                  width: 30, height: 30, borderRadius: '50%',
                  background: isActive ? color : isDone ? color : '#e2e8f0',
                  border: `2px solid ${isActive || isDone ? color : '#cbd5e1'}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 11, fontWeight: 700,
                  color: isActive || isDone ? '#fff' : '#94a3b8',
                  transition: 'all 0.15s', flexShrink: 0,
                }}>
                  {isDone ? '✓' : i + 1}
                </div>
                <div style={{ fontSize: 10, marginTop: 4, fontWeight: isActive ? 700 : 500, color: isActive ? color : isDone ? '#475569' : '#94a3b8', whiteSpace: 'nowrap', textAlign: 'center', lineHeight: 1.2 }}>
                  {stage.label}
                </div>
              </div>
              {i < PIPELINE_RAIL.length - 1 && (
                <div style={{ flex: 1, height: 2, background: (!isLost && currentIdx > i) ? '#94a3b8' : '#e2e8f0', marginBottom: 20, minWidth: 6, flexShrink: 1 }} />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {isLost && (
        <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ flex: 1, height: 2, background: '#e2e8f0' }} />
          <span style={{ fontSize: 11, fontWeight: 700, color: '#dc2626', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 20, padding: '2px 10px', whiteSpace: 'nowrap' }}>✗ Closed Lost</span>
        </div>
      )}
    </div>
  );
}

// ─── STYLES ───────────────────────────────────────────────────────────────────

const S = {
  navy: '#1e3a5f', navyDark: '#162d4a', amber: '#f59e0b',
  page: { minHeight: '100vh', background: '#f8fafc', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  nav: { background: '#1e3a5f', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 60, position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' },
  navBrand: { color: '#fff', fontWeight: 700, fontSize: 18, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 },
  navLinks: { display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'nowrap' },
  navLink: { color: 'rgba(255,255,255,0.8)', textDecoration: 'none', padding: '5px 9px', borderRadius: 6, fontSize: 13, fontWeight: 500, transition: 'all 0.15s', whiteSpace: 'nowrap' },
  navLinkActive: { color: '#fff', background: 'rgba(255,255,255,0.15)' },
  main: { maxWidth: 1200, margin: '0 auto', padding: '32px 24px' },
  container: { maxWidth: 1200, margin: '0 auto', padding: '32px 24px' },
  card: { background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: 24, marginBottom: 20 },
  cardSm: { background: '#fff', borderRadius: 10, border: '1px solid #e2e8f0', padding: 16, marginBottom: 12 },
  h1: { fontSize: 26, fontWeight: 700, color: '#0f172a', margin: '0 0 4px 0' },
  h2: { fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 16px 0' },
  h3: { fontSize: 16, fontWeight: 600, color: '#1e293b', margin: '0 0 12px 0' },
  label: { display: 'block', fontSize: 12, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, color: '#1e293b', outline: 'none', boxSizing: 'border-box', background: '#fff' },
  textarea: { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, color: '#1e293b', outline: 'none', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' },
  select: { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, color: '#1e293b', outline: 'none', boxSizing: 'border-box', background: '#fff' },
  btn: { padding: '10px 20px', borderRadius: 8, border: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s' },
  btnPrimary: { background: '#1e3a5f', color: '#fff' },
  btnSecondary: { background: '#f1f5f9', color: '#1e293b', border: '1px solid #e2e8f0' },
  btnDanger: { background: '#dc2626', color: '#fff' },
  btnSuccess: { background: '#16a34a', color: '#fff' },
  btnAmber: { background: '#f59e0b', color: '#fff' },
  btnSm: { padding: '6px 14px', fontSize: 13 },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 },
  grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 20 },
  grid4: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 16 },
  statCard: { background: '#1e3a5f', borderRadius: 12, padding: 20, color: '#fff', textAlign: 'center' },
  statCardLight: { background: '#f8fafc', borderRadius: 12, padding: 20, border: '1px solid #e2e8f0', textAlign: 'center' },
  badge: { display: 'inline-block', padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { padding: '10px 12px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '2px solid #e2e8f0' },
  td: { padding: '12px', borderBottom: '1px solid #f1f5f9', fontSize: 14, color: '#374151', verticalAlign: 'middle' },
  row: { display: 'flex', alignItems: 'center', gap: 12 },
  spaceBetween: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  error: { background: '#fee2e2', border: '1px solid #fca5a5', color: '#dc2626', padding: '12px 16px', borderRadius: 8, fontSize: 14, marginBottom: 16 },
  success: { background: '#dcfce7', border: '1px solid #86efac', color: '#16a34a', padding: '12px 16px', borderRadius: 8, fontSize: 14, marginBottom: 16 },
  info: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1d4ed8', padding: '12px 16px', borderRadius: 8, fontSize: 14, marginBottom: 16 },
  tab: { padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 500, background: 'transparent', color: '#64748b', transition: 'all 0.15s' },
  tabActive: { background: '#1e3a5f', color: '#fff' },
  divider: { border: 'none', borderTop: '1px solid #e2e8f0', margin: '20px 0' },
  pill: { display: 'inline-block', padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600, background: '#f1f5f9', color: '#475569' },
};

// ─── AUTH PROVIDER ────────────────────────────────────────────────────────────

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => {
    // Consume SSO token from URL param if present (cross-portal login from admin)
    const params = new URLSearchParams(window.location.search);
    const sso = params.get('sso');
    if (sso) {
      localStorage.setItem('sales_token', sso);
      window.history.replaceState({}, '', window.location.pathname);
      return sso;
    }
    return localStorage.getItem('sales_token');
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetch(`${API}/api/sales/auth/me`, { headers: apiHeaders(token) })
        .then(r => r.json())
        .then(data => { if (data.id) setUser(data); else { localStorage.removeItem('sales_token'); setToken(null); } })
        .catch(() => { localStorage.removeItem('sales_token'); setToken(null); })
        .finally(() => setLoading(false));
    } else { setLoading(false); }
  }, [token]);

  const login = useCallback((tok, userData) => {
    localStorage.setItem('sales_token', tok);
    setToken(tok);
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('sales_token');
    setToken(null);
    setUser(null);
  }, []);

  const updateUser = useCallback((patch) => {
    setUser(u => u ? { ...u, ...patch } : u);
  }, []);

  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif', color: '#64748b' }}>Loading…</div>;

  return <AuthContext.Provider value={{ user, token, login, logout, updateUser }}>{children}</AuthContext.Provider>;
}

function useAuth() { return useContext(AuthContext); }

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.salesRole)) return <Navigate to="/" replace />;
  return children;
}

// ─── NAV ──────────────────────────────────────────────────────────────────────

function GlobalStyles() {
  return (
    <style>{`
      *, *::before, *::after { box-sizing: border-box; }
      .cb-hamburger {
        display: none; background: none; border: none; cursor: pointer;
        padding: 8px; flex-direction: column; gap: 5px; align-items: center;
        justify-content: center; border-radius: 6px;
      }
      .cb-hamburger:hover { background: rgba(255,255,255,0.1); }
      .cb-hamburger span { display: block; width: 22px; height: 2px; background: rgba(255,255,255,0.9); border-radius: 2px; }
      .cb-nav-drawer-backdrop {
        display: none; position: fixed; inset: 0; top: 60px;
        background: rgba(0,0,0,0.4); z-index: 200;
      }
      .cb-nav-drawer {
        position: absolute; top: 60px; left: 0; right: 0;
        background: #fff; box-shadow: 0 8px 32px rgba(0,0,0,0.18);
        border-radius: 0 0 12px 12px; z-index: 300; overflow: hidden;
      }
      @media (max-width: 768px) {
        .cb-nav-links { display: none !important; }
        .cb-hamburger { display: flex !important; }
        .cb-grid2 { grid-template-columns: 1fr !important; }
        .cb-grid3 { grid-template-columns: 1fr !important; }
        .cb-grid4 { grid-template-columns: 1fr 1fr !important; }
        .cb-main { padding: 16px 14px !important; }
      }
      @media (min-width: 769px) {
        .cb-nav-drawer { display: none !important; }
      }
    `}</style>
  );
}

function Nav() {
  const { user, token, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [actionCount, setActionCount] = useState(0);
  const [inboxCount, setInboxCount] = useState(0);
  const [followUpCount, setFollowUpCount] = useState(0);
  const isSuperAdmin = user?.salesRole === 'super_admin';
  const isActive = (path) => location.pathname.startsWith(path);
  const isSuperOrDir = user && ['super_admin', 'sales_director'].includes(user.salesRole);
  const isManager = user && ['super_admin', 'sales_director', 'sales_manager'].includes(user.salesRole);

  // Poll pending action count for super_admin badge
  React.useEffect(() => {
    if (!isSuperAdmin || !token) return;
    async function fetchCount() {
      try {
        const r = await fetch(`${API}/api/sales/actions/count`, { headers: apiHeaders(token) });
        const d = await r.json();
        if (d.count != null) setActionCount(d.count);
      } catch(e) {}
    }
    fetchCount();
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, [isSuperAdmin, token]);

  // Poll inbox unread count for all users
  React.useEffect(() => {
    if (!token) return;
    async function fetchInboxCount() {
      try {
        const r = await fetch(`${API}/api/sales/inbox`, { headers: apiHeaders(token) });
        const d = await r.json();
        if (d.unreadCount != null) setInboxCount(d.unreadCount);
      } catch(e) {}
    }
    fetchInboxCount();
    const interval = setInterval(fetchInboxCount, 60000);
    return () => clearInterval(interval);
  }, [token]);

  // Poll follow-up due count (today + overdue) for the badge
  React.useEffect(() => {
    if (!token) return;
    async function fetchFollowUpCount() {
      try {
        const r = await fetch(`${API}/api/sales/cadence`, { headers: apiHeaders(token) });
        const d = await r.json();
        if (typeof d.dueCount === 'number') setFollowUpCount(d.dueCount);
      } catch(e) {}
    }
    fetchFollowUpCount();
    const interval = setInterval(fetchFollowUpCount, 120000); // 2-min poll
    return () => clearInterval(interval);
  }, [token]);

  const [adminMenuOpen, setAdminMenuOpen] = React.useState(false);
  const [mobileAdminOpen, setMobileAdminOpen] = React.useState(false);

  const navItems = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/inbox', label: 'Inbox', badge: inboxCount },
    { path: '/opportunities', label: 'Opportunities' },
    { path: '/leads', label: 'Leads' },
    { path: '/follow-ups', label: '🔔 Follow-Ups', badge: followUpCount },
    { path: '/quotes', label: '📄 Quotes' },
    { path: '/message-analytics', label: '📊 Email Analytics' },
    { path: '/cities', label: 'Cities' },
    { path: '/customers', label: 'Customers' },
    { path: '/analytics', label: 'Analytics' },
    { path: '/reports', label: 'Reports' },
    ...(isSuperOrDir ? [{ path: '/commission', label: 'Commission' }] : []),
    { path: '/playbook', label: 'Playbook' },
    { path: '/downloads', label: 'Downloads' },
    ...(!isSuperAdmin ? [{ path: '/bounces', label: 'Bounces' }] : []),
    ...(isManager ? [{ path: '/users', label: 'Team' }] : []),
    { path: '/profile', label: user?.name?.split(' ')[0] || 'Me' },
  ];

  // Super admin items live in the Admin dropdown only
  const adminItems = isSuperAdmin ? [
    { path: '/contacts', label: '👥 Contacts' },
    { path: '/scheduled-queue', label: '📅 Sched Queue' },
    { path: '/payout', label: '💰 Payout' },
    { path: '/actions', label: '⚙️ Actions', badge: actionCount },
  ] : [];

  const adminActive = adminItems.some(item => location.pathname.startsWith(item.path));

  // Close menus on route change
  React.useEffect(() => { setMenuOpen(false); setAdminMenuOpen(false); setMobileAdminOpen(false); }, [location.pathname]);

  return (
    <div style={{ position: 'relative' }}>
      <nav style={S.nav}>
        <Link to="/" style={S.navBrand}>
          <svg width="28" height="28" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" style={{flexShrink:0}}><rect width="36" height="36" rx="8" fill="rgba(255,255,255,0.15)"/><rect x="5" y="16" width="5" height="15" rx="1" fill="white"/><rect x="12" y="11" width="5" height="20" rx="1" fill="white"/><rect x="19" y="6" width="5" height="25" rx="1" fill="white"/><rect x="26" y="13" width="4" height="18" rx="1" fill="#93c5fd"/></svg>
          <span>CivicBot <span style={{ color: '#f59e0b', fontWeight: 400, fontSize: 14 }}>Sales</span></span>
        </Link>
        {/* Desktop nav links */}
        <div className="cb-nav-links" style={S.navLinks}>
          {navItems.map((item, i) =>
            item.divider
              ? <span key={`div-${i}`} style={{ width: 1, height: 18, background: 'rgba(255,255,255,0.2)', margin: '0 6px', flexShrink: 0 }} />
              : (
                <Link key={item.path} to={item.path} style={{ ...S.navLink, ...(isActive(item.path) ? S.navLinkActive : {}), position: 'relative' }}>
                  {item.label}
                  {item.badge > 0 && <span style={{ position: 'absolute', top: -6, right: -10, background: '#dc2626', color: '#fff', borderRadius: '50%', fontSize: 10, fontWeight: 700, minWidth: 16, height: 16, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 3px', lineHeight: 1 }}>{item.badge}</span>}
                </Link>
              )
          )}

          {/* Admin dropdown — super admin only */}
          {isSuperAdmin && (
            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setAdminMenuOpen(o => !o)}
                style={{ ...S.navLink, ...(adminActive || adminMenuOpen ? S.navLinkActive : {}), position: 'relative', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
                Admin
                <span style={{ fontSize: 9, opacity: 0.8 }}>{adminMenuOpen ? '▲' : '▼'}</span>
                {actionCount > 0 && <span style={{ position: 'absolute', top: -6, right: -6, background: '#dc2626', color: '#fff', borderRadius: '50%', fontSize: 10, fontWeight: 700, minWidth: 16, height: 16, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 3px', lineHeight: 1 }}>{actionCount}</span>}
              </button>
              {adminMenuOpen && (
                <>
                  <div style={{ position: 'fixed', inset: 0, zIndex: 299 }} onClick={() => setAdminMenuOpen(false)} />
                  <div style={{ position: 'absolute', top: 'calc(100% + 10px)', right: 0, background: '#fff', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.18)', border: '1px solid #e2e8f0', minWidth: 200, zIndex: 300, overflow: 'hidden' }}>
                    <div style={{ padding: '8px 14px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#94a3b8', borderBottom: '1px solid #f1f5f9' }}>Super Admin</div>
                    {adminItems.map(item => (
                      <Link key={item.path} to={item.path}
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 16px', color: isActive(item.path) ? '#1e3a5f' : '#374151', fontWeight: isActive(item.path) ? 700 : 500, fontSize: 14, textDecoration: 'none', background: isActive(item.path) ? '#eff6ff' : 'transparent', borderBottom: '1px solid #f8fafc' }}>
                        {item.label}
                        {item.badge > 0 && <span style={{ background: '#dc2626', color: '#fff', borderRadius: 12, fontSize: 11, fontWeight: 700, minWidth: 20, height: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 5px' }}>{item.badge}</span>}
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}

          <span style={{ width: 1, height: 18, background: 'rgba(255,255,255,0.2)', margin: '0 6px', flexShrink: 0 }} />
          <button onClick={() => { logout(); navigate('/login'); }} style={{ ...S.btn, ...S.btnSm, background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)' }}>Sign Out</button>
        </div>
        {/* Hamburger button — mobile only */}
        <button className="cb-hamburger" onClick={() => setMenuOpen(o => !o)} aria-label="Toggle menu">
          <span /><span /><span />
        </button>
      </nav>
      {/* Mobile dropdown drawer */}
      {menuOpen && (
        <>
          <div style={{ position: 'fixed', inset: 0, top: 60, background: 'rgba(0,0,0,0.4)', zIndex: 200 }} onClick={() => setMenuOpen(false)} />
          <div className="cb-nav-drawer">
            {navItems.map((item, i) =>
              item.divider
                ? <div key={`div-${i}`} style={{ height: 1, background: '#e2e8f0', margin: '4px 0' }} />
                : (
                  <Link key={item.path} to={item.path} onClick={() => setMenuOpen(false)}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px', color: isActive(item.path) ? '#1e3a5f' : '#374151', fontWeight: isActive(item.path) ? 700 : 500, fontSize: 15, textDecoration: 'none', borderBottom: '1px solid #f1f5f9', background: isActive(item.path) ? '#eff6ff' : '#fff' }}>
                    {item.label}
                    {item.badge > 0 && <span style={{ background: '#dc2626', color: '#fff', borderRadius: 12, fontSize: 11, fontWeight: 700, minWidth: 20, height: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 5px' }}>{item.badge}</span>}
                  </Link>
                )
            )}
            {/* Admin section in mobile drawer */}
            {isSuperAdmin && (
              <>
                <div style={{ height: 1, background: '#e2e8f0', margin: '4px 0' }} />
                <button onClick={() => setMobileAdminOpen(o => !o)}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '14px 20px', background: adminActive ? '#eff6ff' : '#f8fafc', border: 'none', borderBottom: '1px solid #f1f5f9', color: '#1e3a5f', fontWeight: 700, fontSize: 15, cursor: 'pointer', textAlign: 'left' }}>
                  <span>⚙️ Admin</span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {actionCount > 0 && <span style={{ background: '#dc2626', color: '#fff', borderRadius: 12, fontSize: 11, fontWeight: 700, minWidth: 20, height: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 5px' }}>{actionCount}</span>}
                    <span style={{ fontSize: 11, color: '#94a3b8' }}>{mobileAdminOpen ? '▲' : '▼'}</span>
                  </div>
                </button>
                {mobileAdminOpen && adminItems.map(item => (
                  <Link key={item.path} to={item.path} onClick={() => setMenuOpen(false)}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '13px 20px 13px 36px', color: isActive(item.path) ? '#1e3a5f' : '#374151', fontWeight: isActive(item.path) ? 700 : 500, fontSize: 14, textDecoration: 'none', borderBottom: '1px solid #f1f5f9', background: isActive(item.path) ? '#eff6ff' : '#fff' }}>
                    {item.label}
                    {item.badge > 0 && <span style={{ background: '#dc2626', color: '#fff', borderRadius: 12, fontSize: 11, fontWeight: 700, minWidth: 20, height: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 5px' }}>{item.badge}</span>}
                  </Link>
                ))}
              </>
            )}
            <button onClick={() => { logout(); navigate('/login'); setMenuOpen(false); }}
              style={{ display: 'block', width: '100%', padding: '14px 20px', background: '#fff', border: 'none', borderTop: '2px solid #e2e8f0', color: '#dc2626', fontWeight: 600, fontSize: 15, textAlign: 'left', cursor: 'pointer' }}>
              Sign Out
            </button>
          </div>
        </>
      )}
    </div>
  );
}

// ─── LOGIN ────────────────────────────────────────────────────────────────────

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/api/sales/auth/login`, { method: 'POST', headers: apiHeaders(), body: JSON.stringify(form) });
      const data = await r.json();
      if (!r.ok) { setError(data.error || 'Login failed'); return; }
      login(data.token, data.user);
      navigate('/dashboard');
    } catch { setError('Network error. Please try again.'); }
    finally { setLoading(false); }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3a5f 0%, #162d4a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display:'flex', justifyContent:'center', marginBottom: 12 }}><svg width="56" height="56" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="36" rx="8" fill="#1e3a5f"/><rect x="5" y="16" width="5" height="15" rx="1" fill="white"/><rect x="12" y="11" width="5" height="20" rx="1" fill="white"/><rect x="19" y="6" width="5" height="25" rx="1" fill="white"/><rect x="26" y="13" width="4" height="18" rx="1" fill="#3b82f6"/></svg></div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: '#0f172a', margin: '0 0 4px 0' }}>CivicBot Sales</h1>
          <p style={{ color: '#64748b', margin: 0, fontSize: 14 }}>Sign in to your sales portal</p>
        </div>
        {error && <div style={S.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={S.label}>Email</label>
            <input style={S.input} type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="you@example.com" required autoFocus />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={S.label}>Password</label>
            <input style={S.input} type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="••••••••" required />
          </div>
          <button type="submit" style={{ ...S.btn, ...S.btnPrimary, width: '100%', padding: '12px', fontSize: 15 }} disabled={loading}>{loading ? 'Signing in…' : 'Sign In'}</button>
        </form>
        <div style={{ marginTop: 20, textAlign: 'center', fontSize: 14 }}>
          <Link to="/forgot-password" style={{ color: '#1e3a5f', textDecoration: 'none' }}>Forgot password?</Link>
          <span style={{ color: '#d1d5db', margin: '0 10px' }}>|</span>
          <Link to="/signup" style={{ color: '#1e3a5f', textDecoration: 'none' }}>Request access</Link>
        </div>
      </div>
    </div>
  );
}

// ─── SIGNUP ───────────────────────────────────────────────────────────────────

function Signup() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (form.password !== form.confirm) { setError('Passwords do not match'); return; }
    if (form.password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/api/sales/auth/signup`, { method: 'POST', headers: apiHeaders(), body: JSON.stringify(form) });
      const data = await r.json();
      if (!r.ok) { setError(data.error || 'Signup failed'); return; }
      setSuccess(true);
    } catch { setError('Network error. Please try again.'); }
    finally { setLoading(false); }
  }

  if (success) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3a5f 0%, #162d4a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 420, textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
        <h2 style={{ ...S.h2, textAlign: 'center' }}>Application Submitted</h2>
        <p style={{ color: '#64748b', marginBottom: 24 }}>Your account is pending approval. You'll receive an email once a manager reviews your application.</p>
        <button onClick={() => navigate('/login')} style={{ ...S.btn, ...S.btnPrimary }}>Back to Login</button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3a5f 0%, #162d4a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ display:'flex', justifyContent:'center', marginBottom: 8 }}><svg width="52" height="52" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="36" rx="8" fill="#1e3a5f"/><rect x="5" y="16" width="5" height="15" rx="1" fill="white"/><rect x="12" y="11" width="5" height="20" rx="1" fill="white"/><rect x="19" y="6" width="5" height="25" rx="1" fill="white"/><rect x="26" y="13" width="4" height="18" rx="1" fill="#3b82f6"/></svg></div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', margin: '0 0 4px 0' }}>Join CivicBot Sales</h1>
          <p style={{ color: '#64748b', margin: 0, fontSize: 14 }}>Your account will be reviewed by a manager</p>
        </div>
        {error && <div style={S.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          {[['name','Full Name','text','John Smith'],['email','Email','email','you@example.com'],['phone','Phone','tel','(555) 000-0000']].map(([field, label, type, ph]) => (
            <div key={field} style={{ marginBottom: 14 }}>
              <label style={S.label}>{label}</label>
              <input style={S.input} type={type} value={form[field]} onChange={e => setForm(f => ({ ...f, [field]: e.target.value }))} placeholder={ph} required={field !== 'phone'} />
            </div>
          ))}
          <div style={{ marginBottom: 14 }}>
            <label style={S.label}>Password</label>
            <input style={S.input} type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="Min 8 characters" required />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={S.label}>Confirm Password</label>
            <input style={S.input} type="password" value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} placeholder="••••••••" required />
          </div>
          <button type="submit" style={{ ...S.btn, ...S.btnPrimary, width: '100%', padding: '12px' }} disabled={loading}>{loading ? 'Submitting…' : 'Request Access'}</button>
        </form>
        <div style={{ marginTop: 16, textAlign: 'center', fontSize: 14 }}>
          <Link to="/login" style={{ color: '#1e3a5f', textDecoration: 'none' }}>Already have an account? Sign in</Link>
        </div>
      </div>
    </div>
  );
}

// ─── SET PASSWORD ─────────────────────────────────────────────────────────────

function SetPassword() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token');
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (form.password !== form.confirm) { setError('Passwords do not match'); return; }
    if (form.password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/api/sales/auth/set-password`, { method: 'POST', headers: apiHeaders(), body: JSON.stringify({ token, password: form.password }) });
      const data = await r.json();
      if (!r.ok) { setError(data.error || 'Failed'); return; }
      setSuccess(true);
    } catch { setError('Network error'); }
    finally { setLoading(false); }
  }

  if (success) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3a5f 0%, #162d4a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, maxWidth: 380, textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔐</div>
        <h2 style={S.h2}>Password Set</h2>
        <p style={{ color: '#64748b', marginBottom: 24 }}>Your password has been set. You can now sign in.</p>
        <button onClick={() => navigate('/login')} style={{ ...S.btn, ...S.btnPrimary }}>Go to Login</button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3a5f 0%, #162d4a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 380 }}>
        <h1 style={{ ...S.h1, textAlign: 'center', marginBottom: 24 }}>Set Your Password</h1>
        {error && <div style={S.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={S.label}>New Password</label>
            <input style={S.input} type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={S.label}>Confirm Password</label>
            <input style={S.input} type="password" value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} required />
          </div>
          <button type="submit" style={{ ...S.btn, ...S.btnPrimary, width: '100%' }} disabled={loading}>{loading ? 'Saving…' : 'Set Password'}</button>
        </form>
      </div>
    </div>
  );
}

// ─── FORGOT PASSWORD ──────────────────────────────────────────────────────────

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    await fetch(`${API}/api/sales/auth/forgot-password`, { method: 'POST', headers: apiHeaders(), body: JSON.stringify({ email }) });
    setSent(true); setLoading(false);
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3a5f 0%, #162d4a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 380 }}>
        {sent ? (<div style={{ textAlign: 'center' }}><div style={{ fontSize: 48, marginBottom: 16 }}>📧</div><h2 style={S.h2}>Check Your Email</h2><p style={{ color: '#64748b' }}>If an account exists, a reset link has been sent.</p><Link to="/login" style={{ color: '#1e3a5f' }}>Back to login</Link></div>)
        : (<><h1 style={{ ...S.h1, marginBottom: 8 }}>Reset Password</h1><p style={{ color: '#64748b', marginBottom: 24 }}>Enter your email and we'll send a reset link.</p><form onSubmit={handleSubmit}><div style={{ marginBottom: 16 }}><label style={S.label}>Email</label><input style={S.input} type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus /></div><button type="submit" style={{ ...S.btn, ...S.btnPrimary, width: '100%' }} disabled={loading}>{loading ? 'Sending…' : 'Send Reset Link'}</button></form><div style={{ marginTop: 16, textAlign: 'center' }}><Link to="/login" style={{ color: '#1e3a5f', fontSize: 14 }}>Back to login</Link></div></>)}
      </div>
    </div>
  );
}

// ─── DASHBOARD ────────────────────────────────────────────────────────────────

// ─── Inbound Leads panel — warm leads from the CivicBot website ROI calculator ─
function InboundLeadsPanel() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [claiming, setClaiming] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/sales/inbound-leads`, { headers: apiHeaders(token) })
      .then(r => r.json())
      .then(d => { if (Array.isArray(d)) setLeads(d); })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [token]);

  const claim = async (opp) => {
    setClaiming(opp.id);
    try {
      const r = await fetch(`${API}/api/sales/opportunities/${opp.id}/claim`, { method: 'POST', headers: apiHeaders(token) });
      const d = await r.json();
      if (d.leadId) { navigate(`/leads/${d.leadId}`); return; }
      alert(d.error || 'Could not claim this lead.');
    } catch (e) { alert('Could not claim this lead.'); }
    setClaiming(null);
  };

  const fmtAge = (ts) => {
    if (!ts) return '';
    const d = new Date(ts.includes('T') ? ts : ts.replace(' ', 'T') + 'Z');
    const mins = Math.floor((Date.now() - d.getTime()) / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return mins + ' min ago';
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return hrs + ' hr' + (hrs > 1 ? 's' : '') + ' ago';
    const days = Math.floor(hrs / 24);
    return days + ' day' + (days > 1 ? 's' : '') + ' ago';
  };

  if (!loaded) return null;
  const unclaimed = leads.filter(l => l.status === 'available').length;

  return (
    <div style={{ ...S.card, border: '1px solid #fdba74', marginBottom: 24, padding: 0, overflow: 'hidden' }}>
      <div style={{ background: '#fff7ed', borderBottom: '1px solid #fed7aa', padding: '13px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontWeight: 800, color: '#9a3412', fontSize: 15 }}>🔥 Inbound Leads — CivicBot Website</div>
        <span style={{ background: '#ea580c', color: '#fff', fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20 }}>{unclaimed} unclaimed</span>
      </div>
      {leads.length === 0
        ? <div style={{ padding: '22px 18px', fontSize: 13, color: '#94a3b8' }}>No inbound leads yet — warm leads from the CivicBot website ROI calculator will land here.</div>
        : leads.map(l => {
        const claimable = l.status === 'available';
        return (
          <div key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '13px 18px', borderBottom: '1px solid #f1f5f9' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, color: '#0f172a', fontSize: 14 }}>
                {l.org_name}{l.org_state ? ', ' + l.org_state : ''}
                {!claimable && <span style={{ marginLeft: 8, background: '#fef9c3', border: '1px solid #fde047', borderRadius: 6, fontSize: 10, color: '#854d0e', fontWeight: 700, padding: '2px 7px' }}>Already in pipeline</span>}
              </div>
              <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                {l.contact_name || '—'}{l.contact_email ? ' · ' + l.contact_email : ''}
                {l.roi_calls ? ' · ' + l.roi_calls + ' calls/mo' : ''}
                {l.roi_est_savings > 0 && <span style={{ color: '#059669', fontWeight: 700 }}> · ~${Number(l.roi_est_savings).toLocaleString()}/yr savings</span>}
              </div>
            </div>
            <div style={{ fontSize: 11, color: '#94a3b8', whiteSpace: 'nowrap' }}>{fmtAge(l.roi_interest_at)}</div>
            {claimable
              ? <button onClick={() => claim(l)} disabled={claiming === l.id} style={{ background: '#1e3a5f', color: '#fff', border: 'none', borderRadius: 7, fontSize: 12, fontWeight: 700, padding: '8px 18px', cursor: 'pointer', whiteSpace: 'nowrap' }}>{claiming === l.id ? 'Claiming…' : 'Claim →'}</button>
              : <button onClick={() => navigate(l.lead_id ? `/leads/${l.lead_id}` : '/opportunities')} style={{ background: '#e2e8f0', color: '#334155', border: 'none', borderRadius: 7, fontSize: 12, fontWeight: 700, padding: '8px 18px', cursor: 'pointer', whiteSpace: 'nowrap' }}>Open →</button>}
          </div>
        );
      })}
    </div>
  );
}

function Dashboard() {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [inboxData, setInboxData] = useState({ emails: [], unreadCount: 0 });

  useEffect(() => {
    fetch(`${API}/api/sales/dashboard`, { headers: apiHeaders(token) })
      .then(r => r.json()).then(setData).finally(() => setLoading(false));
    fetch(`${API}/api/sales/inbox`, { headers: apiHeaders(token) })
      .then(r => r.json()).then(d => setInboxData((d && Array.isArray(d.emails)) ? d : { emails: [], unreadCount: 0 })).catch(() => {});
  }, [token]);

  if (loading) return <div className="cb-main" style={S.main}><p style={{ color: '#64748b' }}>Loading dashboard…</p></div>;
  if (!data) return null;

  const { trialsExpiringSoon = [], trialsExpiredRecently = [], commissionMtd, followUps = [], pendingRequests = 0, subscriptionsExpiring = {} } = data;
  const { within30 = [], within60 = [], within90 = [] } = subscriptionsExpiring;
  const totalExpiring = within30.length + within60.length + within90.length;
  const isManager = ['super_admin', 'sales_director', 'sales_manager'].includes(user?.salesRole);

  return (
    <div className="cb-main" style={S.main}>
      <div style={{ ...S.spaceBetween, marginBottom: 28 }}>
        <div>
          <h1 style={S.h1}>Welcome back, {user?.name?.split(' ')[0]} 👋</h1>
          <p style={{ color: '#64748b', margin: 0 }}>{new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</p>
        </div>
        <button onClick={() => navigate('/cities')} style={{ ...S.btn, ...S.btnPrimary }}>View All Cities →</button>
      </div>

      {/* Commission MTD (reps only) */}
      {commissionMtd && (
        <div style={{ ...S.card, background: 'linear-gradient(135deg, #1e3a5f 0%, #162d4a 100%)', border: 'none', marginBottom: 24 }}>
          <h3 style={{ ...S.h3, color: 'rgba(255,255,255,0.7)', fontWeight: 500, marginBottom: 20, textTransform: 'uppercase', fontSize: 12, letterSpacing: '0.08em' }}>My Commission — {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</h3>
          <div className="cb-grid4" style={S.grid4}>
            {[
              { label: 'Base', value: formatCurrency(commissionMtd.base), tip: 'Annual ARR × 15% commission rate for each deal closed this calendar month.' },
              { label: 'Speed Bonuses', value: formatCurrency(commissionMtd.speedBonus), tip: '+$150 per deal closed within 7 days of trial start; +$75 for days 8–14 of the trial.' },
              { label: 'Volume Bonus', value: formatCurrency(commissionMtd.volumeBonus), tip: 'Bonus for hitting deal count thresholds this month: 3 deals = +$250, 5 deals = +$750, 8+ deals = +$1,500.' },
              { label: 'Total MTD', value: formatCurrency(commissionMtd.total), tip: 'Base commission + speed bonuses + volume bonus for this calendar month.' },
            ].map(({ label, value, tip }) => (
              <div key={label} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 26, fontWeight: 700, color: '#fff' }}>{value}</div>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{label}<InfoTip text={tip} light /></div>
              </div>
            ))}
          </div>
          {commissionMtd.nextBonusTier && (
            <div style={{ marginTop: 20, padding: '12px 16px', background: 'rgba(255,255,255,0.1)', borderRadius: 8 }}>
              <div style={{ color: '#f59e0b', fontWeight: 600, fontSize: 14 }}>
                🎯 {commissionMtd.nextBonusTier.needed} more deal{commissionMtd.nextBonusTier.needed !== 1 ? 's' : ''} = +{formatCurrency(commissionMtd.nextBonusTier.bonus)} volume bonus ({commissionMtd.dealCount}/{commissionMtd.nextBonusTier.deals} deals)
              </div>
            </div>
          )}
        </div>
      )}

      {/* Alert cards */}
      {pendingRequests > 0 && isManager && (
        <div style={{ ...S.info, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} onClick={() => navigate('/cities?tab=requests')}>
          <span>⚠️ <strong>{pendingRequests} pending transfer request{pendingRequests !== 1 ? 's' : ''}</strong> awaiting your review</span>
          <span style={{ fontWeight: 600 }}>Review →</span>
        </div>
      )}

      <InboundLeadsPanel />

      <div className="cb-grid3" style={S.grid3}>
        {/* Trials expiring soon */}
        <div style={S.card}>
          <h3 style={{ ...S.h3, display: 'flex', alignItems: 'center' }}>🔴 Trials Expiring Soon ({trialsExpiringSoon.length})<InfoTip text={'Cities on a free trial whose trial ends within the next 14 days. Close these before the trial expires to earn the speed bonus.'} /></h3>
          {trialsExpiringSoon.length === 0 ? <p style={{ color: '#64748b', fontSize: 14 }}>No trials expiring in the next 14 days.</p> : (
            trialsExpiringSoon.map(city => {
              const badge = trialBadge(city.trial_ends_at, city.billing_status);
              return (
                <div key={city.id} style={{ ...S.cardSm, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} onClick={() => navigate(`/cities/${city.id}`)}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#0f172a' }}>{city.name}</div>
                    {city.rep_name && <div style={{ fontSize: 12, color: '#64748b' }}>{city.rep_name}</div>}
                  </div>
                  <span style={{ ...S.badge, color: badge.color, background: badge.bg }}>{badge.label}</span>
                </div>
              );
            })
          )}
        </div>

        {/* Follow-ups due */}
        <div style={S.card}>
          <h3 style={{ ...S.h3, display: 'flex', alignItems: 'center' }}>📋 Follow-ups Due ({followUps.length})<InfoTip text={'Activities with a follow-up date set within the next 3 days, or already overdue. Log activities on a Lead to schedule follow-ups.'} /></h3>
          {followUps.length === 0 ? <p style={{ color: '#64748b', fontSize: 14 }}>No follow-ups due in the next 3 days.</p> : (
            followUps.map(fu => (
              <div key={fu.id} style={{ ...S.cardSm, cursor: 'pointer' }} onClick={() => navigate(`/cities/${fu.city_id}`)}>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#0f172a' }}>{fu.city_name}</div>
                <div style={{ fontSize: 13, color: '#475569', marginTop: 2 }}>{fu.title}</div>
                <div style={{ fontSize: 12, color: new Date(fu.follow_up_date) < new Date() ? '#dc2626' : '#64748b', marginTop: 2 }}>
                  {new Date(fu.follow_up_date) < new Date() ? '⚠️ Overdue — ' : '📅 '}{formatDate(fu.follow_up_date)}
                </div>
              </div>
            ))
          )}
        </div>

        {/* Email Inbox */}
        <div style={S.card}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
            <h3 style={{ ...S.h3, margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
              📬 Email Inbox
              {inboxData.unreadCount > 0 && (
                <span style={{ background: '#3b82f6', color: '#fff', borderRadius: 20, fontSize: 11, fontWeight: 700, padding: '1px 8px' }}>{inboxData.unreadCount}</span>
              )}
            </h3>
          </div>
          {(inboxData.emails || []).length === 0 ? (
            <p style={{ color: '#64748b', fontSize: 14, marginTop: 8 }}>No replies yet.</p>
          ) : (
            (inboxData.emails || []).slice(0, 4).map(e => {
              const isUnread = !e.read_at;
              const initials = (e.sent_by_name || e.sent_by || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
              const snippet = (e.body || '').replace(/\n/g, ' ').trim().slice(0, 60);
              return (
                <div key={e.id} onClick={() => navigate(`/leads/${e.lead_id}?tab=email`)}
                  style={{ ...S.cardSm, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px' }}>
                  {isUnread && <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#3b82f6', flexShrink: 0 }} />}
                  {!isUnread && <span style={{ width: 7, height: 7, flexShrink: 0 }} />}
                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#1e3a5f', color: '#93c5fd', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 11, flexShrink: 0 }}>{initials}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: isUnread ? 700 : 600, fontSize: 13, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{e.city_name}</div>
                    <div style={{ fontSize: 11, color: '#64748b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{snippet || e.subject}</div>
                  </div>
                </div>
              );
            })
          )}
          <button onClick={() => navigate('/inbox')} style={{ ...S.btn, ...S.btnSecondary, width: '100%', marginTop: 12, fontSize: 12 }}>
            View All Replies →
          </button>
        </div>
      </div>

      {/* Recently expired */}
      {trialsExpiredRecently.length > 0 && (
        <div style={S.card}>
          <h3 style={{ ...S.h3, display: 'flex', alignItems: 'center' }}>⏰ Recently Expired — Re-engage Now ({trialsExpiredRecently.length})<InfoTip text={'Trials that ended in the past 7 days without converting. Re-engage now — these cities saw the product and are still warm.' } /></h3>
          <div className="cb-grid3" style={S.grid3}>
            {trialsExpiredRecently.map(city => (
              <div key={city.id} style={{ ...S.cardSm, cursor: 'pointer', border: '1px solid #fca5a5', background: '#fff5f5' }} onClick={() => navigate(`/cities/${city.id}`)}>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#0f172a' }}>{city.name}</div>
                <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4 }}>Expired {formatDate(city.trial_ends_at)}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Subscriptions renewing in next 90 days */}
      {totalExpiring > 0 && (
        <div style={S.card}>
          <h3 style={S.h3}>🔄 Subscriptions Renewing Soon ({totalExpiring})</h3>
          <p style={{ color: '#64748b', fontSize: 13, marginBottom: 16 }}>Reach out early for procurement — especially annual plans that need budget approval.</p>

          {within30.length > 0 && (
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#dc2626', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ background: '#fee2e2', color: '#dc2626', borderRadius: 20, padding: '2px 10px' }}>Within 30 days</span>
              </div>
              <div className="cb-grid3" style={S.grid3}>
                {within30.map(city => (
                  <div key={city.id} style={{ ...S.cardSm, cursor: 'pointer', border: '1px solid #fca5a5', background: '#fff5f5' }} onClick={() => navigate(`/cities/${city.id}`)}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#0f172a' }}>{city.name}{city.state ? `, ${city.state}` : ''}</div>
                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{city.plan_name || '—'} · {city.billing_period === 'annual' ? 'Annual' : 'Monthly'}</div>
                    <div style={{ fontSize: 12, color: '#dc2626', fontWeight: 600, marginTop: 4 }}>Renews {formatDate(city.subscription_period_end)}</div>
                    {city.rep_name && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{city.rep_name}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}

          {within60.length > 0 && (
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#d97706', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>
                <span style={{ background: '#fef3c7', color: '#d97706', borderRadius: 20, padding: '2px 10px' }}>31–60 days</span>
              </div>
              <div className="cb-grid3" style={S.grid3}>
                {within60.map(city => (
                  <div key={city.id} style={{ ...S.cardSm, cursor: 'pointer', border: '1px solid #fde68a', background: '#fffbeb' }} onClick={() => navigate(`/cities/${city.id}`)}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#0f172a' }}>{city.name}{city.state ? `, ${city.state}` : ''}</div>
                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{city.plan_name || '—'} · {city.billing_period === 'annual' ? 'Annual' : 'Monthly'}</div>
                    <div style={{ fontSize: 12, color: '#d97706', fontWeight: 600, marginTop: 4 }}>Renews {formatDate(city.subscription_period_end)}</div>
                    {city.rep_name && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{city.rep_name}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}

          {within90.length > 0 && (
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>
                <span style={{ background: '#f1f5f9', color: '#6b7280', borderRadius: 20, padding: '2px 10px' }}>61–90 days</span>
              </div>
              <div className="cb-grid3" style={S.grid3}>
                {within90.map(city => (
                  <div key={city.id} style={{ ...S.cardSm, cursor: 'pointer' }} onClick={() => navigate(`/cities/${city.id}`)}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#0f172a' }}>{city.name}{city.state ? `, ${city.state}` : ''}</div>
                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{city.plan_name || '—'} · {city.billing_period === 'annual' ? 'Annual' : 'Monthly'}</div>
                    <div style={{ fontSize: 12, color: '#64748b', fontWeight: 600, marginTop: 4 }}>Renews {formatDate(city.subscription_period_end)}</div>
                    {city.rep_name && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{city.rep_name}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ─── CITIES LIST ──────────────────────────────────────────────────────────────

function CitiesList() {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [stageFilter, setStageFilter] = useState('');
  const [viewMode, setViewMode] = useState('list'); // list | kanban
  const [tab, setTab] = useState('cities');
  const isManager = ['super_admin', 'sales_director', 'sales_manager'].includes(user?.salesRole); // cities | requests

  const load = useCallback(async () => {
    setLoading(true);
    const [c, r] = await Promise.all([
      fetch(`${API}/api/sales/cities`, { headers: apiHeaders(token) }).then(r => r.json()),
      isManager ? fetch(`${API}/api/sales/assignment-requests`, { headers: apiHeaders(token) }).then(r => r.json()) : Promise.resolve([])
    ]);
    setCities(Array.isArray(c) ? c : []);
    setRequests(Array.isArray(r) ? r : []);
    setLoading(false);
  }, [token, isManager]);

  useEffect(() => { load(); }, [load]);

  const filtered = cities.filter(c => {
    const matchSearch = !search || c.name.toLowerCase().includes(search.toLowerCase()) || c.state?.toLowerCase().includes(search.toLowerCase());
    const matchStage = !stageFilter || c.pipelineStage === stageFilter;
    return matchSearch && matchStage;
  });

  async function handleReview(reqId, decision) {
    await fetch(`${API}/api/sales/assignment-requests/${reqId}/review`, {
      method: 'POST', headers: apiHeaders(token), body: JSON.stringify({ decision })
    });
    load();
  }

  if (loading) return <div className="cb-main" style={S.main}><p style={{ color: '#64748b' }}>Loading cities…</p></div>;

  return (
    <div className="cb-main" style={S.main}>
      <div style={{ ...S.spaceBetween, marginBottom: 24 }}>
        <h1 style={S.h1}>Cities Pipeline</h1>
        <div style={S.row}>
          <button onClick={() => setViewMode('list')} style={{ ...S.btn, ...S.btnSm, ...(viewMode === 'list' ? S.btnPrimary : S.btnSecondary) }}>List</button>
          <button onClick={() => setViewMode('kanban')} style={{ ...S.btn, ...S.btnSm, ...(viewMode === 'kanban' ? S.btnPrimary : S.btnSecondary) }}>Kanban</button>
        </div>
      </div>

      {/* Tabs */}
      {isManager && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {[['cities', 'Cities'], ['requests', `Transfer Requests${requests.length > 0 ? ` (${requests.length})` : ''}`]].map(([key, label]) => (
            <button key={key} onClick={() => setTab(key)} style={{ ...S.tab, ...(tab === key ? S.tabActive : {}) }}>{label}</button>
          ))}
        </div>
      )}

      {tab === 'requests' && (
        <div style={S.card}>
          <h3 style={S.h3}>Pending Transfer Requests</h3>
          {requests.length === 0 ? <p style={{ color: '#64748b', fontSize: 14 }}>No pending requests.</p> : requests.map(req => (
            <div key={req.id} style={{ ...S.cardSm, ...S.spaceBetween }}>
              <div>
                <div style={{ fontWeight: 600 }}>{req.city_name}</div>
                <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}><strong>{req.requesting_rep_name}</strong> wants to take over from <strong>{req.current_rep_name || 'unassigned'}</strong></div>
                <div style={{ fontSize: 13, color: '#475569', marginTop: 4, fontStyle: 'italic' }}>"{req.reason}"</div>
              </div>
              <div style={S.row}>
                <button onClick={() => handleReview(req.id, 'approved')} style={{ ...S.btn, ...S.btnSm, ...S.btnSuccess }}>Approve</button>
                <button onClick={() => handleReview(req.id, 'rejected')} style={{ ...S.btn, ...S.btnSm, ...S.btnDanger }}>Reject</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === 'cities' && viewMode === 'list' && (
        <>
          {/* Filters */}
          <div style={{ ...S.row, marginBottom: 20, flexWrap: 'wrap' }}>
            <input style={{ ...S.input, maxWidth: 280 }} placeholder="Search cities…" value={search} onChange={e => setSearch(e.target.value)} />
            <select style={{ ...S.select, maxWidth: 200 }} value={stageFilter} onChange={e => setStageFilter(e.target.value)}>
              <option value="">All Stages</option>
              {STAGES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
            </select>
            <span style={{ color: '#64748b', fontSize: 14 }}>{filtered.length} cities</span>
          </div>

          <div style={S.card}>
            <table style={S.table}>
              <thead>
                <tr>
                  {['City', 'Stage', 'Trial Status', 'Rep', 'Submissions', 'ARR', 'Actions'].map(h => (
                    <th key={h} style={S.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(city => {
                  const badge = trialBadge(city.trialEndsAt, city.billingStatus);
                  const stageColor = STAGE_COLORS[city.pipelineStage] || '#6b7280';
                  return (
                    <tr key={city.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/cities/${city.id}`)}>
                      <td style={S.td}><div style={{ fontWeight: 600, color: '#0f172a' }}>{city.name}</div><div style={{ fontSize: 12, color: '#64748b' }}>{city.state}</div></td>
                      <td style={S.td}><span style={{ ...S.badge, color: stageColor, background: stageColor + '18' }}>{STAGES.find(s => s.key === city.pipelineStage)?.label || 'Prospect'}</span></td>
                      <td style={S.td}><span style={{ ...S.badge, color: badge.color, background: badge.bg }}>{badge.label}</span></td>
                      <td style={S.td}><span style={{ fontSize: 14, color: city.assignedRepName ? '#1e293b' : '#94a3b8' }}>{city.assignedRepName || '—'}</span></td>
                      <td style={S.td}><span style={{ fontWeight: 600 }}>{city.submissionCount.toLocaleString()}</span></td>
                      <td style={S.td}><span style={{ color: city.isAnnual ? '#16a34a' : '#94a3b8', fontWeight: 600 }}>{city.isAnnual ? formatCurrency(city.arr) : 'Monthly'}</span></td>
                      <td style={S.td} onClick={e => e.stopPropagation()}>
                        {!city.assignedRepId && user?.salesRole === 'sales_rep' && (
                          <button onClick={async () => {
                            await fetch(`${API}/api/sales/cities/${city.id}/claim`, { method: 'POST', headers: apiHeaders(token) });
                            load();
                          }} style={{ ...S.btn, ...S.btnSm, ...S.btnAmber }}>Claim</button>
                        )}
                      </td>
                    </tr>
                  );
                })}
                {filtered.length === 0 && <tr><td colSpan={7} style={{ ...S.td, textAlign: 'center', color: '#64748b', padding: 40 }}>No cities match your filters</td></tr>}
              </tbody>
            </table>
          </div>
        </>
      )}

      {tab === 'cities' && viewMode === 'kanban' && (
        <div style={{ display: 'flex', gap: 16, overflowX: 'auto', paddingBottom: 16 }}>
          {STAGES.map(stage => {
            const stageCities = filtered.filter(c => (c.pipelineStage || 'prospect') === stage.key);
            return (
              <div key={stage.key} style={{ minWidth: 220, background: '#f8fafc', borderRadius: 12, border: '1px solid #e2e8f0', padding: 12 }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: STAGE_COLORS[stage.key], marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  {stage.label} <span style={{ background: STAGE_COLORS[stage.key] + '20', color: STAGE_COLORS[stage.key], borderRadius: 10, padding: '1px 8px', fontSize: 12 }}>{stageCities.length}</span>
                </div>
                {stageCities.map(city => {
                  const badge = trialBadge(city.trialEndsAt, city.billingStatus);
                  return (
                    <div key={city.id} onClick={() => navigate(`/cities/${city.id}`)} style={{ background: '#fff', borderRadius: 8, padding: 10, marginBottom: 8, border: '1px solid #e2e8f0', cursor: 'pointer', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{city.name}</div>
                      <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>{city.state}</div>
                      <span style={{ ...S.badge, fontSize: 11, color: badge.color, background: badge.bg, marginTop: 6 }}>{badge.label}</span>
                    </div>
                  );
                })}
                {stageCities.length === 0 && <div style={{ fontSize: 12, color: '#94a3b8', textAlign: 'center', padding: '16px 0' }}>Empty</div>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ─── CITY DETAIL ──────────────────────────────────────────────────────────────

function CityDetail() {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const cityId = window.location.pathname.split('/').pop();
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('overview');
  const [activityForm, setActivityForm] = useState({ type: 'note', title: '', body: '', followUpDate: '' });
  const [contactForm, setContactForm] = useState({ name: '', title: '', email: '', phone: '', isPrimary: false });
  const [emailForm, setEmailForm] = useState({ contactName: '', recipientEmail: '', subject: '', body: '', customNotes: '' });
  const [generatingEmail, setGeneratingEmail] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [emailMsg, setEmailMsg] = useState('');
  const [stageForm, setStageForm] = useState({ stage: '', competitiveDisplacement: '', winLossReason: '', notes: '' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    const data = await fetch(`${API}/api/sales/cities/${cityId}`, { headers: apiHeaders(token) }).then(r => r.json());
    setCity(data);
    setStageForm({ stage: data.pipelineStage || 'prospect', competitiveDisplacement: data.competitiveDisplacement || '', winLossReason: data.winLossReason || '', notes: data.pipelineNotes || '' });
    const primary = data.contacts?.find(c => c.is_primary);
    if (primary) setEmailForm(f => ({ ...f, contactName: primary.name, recipientEmail: primary.email }));
    setLoading(false);
  }, [token, cityId]);

  useEffect(() => { load(); }, [load]);

  async function saveStage() {
    setSaving(true);
    await fetch(`${API}/api/sales/cities/${cityId}/stage`, { method: 'PATCH', headers: apiHeaders(token), body: JSON.stringify(stageForm) });
    setMsg('Stage saved'); load(); setSaving(false);
    setTimeout(() => setMsg(''), 3000);
  }

  async function logActivity(e) {
    e.preventDefault(); setSaving(true);
    await fetch(`${API}/api/sales/cities/${cityId}/activities`, { method: 'POST', headers: apiHeaders(token), body: JSON.stringify(activityForm) });
    setActivityForm({ type: 'note', title: '', body: '', followUpDate: '' });
    setMsg('Activity logged'); load(); setSaving(false);
    setTimeout(() => setMsg(''), 3000);
  }

  async function addContact(e) {
    e.preventDefault(); setSaving(true);
    await fetch(`${API}/api/sales/cities/${cityId}/contacts`, { method: 'POST', headers: apiHeaders(token), body: JSON.stringify(contactForm) });
    setContactForm({ name: '', title: '', email: '', phone: '', isPrimary: false });
    setMsg('Contact added'); load(); setSaving(false);
    setTimeout(() => setMsg(''), 3000);
  }

  async function deleteContact(contactId) {
    await fetch(`${API}/api/sales/cities/${cityId}/contacts/${contactId}`, { method: 'DELETE', headers: apiHeaders(token) });
    load();
  }

  async function generateEmail() {
    setGeneratingEmail(true); setEmailMsg('');
    const data = await fetch(`${API}/api/sales/generate-email`, {
      method: 'POST', headers: apiHeaders(token),
      body: JSON.stringify({ cityId, contactName: emailForm.contactName, customNotes: emailForm.customNotes })
    }).then(r => r.json());
    setEmailForm(f => ({ ...f, subject: data.subject || '', body: data.body || '' }));
    setGeneratingEmail(false);
  }

  async function sendEmail(method) {
    setSendingEmail(true); setEmailMsg('');
    if (method === 'copy') {
      navigator.clipboard.writeText(`Subject: ${emailForm.subject}\n\n${emailForm.body}`);
      await fetch(`${API}/api/sales/send-email`, { method: 'POST', headers: apiHeaders(token), body: JSON.stringify({ cityId, recipientEmail: emailForm.recipientEmail, recipientName: emailForm.contactName, subject: emailForm.subject, body: emailForm.body, aiGenerated: true, sendMethod: 'copy' }) });
      setEmailMsg('Copied to clipboard and logged!');
    } else {
      const r = await fetch(`${API}/api/sales/send-email`, { method: 'POST', headers: apiHeaders(token), body: JSON.stringify({ cityId, recipientEmail: emailForm.recipientEmail, recipientName: emailForm.contactName, subject: emailForm.subject, body: emailForm.body, aiGenerated: true, sendMethod: 'sendgrid' }) });
      const data = await r.json();
      setEmailMsg(data.success ? `Email sent to ${emailForm.recipientEmail}!` : data.error || 'Failed to send');
    }
    setSendingEmail(false); load();
  }

  async function claimCity() {
    await fetch(`${API}/api/sales/cities/${cityId}/claim`, { method: 'POST', headers: apiHeaders(token) });
    load();
  }

  if (loading) return <div className="cb-main" style={S.main}><p style={{ color: '#64748b' }}>Loading…</p></div>;
  if (!city?.id) return <div className="cb-main" style={S.main}><p>City not found.</p></div>;

  const badge = trialBadge(city.trialEndsAt, city.billingStatus);
  const stageColor = STAGE_COLORS[city.pipelineStage] || '#6b7280';

  return (
    <div className="cb-main" style={S.main}>
      {/* Header */}
      <div style={{ ...S.spaceBetween, marginBottom: 24 }}>
        <div>
          <button onClick={() => navigate('/cities')} style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 14, padding: 0, marginBottom: 8 }}>← Back to Cities</button>
          <h1 style={S.h1}>{city.name} {city.state && <span style={{ color: '#64748b', fontWeight: 400 }}>— {city.state}</span>}</h1>
          <div style={S.row}>
            <span style={{ ...S.badge, color: badge.color, background: badge.bg }}>{badge.label}</span>
            <span style={{ ...S.badge, color: stageColor, background: stageColor + '18' }}>{STAGES.find(s => s.key === city.pipelineStage)?.label || 'Prospect'}</span>
            {city.isCityworks && <span style={S.pill}>Cityworks</span>}
            {city.isAnnual && <span style={{ ...S.pill, background: '#dcfce7', color: '#16a34a' }}>Annual — {formatCurrency(city.arr)}</span>}
          </div>
        </div>
        <div style={S.row}>
          {!city.assignedRepId && user?.salesRole === 'sales_rep' && (
            <button onClick={claimCity} style={{ ...S.btn, ...S.btnAmber }}>Claim This City</button>
          )}
          {city.assignedRepId && city.assignedRepId !== user?.id && user?.salesRole === 'sales_rep' && (
            <button onClick={() => setTab('transfer')} style={{ ...S.btn, ...S.btnSecondary }}>Request Transfer</button>
          )}
        </div>
      </div>

      {msg && <div style={S.success}>{msg}</div>}

      {/* Stats row */}
      <div style={{ ...S.grid4, marginBottom: 24 }}>
        {[
          { label: 'Total Submissions', value: city.submissionCount?.toLocaleString() || '0' },
          { label: 'Last 30 Days', value: city.submissions30d?.toLocaleString() || '0' },
          { label: 'Trial Ends', value: formatDate(city.trialEndsAt) },
          { label: 'Assigned Rep', value: city.assignedRepName || 'Unassigned' },
        ].map(({ label, value }) => (
          <div key={label} style={S.statCardLight}>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#0f172a' }}>{value}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {['overview', 'email', 'activity', 'contacts'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{ ...S.tab, ...(tab === t ? S.tabActive : {}) }}>{t.charAt(0).toUpperCase() + t.slice(1)}</button>
        ))}
      </div>

      {/* OVERVIEW TAB */}
      {tab === 'overview' && (
        <div className="cb-grid2" style={S.grid2}>
          <div>
            {/* Pipeline Stage */}
            <div style={S.card}>
              <h3 style={S.h3}>Pipeline Stage</h3>
              <div style={{ marginBottom: 12 }}>
                <label style={S.label}>Stage</label>
                <select style={S.select} value={stageForm.stage} onChange={e => setStageForm(f => ({ ...f, stage: e.target.value }))}>
                  {STAGES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={S.label}>Competitive Displacement</label>
                <select style={S.select} value={stageForm.competitiveDisplacement} onChange={e => setStageForm(f => ({ ...f, competitiveDisplacement: e.target.value }))}>
                  <option value="">Not specified</option>
                  {['Phone/Manual', 'SeeClickFix', 'PublicStuff', 'CivicPlus', 'None (New Process)', 'Other'].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
              {['closed_won','closed_lost'].includes(stageForm.stage) && (
                <div style={{ marginBottom: 12 }}>
                  <label style={S.label}>{stageForm.stage === 'closed_won' ? 'Why did they buy?' : 'Why did they not buy?'}</label>
                  <input style={S.input} value={stageForm.winLossReason} onChange={e => setStageForm(f => ({ ...f, winLossReason: e.target.value }))} placeholder="Brief reason…" />
                </div>
              )}
              <div style={{ marginBottom: 16 }}>
                <label style={S.label}>Notes</label>
                <textarea style={{ ...S.textarea, minHeight: 80 }} value={stageForm.notes} onChange={e => setStageForm(f => ({ ...f, notes: e.target.value }))} placeholder="Stage notes…" />
              </div>
              <button onClick={saveStage} style={{ ...S.btn, ...S.btnPrimary }} disabled={saving}>{saving ? 'Saving…' : 'Save Stage'}</button>
            </div>

            {/* CivicBot Info */}
            <div style={S.card}>
              <h3 style={S.h3}>CivicBot Info</h3>
              {[
                ['Plan', city.planName || '—'],
                ['Billing', city.billingStatus],
                ['Billing Period', city.billingPeriod || '—'],
                ['Delivery', city.emailDelivery ? 'Email' : 'Cityworks'],
                ['ARR', city.isAnnual ? formatCurrency(city.arr) : 'Monthly (no commission)'],
                ['Joined', formatDate(city.createdAt)],
              ].map(([label, value]) => (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9', fontSize: 14 }}>
                  <span style={{ color: '#64748b' }}>{label}</span>
                  <span style={{ fontWeight: 500, color: '#1e293b' }}>{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Recent Activity */}
          <div style={S.card}>
            <h3 style={S.h3}>Recent Activity</h3>
            {city.activities?.length === 0 && <p style={{ color: '#64748b', fontSize: 14 }}>No activity yet.</p>}
            {city.activities?.slice(0, 10).map(a => (
              <div key={a.id} style={{ padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                <div style={{ ...S.spaceBetween, marginBottom: 2 }}>
                  <span style={{ ...S.pill, background: '#f1f5f9', fontSize: 11 }}>{a.type}</span>
                  <span style={{ fontSize: 11, color: '#94a3b8' }}>{formatDate(a.created_at)}</span>
                </div>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#1e293b', marginTop: 4 }}>{a.title}</div>
                {a.body && <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>{a.body}</div>}
                {a.rep_name && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>by {a.rep_name}</div>}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* EMAIL TAB */}
      {tab === 'email' && (
        <div style={S.card}>
          <h3 style={S.h3}>🤖 AI Trial Email Generator</h3>
          <p style={{ color: '#64748b', fontSize: 14, marginBottom: 20 }}>Generate a personalized trial follow-up email using AI, then send or copy it.</p>
          <div className="cb-grid2" style={S.grid2}>
            <div>
              <div style={{ marginBottom: 12 }}>
                <label style={S.label}>Contact Name</label>
                <input style={S.input} value={emailForm.contactName} onChange={e => setEmailForm(f => ({ ...f, contactName: e.target.value }))} placeholder="e.g. Jane Smith" />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={S.label}>Recipient Email</label>
                <input style={S.input} type="email" value={emailForm.recipientEmail} onChange={e => setEmailForm(f => ({ ...f, recipientEmail: e.target.value }))} placeholder="contact@city.gov" />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={S.label}>Additional Context (optional)</label>
                <textarea style={{ ...S.textarea, minHeight: 60 }} value={emailForm.customNotes} onChange={e => setEmailForm(f => ({ ...f, customNotes: e.target.value }))} placeholder="e.g. Spoke with John last week, interested in Cityworks integration…" />
              </div>
              <button onClick={generateEmail} style={{ ...S.btn, ...S.btnPrimary, width: '100%' }} disabled={generatingEmail}>{generatingEmail ? '✨ Generating…' : '✨ Generate AI Email'}</button>
            </div>
            <div>
              <div style={{ marginBottom: 12 }}>
                <label style={S.label}>Subject Line</label>
                <input style={S.input} value={emailForm.subject} onChange={e => setEmailForm(f => ({ ...f, subject: e.target.value }))} placeholder="AI will generate this…" />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={S.label}>Email Body</label>
                <textarea style={{ ...S.textarea, minHeight: 220 }} value={emailForm.body} onChange={e => setEmailForm(f => ({ ...f, body: e.target.value }))} placeholder="AI will generate this…" />
              </div>
              {emailMsg && <div style={emailMsg.includes('sent') || emailMsg.includes('Copied') ? S.success : S.error}>{emailMsg}</div>}
              <div style={S.row}>
                <button onClick={() => sendEmail('sendgrid')} style={{ ...S.btn, ...S.btnPrimary, flex: 1 }} disabled={sendingEmail || !emailForm.subject || !emailForm.recipientEmail}>{sendingEmail ? 'Sending…' : '📤 Send Email'}</button>
                <button onClick={() => sendEmail('copy')} style={{ ...S.btn, ...S.btnSecondary, flex: 1 }} disabled={!emailForm.subject}>📋 Copy</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ACTIVITY TAB */}
      {tab === 'activity' && (
        <div className="cb-grid2" style={S.grid2}>
          <div style={S.card}>
            <h3 style={S.h3}>Log Activity</h3>
            <form onSubmit={logActivity}>
              <div style={{ marginBottom: 12 }}>
                <label style={S.label}>Type</label>
                <select style={S.select} value={activityForm.type} onChange={e => setActivityForm(f => ({ ...f, type: e.target.value }))}>
                  {ACTIVITY_TYPES.map(t => <option key={t} value={t}>{t.replace('_', ' ')}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={S.label}>Title</label>
                <input style={S.input} value={activityForm.title} onChange={e => setActivityForm(f => ({ ...f, title: e.target.value }))} placeholder="Brief summary…" required />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={S.label}>Notes</label>
                <textarea style={{ ...S.textarea, minHeight: 80 }} value={activityForm.body} onChange={e => setActivityForm(f => ({ ...f, body: e.target.value }))} placeholder="Details…" />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={S.label}>Follow-up Date (optional)</label>
                <input style={S.input} type="date" value={activityForm.followUpDate} onChange={e => setActivityForm(f => ({ ...f, followUpDate: e.target.value }))} />
              </div>
              <button type="submit" style={{ ...S.btn, ...S.btnPrimary, width: '100%' }} disabled={saving}>{saving ? 'Logging…' : 'Log Activity'}</button>
            </form>
          </div>
          <div style={S.card}>
            <h3 style={S.h3}>Activity History</h3>
            {city.activities?.length === 0 && <p style={{ color: '#64748b', fontSize: 14 }}>No activities yet.</p>}
            {city.activities?.map(a => (
              <div key={a.id} style={{ padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                <div style={S.spaceBetween}>
                  <span style={{ ...S.pill, background: '#f1f5f9', fontSize: 11 }}>{a.type}</span>
                  <span style={{ fontSize: 11, color: '#94a3b8' }}>{formatDate(a.created_at)}</span>
                </div>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#1e293b', marginTop: 4 }}>{a.title}</div>
                {a.body && <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>{a.body}</div>}
                {a.follow_up_date && <div style={{ fontSize: 12, color: '#f59e0b', marginTop: 2 }}>📅 Follow-up: {formatDate(a.follow_up_date)}</div>}
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>by {a.rep_name || 'Admin'}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* CONTACTS TAB */}
      {tab === 'contacts' && (
        <div className="cb-grid2" style={S.grid2}>
          <div style={S.card}>
            <h3 style={S.h3}>Add Contact</h3>
            <form onSubmit={addContact}>
              {[['name','Name','text','Jane Smith',true],['title','Title','text','City Manager',false],['email','Email','email','jane@city.gov',false],['phone','Phone','tel','(555) 000-0000',false]].map(([field,label,type,ph,req]) => (
                <div key={field} style={{ marginBottom: 12 }}>
                  <label style={S.label}>{label}</label>
                  <input style={S.input} type={type} value={contactForm[field]} onChange={e => setContactForm(f => ({ ...f, [field]: e.target.value }))} placeholder={ph} required={req} />
                </div>
              ))}
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, color: '#374151', marginBottom: 16, cursor: 'pointer' }}>
                <input type="checkbox" checked={contactForm.isPrimary} onChange={e => setContactForm(f => ({ ...f, isPrimary: e.target.checked }))} />
                Set as primary contact
              </label>
              <button type="submit" style={{ ...S.btn, ...S.btnPrimary, width: '100%' }} disabled={saving}>{saving ? 'Adding…' : 'Add Contact'}</button>
            </form>
          </div>
          <div style={S.card}>
            <h3 style={S.h3}>Contacts ({city.contacts?.length || 0})</h3>
            {city.contacts?.length === 0 && <p style={{ color: '#64748b', fontSize: 14 }}>No contacts yet.</p>}
            {city.contacts?.map(c => (
              <div key={c.id} style={{ ...S.cardSm, ...S.spaceBetween }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{c.name} {c.is_primary ? <span style={{ ...S.badge, background: '#eff6ff', color: '#1d4ed8', fontSize: 11 }}>Primary</span> : null}</div>
                  {c.title && <div style={{ fontSize: 13, color: '#64748b' }}>{c.title}</div>}
                  {c.email && <div style={{ fontSize: 13, color: '#1e3a5f' }}>{c.email}</div>}
                  {c.phone && <div style={{ fontSize: 13, color: '#64748b' }}>{c.phone}</div>}
                </div>
                <button onClick={() => deleteContact(c.id)} style={{ ...S.btn, ...S.btnSm, background: '#fee2e2', color: '#dc2626', border: 'none' }}>Remove</button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── TEAM / USERS PAGE ────────────────────────────────────────────────────────

function UsersPage() {
  const { user, token } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('active');
  const [editUser, setEditUser] = useState(null);
  const [msg, setMsg] = useState('');
  const [showCreate, setShowCreate] = useState(false);
  const [createForm, setCreateForm] = useState({ name: '', email: '', phone: '', role: 'sales_rep', commissionRate: '15.0', password: '', confirmPassword: '' });
  const [creating, setCreating] = useState(false);
  const [createError, setCreateError] = useState('');
  const [createSuccess, setCreateSuccess] = useState('');
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const isSuperOrDir = ['super_admin', 'sales_director'].includes(user?.salesRole);
  const isSuperAdmin = user?.salesRole === 'super_admin';

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/sales/users`, { headers: apiHeaders(token) });
      if (res.status === 401) { setMsg('Session expired — please sign out and sign back in.'); setLoading(false); return; }
      const data = await res.json();
      setUsers(Array.isArray(data) ? data : []);
    } catch (e) { setMsg('Failed to load team: ' + e.message); }
    setLoading(false);
  }, [token]);

  useEffect(() => { load(); }, [load]);

  async function approveUser(id) {
    await fetch(`${API}/api/sales/users/${id}/approve`, { method: 'POST', headers: apiHeaders(token), body: JSON.stringify({}) });
    setMsg('User approved — welcome email sent'); load(); setTimeout(() => setMsg(''), 4000);
  }

  async function rejectUser(id) {
    await fetch(`${API}/api/sales/users/${id}/reject`, { method: 'POST', headers: apiHeaders(token), body: JSON.stringify({ reason: '' }) });
    setMsg('User rejected'); load(); setTimeout(() => setMsg(''), 3000);
  }

  async function saveUser(updates) {
    await fetch(`${API}/api/sales/users/${editUser.id}`, { method: 'PATCH', headers: apiHeaders(token), body: JSON.stringify(updates) });
    setEditUser(null); setMsg('User updated'); load(); setTimeout(() => setMsg(''), 3000);
  }

  async function disableUser(id) {
    await fetch(`${API}/api/sales/users/${id}`, { method: 'PATCH', headers: apiHeaders(token), body: JSON.stringify({ status: 'inactive' }) });
    setMsg('Rep disabled'); load(); setTimeout(() => setMsg(''), 3000);
  }

  async function enableUser(id) {
    await fetch(`${API}/api/sales/users/${id}`, { method: 'PATCH', headers: apiHeaders(token), body: JSON.stringify({ status: 'active' }) });
    setMsg('Rep re-enabled'); load(); setTimeout(() => setMsg(''), 3000);
  }

  async function deleteUser(id) {
    await fetch(`${API}/api/sales/users/${id}`, { method: 'DELETE', headers: apiHeaders(token) });
    setConfirmDeleteId(null); setMsg('Rep deleted'); load(); setTimeout(() => setMsg(''), 3000);
  }

  async function handleCreate(e) {
    e.preventDefault();
    if (createForm.password && createForm.password !== createForm.confirmPassword) {
      setCreateError('Passwords do not match'); return;
    }
    setCreating(true); setCreateError(''); setCreateSuccess('');
    try {
      const payload = { name: createForm.name, email: createForm.email, phone: createForm.phone, role: createForm.role, commissionRate: createForm.commissionRate };
      if (createForm.password) payload.password = createForm.password;
      const r = await fetch(`${API}/api/sales/users/create`, { method: 'POST', headers: apiHeaders(token), body: JSON.stringify(payload) });
      const data = await r.json();
      if (!r.ok) { setCreateError(data.error || 'Failed to create'); setCreating(false); return; }
      if (data.passwordSet) {
        setCreateSuccess(`direct:${data.message}`);
      } else {
        setCreateSuccess(`link:${data.setPasswordUrl}`);
      }
      setCreateForm({ name: '', email: '', phone: '', role: 'sales_rep', commissionRate: '15.0', password: '', confirmPassword: '' });
      load();
    } catch (e) { setCreateError('Network error'); }
    setCreating(false);
  }

  const pending = users.filter(u => u.status === 'pending');
  const active = users.filter(u => u.status === 'active');
  const inactive = users.filter(u => u.status === 'inactive');

  if (loading) return <div className="cb-main" style={S.main}><p style={{ color: '#64748b' }}>Loading team…</p></div>;

  return (
    <div className="cb-main" style={S.main}>
      <div style={{ ...S.spaceBetween, marginBottom: 24 }}>
        <h1 style={{ ...S.h1, margin: 0 }}>Sales Team</h1>
        {isSuperAdmin && <button style={{ ...S.btn, ...S.btnPrimary }} onClick={() => { setShowCreate(true); setCreateError(''); setCreateSuccess(''); }}>+ Add Team Member</button>}
      </div>
      {msg && <div style={S.success}>{msg}</div>}

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[['pending', `Pending (${pending.length})`], ['active', `Active (${active.length})`], ['inactive', `Inactive (${inactive.length})`]].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{ ...S.tab, ...(tab === key ? S.tabActive : {}) }}>{label}</button>
        ))}
      </div>

      {tab === 'pending' && (
        <div style={S.card}>
          {pending.length === 0 ? <p style={{ color: '#64748b' }}>No pending signups.</p> : pending.map(u => (
            <div key={u.id} style={{ ...S.cardSm, ...S.spaceBetween }}>
              <div>
                <div style={{ fontWeight: 600 }}>{u.name}</div>
                <div style={{ fontSize: 13, color: '#64748b' }}>{u.email} {u.phone && `· ${u.phone}`}</div>
                <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>Applied {formatDate(u.createdAt)}</div>
              </div>
              <div style={S.row}>
                <button onClick={() => approveUser(u.id)} style={{ ...S.btn, ...S.btnSm, ...S.btnSuccess }}>Approve</button>
                <button onClick={() => rejectUser(u.id)} style={{ ...S.btn, ...S.btnSm, ...S.btnDanger }}>Reject</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {(tab === 'active' || tab === 'inactive') && (
        <div style={S.card}>
          <table style={S.table}>
            <thead>
              <tr>{['Name', 'Role', 'Commission Rate', 'Email', 'Phone', ...(isSuperOrDir ? ['Actions'] : [])].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {(tab === 'active' ? active : inactive).map(u => (
                <tr key={u.id}>
                  <td style={S.td}><div style={{ fontWeight: 600 }}>{u.name}</div></td>
                  <td style={S.td}><span style={S.pill}>{u.salesRole?.replace('sales_', '').replace('_', ' ')}</span></td>
                  <td style={S.td}>{u.commissionRate != null ? `${(u.commissionRate * 100).toFixed(1)}%` : '—'}</td>
                  <td style={S.td}>{u.email}</td>
                  <td style={S.td}>{u.phone || '—'}</td>
                  {isSuperOrDir && <td style={S.td}>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {tab === 'active' && <button onClick={() => setEditUser(u)} style={{ ...S.btn, ...S.btnSm, ...S.btnSecondary }}>Edit</button>}
                      {isSuperAdmin && tab === 'active' && (
                        <button onClick={() => disableUser(u.id)} style={{ ...S.btn, ...S.btnSm, background: '#fef3c7', color: '#92400e', border: '1px solid #fcd34d' }}>Disable</button>
                      )}
                      {isSuperAdmin && tab === 'inactive' && (
                        <button onClick={() => enableUser(u.id)} style={{ ...S.btn, ...S.btnSm, ...S.btnSuccess }}>Re-enable</button>
                      )}
                      {isSuperAdmin && (
                        confirmDeleteId === u.id ? (
                          <span style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                            <span style={{ fontSize: 12, color: '#dc2626', fontWeight: 600 }}>Delete?</span>
                            <button onClick={() => deleteUser(u.id)} style={{ ...S.btn, ...S.btnSm, ...S.btnDanger }}>Yes</button>
                            <button onClick={() => setConfirmDeleteId(null)} style={{ ...S.btn, ...S.btnSm, ...S.btnSecondary }}>No</button>
                          </span>
                        ) : (
                          <button onClick={() => setConfirmDeleteId(u.id)} style={{ ...S.btn, ...S.btnSm, ...S.btnDanger }}>Delete</button>
                        )
                      )}
                    </div>
                  </td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Edit modal */}
      {editUser && isSuperOrDir && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ ...S.card, width: 460, margin: 0 }}>
            <h3 style={S.h3}>Edit {editUser.name}</h3>
            <EditUserForm user={editUser} onSave={saveUser} onCancel={() => setEditUser(null)} />
          </div>
        </div>
      )}

      {/* Create User modal */}
      {showCreate && isSuperAdmin && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ ...S.card, width: 500, margin: 0 }}>
            <div style={{ ...S.spaceBetween, marginBottom: 20 }}>
              <h3 style={{ ...S.h3, margin: 0 }}>Add Team Member</h3>
              <button onClick={() => setShowCreate(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#64748b' }}>✕</button>
            </div>
            {createError && <div style={S.error}>{createError}</div>}
            {createSuccess ? (
              <div>
                {createSuccess.startsWith('direct:') ? (
                  <div style={S.success}>{createSuccess.replace('direct:', '')}</div>
                ) : (
                  <div>
                    <div style={S.success}>User created — invite email sent!</div>
                    <div style={{ marginTop: 12, padding: 12, background: '#f8fafc', borderRadius: 8, fontSize: 13, wordBreak: 'break-all', color: '#1e3a5f' }}>
                      <div style={{ fontWeight: 600, marginBottom: 4 }}>Set-password link (share directly if email isn't delivered):</div>
                      {createSuccess.replace('link:', '')}
                    </div>
                  </div>
                )}
                <button style={{ ...S.btn, ...S.btnSecondary, width: '100%', marginTop: 16 }} onClick={() => { setShowCreate(false); setCreateSuccess(''); }}>Done</button>
              </div>
            ) : (
              <form onSubmit={handleCreate}>
                <div className="cb-grid2" style={S.grid2}>
                  <div>
                    <label style={S.label}>Full Name *</label>
                    <input style={S.input} required value={createForm.name} onChange={e => setCreateForm(f => ({ ...f, name: e.target.value }))} />
                  </div>
                  <div>
                    <label style={S.label}>Email *</label>
                    <input style={S.input} type="email" required value={createForm.email} onChange={e => setCreateForm(f => ({ ...f, email: e.target.value }))} />
                  </div>
                </div>
                <div className="cb-grid2" style={S.grid2}>
                  <div>
                    <label style={S.label}>Phone</label>
                    <input style={S.input} type="tel" value={createForm.phone} onChange={e => setCreateForm(f => ({ ...f, phone: e.target.value }))} />
                  </div>
                  <div>
                    <label style={S.label}>Role</label>
                    <select style={S.select} value={createForm.role} onChange={e => setCreateForm(f => ({ ...f, role: e.target.value }))}>
                      <option value="sales_rep">Sales Rep</option>
                      <option value="sales_manager">Sales Manager</option>
                      <option value="sales_director">Sales Director</option>
                    </select>
                  </div>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <label style={S.label}>Commission Rate (%)</label>
                  <input style={S.input} type="number" step="0.1" min="0" max="100" value={createForm.commissionRate} onChange={e => setCreateForm(f => ({ ...f, commissionRate: e.target.value }))} />
                </div>
                <hr style={S.divider} />
                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#1e293b', marginBottom: 4 }}>Set Password (Optional)</div>
                  <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>
                    Leave blank to send a set-password email to the rep. Fill in to set a password directly — useful when the rep doesn't have a company email yet.
                  </div>
                </div>
                <div className="cb-grid2" style={S.grid2}>
                  <div>
                    <label style={S.label}>Password</label>
                    <input style={S.input} type="password" value={createForm.password} onChange={e => setCreateForm(f => ({ ...f, password: e.target.value }))} placeholder="Min 8 characters" autoComplete="new-password" />
                  </div>
                  <div>
                    <label style={S.label}>Confirm Password</label>
                    <input style={S.input} type="password" value={createForm.confirmPassword} onChange={e => setCreateForm(f => ({ ...f, confirmPassword: e.target.value }))} placeholder="Repeat password" autoComplete="new-password" />
                  </div>
                </div>
                <div style={{ fontSize: 12, color: '#64748b', marginBottom: 20, marginTop: 4 }}>
                  {createForm.password ? (createForm.password === createForm.confirmPassword ? '✅ Passwords match — invite email will NOT be sent' : '❌ Passwords do not match') : 'No password set — invite email will be sent upon creation'}
                </div>
                <div style={{ display: 'flex', gap: 12 }}>
                  <button type="submit" style={{ ...S.btn, ...S.btnPrimary, flex: 1 }} disabled={creating}>
                    {creating ? 'Creating…' : createForm.password ? 'Create with Password' : 'Create & Send Invite'}
                  </button>
                  <button type="button" style={{ ...S.btn, ...S.btnSecondary }} onClick={() => setShowCreate(false)}>Cancel</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function EditUserForm({ user, onSave, onCancel }) {
  const [form, setForm] = useState({ name: user.name, email: user.email, phone: user.phone || '', role: user.salesRole, commissionRate: (user.commissionRate * 100).toFixed(1), status: user.status });
  return (
    <div>
      {[['name','Name','text'],['email','Email','email'],['phone','Phone','tel']].map(([field,label,type]) => (
        <div key={field} style={{ marginBottom: 12 }}>
          <label style={S.label}>{label}</label>
          <input style={S.input} type={type} value={form[field]} onChange={e => setForm(f => ({ ...f, [field]: e.target.value }))} />
        </div>
      ))}
      <div style={{ marginBottom: 12 }}>
        <label style={S.label}>Role</label>
        <select style={S.select} value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))}>
          {['sales_rep','sales_manager','sales_director'].map(r => <option key={r} value={r}>{r.replace('sales_','').replace('_',' ')}</option>)}
        </select>
      </div>
      <div style={{ marginBottom: 12 }}>
        <label style={S.label}>Commission Rate (%)</label>
        <input style={S.input} type="number" step="0.1" min="0" max="100" value={form.commissionRate} onChange={e => setForm(f => ({ ...f, commissionRate: e.target.value }))} />
      </div>
      <div style={{ marginBottom: 20 }}>
        <label style={S.label}>Status</label>
        <select style={S.select} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
          {['active','inactive'].map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div style={S.row}>
        <button onClick={() => onSave({ ...form, commissionRate: parseFloat(form.commissionRate) / 100, role: form.role })} style={{ ...S.btn, ...S.btnPrimary, flex: 1 }}>Save Changes</button>
        <button onClick={onCancel} style={{ ...S.btn, ...S.btnSecondary, flex: 1 }}>Cancel</button>
      </div>
    </div>
  );
}

// ─── CUSTOMERS PAGE ───────────────────────────────────────────────────────────

function CustomersPage() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState('');
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all'); // all | valid | expired
  const [sortBy, setSortBy] = useState('name'); // name | expiry | arr

  const loadCustomers = useCallback(async () => {
    setLoading(true); setFetchError('');
    try {
      const r = await fetch(`${API}/api/sales/customers`, { headers: apiHeaders(token) });
      const data = await r.json();
      if (Array.isArray(data)) {
        setCustomers(data);
      } else {
        const msg = data?.detail || data?.error || JSON.stringify(data);
        setFetchError(`API error: ${msg}`);
        console.error('[Customers] API error:', data);
      }
    } catch (e) {
      setFetchError(`Network error: ${e.message}`);
      console.error('[Customers] Fetch error:', e);
    }
    setLoading(false);
  }, [token]);

  useEffect(() => { loadCustomers(); }, [loadCustomers]);

  const filtered = customers
    .filter(c => {
      const matchSearch = !search ||
        c.name.toLowerCase().includes(search.toLowerCase()) ||
        (c.state || '').toLowerCase().includes(search.toLowerCase()) ||
        (c.contactName || '').toLowerCase().includes(search.toLowerCase()) ||
        (c.contactEmail || '').toLowerCase().includes(search.toLowerCase());
      const matchStatus = statusFilter === 'all' || c.subscriptionStatus.toLowerCase() === statusFilter;
      return matchSearch && matchStatus;
    })
    .sort((a, b) => {
      if (sortBy === 'expiry') {
        const ad = a.expiryDate || '9999'; const bd = b.expiryDate || '9999';
        return ad < bd ? -1 : ad > bd ? 1 : 0;
      }
      if (sortBy === 'arr') {
        const av = a.arr || a.subscriptionAmount || 0;
        const bv = b.arr || b.subscriptionAmount || 0;
        return bv - av;
      }
      return a.name.localeCompare(b.name);
    });

  function displayAmount(c) {
    const amt = c.subscriptionAmount;
    if (!amt) return '—';
    return '$' + Number(amt).toLocaleString() + (c.isAnnual ? '/yr' : '/mo');
  }

  function exportCSV() {
    const headers = ['City', 'State', 'Products', 'Plan', 'Status', 'Expiry Date', 'Contact Name', 'Contact Email', 'Contact Phone', 'Subscription Amount', 'Billing Period', 'Rep'];
    const rows = filtered.map(c => [
      c.name, c.state || '', [c.planName, c.hasAnswers ? '+ Answers' : ''].filter(Boolean).join(' '), c.planName || '',
      c.subscriptionStatus, c.expiryDate ? formatDate(c.expiryDate) : '—',
      c.contactName || '', c.contactEmail || '', c.contactPhone || '',
      c.subscriptionAmount ? '$' + Number(c.subscriptionAmount).toLocaleString() : '', c.billingPeriod || '', c.repName || '',
    ]);
    const nl = String.fromCharCode(10);
    const csv = [headers].concat(rows).map(r => r.map(v => '"' + String(v).replace(/"/g, '""') + '"').join(',')).join(nl);
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url;
    a.download = 'customers-' + new Date().toISOString().slice(0, 10) + '.csv'; a.click();
    URL.revokeObjectURL(url);
  }

  const validCount = customers.filter(c => c.subscriptionStatus === 'Valid').length;
  const expiredCount = customers.filter(c => c.subscriptionStatus === 'Expired').length;
  const totalArr = customers.filter(c => c.isAnnual).reduce((s, c) => s + (c.subscriptionAmount || 0), 0);

  if (loading) return <div className="cb-main" style={S.main}><p style={{ color: '#64748b' }}>Loading customers…</p></div>;

  return (
    <div className="cb-main" style={S.main}>
      <div style={{ ...S.spaceBetween, marginBottom: 24 }}>
        <div>
          <h1 style={S.h1}>Current Customers</h1>
          <p style={{ color: '#64748b', margin: 0, fontSize: 14 }}>Active paid subscriptions — track renewals and retention</p>
        </div>
        <div style={S.row}>
          <button onClick={loadCustomers} style={{ ...S.btn, ...S.btnSm, ...S.btnSecondary }}>↻ Refresh</button>
          <button onClick={exportCSV} style={{ ...S.btn, ...S.btnSecondary }}>📥 Export CSV</button>
        </div>
      </div>
      {fetchError && <div style={S.error}>{fetchError}</div>}

      {/* Summary stats */}
      <div style={{ ...S.grid4, marginBottom: 24 }}>
        <div style={S.statCard}>
          <div style={{ fontSize: 28, fontWeight: 700 }}>{customers.length}</div>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', marginTop: 4 }}>Total Customers</div>
        </div>
        <div style={{ ...S.statCardLight }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#16a34a' }}>{validCount}</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>Active / Valid</div>
        </div>
        <div style={{ ...S.statCardLight }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: expiredCount > 0 ? '#dc2626' : '#94a3b8' }}>{expiredCount}</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>Expired</div>
        </div>
        <div style={S.statCardLight}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#1e3a5f' }}>{totalArr > 0 ? '$' + Number(totalArr).toLocaleString() : '—'}</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>Annual ARR (tracked)</div>
        </div>
      </div>

      {/* Filters */}
      <div style={{ ...S.row, marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
        <input style={{ ...S.input, maxWidth: 300 }} placeholder="Search city, contact, email…" value={search} onChange={e => setSearch(e.target.value)} />
        <div style={S.row}>
          {[['all', 'All'], ['valid', '✅ Valid'], ['expired', '⚠️ Expired']].map(([val, label]) => (
            <button key={val} onClick={() => setStatusFilter(val)} style={{ ...S.btn, ...S.btnSm, ...(statusFilter === val ? S.btnPrimary : S.btnSecondary) }}>{label}</button>
          ))}
        </div>
        <select style={{ ...S.select, maxWidth: 180 }} value={sortBy} onChange={e => setSortBy(e.target.value)}>
          <option value="name">Sort: City Name</option>
          <option value="expiry">Sort: Expiry Date</option>
          <option value="arr">Sort: Amount (High→Low)</option>
        </select>
        <span style={{ color: '#64748b', fontSize: 14, marginLeft: 'auto' }}>{filtered.length} customer{filtered.length !== 1 ? 's' : ''}</span>
      </div>

      {/* Table */}
      <div style={{ ...S.card, padding: 0, overflowX: 'auto' }}>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>City</th>
              <th style={S.th}>Subscription Products</th>
              <th style={S.th}>Status</th>
              <th style={S.th}>Expiry / Renewal</th>
              <th style={S.th}>Admin Contact</th>
              <th style={S.th}>Amount</th>
              <th style={S.th}>ARR / Billing</th>
              <th style={S.th}>Rep</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={8} style={{ ...S.td, textAlign: 'center', color: '#64748b', padding: 40 }}>No customers match your filters.</td></tr>
            )}
            {filtered.map(c => {
              const expired = c.subscriptionStatus === 'Expired';
              const expiringSoon = !expired && c.expiryDate && (new Date(c.expiryDate) - Date.now()) <= 30 * 24 * 60 * 60 * 1000;
              return (
                <tr key={c.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/cities/${c.id}`)}>
                  {/* City */}
                  <td style={S.td}>
                    <div style={{ fontWeight: 600, color: '#0f172a' }}>{c.name}</div>
                    {c.state && <div style={{ fontSize: 12, color: '#64748b' }}>{c.state}</div>}
                  </td>

                  {/* Products */}
                  <td style={S.td}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <span style={{ ...S.pill, background: '#eff6ff', color: '#1d4ed8', fontSize: 11 }}>
                        CivicBot {c.isCityworks ? '(CW)' : '(Email)'}
                      </span>
                      {c.hasAnswers && (
                        <span style={{ ...S.pill, background: '#f5f3ff', color: '#7c3aed', fontSize: 11 }}>Answers Q&A</span>
                      )}
                    </div>
                  </td>

                  {/* Status */}
                  <td style={S.td}>
                    <span style={{ ...S.badge, color: expired ? '#dc2626' : '#16a34a', background: expired ? '#fee2e2' : '#dcfce7' }}>
                      {expired ? '⚠️ Expired' : '✅ Valid'}
                    </span>
                  </td>

                  {/* Expiry */}
                  <td style={S.td}>
                    {c.expiryDate ? (
                      <div style={{ fontSize: 13, fontWeight: 600, color: expired ? '#dc2626' : expiringSoon ? '#d97706' : '#1e293b' }}>
                        {formatDate(c.expiryDate)}
                      </div>
                    ) : <span style={{ color: '#94a3b8' }}>—</span>}
                    {expiringSoon && !expired && <div style={{ fontSize: 11, color: '#d97706', marginTop: 2 }}>Renewing soon</div>}
                    {expired && <div style={{ fontSize: 11, color: '#dc2626', marginTop: 2 }}>Needs renewal</div>}
                  </td>

                  {/* Admin Contact */}
                  <td style={S.td}>
                    {c.contactName && <div style={{ fontWeight: 600, fontSize: 13 }}>{c.contactName}</div>}
                    {c.contactEmail && <div style={{ fontSize: 12, color: '#1e3a5f' }}>{c.contactEmail}</div>}
                    {c.contactPhone && <div style={{ fontSize: 12, color: '#64748b' }}>{c.contactPhone}</div>}
                    {!c.contactName && !c.contactEmail && <span style={{ color: '#94a3b8', fontSize: 13 }}>—</span>}
                  </td>

                  {/* Subscription Amount */}
                  <td style={S.td}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#0f172a' }}>{displayAmount(c)}</div>
                    <div style={{ fontSize: 11, color: '#64748b' }}>{c.isManuallyActivated ? 'Manual' : 'Stripe'}</div>
                  </td>

                  {/* ARR / Billing */}
                  <td style={S.td}>
                    <span style={{ ...S.badge, color: c.isAnnual ? '#16a34a' : '#6b7280', background: c.isAnnual ? '#dcfce720' : '#f1f5f9', border: '1px solid ' + (c.isAnnual ? '#16a34a30' : '#e2e8f0') }}>
                      {c.isAnnual ? 'Annual' : 'Monthly'}
                    </span>
                  </td>

                  {/* Rep */}
                  <td style={S.td}>
                    <span style={{ fontSize: 13, color: c.repName ? '#1e293b' : '#94a3b8' }}>{c.repName || 'Unassigned'}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ─── INBOX PAGE ──────────────────────────────────────────────────────────────

function InboxPage() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState({ emails: [], unreadCount: 0 });
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all | unread
  const [markingAll, setMarkingAll] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/sales/inbox`, { headers: apiHeaders(token) });
      const d = await r.json();
      setData((d && Array.isArray(d.emails)) ? d : { emails: [], unreadCount: 0 });
    } catch(e) {}
    setLoading(false);
  }, [token]);

  useEffect(() => { load(); }, [load]);

  async function markAllRead() {
    setMarkingAll(true);
    try {
      await fetch(`${API}/api/sales/inbox/mark-all-read`, { method: 'POST', headers: apiHeaders(token) });
      await load();
    } catch(e) {}
    setMarkingAll(false);
  }

  async function markRead(emailId) {
    await fetch(`${API}/api/sales/emails/${emailId}/read`, { method: 'PATCH', headers: apiHeaders(token) });
    setData(prev => ({
      ...prev,
      emails: prev.emails.map(e => e.id === emailId ? { ...e, read_at: new Date().toISOString() } : e),
      unreadCount: Math.max(0, prev.unreadCount - 1),
    }));
  }

  const stageBadge = (stage) => {
    const map = {
      prospect:  { label: 'Prospect',  bg: '#f1f5f9', color: '#64748b' },
      contacted: { label: 'Contacted', bg: '#dbeafe', color: '#1d4ed8' },
      demo:      { label: 'Demo',      bg: '#fef3c7', color: '#d97706' },
      trial:     { label: 'Trial',     bg: '#fee2e2', color: '#dc2626' },
      close:     { label: 'Close',     bg: '#dcfce7', color: '#16a34a' },
      customer:  { label: 'Customer',  bg: '#dcfce7', color: '#16a34a' },
      nurture:   { label: 'Nurture',   bg: '#f5f3ff', color: '#7c3aed' },
      lost:      { label: 'Lost',      bg: '#f1f5f9', color: '#94a3b8' },
    };
    return map[stage?.toLowerCase()] || { label: stage || '—', bg: '#f1f5f9', color: '#64748b' };
  };

  const filtered = (data.emails || []).filter(e => filter === 'unread' ? !e.read_at : true);

  return (
    <div className="cb-main" style={S.main}>
      <div style={{ ...S.spaceBetween, marginBottom: 24 }}>
        <div>
          <h1 style={S.h1}>📬 Inbox</h1>
          <p style={{ color: '#64748b', margin: 0 }}>
            {data.unreadCount > 0 ? `${data.unreadCount} unread repl${data.unreadCount === 1 ? 'y' : 'ies'}` : 'All caught up'} · {data.emails.length} total
          </p>
        </div>
        {data.unreadCount > 0 && (
          <button onClick={markAllRead} disabled={markingAll} style={{ ...S.btn, ...S.btnSecondary }}>
            {markingAll ? 'Marking…' : 'Mark all read'}
          </button>
        )}
      </div>

      {/* Filter pills */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[['all', 'All'], ['unread', 'Unread']].map(([key, label]) => (
          <button key={key} onClick={() => setFilter(key)}
            style={{ ...S.btn, ...(filter === key ? S.btnPrimary : S.btnSecondary), ...S.btnSm }}>
            {label}
            {key === 'unread' && data.unreadCount > 0 && (
              <span style={{ marginLeft: 6, background: 'rgba(255,255,255,0.25)', borderRadius: 20, padding: '0 6px', fontSize: 10, fontWeight: 700 }}>{data.unreadCount}</span>
            )}
          </button>
        ))}
      </div>

      {loading ? (
        <p style={{ color: '#64748b' }}>Loading…</p>
      ) : filtered.length === 0 ? (
        <div style={S.card}>
          <p style={{ color: '#64748b', textAlign: 'center', padding: '24px 0' }}>
            {filter === 'unread' ? '✅ No unread replies.' : '📭 No replies yet. Send emails via a Lead to start tracking replies.'}
          </p>
        </div>
      ) : (
        <div style={S.card}>
          {filtered.map((e, i) => {
            const isUnread = !e.read_at;
            const initials = (e.sent_by_name || e.sent_by || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
            const snippet = (e.body || '').replace(/\n/g, ' ').trim().slice(0, 120);
            const sb = stageBadge(e.pipeline_stage);
            return (
              <div key={e.id}
                onClick={() => {
                  if (isUnread) markRead(e.id);
                  navigate(`/leads/${e.lead_id}?tab=email`);
                }}
                style={{
                  display: 'flex', alignItems: 'flex-start', gap: 12, padding: '14px 0',
                  borderBottom: i < filtered.length - 1 ? '1px solid #f1f5f9' : 'none',
                  cursor: 'pointer', background: isUnread ? '#f8faff' : 'transparent',
                  borderRadius: 6, paddingLeft: isUnread ? 10 : 0, paddingRight: isUnread ? 10 : 0,
                  marginLeft: isUnread ? -10 : 0, marginRight: isUnread ? -10 : 0,
                }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: isUnread ? '#3b82f6' : 'transparent', flexShrink: 0, marginTop: 6 }} />
                <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#1e3a5f', color: '#93c5fd', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, flexShrink: 0 }}>{initials}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
                    <span style={{ fontWeight: isUnread ? 700 : 600, fontSize: 14, color: '#0f172a' }}>{e.sent_by_name || e.sent_by}</span>
                    <span style={{ fontSize: 12, color: '#64748b' }}>· {e.city_name}</span>
                    {e.owner_rep_name && <span style={{ fontSize: 11, color: '#94a3b8' }}>· {e.owner_rep_name}</span>}
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{e.subject}</div>
                  <div style={{ fontSize: 12, color: '#64748b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{snippet || '(no body)'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6, flexShrink: 0 }}>
                  <span style={{ fontSize: 11, color: '#94a3b8' }}>{formatDateTime(e.sent_at)}</span>
                  {e.pipeline_stage && (
                    <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: sb.bg, color: sb.color, textTransform: 'capitalize' }}>{sb.label}</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ ...S.card, marginTop: 20, background: '#f8fafc', border: '1px dashed #cbd5e1' }}>
        <h4 style={{ fontSize: 13, fontWeight: 700, color: '#374151', marginBottom: 6 }}>💡 How reply tracking works</h4>
        <p style={{ fontSize: 13, color: '#64748b', lineHeight: 1.6, margin: 0 }}>
          When you send an email via the portal, a unique reply-to address is set on the message. When the lead hits Reply in their email client, it routes back here automatically — no manual logging needed.
          Replies appear in the lead's Email tab and in this Inbox. <strong style={{ color: '#374151' }}>Note:</strong> emails copied to clipboard and sent from your own email client are not tracked automatically.
        </p>
      </div>
    </div>
  );
}

// ─── COMMISSION PAGE ──────────────────────────────────────────────────────────

function CommissionPage() {
  const { token, user } = useAuth();
  const isSuperAdmin = user?.salesRole === 'super_admin';
  const isSuperOrDir = isSuperAdmin || user?.salesRole === 'sales_director';
  const [view, setView] = useState('month'); // 'year' | 'month'
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [togglingPaid, setTogglingPaid] = useState({});
  const [estData, setEstData] = useState(null);
  const [estRepFilter, setEstRepFilter] = useState('mine'); // 'mine' | 'team'

  async function load() {
    setLoading(true);
    setData(null);
    try {
      const url = view === 'year'
        ? `${API}/api/sales/commission?view=year&year=${year}`
        : `${API}/api/sales/commission?view=month&month=${month}`;
      const result = await fetch(url, { headers: apiHeaders(token) }).then(r => r.json());
      setData(result);
    } catch (e) {
      console.error('[Commission] load error:', e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetch(`${API}/api/sales/commission/estimated`, { headers: apiHeaders(token) })
      .then(r => r.json()).then(d => { if (d.pipeline) setEstData(d); })
      .catch(() => {});
  }, [token]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [view, month, year]);

  async function togglePaid(dealId, currentlyPaid) {
    setTogglingPaid(p => ({ ...p, [dealId]: true }));
    await fetch(`${API}/api/sales/deals/${dealId}/mark-paid`, {
      method: 'PATCH', headers: apiHeaders(token),
      body: JSON.stringify({ paid: !currentlyPaid }),
    });
    setTogglingPaid(p => ({ ...p, [dealId]: false }));
    load();
  }

  function exportCsv() {
    if (!data) return;
    const rows = [['Rep', 'FY Total', 'Q1', 'Q2', 'Q3', 'Q4']];
    data.reps.forEach(r => rows.push([r.repName, r.yearTotal, ...r.quarters.map(q => q.grandTotal)]));
    const csv = rows.map(r => r.join(',')).join('\n');
    const a = document.createElement('a'); a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    a.download = `commission-${year}.csv`; a.click();
  }

  function printPdf() { window.print(); }

  function RepDealTable({ deals, volumeBonus, repId }) {
    if (!deals?.length) return null;
    const cols = [
      ['City', null],
      ['Plan', null],
      ['ARR', 'Annual contract value for this deal. Commission is only calculated on annual plans.'],
      ['Base', 'ARR × commission rate for this deal.'],
      ['Speed Bonus', '+$150 if closed within 7 days of trial start; +$75 for days 8–14. $0 after day 14.'],
      ['Deal Total', 'Base commission + speed bonus for this deal.'],
      ['Closed', null],
      ...(isSuperAdmin ? [['Paid', 'Mark this deal\'s commission as disbursed to the rep.']] : []),
    ];
    return (
      <div style={{ marginTop: 12 }}>
        <hr style={S.divider} />
        <table style={S.table}>
          <thead>
            <tr>
              {cols.map(([h, tip]) => (
                <th key={h} style={S.th}>
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>{h}{tip && <InfoTip text={tip} />}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {deals.map((d, i) => (
              <tr key={d.id || i} style={d.commissionPaidAt ? { opacity: 0.55 } : {}}>
                <td style={S.td}>{d.cityId}</td>
                <td style={S.td}>{d.planName}</td>
                <td style={S.td}>{formatCurrency(d.arr)}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></td>
                <td style={S.td}>{formatCurrency(d.base)}</td>
                <td style={S.td}>{d.speedBonus > 0 ? <span style={{ color: '#d97706', fontWeight: 600 }}>+{formatCurrency(d.speedBonus)}</span> : '—'}</td>
                <td style={{ ...S.td, fontWeight: 700, color: '#1e3a5f' }}>{formatCurrency(d.base + (d.speedBonus || 0))}</td>
                <td style={S.td}>{formatDate(d.closedAt)}</td>
                {isSuperAdmin && (
                  <td style={S.td}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        checked={!!d.commissionPaidAt}
                        disabled={!!togglingPaid[d.id]}
                        onChange={() => togglePaid(d.id, !!d.commissionPaidAt)}
                      />
                      {d.commissionPaidAt
                        ? <span style={{ color: '#16a34a', fontSize: 12, fontWeight: 600 }}>Paid {formatDate(d.commissionPaidAt)}{d.commissionPaidNote ? ` · ${d.commissionPaidNote}` : ''}</span>
                        : <span style={{ color: '#64748b', fontSize: 12 }}>Unpaid</span>}
                    </label>
                  </td>
                )}
              </tr>
            ))}
            {volumeBonus > 0 && (
              <tr style={{ background: '#fffbeb', borderTop: '2px solid #fcd34d' }}>
                <td colSpan={cols.length - (isSuperAdmin ? 2 : 1)} style={{ ...S.td, color: '#92400e', fontWeight: 600, textAlign: 'right', fontSize: 12 }}>
                  🏆 Volume Bonus ({deals.length} deal{deals.length !== 1 ? 's' : ''} this month)
                </td>
                <td style={{ ...S.td, fontWeight: 800, color: '#d97706' }}>+{formatCurrency(volumeBonus)}</td>
                {isSuperAdmin && <td style={S.td} />}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }

  const periodLabel = view === 'year'
    ? year
    : new Date(month + '-01').toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });

  return (
    <div className="cb-main" style={S.main}>
      <style>{`@media print { .no-print { display: none !important; } }`}</style>

      <div style={{ ...S.spaceBetween, marginBottom: 24 }} className="no-print">
        <h1 style={S.h1}>Commission Dashboard</h1>
        <div style={S.row}>
          {/* View toggle */}
          <div style={{ display: 'flex', borderRadius: 8, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
            {[['month', 'Monthly'], ['year', 'Yearly']].map(([v, label]) => (
              <button key={v} onClick={() => setView(v)} style={{ ...S.btn, borderRadius: 0, border: 'none', background: view === v ? '#1e3a5f' : '#fff', color: view === v ? '#fff' : '#475569', padding: '6px 16px', fontSize: 13 }}>{label}</button>
            ))}
          </div>
          {view === 'month'
            ? <input style={{ ...S.input, maxWidth: 160 }} type="month" value={month} onChange={e => setMonth(e.target.value)} />
            : <input style={{ ...S.input, maxWidth: 100 }} type="number" min="2024" max="2030" value={year} onChange={e => setYear(e.target.value)} />
          }
          {view === 'year' && <button onClick={exportCsv} style={{ ...S.btn, ...S.btnSecondary }} disabled={!data}>Export CSV</button>}
          {view === 'year' && isSuperOrDir && <button onClick={printPdf} style={{ ...S.btn, ...S.btnSecondary }} disabled={!data}>🖨 Print PDF</button>}
        </div>
      </div>

      {/* ── Estimated Commissions ── */}
      {estData && (() => {
        const myId = user?.id || 'super_admin';
        const pipeline = estRepFilter === 'mine'
          ? estData.pipeline.filter(p => p.repId === myId)
          : estData.pipeline;
        const trials = estRepFilter === 'mine'
          ? estData.trials.filter(t => t.repId === myId)
          : estData.trials;

        // Group pipeline by stage (sum across reps if team view)
        const stageOrder = ['prospect','contacted','demo_booked','trial_active','nurturing','negotiating'];
        const stageMap = {};
        for (const p of pipeline) {
          if (!stageMap[p.stage]) stageMap[p.stage] = { stage: p.stage, stageLabel: p.stageLabel, count: 0, totalArr: 0, estBase: 0 };
          stageMap[p.stage].count += p.count;
          stageMap[p.stage].totalArr += p.totalArr;
          stageMap[p.stage].estBase += p.estBase;
        }
        const stageRows = stageOrder.map(s => stageMap[s]).filter(Boolean);

        const totalPipelineArr = stageRows.reduce((s, r) => s + r.totalArr, 0);
        const totalPipelineBase = stageRows.reduce((s, r) => s + r.estBase, 0);
        const totalTrialBase = trials.reduce((s, t) => s + t.estBase, 0);
        const totalTrialSpeed = trials.reduce((s, t) => s + t.estSpeed, 0);
        const grandEst = totalPipelineBase + totalTrialBase + totalTrialSpeed;

        return (
          <div style={{ ...S.card, marginBottom: 24, border: '2px solid #fcd34d', background: '#fffbeb' }}>
            <div style={{ ...S.spaceBetween, marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
              <div>
                <h2 style={{ ...S.h2, margin: 0, color: '#92400e' }}>⚡ Estimated Commissions</h2>
                <p style={{ fontSize: 13, color: '#b45309', margin: '4px 0 0' }}>Forward-looking estimates based on current pipeline and active trials</p>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                {[['mine', 'My Estimates'], ['team', 'Full Team']].map(([key, label]) => (
                  <button key={key} onClick={() => setEstRepFilter(key)}
                    style={{ ...S.btn, ...S.btnSm, background: estRepFilter === key ? '#92400e' : '#fef3c7', color: estRepFilter === key ? '#fff' : '#92400e', border: '1px solid #fcd34d', fontWeight: 600 }}>
                    {label}
                  </button>
                ))}
              </div>
            </div>

            {/* Summary cards */}
            <div className="cb-grid4" style={{ ...S.grid4, marginBottom: 20 }}>
              {[
                ['Pipeline ARR', totalPipelineArr, 'Est. value in pipeline', true, 'Sum of estimated annual ARR across all active pipeline leads (excludes Closed Won/Lost/Released).'],
                ['Est. Pipeline Commission', totalPipelineBase, 'If all pipeline closes', false, 'Pipeline ARR × 15% commission rate. Forward-looking estimate — assumes every open lead closes on an annual plan.'],
                ['Est. Trial Commission', totalTrialBase + totalTrialSpeed, `${trials.length} active trial${trials.length !== 1 ? 's' : ''}`, false, 'Base commission (ARR × 15%) + estimated speed bonus for each active trial city. Speed bonus: +$150 if Day ≤7, +$75 if Day ≤14.'],
                ['Est. Grand Total', grandEst, 'Pipeline + trials', false, 'Total estimated commission = pipeline estimate + active trial estimate. Best-case scenario if all pipeline closes.'],
              ].map(([label, val, sub, isArr, tip]) => (
                <div key={label} style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', border: '1px solid #fde68a', textAlign: 'center' }}>
                  <div style={{ fontSize: 20, fontWeight: 800, color: '#92400e' }}>
                    {formatCurrency(val)}{isArr ? <span style={{ fontSize: 11, color: '#b45309' }}>/yr</span> : ''}
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{label}<InfoTip text={tip} /></div>
                  <div style={{ fontSize: 11, color: '#92400e', marginTop: 2 }}>{sub}</div>
                </div>
              ))}
            </div>

            {/* Pipeline by stage */}
            {stageRows.length > 0 && (
              <div style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#b45309', letterSpacing: '0.07em', marginBottom: 8 }}>
                  Pipeline by Stage {estRepFilter === 'mine' ? '— You' : '— Full Team'}
                </div>
                <div style={{ borderRadius: 8, overflow: 'hidden', border: '1px solid #fde68a' }}>
                  <table style={S.table}>
                    <thead>
                      <tr style={{ background: '#fef9c3' }}>
                        {[
                          ['Stage', null],
                          ['Leads', 'Count of active leads in this stage.'],
                          ['Est. ARR', 'Sum of estimated annual ARR for leads in this stage.'],
                          ['Est. Commission', 'Stage ARR × 15% commission rate. Assumes all leads close on annual plans.'],
                        ].map(([h, tip]) => (
                          <th key={h} style={{ ...S.th, background: 'transparent' }}>
                            <span style={{ display: 'inline-flex', alignItems: 'center' }}>{h}{tip && <InfoTip text={tip} />}</span>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {stageRows.map(row => {
                        const color = STAGE_COLORS[row.stage] || '#6b7280';
                        return (
                          <tr key={row.stage} style={{ background: '#fff' }}>
                            <td style={S.td}><span style={{ ...S.badge, color, background: color + '18' }}>{row.stageLabel}</span></td>
                            <td style={S.td}>{row.count}</td>
                            <td style={S.td}>{formatCurrency(row.totalArr)}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></td>
                            <td style={{ ...S.td, fontWeight: 700, color: '#15803d' }}>{formatCurrency(row.estBase)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Active Trials */}
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#b45309', letterSpacing: '0.07em', marginBottom: 8 }}>
                Active Trials {estRepFilter === 'mine' ? '— You' : '— Full Team'}
                <InfoTip text={'Speed bonus: +$150 if payment received by EOD Day 7, +$75 for Days 8–14. Clock starts on Trial Day 1.'} />
              </div>
              {trials.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '16px 0', color: '#b45309', fontSize: 13 }}>No active trials {estRepFilter === 'mine' ? 'assigned to you' : 'right now'}.</div>
              ) : (
                <div style={{ borderRadius: 8, overflow: 'hidden', border: '1px solid #fde68a' }}>
                  <table style={S.table}>
                    <thead>
                      <tr style={{ background: '#fef9c3' }}>
                        {[
                          ['City', null],
                          ...(estRepFilter === 'team' ? [['Rep', null]] : []),
                          ['ARR', 'Annual contract value. Monthly plans show "—" — only annual plans generate commission.'],
                          ['Trial Day', 'Days elapsed since trial start (trial_ends_at − 30 days = Day 1).'],
                          ['Speed Window', 'Tier 1: close by EOD Day 7 for +$150. Tier 2: Days 8–14 for +$75. After Day 14: no speed bonus.'],
                          ['Est. Base', 'Annual ARR × 15% commission rate.'],
                          ['Est. Speed', 'Estimated speed bonus: +$150 if currently in Tier 1 window, +$75 if Tier 2, $0 after Day 14.'],
                          ['Est. Total', 'Base commission + estimated speed bonus.'],
                        ].map(([h, tip]) => (
                          <th key={h} style={{ ...S.th, background: 'transparent' }}>
                            <span style={{ display: 'inline-flex', alignItems: 'center' }}>{h}{tip && <InfoTip text={tip} />}</span>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {trials.map(t => {
                        let windowLabel, windowColor;
                        if (t.tier === 1)      { windowLabel = `Day ${t.dayNumber} of 7 — Tier 1 open`; windowColor = '#16a34a'; }
                        else if (t.tier === 2) { windowLabel = `Day ${t.dayNumber} of 14 — Tier 2 open`; windowColor = '#d97706'; }
                        else                   { windowLabel = `Day ${t.dayNumber} — Closed`; windowColor = '#dc2626'; }
                        const isAnnual = t.billingPeriod === 'annual';
                        return (
                          <tr key={t.cityId} style={{ background: '#fff' }}>
                            <td style={S.td}><div style={{ fontWeight: 600 }}>{t.cityName}{t.cityState ? `, ${t.cityState}` : ''}</div></td>
                            {estRepFilter === 'team' && <td style={S.td}>{t.repName}</td>}
                            <td style={S.td}>
                              {t.arr > 0 ? <>{formatCurrency(t.arr)}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></> : <span style={{ color: '#94a3b8', fontSize: 12 }}>Monthly — no commission</span>}
                            </td>
                            <td style={{ ...S.td, fontWeight: 700, color: '#1e3a5f' }}>Day {t.dayNumber}</td>
                            <td style={S.td}><span style={{ fontSize: 12, fontWeight: 600, color: windowColor }}>{windowLabel}</span></td>
                            <td style={{ ...S.td, color: '#15803d', fontWeight: 600 }}>{isAnnual ? formatCurrency(t.estBase) : '—'}</td>
                            <td style={{ ...S.td, color: t.estSpeed > 0 ? '#d97706' : '#94a3b8', fontWeight: t.estSpeed > 0 ? 700 : 400 }}>
                              {isAnnual && t.estSpeed > 0 ? `+${formatCurrency(t.estSpeed)}` : '—'}
                            </td>
                            <td style={{ ...S.td, fontWeight: 800, color: '#1e3a5f' }}>{isAnnual ? formatCurrency(t.estTotal) : '—'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* Summary totals */}
      {data && (
        <div style={{ ...S.card, background: 'linear-gradient(135deg, #1e3a5f 0%, #162d4a 100%)', border: 'none', marginBottom: 24 }}>
          <div style={{ textAlign: 'center', marginBottom: 8 }}>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.55)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em' }}>{periodLabel}</div>
          </div>
          <div className="cb-grid4" style={S.grid4}>
            {[
              { label: 'Total Payout', value: formatCurrency(data.totalPayout), tip: 'Sum of all commission payouts (base + speed bonuses) for the selected period across all reps.' },
              { label: 'Active Reps', value: data.reps?.filter(r => (r.dealCount || 0) > 0 || (r.quarters || []).some(q => q.dealCount > 0)).length || 0, tip: 'Number of reps who closed at least one deal in the selected period.' },
              { label: 'Total Deals', value: view === 'year'
                  ? data.reps?.reduce((s, r) => s + r.quarters.reduce((qs, q) => qs + q.dealCount, 0), 0) || 0
                  : data.reps?.reduce((s, r) => s + r.dealCount, 0) || 0, tip: 'Total closed-won deals across all reps in the selected period.' },
              { label: 'View', value: view === 'year' ? `FY ${year}` : periodLabel, tip: null },
            ].map(({ label, value, tip }) => (
              <div key={label} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 26, fontWeight: 700, color: '#fff' }}>{value}</div>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{label}{tip && <InfoTip text={tip} light />}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {loading && <p style={{ color: '#64748b' }}>Calculating…</p>}

      {/* Year view: Q1-Q4 per rep */}
      {view === 'year' && data?.reps?.map(rep => (
        <div key={rep.repId} style={{ ...S.card, marginBottom: 16 }}>
          <div style={{ ...S.spaceBetween, marginBottom: 16 }}>
            <div>
              <h3 style={{ ...S.h3, margin: 0 }}>{rep.repName}</h3>
              <span style={{ fontSize: 13, color: '#64748b' }}>{(rep.commissionRate * 100).toFixed(1)}% rate · {rep.repStatus === 'inactive' ? <span style={{ color: '#dc2626' }}>Inactive</span> : 'Active'}</span>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 24, fontWeight: 700, color: '#1e3a5f' }}>{formatCurrency(rep.yearTotal)}</div>
              <div style={{ fontSize: 12, color: '#64748b' }}>FY {year} Total</div>
            </div>
          </div>
          <div className="cb-grid4" style={S.grid4}>
            {rep.quarters.map(q => (
              <div key={q.label} style={{ ...S.statCardLight, textAlign: 'center' }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', marginBottom: 6, textTransform: 'uppercase' }}>{q.label}</div>
                <div style={{ fontSize: 20, fontWeight: 700, color: '#0f172a' }}>{formatCurrency(q.grandTotal)}</div>
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{q.dealCount} deal{q.dealCount !== 1 ? 's' : ''}</div>
              </div>
            ))}
          </div>
          {rep.quarters.flatMap(q => q.deals).length > 0 && (
            <RepDealTable deals={rep.quarters.flatMap(q => q.deals)} />
          )}
        </div>
      ))}

      {/* Month view — Per-rep detail cards */}
      {view === 'month' && data?.reps?.map(rep => (
        <div key={rep.repId} style={{ ...S.card, marginBottom: 16 }}>
          <div style={{ ...S.spaceBetween, marginBottom: 16 }}>
            <div>
              <h3 style={{ ...S.h3, margin: 0 }}>{rep.repName}</h3>
              <span style={{ fontSize: 13, color: '#64748b' }}>{(rep.commissionRate * 100).toFixed(1)}% rate · {rep.dealCount} deal{rep.dealCount !== 1 ? 's' : ''} · {rep.repStatus === 'inactive' ? <span style={{ color: '#dc2626' }}>Inactive</span> : 'Active'}</span>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 24, fontWeight: 700, color: '#1e3a5f' }}>{formatCurrency(rep.grandTotal)}</div>
              <div style={{ fontSize: 12, color: '#64748b' }}>Total Payout</div>
            </div>
          </div>
          <div className="cb-grid4" style={S.grid4}>
            {[
              ['Base Commission', rep.base, 'Sum of (annual ARR × commission rate) for each closed deal in this period.'],
              ['Speed Bonuses', rep.speedBonuses, '+$150 per deal closed within 7 days of trial start; +$75 for days 8–14.'],
              ['Volume Bonus', rep.volumeBonus, 'Monthly deal-count bonus: 3 deals = +$250, 5 deals = +$750, 8+ deals = +$1,500.'],
              ['Total Payout', rep.grandTotal, 'Base + speed bonuses + volume bonus.'],
            ].map(([label, val, tip]) => (
              <div key={label} style={S.statCardLight}>
                <div style={{ fontSize: 18, fontWeight: 700, color: '#0f172a' }}>{formatCurrency(val)}</div>
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{label}<InfoTip text={tip} /></div>
              </div>
            ))}
          </div>
          <RepDealTable deals={rep.deals} volumeBonus={rep.volumeBonus} repId={rep.repId} />
        </div>
      ))}

      {data?.reps?.length === 0 && <div style={S.card}><p style={{ color: '#64748b', textAlign: 'center' }}>No commission data for this period.</p></div>}
    </div>
  );
}

// ─── PAYOUT PAGE (super admin only) ───────────────────────────────────────────

function PayoutPage() {
  const { token } = useAuth();
  const [tab, setTab] = useState('run'); // 'run' | 'procedures'
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [togglingRepPaid, setTogglingRepPaid] = useState({});
  const [payNoteInput, setPayNoteInput] = useState('');
  const [payNoteRepId, setPayNoteRepId] = useState(null);

  const periodLabel = new Date(month + '-01').toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });

  const load = useCallback(async () => {
    setLoading(true); setData(null);
    try {
      const r = await fetch(`${API}/api/sales/commission?view=month&month=${month}`, { headers: apiHeaders(token) });
      setData(await r.json());
    } catch (e) {} finally { setLoading(false); }
  }, [token, month]);

  useEffect(() => { load(); }, [load]);

  async function markRepPaid(repId, paid, note) {
    setTogglingRepPaid(p => ({ ...p, [repId]: true }));
    await fetch(`${API}/api/sales/commission/rep-paid`, {
      method: 'POST', headers: apiHeaders(token),
      body: JSON.stringify({ repId, month, paid, note: note || undefined }),
    });
    setTogglingRepPaid(p => ({ ...p, [repId]: false }));
    setPayNoteRepId(null); setPayNoteInput('');
    load();
  }

  function exportPayoutSheet() {
    if (!data) return;
    const rows = [['CivicBot Sales — Payout Sheet', periodLabel], []];
    rows.push(['Rep', 'Deals', 'Base Commission', 'Speed Bonuses', 'Volume Bonus', 'Total Payout', 'Status', 'Payment Note']);
    data.reps.forEach(r => rows.push([
      r.repName, r.dealCount,
      r.base, r.speedBonuses, r.volumeBonus, r.grandTotal,
      r.deals?.every(d => d.commissionPaidAt) ? 'Paid' : 'Unpaid',
      r.deals?.filter(d => d.commissionPaidNote).map(d => d.commissionPaidNote).join('; ') || '',
    ]));
    rows.push(['TOTAL', data.reps.reduce((s, r) => s + r.dealCount, 0),
      data.reps.reduce((s, r) => s + r.base, 0), data.reps.reduce((s, r) => s + r.speedBonuses, 0),
      data.reps.reduce((s, r) => s + r.volumeBonus, 0),
      data.totalPayout, '', '']);
    rows.push([], ['DEAL DETAIL'], ['Rep', 'City', 'Plan', 'ARR', 'Base', 'Speed Bonus', 'Closed Date', 'Paid Date', 'Payment Note']);
    data.reps.forEach(r => (r.deals || []).forEach(d => rows.push([
      r.repName, d.cityId, d.planName, d.arr, d.base, d.speedBonus,
      d.closedAt ? d.closedAt.slice(0, 10) : '',
      d.commissionPaidAt ? d.commissionPaidAt.slice(0, 10) : 'Unpaid',
      d.commissionPaidNote || '',
    ])));
    const csv = rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',')).join('\n');
    const a = document.createElement('a'); a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    a.download = `payout-sheet-${month}.csv`; a.click();
  }

  const spSection = (num, title, children) => (
    <div key={num} style={{ marginBottom: 28 }}>
      <h3 style={{ ...S.h3, color: '#1e3a5f', borderBottom: '2px solid #e2e8f0', paddingBottom: 8, marginBottom: 12 }}>
        {num}. {title}
      </h3>
      {children}
    </div>
  );

  const spItem = (label, text) => (
    <div key={label} style={{ display: 'flex', gap: 12, marginBottom: 8, fontSize: 14 }}>
      <span style={{ minWidth: 6, height: 6, borderRadius: '50%', background: '#1e3a5f', marginTop: 7, flexShrink: 0 }} />
      <span><strong style={{ color: '#0f172a' }}>{label}:</strong> <span style={{ color: '#475569' }}>{text}</span></span>
    </div>
  );

  return (
    <div className="cb-main" style={S.main}>
      <style>{`@media print { .no-print { display: none !important; } }`}</style>

      <div style={{ ...S.spaceBetween, marginBottom: 24 }} className="no-print">
        <h1 style={S.h1}>💳 Payout</h1>
        <div style={{ display: 'flex', borderRadius: 8, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
          {[['run', 'Payout Run'], ['procedures', 'Standards & Procedures']].map(([v, label]) => (
            <button key={v} onClick={() => setTab(v)}
              style={{ ...S.btn, borderRadius: 0, border: 'none', background: tab === v ? '#1e3a5f' : '#fff', color: tab === v ? '#fff' : '#475569', padding: '6px 18px', fontSize: 13 }}>
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* ── PAYOUT RUN TAB ── */}
      {tab === 'run' && (
        <div>
          <div style={{ ...S.spaceBetween, marginBottom: 20 }} className="no-print">
            <div style={S.row}>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#475569' }}>Period:</label>
              <input style={{ ...S.input, maxWidth: 160 }} type="month" value={month} onChange={e => setMonth(e.target.value)} />
            </div>
            <div style={S.row}>
              <button onClick={exportPayoutSheet} style={{ ...S.btn, ...S.btnSecondary }} disabled={!data || loading}>⬇ Export Payout Sheet</button>
              <button onClick={() => window.print()} style={{ ...S.btn, ...S.btnSecondary }} disabled={!data}>🖨 Print</button>
            </div>
          </div>

          {loading && <p style={{ color: '#64748b' }}>Loading…</p>}

          {data && (
            <>
              {/* Summary stat bar */}
              <div className="cb-grid4" style={{ ...S.grid4, marginBottom: 24 }}>
                {[
                  { label: 'Total Payout', value: formatCurrency(data.totalPayout), tip: 'Sum of all rep payouts for this period.' },
                  { label: 'Active Reps', value: data.reps.filter(r => r.dealCount > 0).length, tip: 'Reps with at least one deal this month.' },
                  { label: 'Total Deals', value: data.reps.reduce((s, r) => s + r.dealCount, 0), tip: 'Closed-won annual deals this month.' },
                  { label: 'All Paid', value: data.reps.filter(r => r.dealCount > 0).every(r => r.deals?.every(d => d.commissionPaidAt)) ? '✓ Yes' : 'Pending', tip: 'Whether all rep commissions for this period are marked paid.' },
                ].map(({ label, value, tip }) => (
                  <div key={label} style={{ ...S.card, textAlign: 'center', marginBottom: 0, padding: '14px 12px' }}>
                    <div style={{ fontSize: 22, fontWeight: 700, color: '#1e3a5f' }}>{value}</div>
                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{label}<InfoTip text={tip} /></div>
                  </div>
                ))}
              </div>

              {/* Ledger table */}
              <div style={{ ...S.card, padding: 0, overflow: 'hidden', marginBottom: 24 }}>
                <div style={{ padding: '16px 20px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#0f172a' }}>{periodLabel} — Payout Ledger</div>
                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Pay by the 15th of the following month · Annual plans only · Collected revenue only</div>
                  </div>
                </div>
                <table style={S.table}>
                  <thead>
                    <tr style={{ background: '#1e3a5f' }}>
                      {[
                        ['Rep', null],
                        ['Deals', 'Closed-won annual deals this month.'],
                        ['Base', 'ARR × commission rate.'],
                        ['Speed', '+$150 (≤7d) or +$75 (≤14d) per deal.'],
                        ['Volume', '3=$250 · 5=$750 · 8+=$1,500.'],
                            ['Total Owed', 'Full payout: base + speed bonuses + volume bonus.'],
                        ['Status', null],
                      ].map(([h, tip]) => (
                        <th key={h} style={{ ...S.th, background: 'transparent', color: '#fff', borderBottom: 'none' }}>
                          <span style={{ display: 'inline-flex', alignItems: 'center' }}>{h}{tip && <InfoTip text={tip} light />}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.reps.map((rep, ri) => {
                      const allPaid = rep.deals?.length > 0 && rep.deals.every(d => d.commissionPaidAt);
                      const latestPaidDate = rep.deals?.filter(d => d.commissionPaidAt).map(d => d.commissionPaidAt).sort().pop();
                      const latestNote = rep.deals?.filter(d => d.commissionPaidNote).map(d => d.commissionPaidNote).pop();
                      return (
                        <tr key={rep.repId} style={{ background: ri % 2 === 0 ? '#fff' : '#f8fafc' }}>
                          <td style={{ ...S.td, fontWeight: 600 }}>{rep.repName}</td>
                          <td style={S.td}>{rep.dealCount}</td>
                          <td style={S.td}>{formatCurrency(rep.base)}</td>
                          <td style={S.td}>{rep.speedBonuses > 0 ? <span style={{ color: '#d97706', fontWeight: 600 }}>+{formatCurrency(rep.speedBonuses)}</span> : '—'}</td>
                          <td style={S.td}>{rep.volumeBonus > 0 ? <span style={{ color: '#7c3aed', fontWeight: 600 }}>+{formatCurrency(rep.volumeBonus)}</span> : '—'}</td>
                          <td style={{ ...S.td, fontWeight: 800, fontSize: 15, color: '#1e3a5f' }}>{formatCurrency(rep.grandTotal)}</td>
                          <td style={S.td}>
                            {rep.dealCount === 0
                              ? <span style={{ color: '#94a3b8', fontSize: 12 }}>No deals</span>
                              : allPaid
                                ? (
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                      <span style={{ color: '#16a34a', fontSize: 12, fontWeight: 600 }}>✓ Paid {latestPaidDate ? formatDate(latestPaidDate) : ''}</span>
                                      <button onClick={() => markRepPaid(rep.repId, false)} style={{ ...S.btn, ...S.btnSm, background: '#fee2e2', color: '#dc2626', border: 'none', fontSize: 11 }} disabled={!!togglingRepPaid[rep.repId]}>Undo</button>
                                    </div>
                                    {latestNote && <span style={{ fontSize: 11, color: '#64748b' }}>{latestNote}</span>}
                                  </div>
                                )
                                : payNoteRepId === rep.repId
                                  ? (
                                    <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                                      <input
                                        value={payNoteInput}
                                        onChange={e => setPayNoteInput(e.target.value)}
                                        placeholder="Method (ACH, Venmo, Check #...)"
                                        style={{ ...S.input, fontSize: 12, padding: '4px 8px', width: 200 }}
                                        onKeyDown={e => e.key === 'Enter' && markRepPaid(rep.repId, true, payNoteInput)}
                                        autoFocus
                                      />
                                      <button onClick={() => markRepPaid(rep.repId, true, payNoteInput)} style={{ ...S.btn, ...S.btnSm, background: '#16a34a', color: '#fff', border: 'none' }} disabled={!!togglingRepPaid[rep.repId]}>Confirm</button>
                                      <button onClick={() => { setPayNoteRepId(null); setPayNoteInput(''); }} style={{ ...S.btn, ...S.btnSm, background: '#f1f5f9', color: '#64748b', border: 'none' }}>Cancel</button>
                                    </div>
                                  )
                                  : (
                                    <button onClick={() => setPayNoteRepId(rep.repId)} style={{ ...S.btn, ...S.btnSm, background: '#1e3a5f', color: '#fff', border: 'none' }} disabled={!!togglingRepPaid[rep.repId]}>
                                      Mark Paid
                                    </button>
                                  )
                            }
                          </td>
                        </tr>
                      );
                    })}
                    <tr style={{ background: '#f0f9ff', borderTop: '2px solid #1e3a5f' }}>
                      <td style={{ ...S.td, fontWeight: 700 }}>TOTAL</td>
                      <td style={{ ...S.td, fontWeight: 700 }}>{data.reps.reduce((s, r) => s + r.dealCount, 0)}</td>
                      <td style={{ ...S.td, fontWeight: 700 }}>{formatCurrency(data.reps.reduce((s, r) => s + r.base, 0))}</td>
                      <td style={{ ...S.td, fontWeight: 700 }}>{formatCurrency(data.reps.reduce((s, r) => s + r.speedBonuses, 0))}</td>
                      <td style={{ ...S.td, fontWeight: 700 }}>{formatCurrency(data.reps.reduce((s, r) => s + r.volumeBonus, 0))}</td>
                      <td style={{ ...S.td, fontWeight: 800, fontSize: 16, color: '#1e3a5f' }}>{formatCurrency(data.totalPayout)}</td>
                      <td style={S.td} />
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Per-rep deal detail */}
              {data.reps.filter(r => r.dealCount > 0).map(rep => (
                <div key={rep.repId} style={{ ...S.card, marginBottom: 16 }}>
                  <div style={{ ...S.spaceBetween, marginBottom: 4 }}>
                    <h3 style={{ ...S.h3, margin: 0 }}>{rep.repName} — Deal Detail</h3>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 20, fontWeight: 700, color: '#1e3a5f' }}>{formatCurrency(rep.grandTotal)}</div>
                      <div style={{ fontSize: 12, color: '#64748b' }}>Total Payout</div>
                    </div>
                  </div>
                  <table style={{ ...S.table, marginTop: 12 }}>
                    <thead>
                      <tr>
                        {[['City', null], ['Plan', null], ['ARR', null], ['Base', null], ['Speed Bonus', null], ['Deal Total', null], ['Closed', null], ['Paid', null]].map(([h]) => (
                          <th key={h} style={S.th}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rep.deals.map((d, i) => (
                        <tr key={d.id || i} style={d.commissionPaidAt ? { opacity: 0.6 } : {}}>
                          <td style={S.td}>{d.cityId}</td>
                          <td style={S.td}>{d.planName}</td>
                          <td style={S.td}>{formatCurrency(d.arr)}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></td>
                          <td style={S.td}>{formatCurrency(d.base)}</td>
                          <td style={S.td}>{d.speedBonus > 0 ? <span style={{ color: '#d97706', fontWeight: 600 }}>+{formatCurrency(d.speedBonus)}</span> : '—'}</td>
                          <td style={{ ...S.td, fontWeight: 700 }}>{formatCurrency(d.base + (d.speedBonus || 0))}</td>
                          <td style={S.td}>{formatDate(d.closedAt)}</td>
                          <td style={S.td}>
                            {d.commissionPaidAt
                              ? <span style={{ color: '#16a34a', fontSize: 12, fontWeight: 600 }}>✓ {formatDate(d.commissionPaidAt)}{d.commissionPaidNote ? ` · ${d.commissionPaidNote}` : ''}</span>
                              : <span style={{ color: '#94a3b8', fontSize: 12 }}>Unpaid</span>}
                          </td>
                        </tr>
                      ))}
                      {rep.volumeBonus > 0 && (
                        <tr style={{ background: '#fffbeb', borderTop: '2px solid #fcd34d' }}>
                          <td colSpan={6} style={{ ...S.td, color: '#92400e', fontWeight: 600, textAlign: 'right', fontSize: 12 }}>
                            🏆 Volume Bonus ({rep.dealCount} deal{rep.dealCount !== 1 ? 's' : ''})
                          </td>
                          <td colSpan={2} style={{ ...S.td, fontWeight: 800, color: '#d97706' }}>+{formatCurrency(rep.volumeBonus)}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              ))}

              {data.reps.filter(r => r.dealCount > 0).length === 0 && (
                <div style={S.card}><p style={{ color: '#64748b', textAlign: 'center' }}>No closed deals for {periodLabel}.</p></div>
              )}
            </>
          )}
        </div>
      )}

      {/* ── STANDARDS & PROCEDURES TAB ── */}
      {tab === 'procedures' && (
        <div>
          <div style={{ ...S.card, marginBottom: 24, background: 'linear-gradient(135deg, #1e3a5f 0%, #162d4a 100%)', border: 'none' }}>
            <div style={{ color: '#fff' }}>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(255,255,255,0.6)', marginBottom: 6 }}>Internal Document — Super Admin Only</div>
              <h2 style={{ ...S.h2, color: '#fff', margin: '0 0 4px' }}>Commission Payout Standards & Procedures</h2>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, margin: 0 }}>Effective May 2026 · Owner: Brandon Wright / Centricity GIS · Review annually</p>
            </div>
          </div>

          {spSection(1, 'Payout Schedule', <>
            {spItem('Frequency', 'Monthly. Commission payouts are processed once per calendar month.')}
            {spItem('Payment Date', 'The 15th of the following month. May commissions → paid June 15. If the 15th falls on a weekend or federal holiday, payment processes the next business day.')}
            {spItem('Why the 15th?', 'Provides 14 days after month close to verify Stripe payments cleared, resolve any disputes, and confirm final deal counts for volume bonus calculation.')}
            {spItem('Not 1st & 15th', '"1st and 15th" is a base salary + commission cadence. For 100% commission roles, monthly is the industry standard — it aligns payout with a clean accounting cycle.')}
            {spItem('Rep Notification', 'Mark deals paid in the Payout Run tab. Reps are expected to track their own commissions via the Commission Dashboard.')}
          </>)}

          {spSection(2, 'Eligibility Rules', <>
            {spItem('Annual Plans Only', 'Commission is earned exclusively on annual subscription plans. Monthly plans generate $0 commission. Always pitch annual — it is the only plan that produces commission.')}
            {spItem('Collected Revenue', 'Commission is paid on collected revenue only. The customer\'s first Stripe payment must successfully process before the commission is disbursable. If payment fails and is never collected, no commission is owed.')}
            {spItem('Active Employment', 'Rep must be active/contracted at the time of payout (the 15th). Reps terminated before the payout date forfeit uncollected commission for that period. Exception: super admin discretion.')}
            {spItem('No-Commission Deals', 'Deals flagged no_commission by super admin (e.g., internal pilots, comped accounts, renegotiated contracts) are excluded from all calculations.')}
          </>)}

          {spSection(3, 'Commission Components', <>
            <div style={{ background: '#f8fafc', borderRadius: 10, padding: '16px 20px', marginBottom: 16 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#1e3a5f', marginBottom: 12 }}>Formula: Payout = (ARR × Rate) + Speed Bonus + Volume Bonus</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                {[
                  { label: '3.1 Base Commission', color: '#1e3a5f', items: ['Rate: 15% of Annual Recurring Revenue (ARR)', 'ARR = annual plan price + any Answers add-on', 'Example: Growth CW annual = $5,000 ARR → $750 base'] },
                  { label: '3.2 Speed Bonus', color: '#d97706', items: ['Tier 1: +$150 per deal closed by EOD Day 7 of trial', 'Tier 2: +$75 per deal closed Days 8–14 of trial', 'No bonus after Day 14. Day 1 = trial start date.', 'Applies to initial close only — not renewals.'] },
                  { label: '3.3 Volume Bonus', color: '#7c3aed', items: ['3 deals closed in month = +$250', '5 deals closed in month = +$750', '8+ deals closed in month = +$1,500', 'Paid at the highest threshold reached. Resets the 1st of each month. Stacks with speed bonus.'] },
                ].map(({ label, color, items }) => (
                  <div key={label} style={{ background: '#fff', border: `2px solid ${color}22`, borderRadius: 8, padding: '12px 14px' }}>
                    <div style={{ fontWeight: 700, color, fontSize: 13, marginBottom: 8 }}>{label}</div>
                    {items.map((item, i) => (
                      <div key={i} style={{ display: 'flex', gap: 8, fontSize: 13, marginBottom: 4, color: '#475569' }}>
                        <span style={{ color, flexShrink: 0 }}>·</span> {item}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </>)}

          {spSection(4, 'Clawback Policy', <>
            {spItem('90-Day Window', 'If a customer cancels or reverses payment within 90 days of the original close date, 100% of the base commission for that deal is clawed back.')}
            {spItem('Speed Bonus Clawback', 'Speed bonuses are clawed back only if the cancellation occurs within 90 days AND the rep had a material role in the cancellation (e.g., misrepresentation during sales).')}
            {spItem('Volume Bonus', 'Volume bonus is not clawed back once the monthly threshold was legitimately reached, unless the clawback brings the rep below threshold — in which case the bonus is recalculated at the lower tier.')}
            {spItem('Clawback Execution', 'Clawbacks are applied as deductions from the following month\'s payout — not as retroactive recovery from prior payments. Document the reason in the deal record before deduction.')}
          </>)}

          {spSection(5, 'Dispute Resolution', <>
            {spItem('Dispute Window', 'Reps have until the 10th of the payout month to flag disputes (e.g., incorrect ARR, missing deal, wrong speed tier). Disputes received after the 10th are addressed in the following month\'s payout.')}
            {spItem('How to Dispute', 'Rep submits dispute to Brandon Wright via email with: city name, deal amount, and the specific discrepancy.')}
            {spItem('Resolution Authority', 'Super admin (Brandon Wright) has final authority on all commission calculations and dispute resolutions.')}
            {spItem('Audit Trail', 'All deal records, paid dates, and payment notes are stored permanently in the portal. Export Payout Sheet after each run and retain for 7 years.')}
          </>)}

          {spSection(6, 'Payment Methods & Record Keeping', <>
            {spItem('Default Method', 'ACH direct deposit. Rep provides bank details to payroll.')}
            {spItem('Alternatives', 'Venmo, Zelle, or company check (checks require 5 business day lead time). Document the method in the "Note" field when marking paid in the Payout Run tab.')}
            {spItem('Portal Record', 'Super admin must mark all deals as paid in the Payout Run tab within 2 business days of payment. This creates the audit trail.')}
            {spItem('CSV Archive', 'Export Payout Sheet (CSV) from the Payout Run tab after each monthly payout. Retain for a minimum of 7 years for tax and labor compliance.')}
            {spItem('Tax Treatment', 'Commission reported as supplemental W-2 wages (employees) or 1099-NEC (contractors). Centricity GIS issues tax documents per legal obligations. Reps consult their own tax advisor.')}
          </>)}

          {spSection(7, 'Plan Change & Edge Cases', <>
            {spItem('Mid-Year Upgrades', 'If a city upgrades their plan mid-year, additional commission is earned on the ARR delta for the new annual plan.')}
            {spItem('Downgrades', 'Downgrades during an active annual contract do not trigger clawback unless the original plan is fully canceled.')}
            {spItem('Transferred Leads', 'Commission belongs to the rep who closed the deal (sales_rep_id on the deal record). Lead transfers before close shift commission eligibility to the new rep.')}
            {spItem('Comped / Pilot Accounts', 'Accounts flagged as no_commission or manually_activated without payment are excluded. Super admin documents reason at time of flag.')}
          </>)}

          <div style={{ ...S.info, marginTop: 8 }}>
            <strong>Questions?</strong> Contact Brandon Wright · bwright@centricitygis.com · This document is reviewed annually. Last updated May 2026.
          </div>
        </div>
      )}
    </div>
  );
}

// ─── PROFILE PAGE ─────────────────────────────────────────────────────────────

function ProfilePage() {
  const { user, token, updateUser } = useAuth();
  const [form, setForm] = useState({ name: user?.name || '', email: user?.email || '', phone: user?.phone || '', leaderboardOptIn: user?.leaderboardOptIn ?? true });
  const [msg, setMsg] = useState('');
  const isSuperAdmin = user?.salesRole === 'super_admin';

  async function save(e) {
    e.preventDefault();
    const res = await fetch(`${API}/api/sales/users/${user.id}`, { method: 'PATCH', headers: apiHeaders(token), body: JSON.stringify(form) });
    if (res.ok) {
      updateUser({ name: form.name, email: form.email, phone: form.phone, leaderboardOptIn: form.leaderboardOptIn });
      setMsg('Profile updated');
    } else {
      setMsg('Save failed — please try again');
    }
    setTimeout(() => setMsg(''), 3000);
  }

  return (
    <div className="cb-main" style={S.main}>
      <h1 style={{ ...S.h1, marginBottom: 24 }}>My Profile</h1>
      <div style={{ maxWidth: 480 }}>
        {msg && <div style={S.success}>{msg}</div>}
        <div style={S.card}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#1e3a5f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, color: '#fff', margin: '0 auto 12px' }}>
              {user?.name?.charAt(0) || '?'}
            </div>
            <div style={{ fontWeight: 700, fontSize: 18 }}>{user?.name}</div>
            <span style={S.pill}>{user?.salesRole?.replace('sales_','').replace('_',' ')}</span>
          </div>
          <form onSubmit={save}>
            {[['name','Name','text'],['email','Email','email'],['phone','Phone','tel']].map(([field,label,type]) => (
              <div key={field} style={{ marginBottom: 14 }}>
                <label style={S.label}>{label}</label>
                <input style={S.input} type={type} value={form[field] || ''} onChange={e => setForm(f => ({ ...f, [field]: e.target.value }))} disabled={isSuperAdmin && field !== 'phone'} />
              </div>
            ))}
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, cursor: 'pointer', marginBottom: 20 }}>
              <input type="checkbox" checked={form.leaderboardOptIn} onChange={e => setForm(f => ({ ...f, leaderboardOptIn: e.target.checked }))} disabled={isSuperAdmin} />
              Show me on team leaderboard
            </label>
            <button type="submit" style={{ ...S.btn, ...S.btnPrimary, width: '100%' }}>Save Profile</button>
          </form>
        </div>
        <div style={S.card}>
          <h3 style={S.h3}>Commission Rate</h3>
          <div style={{ fontSize: 32, fontWeight: 700, color: '#1e3a5f' }}>{user?.commissionRate != null ? `${(user.commissionRate * 100).toFixed(1)}%` : 'Set by Admin'}</div>
          <p style={{ color: '#64748b', fontSize: 13, marginTop: 8 }}>15% base on annual ARR · Speed bonus: +$150 (≤7d) or +$75 (≤14d) · Volume: 3 deals=$250, 5=$750, 8+=$1,500</p>
        </div>
      </div>
    </div>
  );
}

// ─── OPPORTUNITIES ────────────────────────────────────────────────────────────

const STATUS_COLORS = { available: '#16a34a', claimed: '#d97706', converted: '#1e3a5f', excluded: '#94a3b8' };
const STATUS_LABELS = { available: 'Available', claimed: 'Claimed', converted: 'Converted', excluded: 'Excluded' };

function parseCSVText(text) {
  const lines = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
  const rows = [];
  for (const line of lines) {
    if (!line.trim()) continue;
    const row = []; let field = '', inQ = false;
    for (let i = 0; i < line.length; i++) {
      const c = line[i];
      if (c === '"') {
        if (inQ) { if (line[i+1] === '"') { field += '"'; i++; } else { inQ = false; } }
        else { inQ = true; }
      } else if (c === ',' && !inQ) { row.push(field.trim()); field = ''; }
      else field += c;
    }
    row.push(field.trim()); rows.push(row);
  }
  return rows;
}

// Import Wizard Modal
function ImportWizard({ onClose, onImported, token }) {
  const [step, setStep] = useState(1); // 1=upload, 2=map, 3=validate, 4=confirm
  const [file, setFile] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [preview, setPreview] = useState([]);
  const [rawRows, setRawRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [mapping, setMapping] = useState({ orgName: '', orgState: '', orgType: '', contactName: '', contactTitle: '', contactEmail: '', contactPhone: '', website: '', population: '', employeeSize: '', companyLinkedin: '', companyFacebook: '', companyTwitter: '', contactTier: '', contactLinkedin: '', orgSource: '' });
  const [batchName, setBatchName] = useState('');
  const [source, setSource] = useState('');
  const [validating, setValidating] = useState(false);
  const [validation, setValidation] = useState(null); // { results, dupeCount, okCount }
  const [skipKeys, setSkipKeys] = useState(new Set());
  const [importing, setImporting] = useState(false);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState('');

  function handleFileChange(e) {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f); setErr('');
    const reader = new FileReader();
    reader.onload = ev => {
      const rows = parseCSVText(ev.target.result);
      if (rows.length < 2) { setErr('File must have a header row + data rows'); return; }
      const hdrs = rows[0];
      const rawData = rows.slice(1).map(r => { const o = {}; hdrs.forEach((h, i) => { o[h] = r[i] || ''; }); return o; });
      setHeaders(hdrs);
      setRawRows(rawData);
      setPreview(rawData.slice(0, 5));
      setTotalRows(rawData.length);
      setBatchName(f.name.replace(/\.[^.]+$/, ''));
      // Auto-detect common column names
      const lower = hdrs.map(h => h.toLowerCase());
      const guess = (keys) => { for (const k of keys) { const i = lower.findIndex(h => h.includes(k)); if (i >= 0) return hdrs[i]; } return ''; };
      setMapping({
        orgName: guess(['company name','city','organization','org','municipality','entity','name']),
        orgState: guess(['state','province']),
        orgType: guess(['industry','type','kind','category']),
        contactName: guess(['contact name','full name','contact','person','representative']),
        contactTitle: guess(['job title','title','position','role']),
        contactEmail: guess(['email address','email','e-mail']),
        contactPhone: guess(['phone number','phone','mobile','cell','telephone']),
        website: guess(['web address','website','web','url','site']),
        population: guess(['population','pop']),
        employeeSize: guess(['employee size','employees','employee count','emp size']),
        companyLinkedin: guess(['company linkedin','company linked','org linkedin']),
        companyFacebook: guess(['company facebook','facebook']),
        companyTwitter: guess(['company twitter','twitter','x/']),
        contactTier: guess(['civicbot tier','tier','contact tier']),
        contactLinkedin: guess(['person linkedin','contact linkedin','person linked','linkedin']),
        orgSource: guess(['cityworks','source sheet','source','list']),
      });
      setStep(2);
    };
    reader.readAsText(f);
  }

  async function runValidation() {
    if (!mapping.orgName) { setErr('Map the Organization Name column first'); return; }
    setValidating(true); setErr('');
    try {
      const res = await fetch(`${API}/api/sales/import/validate`, {
        method: 'POST', headers: apiHeaders(token),
        body: JSON.stringify({ rows: rawRows, mapping }),
      });
      if (!res.ok) {
        const text = await res.text();
        let msg = `Server error ${res.status}`;
        try { const j = JSON.parse(text); msg = j.error || msg; } catch {}
        throw new Error(msg);
      }
      const r = await res.json();
      if (r.error) throw new Error(r.error);
      setValidation(r);
      setSkipKeys(new Set());
      setStep(3);
    } catch (e) { setErr(e.message || 'Unknown error — check console'); console.error('[ImportWizard] validate failed:', e); }
    finally { setValidating(false); }
  }

  async function confirmImport() {
    setImporting(true); setErr('');
    try {
      const r = await fetch(`${API}/api/sales/import/confirm`, {
        method: 'POST', headers: apiHeaders(token),
        body: JSON.stringify({ rows: rawRows, mapping, skipKeys: [...skipKeys], batchName, source, filename: file?.name || '' }),
      }).then(r => r.json());
      if (r.error) throw new Error(r.error);
      setDone(r); setStep(4);
    } catch (e) { setErr(e.message); }
    setImporting(false);
  }

  const FIELD_LABELS = [
    ['orgName', 'Organization Name *'],
    ['orgState', 'State'],
    ['orgType', 'Org Type'],
    ['website', 'Website'],
    ['population', 'Population'],
    ['employeeSize', 'Employee Size'],
    ['companyLinkedin', 'Company LinkedIn'],
    ['companyFacebook', 'Company Facebook'],
    ['companyTwitter', 'Company Twitter/X'],
    ['contactName', 'Contact Name'],
    ['contactTitle', 'Contact Title'],
    ['contactEmail', 'Contact Email'],
    ['contactPhone', 'Contact Phone'],
    ['contactTier', 'Contact Tier'],
    ['contactLinkedin', 'Contact LinkedIn'],
    ['orgSource', 'Source'],
  ];

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 700, maxHeight: '90vh', overflow: 'auto', padding: 28 }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div>
            <h2 style={{ ...S.h2, margin: 0 }}>Import Opportunities from CSV</h2>
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              {['Upload', 'Map Fields', 'Review Duplicates', 'Done'].map((label, i) => (
                <span key={i} style={{ fontSize: 12, fontWeight: 600, padding: '2px 10px', borderRadius: 12, background: step === i + 1 ? '#1e3a5f' : '#f1f5f9', color: step === i + 1 ? '#fff' : step > i + 1 ? '#16a34a' : '#94a3b8' }}>
                  {step > i + 1 ? '✓ ' : ''}{label}
                </span>
              ))}
            </div>
          </div>
          <button onClick={onClose} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>✕ Close</button>
        </div>

        {err && <div style={S.error}>{err}</div>}

        {/* Step 1: Upload */}
        {step === 1 && (
          <div>
            <p style={{ color: '#64748b', marginBottom: 16 }}>Upload a CSV file exported from a GRAMA request or any contact list. You'll map the columns in the next step.</p>
            <label style={{ display: 'block', border: '2px dashed #cbd5e1', borderRadius: 10, padding: '32px 24px', textAlign: 'center', cursor: 'pointer', background: '#f8fafc' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>📁</div>
              <div style={{ fontWeight: 600, color: '#1e3a5f', marginBottom: 4 }}>Click to choose a CSV file</div>
              <div style={{ fontSize: 12, color: '#94a3b8' }}>Supports .csv files with any column order</div>
              <input type="file" accept=".csv,text/csv" style={{ display: 'none' }} onChange={handleFileChange} />
            </label>
          </div>
        )}

        {/* Step 2: Map Fields */}
        {step === 2 && (
          <div>
            <p style={{ color: '#64748b', marginBottom: 16 }}>Match your CSV columns to the fields below. Only <strong>Organization Name</strong> is required.</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
              {FIELD_LABELS.map(([key, label]) => (
                <div key={key}>
                  <label style={S.label}>{label}</label>
                  <select style={S.select} value={mapping[key]} onChange={e => setMapping(m => ({ ...m, [key]: e.target.value }))}>
                    <option value="">— Skip —</option>
                    {headers.map(h => <option key={h} value={h}>{h}</option>)}
                  </select>
                </div>
              ))}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
              <div style={{ gridColumn: 'span 2' }}><label style={S.label}>Batch Name</label><input style={S.input} value={batchName} onChange={e => setBatchName(e.target.value)} placeholder="e.g. Utah GRAMA 2026" /></div>
            </div>
            {/* Preview */}
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#94a3b8', marginBottom: 6, textTransform: 'uppercase' }}>Preview ({preview.length} of {totalRows} rows)</div>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ ...S.table, fontSize: 11 }}>
                  <thead><tr>{headers.map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>{preview.map((row, i) => <tr key={i}>{headers.map(h => <td key={h} style={S.td}>{row[h]}</td>)}</tr>)}</tbody>
                </table>
              </div>
            </div>
            {err && <div style={{ ...S.error, marginBottom: 10 }}>{err}</div>}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setStep(1)} style={{ ...S.btn, ...S.btnSecondary }}>← Back</button>
              <button onClick={runValidation} style={{ ...S.btn, ...S.btnPrimary }} disabled={!mapping.orgName || validating}>{validating ? 'Checking duplicates…' : `Check ${totalRows} rows for duplicates →`}</button>
            </div>
          </div>
        )}

        {/* Step 3: Validate / Review */}
        {step === 3 && validation && (
          <div>
            <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
              <div style={{ ...S.statCardLight, flex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: 22, fontWeight: 700, color: '#16a34a' }}>{validation.groups.filter(g => g.status === 'ok' && !skipKeys.has(g.key)).length}</div>
                <div style={{ fontSize: 12, color: '#64748b' }}>New cities</div>
              </div>
              <div style={{ ...S.statCardLight, flex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: 22, fontWeight: 700, color: '#d97706' }}>{validation.groups.filter(g => g.status === 'duplicate' && !skipKeys.has(g.key)).length}</div>
                <div style={{ fontSize: 12, color: '#64748b' }}>Potential duplicates</div>
              </div>
              <div style={{ ...S.statCardLight, flex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: 22, fontWeight: 700, color: '#94a3b8' }}>{skipKeys.size}</div>
                <div style={{ fontSize: 12, color: '#64748b' }}>Excluded</div>
              </div>
            </div>
            <div style={{ maxHeight: 360, overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: 8 }}>
              {validation.groups.map(g => {
                const skipped = skipKeys.has(g.key);
                return (
                  <div key={g.key} style={{ padding: '10px 14px', borderBottom: '1px solid #f1f5f9', background: skipped ? '#f8fafc' : g.status === 'duplicate' ? '#fffbeb' : '#fff', opacity: skipped ? 0.5 : 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <span style={{ fontWeight: 600, fontSize: 13 }}>{g.orgName}</span>
                        {g.orgState && <span style={{ fontSize: 12, color: '#64748b', marginLeft: 6 }}>{g.orgState}</span>}
                        <span style={{ fontSize: 11, color: '#94a3b8', marginLeft: 8 }}>{g.contactCount} contact{g.contactCount !== 1 ? 's' : ''}</span>
                        {g.status === 'duplicate' && (
                          <div style={{ marginTop: 4 }}>
                            {g.duplicates.map(d => (
                              <span key={d.id} style={{ fontSize: 11, background: '#fef3c7', color: '#92400e', borderRadius: 6, padding: '1px 7px', marginRight: 4 }}>
                                ⚠ {d.org_name} ({d.org_state}) — {d.score}% match · {STATUS_LABELS[d.status]}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                        {g.status === 'duplicate' && !skipped && <span style={{ fontSize: 11, color: '#d97706', fontWeight: 600 }}>⚠ Duplicate</span>}
                        {g.status === 'ok' && !skipped && <span style={{ fontSize: 11, color: '#16a34a', fontWeight: 600 }}>✓ New</span>}
                        <button onClick={() => setSkipKeys(prev => { const s = new Set(prev); s.has(g.key) ? s.delete(g.key) : s.add(g.key); return s; })}
                          style={{ ...S.btn, ...S.btnSm, ...(skipped ? S.btnPrimary : S.btnSecondary), fontSize: 11 }}>
                          {skipped ? 'Include' : 'Skip'}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <button onClick={() => setStep(2)} style={{ ...S.btn, ...S.btnSecondary }}>← Back</button>
              <button onClick={confirmImport} style={{ ...S.btn, ...S.btnPrimary }} disabled={importing}>
                {importing ? 'Importing…' : `Import ${validation.totalGroups - skipKeys.size} cities →`}
              </button>
            </div>
          </div>
        )}

        {/* Step 4: Done */}
        {step === 4 && done && (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🎉</div>
            <h3 style={{ ...S.h3, color: '#16a34a' }}>Import Complete!</h3>
            <p style={{ color: '#64748b' }}><strong>{done.imported}</strong> organizations imported · <strong>{done.skipped}</strong> skipped</p>
            <button onClick={() => { onImported(); onClose(); }} style={{ ...S.btn, ...S.btnPrimary, marginTop: 16 }}>View Opportunities →</button>
          </div>
        )}
      </div>
    </div>
  );
}

// Contact list with drag-and-drop reorder
function pluralEntity(t) { return t === 'opportunity' ? 'opportunities' : t + 's'; }
function ContactList({ contacts, entityType, entityId, token, onRefresh, canEdit }) {
  const [dragIdx, setDragIdx] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [addForm, setAddForm] = useState({ name: '', title: '', email: '', phone: '', tier: '', linkedin: '' });
  const [adding, setAdding] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});

  async function addContact() {
    if (!addForm.name) return;
    setAdding(true);
    await fetch(`${API}/api/sales/${pluralEntity(entityType)}/${entityId}/contacts`, {
      method: 'POST', headers: apiHeaders(token), body: JSON.stringify(addForm),
    });
    setAdding(false); setShowAdd(false); setAddForm({ name: '', title: '', email: '', phone: '', tier: '', linkedin: '' });
    onRefresh();
  }

  async function deleteContact(id) {
    if (!window.confirm('Delete this contact?')) return;
    await fetch(`${API}/api/sales/contacts/${id}`, { method: 'DELETE', headers: apiHeaders(token) });
    onRefresh();
  }

  async function saveEdit(id) {
    await fetch(`${API}/api/sales/contacts/${id}`, { method: 'PATCH', headers: apiHeaders(token), body: JSON.stringify(editForm) });
    setEditId(null); onRefresh();
  }

  async function reorder(newOrder) {
    await fetch(`${API}/api/sales/${pluralEntity(entityType)}/${entityId}/contacts/reorder`, {
      method: 'PATCH', headers: apiHeaders(token),
      body: JSON.stringify({ order: newOrder.map((c, i) => ({ id: c.id, sort_order: i })) }),
    });
    onRefresh();
  }

  function onDragStart(e, idx) { setDragIdx(idx); e.dataTransfer.effectAllowed = 'move'; }
  function onDragOver(e, idx) {
    e.preventDefault();
    if (dragIdx === null || dragIdx === idx) return;
    const newList = [...contacts];
    const [moved] = newList.splice(dragIdx, 1);
    newList.splice(idx, 0, moved);
    reorder(newList);
    setDragIdx(idx);
  }
  function onDragEnd() { setDragIdx(null); }

  return (
    <div>
      {contacts.map((c, idx) => (
        <div key={c.id} draggable={canEdit} onDragStart={e => onDragStart(e, idx)} onDragOver={e => onDragOver(e, idx)} onDragEnd={onDragEnd}
          style={{ ...S.cardSm, marginBottom: 8, borderLeft: `3px solid ${idx === 0 ? '#1e3a5f' : '#e2e8f0'}`, cursor: canEdit ? 'grab' : 'default', opacity: dragIdx === idx ? 0.5 : 1 }}>
          {editId === c.id ? (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                {[['name','Name'],['title','Title'],['email','Email'],['phone','Phone'],['tier','Tier'],['linkedin','LinkedIn']].map(([f,l]) => (
                  <div key={f}><label style={{ ...S.label, fontSize: 11 }}>{l}</label>
                    <input style={{ ...S.input, fontSize: 12 }} value={editForm[f] || ''} onChange={e => setEditForm(ef => ({ ...ef, [f]: e.target.value }))} /></div>
                ))}
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => saveEdit(c.id)} style={{ ...S.btn, ...S.btnPrimary, ...S.btnSm }}>Save</button>
                <button onClick={() => setEditId(null)} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>Cancel</button>
              </div>
            </div>
          ) : (
            <div>
              {/* Name row */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 4 }}>
                  {canEdit && <span style={{ color: '#cbd5e1', fontSize: 12, cursor: 'grab' }}>⠿</span>}
                  {idx === 0 && <span style={{ fontSize: 10, background: '#1e3a5f', color: '#fff', borderRadius: 6, padding: '1px 6px', fontWeight: 700 }}>PRIMARY</span>}
                  <span style={{ fontWeight: 700, fontSize: 14 }}>{c.name}</span>
                  {c.tier && <span style={{ fontSize: 10, background: '#dbeafe', color: '#1d4ed8', borderRadius: 5, padding: '2px 7px', fontWeight: 700, letterSpacing: '0.03em' }}>{c.tier}</span>}
                </div>
                {canEdit && (
                  <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                    <button onClick={() => { setEditId(c.id); setEditForm({ name: c.name, title: c.title, email: c.email, phone: c.phone, tier: c.tier || '', linkedin: c.linkedin || '' }); }} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm, fontSize: 11 }}>Edit</button>
                    <button onClick={() => deleteContact(c.id)} style={{ ...S.btn, ...S.btnSm, background: '#fee2e2', color: '#dc2626', border: 'none', fontSize: 11 }}>✕</button>
                  </div>
                )}
              </div>
              {/* Title / email / phone */}
              <div style={{ fontSize: 12, color: '#475569', marginBottom: c.linkedin ? 8 : 0 }}>
                {c.title && <div style={{ marginBottom: 2, fontWeight: 500 }}>{c.title}</div>}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                  {c.email && <span>✉ {c.email}</span>}
                  {c.phone && <span>📞 {c.phone}</span>}
                </div>
              </div>
              {/* LinkedIn quick actions */}
              {c.linkedin && (() => {
                const url = c.linkedin.startsWith('http') ? c.linkedin : 'https://' + c.linkedin;
                return (
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 6 }}>
                    <span style={{ fontSize: 11, color: '#94a3b8', flexShrink: 0 }}>LinkedIn:</span>
                    <a href={url} target="_blank" rel="noreferrer"
                      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, fontWeight: 600, background: '#0a66c2', color: '#fff', borderRadius: 5, padding: '3px 9px', textDecoration: 'none' }}>
                      Open ↗
                    </a>
                    <button onClick={() => navigator.clipboard.writeText(url).then(() => { const b = document.activeElement; b.textContent = 'Copied!'; setTimeout(() => { b.textContent = 'Copy URL'; }, 1500); })}
                      style={{ ...S.btn, ...S.btnSm, fontSize: 11, background: '#f1f5f9', color: '#0a66c2', border: '1px solid #bfdbfe', fontWeight: 600, padding: '3px 9px' }}>
                      Copy URL
                    </button>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      ))}
      {canEdit && (
        showAdd ? (
          <div style={{ ...S.cardSm, marginBottom: 8, border: '1px dashed #94a3b8' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
              {[['name','Name *'],['title','Title'],['email','Email'],['phone','Phone'],['tier','Tier'],['linkedin','LinkedIn']].map(([f,l]) => (
                <div key={f}><label style={{ ...S.label, fontSize: 11 }}>{l}</label>
                  <input style={{ ...S.input, fontSize: 12 }} value={addForm[f] || ''} onChange={e => setAddForm(af => ({ ...af, [f]: e.target.value }))} /></div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={addContact} disabled={adding || !addForm.name} style={{ ...S.btn, ...S.btnPrimary, ...S.btnSm }}>Add Contact</button>
              <button onClick={() => setShowAdd(false)} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>Cancel</button>
            </div>
          </div>
        ) : (
          contacts.length < 15 && <button onClick={() => setShowAdd(true)} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm, width: '100%' }}>+ Add Contact</button>
        )
      )}
    </div>
  );
}

// ─── Contacts-only Import Wizard ───────────────────────────────────────────
// Adds contacts to existing opportunities, matching by city name + state.
// Use case: city was already imported but had no contact info; now you have
// a new CSV with the same cities + contact rows.
function ContactsImportWizard({ onClose, onImported, token }) {
  const [step, setStep] = useState(1);
  const [file, setFile] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [rawRows, setRawRows] = useState([]);
  const [mapping, setMapping] = useState({ orgName: '', orgState: '', contactName: '', contactTitle: '', contactEmail: '', contactPhone: '', contactTier: '', contactLinkedin: '' });
  const [validating, setValidating] = useState(false);
  const [validation, setValidation] = useState(null);
  const [skipKeys, setSkipKeys] = useState(new Set());
  const [importing, setImporting] = useState(false);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState('');

  function handleFileChange(e) {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f); setErr('');
    const reader = new FileReader();
    reader.onload = ev => {
      const rows = parseCSVText(ev.target.result);
      if (rows.length < 2) { setErr('File must have a header row + data rows'); return; }
      const hdrs = rows[0];
      const rawData = rows.slice(1).map(r => { const o = {}; hdrs.forEach((h, i) => { o[h] = r[i] || ''; }); return o; });
      setHeaders(hdrs);
      setRawRows(rawData);
      const lower = hdrs.map(h => h.toLowerCase());
      const guess = (keys) => { for (const k of keys) { const i = lower.findIndex(h => h.includes(k)); if (i >= 0) return hdrs[i]; } return ''; };
      setMapping({
        orgName: guess(['company name','city','organization','municipality','entity','name']),
        orgState: guess(['state','province']),
        contactName: guess(['contact name','full name','contact','person','representative']),
        contactTitle: guess(['job title','title','position','role']),
        contactEmail: guess(['email address','email','e-mail']),
        contactPhone: guess(['phone number','phone','mobile','cell','telephone']),
        contactTier: guess(['civicbot tier','tier']),
        contactLinkedin: guess(['linkedin']),
      });
      setStep(2);
    };
    reader.readAsText(f);
  }

  async function runValidation() {
    if (!mapping.orgName) { setErr('Map the City / Organization Name column first'); return; }
    if (!mapping.contactName) { setErr('Map the Contact Name column first'); return; }
    setValidating(true); setErr('');
    try {
      const r = await fetch(`${API}/api/sales/import/contacts/validate`, {
        method: 'POST', headers: apiHeaders(token),
        body: JSON.stringify({ rows: rawRows, mapping }),
      }).then(r => r.json());
      if (r.error) throw new Error(r.error);
      setValidation(r);
      // Default: skip all unmatched groups
      const unmatched = new Set();
      (r.groups || []).forEach(g => { if (!g.matched) unmatched.add(g.key); });
      setSkipKeys(unmatched);
      setStep(3);
    } catch (e) { setErr(e.message || 'Unknown error'); }
    setValidating(false);
  }

  async function confirmImport() {
    setImporting(true); setErr('');
    try {
      const r = await fetch(`${API}/api/sales/import/contacts/confirm`, {
        method: 'POST', headers: apiHeaders(token),
        body: JSON.stringify({ rows: rawRows, mapping, skipKeys: [...skipKeys] }),
      }).then(r => r.json());
      if (r.error) throw new Error(r.error);
      setDone(r); setStep(4);
    } catch (e) { setErr(e.message); }
    setImporting(false);
  }

  function toggleSkip(key) {
    setSkipKeys(prev => { const n = new Set(prev); n.has(key) ? n.delete(key) : n.add(key); return n; });
  }

  const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 };
  const modal = { background: '#fff', borderRadius: 12, padding: 24, maxWidth: 760, width: '100%', maxHeight: '90vh', overflowY: 'auto' };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 20, color: '#1e3a5f' }}>👥 Import Contacts</h2>
            <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>Add contacts to existing opportunities. Cities are matched by name + state.</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 22, color: '#94a3b8', cursor: 'pointer' }}>×</button>
        </div>

        {err && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', padding: '10px 14px', borderRadius: 6, marginBottom: 12, fontSize: 13 }}>⚠ {err}</div>}

        {/* Step indicators */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {['Upload', 'Map Columns', 'Review Matches', 'Done'].map((s, i) => (
            <div key={i} style={{ flex: 1, padding: '6px 10px', borderRadius: 6, fontSize: 11, fontWeight: 700, textAlign: 'center', background: step > i ? '#16a34a25' : step === i + 1 ? '#1e3a5f' : '#f1f5f9', color: step > i ? '#15803d' : step === i + 1 ? '#fff' : '#64748b' }}>
              {step > i ? '✓ ' : ''}{i + 1}. {s}
            </div>
          ))}
        </div>

        {step === 1 && (
          <div>
            <div style={{ padding: 30, border: '2px dashed #cbd5e1', borderRadius: 10, textAlign: 'center' }}>
              <div style={{ fontSize: 36, marginBottom: 10 }}>📄</div>
              <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4, color: '#1e3a5f' }}>Upload your contacts CSV</div>
              <div style={{ fontSize: 12, color: '#64748b', marginBottom: 14 }}>One row per contact. Each row should include the city name (and state, if you have it) so we can match against existing opportunities.</div>
              <input type="file" accept=".csv" onChange={handleFileChange} />
            </div>
          </div>
        )}

        {step === 2 && (
          <div>
            <div style={{ fontSize: 13, color: '#475569', marginBottom: 12 }}>Tell us which CSV column maps to each field. Required: City Name and Contact Name.</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {[
                ['orgName', 'City / Org Name *', true],
                ['orgState', 'State', false],
                ['contactName', 'Contact Name *', true],
                ['contactTitle', 'Title', false],
                ['contactEmail', 'Email', false],
                ['contactPhone', 'Phone', false],
                ['contactTier', 'Tier', false],
                ['contactLinkedin', 'LinkedIn', false],
              ].map(([k, lbl, req]) => (
                <div key={k}>
                  <label style={{ fontSize: 11, color: '#64748b', fontWeight: 600, display: 'block', marginBottom: 4 }}>{lbl}</label>
                  <select value={mapping[k] || ''} onChange={e => setMapping({ ...mapping, [k]: e.target.value })} style={{ width: '100%', padding: 8, border: `1px solid ${req && !mapping[k] ? '#dc2626' : '#cbd5e1'}`, borderRadius: 6, fontSize: 13 }}>
                    <option value="">— Skip —</option>
                    {headers.map(h => <option key={h} value={h}>{h}</option>)}
                  </select>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 18, display: 'flex', justifyContent: 'space-between' }}>
              <button onClick={() => setStep(1)} style={{ ...S.btn, ...S.btnSecondary }}>← Back</button>
              <button onClick={runValidation} disabled={validating} style={{ ...S.btn, ...S.btnPrimary }}>{validating ? 'Checking…' : 'Check matches →'}</button>
            </div>
          </div>
        )}

        {step === 3 && validation && (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 10, marginBottom: 14 }}>
              <div style={{ background: '#16a34a15', border: '1px solid #16a34a40', borderRadius: 8, padding: 12 }}>
                <div style={{ fontSize: 11, color: '#15803d', fontWeight: 700, textTransform: 'uppercase' }}>Matched</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#15803d' }}>{validation.matchedGroups} cities</div>
                <div style={{ fontSize: 12, color: '#16a34a' }}>{validation.matchedContactCount} contacts will be added</div>
              </div>
              <div style={{ background: '#dc262615', border: '1px solid #dc262640', borderRadius: 8, padding: 12 }}>
                <div style={{ fontSize: 11, color: '#dc2626', fontWeight: 700, textTransform: 'uppercase' }}>Not matched</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#dc2626' }}>{validation.unmatchedGroups} cities</div>
                <div style={{ fontSize: 12, color: '#dc2626' }}>{validation.unmatchedContactCount} contacts will be skipped</div>
              </div>
            </div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>Unmatched cities are auto-excluded. To import contacts for those cities, first add the opportunity via the regular CSV import, then run this again.</div>
            <div style={{ maxHeight: 280, overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: 6 }}>
              {validation.groups.map(g => (
                <div key={g.key} style={{ display: 'flex', alignItems: 'center', padding: '8px 12px', borderBottom: '1px solid #e2e8f0', background: g.matched ? '#fff' : '#fef2f2', opacity: skipKeys.has(g.key) ? 0.5 : 1 }}>
                  <input type="checkbox" checked={!skipKeys.has(g.key)} onChange={() => toggleSkip(g.key)} disabled={!g.matched} style={{ marginRight: 10 }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{g.orgName}{g.orgState ? `, ${g.orgState}` : ''}</div>
                    <div style={{ fontSize: 11, color: '#64748b' }}>
                      {g.matched ? `✓ Matches existing opportunity${g.matchedOppName !== g.orgName ? ` "${g.matchedOppName}"` : ''} · adds ${g.contacts.length} contact${g.contacts.length === 1 ? '' : 's'}` : `✗ No existing opportunity found — ${g.contacts.length} contact${g.contacts.length === 1 ? '' : 's'} will be skipped`}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between' }}>
              <button onClick={() => setStep(2)} style={{ ...S.btn, ...S.btnSecondary }}>← Back</button>
              <button onClick={confirmImport} disabled={importing || validation.matchedGroups === 0} style={{ ...S.btn, ...S.btnPrimary }}>{importing ? 'Importing…' : `Import ${validation.matchedContactCount - validation.groups.filter(g => skipKeys.has(g.key)).reduce((s,g)=>s+g.contacts.length,0)} contacts`}</button>
            </div>
          </div>
        )}

        {step === 4 && done && (
          <div style={{ textAlign: 'center', padding: 30 }}>
            <div style={{ fontSize: 48, marginBottom: 10 }}>✅</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#16a34a', marginBottom: 6 }}>Contacts imported</div>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 18 }}>{done.added} contacts added across {done.oppsTouched} opportunities.</div>
            <button onClick={() => { onImported?.(); onClose(); }} style={{ ...S.btn, ...S.btnPrimary }}>Done</button>
          </div>
        )}
      </div>
    </div>
  );
}

// Opportunity detail panel (slide-in)
function OppDetail({ opp, token, onClose, onRefresh, user, atClaimLimit, oppClaimLimit = 50 }) {
  const [detail, setDetail] = useState(null);
  const [editNotes, setEditNotes] = useState(false);
  const [notes, setNotes] = useState('');
  const [editInfo, setEditInfo] = useState(false);
  const [infoForm, setInfoForm] = useState({});
  const [claiming, setClaiming] = useState(false);
  const [msg, setMsg] = useState('');
  const [showLinkCity, setShowLinkCity] = useState(false);
  const [cities, setCities] = useState([]);
  const [citySearch, setCitySearch] = useState('');
  const [linkMsg, setLinkMsg] = useState('');
  const canEdit = user?.salesRole === 'super_admin' || user?.salesRole === 'sales_director' || user?.salesRole === 'sales_manager';
  const isSuperOrDir = user?.salesRole === 'super_admin' || user?.salesRole === 'sales_director';

  useEffect(() => { loadDetail(); }, [opp.id]);

  async function loadDetail() {
    const d = await fetch(`${API}/api/sales/opportunities/${opp.id}`, { headers: apiHeaders(token) }).then(r => r.json());
    setDetail(d); setNotes(d.notes || '');
  }

  async function saveInfo() {
    await fetch(`${API}/api/sales/opportunities/${opp.id}`, { method: 'PATCH', headers: apiHeaders(token), body: JSON.stringify(infoForm) });
    setEditInfo(false); loadDetail();
  }

  async function saveNotes() {
    await fetch(`${API}/api/sales/opportunities/${opp.id}`, { method: 'PATCH', headers: apiHeaders(token), body: JSON.stringify({ notes }) });
    setEditNotes(false); loadDetail();
  }

  async function claim() {
    setClaiming(true); setMsg('');
    const r = await fetch(`${API}/api/sales/opportunities/${opp.id}/claim`, { method: 'POST', headers: apiHeaders(token) }).then(r => r.json());
    setClaiming(false);
    if (r.error) { setMsg(r.error); return; }
    setMsg('Claimed! Moving to your Leads…');
    setTimeout(() => { onRefresh(); onClose(); }, 1200);
  }

  async function exclude() {
    if (!window.confirm('Exclude this opportunity? It will be hidden from the default view.')) return;
    await fetch(`${API}/api/sales/opportunities/${opp.id}/exclude`, { method: 'POST', headers: apiHeaders(token) });
    onRefresh(); onClose();
  }

  async function restore() {
    await fetch(`${API}/api/sales/opportunities/${opp.id}/restore`, { method: 'POST', headers: apiHeaders(token) });
    onRefresh(); onClose();
  }

  async function openLinkPanel() {
    setLinkMsg(''); setCitySearch('');
    if (!cities.length) {
      const data = await fetch(`${API}/api/sales/cities`, { headers: apiHeaders(token) }).then(r => r.json());
      setCities(Array.isArray(data) ? data : []);
    }
    setShowLinkCity(true);
  }

  async function linkCity(cityId) {
    setLinkMsg('Linking…');
    const r = await fetch(`${API}/api/sales/opportunities/${opp.id}/link-city`, { method: 'POST', headers: apiHeaders(token), body: JSON.stringify({ cityId }) }).then(r => r.json());
    if (r.ok) { setLinkMsg('✅ Linked'); setShowLinkCity(false); loadDetail(); }
    else setLinkMsg(r.error || 'Failed');
  }

  async function unlinkCity() {
    if (!window.confirm('Remove the city link from this opportunity?')) return;
    await fetch(`${API}/api/sales/opportunities/${opp.id}/link-city`, { method: 'DELETE', headers: apiHeaders(token) });
    loadDetail();
  }

  const statusColor = STATUS_COLORS[opp.status] || '#94a3b8';

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 900, display: 'flex', justifyContent: 'flex-end' }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: '#fff', width: '100%', maxWidth: 480, height: '100%', overflowY: 'auto', padding: 24, boxShadow: '-4px 0 24px rgba(0,0,0,0.12)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
          <div>
            <h2 style={{ ...S.h2, margin: 0 }}>{opp.org_name}</h2>
            <div style={{ display: 'flex', gap: 6, marginTop: 6, alignItems: 'center' }}>
              {opp.org_state && <span style={{ ...S.badge }}>{opp.org_state}</span>}
              {opp.org_type && <span style={{ ...S.badge }}>{opp.org_type}</span>}
              <span style={{ ...S.badge, background: statusColor + '20', color: statusColor }}>{STATUS_LABELS[opp.status]}</span>
            </div>
          </div>
          <button onClick={onClose} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>✕</button>
        </div>

        {msg && <div style={S.success}>{msg}</div>}

        {/* Prior trial warning */}
        {opp.prior_trial === 1 && (
          <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13, color: '#b91c1c', display: 'flex', gap: 8, alignItems: 'center' }}>
            <span>🚩</span>
            <span><strong>Prior Trial — Did Not Convert.</strong> This city completed a 30-day trial but did not purchase. Review their history before outreach.</span>
          </div>
        )}

        {/* Linked CivicBot City */}
        <div style={{ ...S.card, marginBottom: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: detail?.linkedCity ? 10 : 0 }}>
            <h3 style={{ ...S.h3, margin: 0 }}>🏙 Linked CivicBot City</h3>
            {isSuperOrDir && !detail?.linkedCity && <button onClick={openLinkPanel} style={{ ...S.btn, ...S.btnPrimary, ...S.btnSm }}>+ Link City</button>}
            {isSuperOrDir && detail?.linkedCity && <button onClick={unlinkCity} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>Unlink</button>}
          </div>
          {detail?.linkedCity ? (
            <div style={{ fontSize: 13 }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>{detail.linkedCity.name}{detail.linkedCity.state ? `, ${detail.linkedCity.state}` : ''}</div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <span style={{ ...S.badge, background: detail.linkedCity.billing_status === 'active' ? '#dcfce7' : '#fef9c3', color: detail.linkedCity.billing_status === 'active' ? '#16a34a' : '#92400e' }}>
                  {detail.linkedCity.billing_status === 'active' ? '✅ Active' : detail.linkedCity.billing_status === 'trialing' ? '🎉 Trial' : detail.linkedCity.billing_status || 'No Trial'}
                </span>
                {detail.linkedCity.plan_name && <span style={S.badge}>{detail.linkedCity.plan_name}</span>}
                {detail.linkedCity.trial_ends_at && <span style={{ ...S.badge, background: '#f1f5f9', color: '#64748b' }}>Trial: {new Date(detail.linkedCity.trial_ends_at).toLocaleDateString()}</span>}
              </div>
            </div>
          ) : (
            <p style={{ color: '#94a3b8', fontSize: 13, margin: 0 }}>{isSuperOrDir ? 'No city linked yet. Use "+ Link City" to connect this opportunity to an existing CivicBot city.' : 'Not linked to a CivicBot city.'}</p>
          )}
          {linkMsg && <div style={{ marginTop: 8, fontSize: 13, color: linkMsg.startsWith('✅') ? '#16a34a' : '#ef4444' }}>{linkMsg}</div>}

          {/* City picker */}
          {showLinkCity && (
            <div style={{ marginTop: 12, borderTop: '1px solid #e2e8f0', paddingTop: 12 }}>
              <input style={{ ...S.input, marginBottom: 8 }} placeholder="Search city name…" value={citySearch} onChange={e => setCitySearch(e.target.value)} autoFocus />
              <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: 6 }}>
                {cities.filter(c => !citySearch || c.name.toLowerCase().includes(citySearch.toLowerCase()) || (c.state || '').toLowerCase().includes(citySearch.toLowerCase()))
                  .slice(0, 30).map(c => (
                    <div key={c.id} onClick={() => linkCity(c.id)} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', fontSize: 13, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'} onMouseLeave={e => e.currentTarget.style.background = ''}>
                      <span>{c.name}{c.state ? `, ${c.state}` : ''}</span>
                      <span style={{ fontSize: 11, color: '#94a3b8' }}>{c.billingStatus === 'active' ? '✅ Active' : c.billingStatus === 'trialing' ? '🎉 Trial' : c.billingStatus || '—'}</span>
                    </div>
                  ))}
                {!cities.length && <div style={{ padding: 12, color: '#94a3b8', fontSize: 13 }}>Loading cities…</div>}
              </div>
              <button onClick={() => setShowLinkCity(false)} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm, marginTop: 8 }}>Cancel</button>
            </div>
          )}
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
          {opp.status === 'available' && (
            <button onClick={claim} disabled={claiming || atClaimLimit} title={atClaimLimit ? `At ${oppClaimLimit}-lead capacity — release a lead first` : ''} style={{ ...S.btn, ...S.btnPrimary, flex: 1, opacity: atClaimLimit ? 0.5 : 1, cursor: atClaimLimit ? 'not-allowed' : 'pointer' }}>{claiming ? 'Claiming…' : atClaimLimit ? '⚡ Claim (At Limit)' : '⚡ Claim as Lead'}</button>
          )}
          {opp.status === 'claimed' && opp.lead_id && (
            <Link to={`/leads/${opp.lead_id}`} style={{ ...S.btn, ...S.btnPrimary, flex: 1, textDecoration: 'none', textAlign: 'center' }}>View Lead →</Link>
          )}
          {opp.status === 'converted' && (
            <span style={{ fontSize: 13, color: '#16a34a', fontWeight: 600 }}>✓ Converted to Customer</span>
          )}
          {(canEdit || isSuperOrDir) && opp.status !== 'excluded' && opp.status !== 'converted' && (
            <button onClick={exclude} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>Exclude</button>
          )}
          {opp.status === 'excluded' && (canEdit || isSuperOrDir) && (
            <button onClick={restore} style={{ ...S.btn, ...S.btnSecondary }}>↩ Restore</button>
          )}
        </div>

        {/* Info */}
        <div style={S.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h3 style={{ ...S.h3, margin: 0 }}>Details</h3>
            {!editInfo && <button onClick={() => { setEditInfo(true); setInfoForm({ orgName: detail?.org_name || opp.org_name || '', orgState: detail?.org_state || opp.org_state || '', orgType: detail?.org_type || opp.org_type || '', status: detail?.status || opp.status || 'available', website: detail?.website || '', population: detail?.population || '', source: detail?.source || '', employeeSize: detail?.employee_size || '', companyLinkedin: detail?.company_linkedin || '', companyFacebook: detail?.company_facebook || '', companyTwitter: detail?.company_twitter || '' }); }} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>Edit</button>}
          </div>
          {editInfo ? (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                <div style={{ gridColumn: 'span 2' }}>
                  <label style={{ ...S.label, fontSize: 11 }}>Organization Name</label>
                  <input style={{ ...S.input, fontSize: 12 }} value={infoForm.orgName || ''} onChange={e => setInfoForm(ef => ({ ...ef, orgName: e.target.value }))} />
                </div>
                <div>
                  <label style={{ ...S.label, fontSize: 11 }}>State</label>
                  <input style={{ ...S.input, fontSize: 12 }} value={infoForm.orgState || ''} onChange={e => setInfoForm(ef => ({ ...ef, orgState: e.target.value }))} placeholder="e.g. CA" maxLength={2} />
                </div>
                <div>
                  <label style={{ ...S.label, fontSize: 11 }}>Org Type</label>
                  <input style={{ ...S.input, fontSize: 12 }} value={infoForm.orgType || ''} onChange={e => setInfoForm(ef => ({ ...ef, orgType: e.target.value }))} placeholder="e.g. Government" />
                </div>
                <div>
                  <label style={{ ...S.label, fontSize: 11 }}>Status</label>
                  <select style={{ ...S.select, fontSize: 12 }} value={infoForm.status || 'available'} onChange={e => setInfoForm(ef => ({ ...ef, status: e.target.value }))}>
                    <option value="available">Available</option>
                    <option value="claimed">Claimed</option>
                    <option value="excluded">Excluded</option>
                    <option value="converted">Converted</option>
                  </select>
                </div>
                <div>
                  <label style={{ ...S.label, fontSize: 11 }}>Source</label>
                  <input style={{ ...S.input, fontSize: 12 }} value={infoForm.source || ''} onChange={e => setInfoForm(ef => ({ ...ef, source: e.target.value }))} />
                </div>
                {[['website','Website'],['population','Population'],['employeeSize','Employee Size']].map(([f,l]) => (
                  <div key={f}><label style={{ ...S.label, fontSize: 11 }}>{l}</label>
                    <input style={{ ...S.input, fontSize: 12 }} value={infoForm[f] || ''} onChange={e => setInfoForm(ef => ({ ...ef, [f]: e.target.value }))} /></div>
                ))}
              </div>
              <div style={{ marginBottom: 8 }}>
                <label style={{ ...S.label, fontSize: 11 }}>Company LinkedIn</label>
                <input style={{ ...S.input, fontSize: 12 }} value={infoForm.companyLinkedin || ''} onChange={e => setInfoForm(ef => ({ ...ef, companyLinkedin: e.target.value }))} placeholder="https://linkedin.com/company/..." />
              </div>
              <div style={{ marginBottom: 8 }}>
                <label style={{ ...S.label, fontSize: 11 }}>Company Facebook</label>
                <input style={{ ...S.input, fontSize: 12 }} value={infoForm.companyFacebook || ''} onChange={e => setInfoForm(ef => ({ ...ef, companyFacebook: e.target.value }))} placeholder="https://facebook.com/..." />
              </div>
              <div style={{ marginBottom: 8 }}>
                <label style={{ ...S.label, fontSize: 11 }}>Company Twitter/X</label>
                <input style={{ ...S.input, fontSize: 12 }} value={infoForm.companyTwitter || ''} onChange={e => setInfoForm(ef => ({ ...ef, companyTwitter: e.target.value }))} placeholder="https://x.com/..." />
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={saveInfo} style={{ ...S.btn, ...S.btnPrimary, ...S.btnSm }}>Save</button>
                <button onClick={() => setEditInfo(false)} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>Cancel</button>
              </div>
            </div>
          ) : (
            <>
              {[
                ['Source', detail?.source || opp.source],
                ['Website', detail?.website || opp.website],
                ['Population', (detail?.population || opp.population)?.toLocaleString()],
                ['Employee Size', detail?.employee_size],
                ['Imported', formatDate(opp.created_at)],
                opp.claimed_by_rep_name ? ['Claimed By', `${opp.claimed_by_rep_name} on ${formatDate(opp.claimed_at)}`] : null,
              ].filter(Boolean).map(([k, v]) => (
                <div key={k} style={{ display: 'flex', gap: 8, marginBottom: 8, fontSize: 13 }}>
                  <span style={{ color: '#64748b', minWidth: 100 }}>{k}</span>
                  <span style={{ wordBreak: 'break-all', color: v ? '#1e293b' : '#cbd5e1' }}>{v || '—'}</span>
                </div>
              ))}
              <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                {detail?.company_linkedin
                  ? <a href={detail.company_linkedin.startsWith('http') ? detail.company_linkedin : 'https://' + detail.company_linkedin} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#0a66c2', textDecoration: 'none', fontWeight: 600 }}>LinkedIn ↗</a>
                  : <span style={{ fontSize: 12, color: '#cbd5e1' }}>LinkedIn —</span>}
                {detail?.company_facebook
                  ? <a href={detail.company_facebook.startsWith('http') ? detail.company_facebook : 'https://' + detail.company_facebook} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#1877f2', textDecoration: 'none', fontWeight: 600 }}>Facebook ↗</a>
                  : <span style={{ fontSize: 12, color: '#cbd5e1' }}>Facebook —</span>}
                {detail?.company_twitter
                  ? <a href={detail.company_twitter.startsWith('http') ? detail.company_twitter : 'https://' + detail.company_twitter} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>X/Twitter ↗</a>
                  : <span style={{ fontSize: 12, color: '#cbd5e1' }}>X/Twitter —</span>}
              </div>
            </>
          )}
        </div>

        {/* Notes */}
        <div style={{ ...S.card, marginTop: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h3 style={{ ...S.h3, margin: 0 }}>Notes</h3>
            {!editNotes && <button onClick={() => setEditNotes(true)} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>Edit</button>}
          </div>
          {editNotes ? (
            <div>
              <textarea style={{ ...S.textarea, minHeight: 80 }} value={notes} onChange={e => setNotes(e.target.value)} />
              <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
                <button onClick={saveNotes} style={{ ...S.btn, ...S.btnPrimary, ...S.btnSm }}>Save</button>
                <button onClick={() => { setEditNotes(false); setNotes(detail?.notes || ''); }} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>Cancel</button>
              </div>
            </div>
          ) : <p style={{ color: notes ? '#374151' : '#94a3b8', fontSize: 13, margin: 0 }}>{notes || 'No notes yet.'}</p>}
        </div>

        {/* Contacts */}
        <div style={{ ...S.card, marginTop: 12 }}>
          <h3 style={S.h3}>Contacts ({detail?.contacts?.length || 0})</h3>
          {detail ? (
            <ContactList contacts={detail.contacts || []} entityType="opportunity" entityId={opp.id} token={token} onRefresh={loadDetail} canEdit={true} />
          ) : <p style={{ color: '#94a3b8', fontSize: 13 }}>Loading…</p>}
        </div>

        {/* Lead history (if claimed before) */}
        {detail?.lead && (
          <div style={{ ...S.card, marginTop: 12, background: '#f8fafc' }}>
            <h3 style={{ ...S.h3, fontSize: 13 }}>Lead History</h3>
            <p style={{ fontSize: 13, color: '#64748b', margin: 0 }}>Stage: <strong>{detail.lead.stage}</strong></p>
          </div>
        )}
      </div>
    </div>
  );
}

function OpportunitiesPage() {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const [opps, setOpps] = useState([]);
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stateFilter, setStateFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('available');
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('created_at');
  const [dir, setDir] = useState('desc');
  const [selectedOpp, setSelectedOpp] = useState(null);
  const [showImport, setShowImport] = useState(false);
  const [showContactsImport, setShowContactsImport] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [addForm, setAddForm] = useState({ orgName: '', orgState: '', orgType: '', website: '', population: '', source: '', notes: '', planTier: 'starter', isCwPlan: false, hasAnswers: false, claimNow: false });
  const [addContacts, setAddContacts] = useState([{ name: '', title: '', email: '', phone: '' }]);
  const [adding, setAdding] = useState(false);
  const [addErr, setAddErr] = useState('');
  const [oppClaimCount, setOppClaimCount] = useState(0);
  const [oppClaimLimit, setOppClaimLimit] = useState(50);
  const [statusCounts, setStatusCounts] = useState({ available: 0, claimed: 0, converted: 0, excluded: 0 });
  const [checkedIds, setCheckedIds] = useState(new Set());
  const [bulkClaiming, setBulkClaiming] = useState(false);
  const [bulkResults, setBulkResults] = useState(null);
  const isSuperOrDir = user?.salesRole === 'super_admin' || user?.salesRole === 'sales_director'; // eslint-disable-line no-unused-vars
  const isManager = ['super_admin','sales_director','sales_manager'].includes(user?.salesRole);
  const atClaimLimit = oppClaimCount >= oppClaimLimit;
  const [syncingTrials, setSyncingTrials] = useState(false);
  const [popMode, setPopMode] = useState('');        // '' | 'lt' | 'gt' | 'between'
  const [popMin, setPopMin] = useState('');
  const [popMax, setPopMax] = useState('');
  const [sourceFilter, setSourceFilter] = useState('');
  const [sources, setSources] = useState([]);

  async function syncExpiredTrials() {
    if (!window.confirm('Scan for cities whose 30-day trials expired 60+ days ago with no conversion, and add them to Opportunities with a red flag? This is safe to run multiple times.')) return;
    setSyncingTrials(true);
    try {
      const r = await fetch(`${API}/api/sales/opportunities/sync-expired-trials`, { method: 'POST', headers: apiHeaders(token) }).then(r => r.json());
      if (r.ok) { alert(`Done. ${r.created} new opportunity${r.created !== 1 ? 'ies' : 'y'} created from ${r.total} expired trial${r.total !== 1 ? 's' : ''}.`); load(); }
      else alert(r.error || 'Sync failed');
    } catch { alert('Network error'); }
    setSyncingTrials(false);
  }

  const [exportingCsv, setExportingCsv] = useState(false);
  async function exportOpportunitiesCsv() {
    setExportingCsv(true);
    try {
      const r = await fetch(`${API}/api/sales/opportunities/export.csv`, { headers: apiHeaders(token) });
      if (!r.ok) { alert('Export failed'); return; }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `civicbot-opportunities-leads-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch { alert('Network error'); }
    setExportingCsv(false);
  }

  async function handleAddOpp(e) {
    e.preventDefault();
    if (!addForm.orgName.trim()) { setAddErr('Organization name is required'); return; }
    setAdding(true); setAddErr('');
    try {
      const { claimNow, ...oppFields } = addForm;
      const r = await fetch(`${API}/api/sales/opportunities`, {
        method: 'POST', headers: apiHeaders(token),
        body: JSON.stringify({ ...oppFields, population: addForm.population ? parseInt(addForm.population) : null }),
      }).then(r => r.json());
      if (r.error) throw new Error(r.error);
      // Add contacts
      for (let i = 0; i < addContacts.length; i++) {
        const c = addContacts[i];
        if (!c.name.trim()) continue;
        await fetch(`${API}/api/sales/opportunities/${r.id}/contacts`, {
          method: 'POST', headers: apiHeaders(token),
          body: JSON.stringify({ ...c, sort_order: i }),
        });
      }
      setShowAdd(false);
      setAddForm({ orgName: '', orgState: '', orgType: '', website: '', population: '', source: '', notes: '', planTier: 'starter', isCwPlan: false, hasAnswers: false, claimNow: false });
      setAddContacts([{ name: '', title: '', email: '', phone: '' }]);
      if (claimNow) {
        const claimRes = await fetch(`${API}/api/sales/opportunities/${r.id}/claim`, { method: 'POST', headers: apiHeaders(token) }).then(res => res.json());
        if (claimRes.leadId) { navigate(`/leads/${claimRes.leadId}`); return; }
      }
      load();
    } catch (err) { setAddErr(err.message); }
    setAdding(false);
  }

  async function handleBulkClaim() {
    const ids = [...checkedIds];
    if (!ids.length) return;
    setBulkClaiming(true);
    const claimed = [], failed = [];
    let currentCount = oppClaimCount;
    for (const id of ids) {
      const opp = opps.find(o => o.id === id);
      const name = opp?.org_name || id;
      if (currentCount >= oppClaimLimit) {
        failed.push({ name, reason: `Exceeds your ${oppClaimLimit}-lead capacity limit` });
        continue;
      }
      const r = await fetch(`${API}/api/sales/opportunities/${id}/claim`, { method: 'POST', headers: apiHeaders(token) }).then(res => res.json());
      if (r.leadId) { claimed.push({ name, leadId: r.leadId }); currentCount++; }
      else { failed.push({ name, reason: r.error || 'Unknown error' }); }
    }
    setBulkResults({ claimed, failed });
    setBulkClaiming(false);
    setCheckedIds(new Set());
    await load();
  }

  async function load() {
    setLoading(true);
    const params = new URLSearchParams({ sort, dir });
    if (stateFilter) params.set('state', stateFilter);
    if (statusFilter) params.set('status', statusFilter);
    if (search) params.set('search', search);
    if (popMode === 'lt' && popMin) params.set('popLt', popMin);
    if (popMode === 'gt' && popMin) params.set('popGt', popMin);
    if (popMode === 'between' && popMin) params.set('popGt', popMin);
    if (popMode === 'between' && popMax) params.set('popLt', popMax);
    if (sourceFilter) params.set('source', sourceFilter);
    const [data, countData] = await Promise.all([
      fetch(`${API}/api/sales/opportunities?${params}`, { headers: apiHeaders(token) }).then(r => r.json()),
      fetch(`${API}/api/sales/leads/opp-claim-count`, { headers: apiHeaders(token) }).then(r => r.json()),
    ]);
    setOpps(data.opportunities || []);
    setStates(data.states || []);
    if (data.statusCounts) setStatusCounts(data.statusCounts);
    if (data.sources) setSources(data.sources);
    if (countData?.count != null) setOppClaimCount(countData.count);
    if (countData?.limit != null) setOppClaimLimit(countData.limit);
    setLoading(false);
  }

  useEffect(() => { load(); }, [stateFilter, statusFilter, search, sort, dir, popMode, popMin, popMax, sourceFilter]); // eslint-disable-line react-hooks/exhaustive-deps

  function toggleSort(col) { if (sort === col) setDir(d => d === 'asc' ? 'desc' : 'asc'); else { setSort(col); setDir('asc'); } }
  function SortBtn({ col, label }) {
    return <span onClick={() => toggleSort(col)} style={{ cursor: 'pointer', userSelect: 'none' }}>{label}{sort === col ? (dir === 'asc' ? ' ↑' : ' ↓') : ''}</span>;
  }

  const counts = statusCounts;
  const availableOpps = opps.filter(o => o.status === 'available');
  const allAvailableChecked = availableOpps.length > 0 && availableOpps.every(o => checkedIds.has(o.id));
  const someChecked = checkedIds.size > 0;
  const canClaimMore = oppClaimLimit - oppClaimCount;

  return (
    <div className="cb-main" style={S.main}>
      {showImport && <ImportWizard token={token} onClose={() => setShowImport(false)} onImported={load} />}
      {showContactsImport && <ContactsImportWizard token={token} onClose={() => setShowContactsImport(false)} onImported={load} />}
      {selectedOpp && <OppDetail opp={selectedOpp} token={token} user={user} atClaimLimit={atClaimLimit} oppClaimLimit={oppClaimLimit} onClose={() => setSelectedOpp(null)} onRefresh={() => { load(); setSelectedOpp(null); }} />}

      {/* Manual Add Opportunity Modal */}
      {showAdd && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 600, maxHeight: '90vh', overflow: 'auto', padding: 28 }}>
            <div style={{ ...S.spaceBetween, marginBottom: 20 }}>
              <h2 style={{ ...S.h2, margin: 0 }}>Add Opportunity</h2>
              <button onClick={() => { setShowAdd(false); setAddErr(''); }} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>✕</button>
            </div>
            {addErr && <div style={S.error}>{addErr}</div>}
            <form onSubmit={handleAddOpp}>
              {/* Organization info */}
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#94a3b8', marginBottom: 10 }}>Organization</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={S.label}>Organization Name *</label>
                    <input style={S.input} required value={addForm.orgName} onChange={e => setAddForm(f => ({ ...f, orgName: e.target.value }))} placeholder="e.g. City of Gilroy" autoFocus />
                  </div>
                  <div>
                    <label style={S.label}>State</label>
                    <input style={S.input} value={addForm.orgState} onChange={e => setAddForm(f => ({ ...f, orgState: e.target.value }))} placeholder="e.g. CA" maxLength={2} />
                  </div>
                  <div>
                    <label style={S.label}>Org Type</label>
                    <select style={S.select} value={addForm.orgType} onChange={e => setAddForm(f => ({ ...f, orgType: e.target.value }))}>
                      <option value="">— Select —</option>
                      {['City','County','Township','District','Borough','Municipality','Other'].map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={S.label}>Website</label>
                    <input style={S.input} value={addForm.website} onChange={e => setAddForm(f => ({ ...f, website: e.target.value }))} placeholder="https://..." />
                  </div>
                  <div>
                    <label style={S.label}>Population</label>
                    <input style={S.input} type="number" min="0" value={addForm.population} onChange={e => setAddForm(f => ({ ...f, population: e.target.value }))} placeholder="e.g. 45000" />
                  </div>
                  <div>
                    <label style={S.label}>Source</label>
                    <input style={S.input} value={addForm.source} onChange={e => setAddForm(f => ({ ...f, source: e.target.value }))} placeholder="e.g. GRAMA Request, Referral" />
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={S.label}>Notes</label>
                    <textarea style={{ ...S.textarea, minHeight: 64 }} value={addForm.notes} onChange={e => setAddForm(f => ({ ...f, notes: e.target.value }))} placeholder="Any relevant background…" />
                  </div>
                </div>
              </div>

              {/* Product / Plan */}
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#94a3b8', marginBottom: 10 }}>Product</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div>
                    <label style={S.label}>Plan Level</label>
                    <select style={S.select} value={addForm.planTier} onChange={e => setAddForm(f => ({ ...f, planTier: e.target.value }))}>
                      <option value="starter">Starter</option>
                      <option value="growth">Growth</option>
                      <option value="professional">Professional</option>
                    </select>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, justifyContent: 'flex-end', paddingBottom: 2 }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, fontWeight: 500, color: '#374151' }}>
                      <input type="checkbox" checked={addForm.isCwPlan} onChange={e => setAddForm(f => ({ ...f, isCwPlan: e.target.checked }))} />
                      Cityworks / Trimble Unity
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, fontWeight: 500, color: '#374151' }}>
                      <input type="checkbox" checked={addForm.hasAnswers} onChange={e => setAddForm(f => ({ ...f, hasAnswers: e.target.checked }))} />
                      CivicBot Answers add-on
                    </label>
                  </div>
                </div>
              </div>

              {/* Contacts */}
              <div style={{ marginBottom: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#94a3b8' }}>Contacts</div>
                  {addContacts.length < 15 && (
                    <button type="button" onClick={() => setAddContacts(cs => [...cs, { name: '', title: '', email: '', phone: '' }])} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>+ Add Contact</button>
                  )}
                </div>
                {addContacts.map((c, i) => (
                  <div key={i} style={{ ...S.cardSm, marginBottom: 8, borderLeft: `3px solid ${i === 0 ? '#1e3a5f' : '#e2e8f0'}` }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                      <span style={{ fontSize: 11, fontWeight: 700, color: i === 0 ? '#1e3a5f' : '#94a3b8' }}>{i === 0 ? 'PRIMARY CONTACT' : `Contact ${i + 1}`}</span>
                      {i > 0 && <button type="button" onClick={() => setAddContacts(cs => cs.filter((_, j) => j !== i))} style={{ ...S.btn, ...S.btnSm, background: '#fee2e2', color: '#dc2626', border: 'none', fontSize: 11 }}>✕ Remove</button>}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                      {[['name','Name','text',i===0?'Required for primary':''],['title','Title','text',''],['email','Email','email',''],['phone','Phone','tel','']].map(([field, label, type, ph]) => (
                        <div key={field}>
                          <label style={{ ...S.label, fontSize: 11 }}>{label}{field === 'name' && i === 0 ? '' : ''}</label>
                          <input style={{ ...S.input, fontSize: 13 }} type={type} value={c[field]} onChange={e => setAddContacts(cs => cs.map((x, j) => j === i ? { ...x, [field]: e.target.value } : x))} placeholder={ph} />
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '10px 14px' }}>
                  <input type="checkbox" checked={addForm.claimNow} onChange={e => setAddForm(f => ({ ...f, claimNow: e.target.checked }))} style={{ width: 16, height: 16, cursor: 'pointer' }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#1e40af' }}>Claim immediately after save</div>
                    <div style={{ fontSize: 12, color: '#3b82f6', marginTop: 1 }}>Creates a Lead in your pipeline right away</div>
                  </div>
                </label>
              </div>
              <div style={{ display: 'flex', gap: 10 }}>
                <button type="button" onClick={() => { setShowAdd(false); setAddErr(''); }} style={{ ...S.btn, ...S.btnSecondary, flex: 1 }}>Cancel</button>
                <button type="submit" disabled={adding} style={{ ...S.btn, ...S.btnPrimary, flex: 2 }}>{adding ? 'Saving…' : addForm.claimNow ? 'Add & Claim' : 'Add Opportunity'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div style={{ ...S.spaceBetween, marginBottom: 20 }}>
        <div>
          <h1 style={S.h1}>Opportunities</h1>
          <p style={{ color: '#64748b', fontSize: 14, margin: 0 }}>Cold leads ready to claim and work</p>
        </div>
        <div style={S.row}>
          <button onClick={() => setShowAdd(true)} style={{ ...S.btn, ...S.btnSecondary }}>+ Add Manually</button>
          {user?.salesRole === 'super_admin' && (
            <button onClick={syncExpiredTrials} disabled={syncingTrials} title="Add cities whose 30-day trials expired 60+ days ago as flagged opportunities" style={{ ...S.btn, ...S.btnSecondary, color: '#b91c1c' }}>
              {syncingTrials ? 'Syncing…' : '🚩 Sync Expired Trials'}
            </button>
          )}
          {isManager && <>
            <button onClick={() => setShowImport(true)} style={{ ...S.btn, ...S.btnPrimary }}>⬆ Import CSV</button>
            <button onClick={() => setShowContactsImport(true)} style={{ ...S.btn, ...S.btnSecondary }} title="Add contacts to existing opportunities by matching the city name">👥 Import Contacts</button>
            <button onClick={exportOpportunitiesCsv} disabled={exportingCsv} style={{ ...S.btn, ...S.btnSecondary }} title="Download all opportunities as CSV — for importing into another system">
              {exportingCsv ? 'Exporting…' : '⬇ Export CSV'}
            </button>
          </>}
        </div>
      </div>

      {/* Capacity notice banner */}
      {(() => {
        const pct = Math.min(100, Math.round((oppClaimCount / oppClaimLimit) * 100));
        const isRed = oppClaimCount >= oppClaimLimit, isAmber = oppClaimCount >= oppClaimLimit * 0.8 && oppClaimCount < oppClaimLimit;
        const barColor = isRed ? '#dc2626' : isAmber ? '#d97706' : '#16a34a';
        const bg = isRed ? '#fef2f2' : isAmber ? '#fffbeb' : '#f0fdf4';
        const border = isRed ? '#fca5a5' : isAmber ? '#fcd34d' : '#bbf7d0';
        return (
          <div style={{ background: bg, border: `1px solid ${border}`, borderRadius: 10, padding: '12px 18px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 16 }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}>
                  {isRed ? '🚫 At capacity — release or close a lead before claiming more.' : `✅ Hey ${user?.name?.split(' ')[0] || 'there'}, you can claim up to ${canClaimMore} more ${canClaimMore === 1 ? 'city' : 'cities'} right now.`}
                </span>
                <span style={{ fontSize: 13, fontWeight: 700, color: barColor, whiteSpace: 'nowrap', marginLeft: 12 }}>{oppClaimCount} / {oppClaimLimit} claimed</span>
              </div>
              <div style={{ background: '#e2e8f0', borderRadius: 4, height: 7, overflow: 'hidden' }}>
                <div style={{ width: `${pct}%`, height: '100%', background: barColor, borderRadius: 4, transition: 'width 0.3s' }} />
              </div>
            </div>
          </div>
        );
      })()}

      {/* Bulk results modal */}
      {bulkResults && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 480, padding: 28, maxHeight: '80vh', overflowY: 'auto' }}>
            <h2 style={{ ...S.h2, marginBottom: 4 }}>Bulk Claim Results</h2>
            <p style={{ color: '#64748b', fontSize: 13, marginBottom: 20 }}>
              {bulkResults.claimed.length} claimed · {bulkResults.failed.length} failed
            </p>
            {bulkResults.claimed.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#16a34a', marginBottom: 8 }}>✅ Successfully Claimed</div>
                {bulkResults.claimed.map((c, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '1px solid #f1f5f9' }}>
                    <span style={{ fontSize: 13, fontWeight: 500 }}>{c.name}</span>
                    <Link to={`/leads/${c.leadId}`} onClick={() => setBulkResults(null)} style={{ fontSize: 12, color: '#3b82f6', textDecoration: 'none' }}>View Lead →</Link>
                  </div>
                ))}
              </div>
            )}
            {bulkResults.failed.length > 0 && (
              <div style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#dc2626', marginBottom: 8 }}>❌ Could Not Claim</div>
                {bulkResults.failed.map((f, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '6px 0', borderBottom: '1px solid #f1f5f9', gap: 12 }}>
                    <span style={{ fontSize: 13, fontWeight: 500 }}>{f.name}</span>
                    <span style={{ fontSize: 12, color: '#ef4444', textAlign: 'right', maxWidth: 240 }}>{f.reason}</span>
                  </div>
                ))}
              </div>
            )}
            <button onClick={() => setBulkResults(null)} style={{ ...S.btn, ...S.btnPrimary, width: '100%' }}>Done</button>
          </div>
        </div>
      )}

      {/* Status pills */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['', 'All'], ['available', 'Available'], ['claimed', 'Claimed'], ['converted', 'Converted'], ['excluded', 'Excluded']].map(([val, label]) => (
          <button key={val} onClick={() => setStatusFilter(val)}
            style={{ ...S.btn, ...S.btnSm, background: statusFilter === val ? '#1e3a5f' : '#f1f5f9', color: statusFilter === val ? '#fff' : '#475569', border: 'none' }}>
            {label} {val && counts[val] != null ? <span style={{ opacity: 0.7 }}>({counts[val]})</span> : ''}
          </button>
        ))}
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
        <input style={{ ...S.input, width: 220 }} placeholder="Search organization…" value={search} onChange={e => setSearch(e.target.value)} />
        <select style={{ ...S.select, width: 160 }} value={stateFilter} onChange={e => setStateFilter(e.target.value)}>
          <option value="">All States</option>
          {states.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select style={{ ...S.select, width: 150 }} value={sourceFilter} onChange={e => setSourceFilter(e.target.value)}>
          <option value="">All Sources</option>
          {sources.map(s => <option key={s} value={s}>{s}</option>)}
          <option value="__blank__">— No source —</option>
        </select>
        <select style={{ ...S.select, width: 140 }} value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
          <option value="">All Statuses</option>
          <option value="available">Available</option>
          <option value="claimed">Claimed</option>
          <option value="converted">Converted</option>
          <option value="excluded">Excluded</option>
        </select>
        {/* Population filter */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          <select style={{ ...S.select, width: 130 }} value={popMode} onChange={e => { setPopMode(e.target.value); setPopMin(''); setPopMax(''); }}>
            <option value="">Population: Any</option>
            <option value="lt">Population &lt;</option>
            <option value="gt">Population &gt;</option>
            <option value="between">Population between</option>
          </select>
          {(popMode === 'lt' || popMode === 'gt') && (
            <input type="number" style={{ ...S.input, width: 110 }} placeholder={popMode === 'lt' ? 'Max pop' : 'Min pop'} value={popMin} onChange={e => setPopMin(e.target.value)} />
          )}
          {popMode === 'between' && (<>
            <input type="number" style={{ ...S.input, width: 100 }} placeholder="Min" value={popMin} onChange={e => setPopMin(e.target.value)} />
            <span style={{ fontSize: 12, color: '#64748b' }}>–</span>
            <input type="number" style={{ ...S.input, width: 100 }} placeholder="Max" value={popMax} onChange={e => setPopMax(e.target.value)} />
          </>)}
          {popMode && <button onClick={() => { setPopMode(''); setPopMin(''); setPopMax(''); }} style={{ ...S.btn, ...S.btnSm, ...S.btnSecondary, fontSize: 11 }}>✕ Clear</button>}
        </div>
        <span style={{ color: '#64748b', fontSize: 13, marginLeft: 'auto', alignSelf: 'center' }}>{opps.length} total</span>
      </div>

      {/* Sticky bulk-action bar */}
      {someChecked && (
        <div style={{ position: 'sticky', top: 0, zIndex: 50, background: '#1e3a5f', borderRadius: 10, padding: '10px 16px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 4px 16px rgba(0,0,0,0.18)' }}>
          <span style={{ color: '#fff', fontSize: 13, fontWeight: 600, flex: 1 }}>
            {checkedIds.size} {checkedIds.size === 1 ? 'opportunity' : 'opportunities'} selected
            {atClaimLimit && <span style={{ color: '#fca5a5', marginLeft: 8 }}>— you're at your {oppClaimLimit}-lead limit</span>}
            {!atClaimLimit && checkedIds.size > canClaimMore && <span style={{ color: '#fcd34d', marginLeft: 8 }}>— {checkedIds.size - canClaimMore} will be skipped (capacity)</span>}
          </span>
          <button onClick={() => setCheckedIds(new Set())} style={{ ...S.btn, ...S.btnSm, background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none' }}>Clear</button>
          <button onClick={handleBulkClaim} disabled={bulkClaiming || atClaimLimit} style={{ ...S.btn, ...S.btnSm, background: atClaimLimit ? '#64748b' : '#3b82f6', color: '#fff', border: 'none', opacity: atClaimLimit ? 0.5 : 1, cursor: atClaimLimit ? 'not-allowed' : 'pointer', fontWeight: 700 }}>
            {bulkClaiming ? `Claiming… (${checkedIds.size})` : `⚡ Claim Checked (${checkedIds.size})`}
          </button>
        </div>
      )}

      {loading ? <p style={{ color: '#64748b', textAlign: 'center', padding: 40 }}>Loading…</p> : opps.length === 0 ? (
        <div style={{ ...S.card, textAlign: 'center', padding: '48px 0' }}>
          <div style={{ display:'flex', justifyContent:'center', marginBottom: 12 }}><svg width="48" height="48" viewBox="0 0 36 36" fill="none"><rect width="36" height="36" rx="8" fill="#e2e8f0"/><rect x="5" y="16" width="5" height="15" rx="1" fill="#94a3b8"/><rect x="12" y="11" width="5" height="20" rx="1" fill="#94a3b8"/><rect x="19" y="6" width="5" height="25" rx="1" fill="#94a3b8"/><rect x="26" y="13" width="4" height="18" rx="1" fill="#3b82f6"/></svg></div>
          <p style={{ color: '#64748b' }}>No opportunities found. {isManager && <span>Import a CSV to get started.</span>}</p>
          {isManager && <button onClick={() => setShowImport(true)} style={{ ...S.btn, ...S.btnPrimary, marginTop: 8 }}>⬆ Import CSV</button>}
        </div>
      ) : (
        <div style={S.card}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={{ ...S.th, width: 36 }} onClick={e => e.stopPropagation()}>
                  {availableOpps.length > 0 && (
                    <input type="checkbox" checked={allAvailableChecked} onChange={e => {
                      if (e.target.checked) setCheckedIds(new Set(availableOpps.map(o => o.id)));
                      else setCheckedIds(new Set());
                    }} title="Select all available" style={{ cursor: 'pointer' }} />
                  )}
                </th>
                <th style={S.th}><SortBtn col="org_name" label="Organization" /></th>
                <th style={S.th}><SortBtn col="org_state" label="State" /></th>
                <th style={S.th}><SortBtn col="population" label="Population" /></th>
                <th style={S.th}>Contacts</th>
                <th style={S.th}>Source</th>
                <th style={S.th}><SortBtn col="status" label="Status" /></th>
                <th style={S.th}><SortBtn col="created_at" label="Added" /></th>
                <th style={S.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {opps.map(opp => {
                const statusColor = STATUS_COLORS[opp.status] || '#94a3b8';
                const isChecked = checkedIds.has(opp.id);
                return (
                  <tr key={opp.id} style={{ cursor: 'pointer', background: isChecked ? '#eff6ff' : undefined }} onClick={() => setSelectedOpp(opp)}>
                    <td style={{ ...S.td, width: 36 }} onClick={e => e.stopPropagation()}>
                      {opp.status === 'available' && (
                        <input type="checkbox" checked={isChecked} onChange={e => {
                          const next = new Set(checkedIds);
                          if (e.target.checked) next.add(opp.id); else next.delete(opp.id);
                          setCheckedIds(next);
                        }} style={{ cursor: 'pointer' }} />
                      )}
                    </td>
                    <td style={{ ...S.td, fontWeight: 600 }}>{opp.prior_trial ? <span title="Prior trial — did not convert" style={{ marginRight: 4 }}>🚩</span> : null}{opp.org_name}</td>
                    <td style={S.td}>{opp.org_state || '—'}</td>
                    <td style={{ ...S.td, fontSize: 12, color: '#475569' }}>{opp.population ? opp.population.toLocaleString() : '—'}</td>
                    <td style={S.td}>{opp.contact_count || 0}</td>
                    <td style={{ ...S.td, fontSize: 12, color: '#64748b', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{opp.source || '—'}</td>
                    <td style={S.td}><span style={{ ...S.badge, background: statusColor + '20', color: statusColor }}>{STATUS_LABELS[opp.status]}</span></td>
                    <td style={{ ...S.td, fontSize: 12 }}>{formatDate(opp.created_at)}</td>
                    <td style={S.td} onClick={e => e.stopPropagation()}>
                      {opp.status === 'available' && (
                        <button disabled={atClaimLimit} title={atClaimLimit ? `At ${oppClaimLimit}-lead capacity — release a lead first` : ''} onClick={async () => {
                          const r = await fetch(`${API}/api/sales/opportunities/${opp.id}/claim`, { method: 'POST', headers: apiHeaders(token) }).then(r => r.json());
                          if (r.error) { alert(r.error); return; }
                          if (r.leadId) { load(); navigate(`/leads/${r.leadId}`); }
                        }} style={{ ...S.btn, ...S.btnPrimary, ...S.btnSm, opacity: atClaimLimit ? 0.4 : 1, cursor: atClaimLimit ? 'not-allowed' : 'pointer' }}>⚡ Claim</button>
                      )}
                      {opp.status === 'claimed' && opp.lead_id && (
                        <Link to={`/leads/${opp.lead_id}`} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm, textDecoration: 'none' }}>Lead →</Link>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ─── LEADS ────────────────────────────────────────────────────────────────────

const LEAD_ANNUAL = {
  email: { starter: 2000, growth: 4000, professional: 6000 },
  cw:    { starter: 2500, growth: 5000, professional: 7500 },
};
// Answers add-on pricing is FLAT — same dollar amount whether the base plan
// is Email or Cityworks. (Updated May 2026 — was previously tiered by delivery.)
const LEAD_ANSWERS = {
  email: { starter: 1500, growth: 2000, professional: 3000 },
  cw:    { starter: 1500, growth: 2000, professional: 3000 },
};

function calcLeadArr(lead) {
  const pt = lead.is_cw_plan ? 'cw' : 'email';
  const tier = lead.plan_tier || 'starter';
  const base = LEAD_ANNUAL[pt][tier] || 0;
  const ans = lead.has_answers ? (LEAD_ANSWERS[pt][tier] || 0) : 0;
  return base + ans;
}

// ─── FOLLOW-UPS (CADENCE) ─────────────────────────────────────────────────────

const CADENCE_LABEL = {
  day3: 'Day 3 — Staff workload',
  day7: 'Day 7 — Stat / social proof',
  day14: 'Day 14 — Soft close',
  stale: 'Stale — consider releasing',
  snoozed: '💤 Snoozed',
  replied: '✓ Replied — your turn',
};

function CadenceChip({ cadence, compact }) {
  if (!cadence) return null;
  const colorMap = {
    day3: { bg: '#16a34a25', fg: '#15803d', bd: '#16a34a60' },
    day7: { bg: '#f59e0b25', fg: '#b45309', bd: '#f59e0b60' },
    day14: { bg: '#dc262625', fg: '#dc2626', bd: '#dc262660' },
    stale: { bg: '#64748b25', fg: '#475569', bd: '#64748b60' },
    snoozed: { bg: '#8b5cf625', fg: '#7c3aed', bd: '#8b5cf660' },
    replied: { bg: '#0ea5e925', fg: '#0369a1', bd: '#0ea5e960' },
  };
  const c = colorMap[cadence.stage] || colorMap.stale;
  const lbl = (compact && cadence.stage !== 'replied' && cadence.stage !== 'snoozed')
    ? `🔔 ${cadence.stage === 'stale' ? 'Stale' : cadence.stage.replace('day', 'Day ')} · ${cadence.daysSince ?? '?'}d`
    : CADENCE_LABEL[cadence.stage] || cadence.stage;
  return <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 700, letterSpacing: 0.3, background: c.bg, color: c.fg, border: `1px solid ${c.bd}`, whiteSpace: 'nowrap' }}>{lbl}</span>;
}

function FollowUpsPage() {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState({ groups: { overdue: [], today: [], thisWeek: [], upcoming: [], snoozed: [] }, all: [], dueCount: 0 });
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('calendar'); // 'list' | 'calendar'
  const [weekOffset, setWeekOffset] = useState(0); // 0 = current week, -1 = last week, etc.
  const [snoozeOpenFor, setSnoozeOpenFor] = useState(null);
  const [snoozeDays, setSnoozeDays] = useState(14);
  const [snoozeNote, setSnoozeNote] = useState('');
  const [snoozedExpanded, setSnoozedExpanded] = useState(false);

  async function load() {
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/sales/cadence`, { headers: apiHeaders(token) });
      const d = await r.json();
      if (d.groups) setData(d);
    } catch (e) { console.error(e); }
    setLoading(false);
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  async function doSnooze() {
    if (!snoozeOpenFor) return;
    try {
      const r = await fetch(`${API}/api/sales/cadence/${snoozeOpenFor}/snooze`, {
        method: 'POST', headers: apiHeaders(token),
        body: JSON.stringify({ days: snoozeDays, note: snoozeNote }),
      });
      const d = await r.json();
      if (d.success) {
        setSnoozeOpenFor(null); setSnoozeNote(''); setSnoozeDays(14);
        load();
      }
    } catch {}
  }

  async function unsnooze(leadId) {
    try {
      await fetch(`${API}/api/sales/cadence/${leadId}/snooze`, { method: 'DELETE', headers: apiHeaders(token) });
      load();
    } catch {}
  }

  function openLeadEmail(leadId) {
    navigate(`/leads/${leadId}?tab=email`);
  }

  const card = (l, urgencyClass) => {
    const borderLeftColor = urgencyClass === 'overdue' ? '#dc2626' : urgencyClass === 'today' ? '#f59e0b' : '#16a34a';
    return (
      <div key={l.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderLeft: `3px solid ${borderLeftColor}`, borderRadius: 8, padding: '12px 14px', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 14 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#1e3a5f' }}>{l.city_name}{l.city_state ? `, ${l.city_state}` : ''}</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 2, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            {l.contact_name && <span>👤 {l.contact_name}</span>}
            {l.contact_name && <span>·</span>}
            <span>Last contacted {l.cadence?.daysSince ?? '?'} days ago</span>
            <CadenceChip cadence={l.cadence} />
          </div>
          {l.cadence?.suggestedAngle && <div style={{ fontSize: 11, color: '#475569', marginTop: 4, fontStyle: 'italic' }}>Suggested angle: {l.cadence.suggestedAngle}</div>}
        </div>
        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
          <button onClick={() => openLeadEmail(l.id)} style={{ padding: '6px 12px', borderRadius: 5, fontSize: 11, fontWeight: 700, border: 'none', cursor: 'pointer', background: '#1e3a5f', color: '#fff' }}>✉️ Draft Follow-Up</button>
          <button onClick={() => { setSnoozeOpenFor(l.id); setSnoozeDays(14); setSnoozeNote(''); }} style={{ padding: '6px 12px', borderRadius: 5, fontSize: 11, fontWeight: 700, border: '1px solid #cbd5e1', background: '#fff', color: '#475569', cursor: 'pointer' }}>💤 Snooze</button>
        </div>
      </div>
    );
  };

  // Calendar grouping: leads by dueDate for the displayed week (weekOffset from current)
  function calendarWeek() {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0=Sun
    const monday = new Date(today);
    monday.setDate(today.getDate() - ((dayOfWeek + 6) % 7) + weekOffset * 7);
    const days = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(monday);
      d.setDate(monday.getDate() + i);
      const iso = d.toISOString().slice(0, 10);
      days.push({ iso, date: d, leads: [] });
    }
    // Include all groups so past/future weeks show their leads
    const allLeads = [
      ...(data.groups.overdue || []),
      ...(data.groups.today || []),
      ...(data.groups.thisWeek || []),
      ...(data.groups.upcoming || []),
      ...(data.groups.snoozed || []),
    ];
    allLeads.forEach(l => {
      if (!l.cadence?.dueDate) return;
      const day = days.find(d => d.iso === l.cadence.dueDate);
      if (day) day.leads.push(l);
    });
    return days;
  }

  function calendarWeekLabel() {
    const today = new Date();
    const dow = today.getDay();
    const monday = new Date(today);
    monday.setDate(today.getDate() - ((dow + 6) % 7) + weekOffset * 7);
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const yearStr = sunday.getFullYear() !== new Date().getFullYear() ? ` ${sunday.getFullYear()}` : '';
    return `${fmt(monday)} – ${fmt(sunday)}${yearStr}`;
  }

  return (
    <div style={S.page}>
      <div style={S.main}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 18 }}>
        <div>
          <h1 style={S.h1}>🔔 Follow-Ups</h1>
          <div style={{ color: '#64748b', fontSize: 13, marginTop: 4 }}>Cadence reminders for leads that haven't responded. Review before sending — replies may have come in.</div>
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          <button onClick={() => setView('list')} style={{ padding: '6px 14px', fontSize: 12, borderRadius: 6, border: '1px solid #cbd5e1', background: view === 'list' ? '#1e3a5f' : '#fff', color: view === 'list' ? '#fff' : '#475569', cursor: 'pointer', fontWeight: 600 }}>☰ List</button>
          <button onClick={() => setView('calendar')} style={{ padding: '6px 14px', fontSize: 12, borderRadius: 6, border: '1px solid #cbd5e1', background: view === 'calendar' ? '#1e3a5f' : '#fff', color: view === 'calendar' ? '#fff' : '#475569', cursor: 'pointer', fontWeight: 600 }}>📅 Calendar</button>
        </div>
      </div>

      {/* Legend */}
      <div style={{ display: 'flex', gap: 14, padding: '10px 14px', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, marginBottom: 16, fontSize: 11, color: '#64748b', flexWrap: 'wrap' }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ width: 12, height: 12, borderRadius: 3, background: '#16a34a' }} />Day 3 — Staff workload</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ width: 12, height: 12, borderRadius: 3, background: '#f59e0b' }} />Day 7 — Stat / social proof</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ width: 12, height: 12, borderRadius: 3, background: '#dc2626' }} />Day 14 — Soft close</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ width: 12, height: 12, borderRadius: 3, background: '#64748b' }} />Stale 21+ days</span>
      </div>

      {loading ? <div style={{ padding: 20, color: '#64748b' }}>Loading…</div> :
        view === 'list' ? (
          <>
            {data.groups.overdue.length > 0 && (
              <div style={{ marginBottom: 18 }}>
                <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, padding: '8px 12px', marginBottom: 8, borderRadius: 6, background: '#dc262615', color: '#dc2626' }}>🔴 Overdue <span style={{ background: 'rgba(0,0,0,.1)', padding: '1px 8px', borderRadius: 10, marginLeft: 8 }}>{data.groups.overdue.length}</span></div>
                {data.groups.overdue.map(l => card(l, 'overdue'))}
              </div>
            )}
            {data.groups.today.length > 0 && (
              <div style={{ marginBottom: 18 }}>
                <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, padding: '8px 12px', marginBottom: 8, borderRadius: 6, background: '#f59e0b15', color: '#b45309' }}>🟡 Due Today <span style={{ background: 'rgba(0,0,0,.1)', padding: '1px 8px', borderRadius: 10, marginLeft: 8 }}>{data.groups.today.length}</span></div>
                {data.groups.today.map(l => card(l, 'today'))}
              </div>
            )}
            {data.groups.thisWeek.length > 0 && (
              <div style={{ marginBottom: 18 }}>
                <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, padding: '8px 12px', marginBottom: 8, borderRadius: 6, background: '#16a34a15', color: '#16a34a' }}>🟢 Coming Up This Week <span style={{ background: 'rgba(0,0,0,.1)', padding: '1px 8px', borderRadius: 10, marginLeft: 8 }}>{data.groups.thisWeek.length}</span><span style={{ marginLeft: 8, fontSize: 11, fontWeight: 500, textTransform: 'none', opacity: 0.7 }}>Cadence dates within the next 7 days</span></div>
                {data.groups.thisWeek.map(l => card(l, 'week'))}
              </div>
            )}
            {data.groups.snoozed.length > 0 && (
              <div style={{ marginBottom: 18 }}>
                <div onClick={() => setSnoozedExpanded(s => !s)} style={{ cursor: 'pointer', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, padding: '8px 12px', marginBottom: 8, borderRadius: 6, background: '#8b5cf615', color: '#7c3aed', display: 'flex', alignItems: 'center', gap: 8 }}>💤 Snoozed <span style={{ background: 'rgba(0,0,0,.1)', padding: '1px 8px', borderRadius: 10 }}>{data.groups.snoozed.length}</span><span style={{ marginLeft: 'auto', fontSize: 11, textTransform: 'none', fontWeight: 500 }}>{snoozedExpanded ? '▲ Hide' : '▼ Show'}</span></div>
                {snoozedExpanded && data.groups.snoozed.map(l => (
                  <div key={l.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderLeft: '3px solid #8b5cf6', borderRadius: 8, padding: '12px 14px', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 14, opacity: 0.7 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 14, fontWeight: 700, color: '#1e3a5f' }}>{l.city_name}{l.city_state ? `, ${l.city_state}` : ''}</div>
                      <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Snoozed until <b>{l.snoozed_until}</b>{l.snooze_note ? ` — "${l.snooze_note}"` : ''}</div>
                    </div>
                    <button onClick={() => unsnooze(l.id)} style={{ padding: '6px 12px', borderRadius: 5, fontSize: 11, fontWeight: 700, border: '1px solid #cbd5e1', background: '#fff', color: '#475569', cursor: 'pointer' }}>↺ Resume Now</button>
                  </div>
                ))}
              </div>
            )}
            {data.groups.overdue.length === 0 && data.groups.today.length === 0 && data.groups.thisWeek.length === 0 && data.groups.upcoming?.length === 0 && data.groups.snoozed.length === 0 && (
              <div style={{ padding: 30, textAlign: 'center', color: '#64748b', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8 }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🎉</div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#1e3a5f', marginBottom: 4 }}>You're all caught up!</div>
                <div style={{ fontSize: 12 }}>No follow-ups due. Cadence starts after your first outbound email to each lead.</div>
              </div>
            )}
          </>
        ) : (
          <div>
            {/* Week navigation bar */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 14px' }}>
              <button onClick={() => setWeekOffset(w => w - 1)} style={{ padding: '5px 14px', fontSize: 14, fontWeight: 700, borderRadius: 6, border: '1px solid #cbd5e1', background: '#f8fafc', color: '#1e3a5f', cursor: 'pointer', lineHeight: 1 }}>‹</button>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: '#1e3a5f' }}>{calendarWeekLabel()}</span>
                {weekOffset !== 0 && (
                  <button onClick={() => setWeekOffset(0)} style={{ padding: '3px 10px', fontSize: 11, fontWeight: 600, borderRadius: 5, border: '1px solid #cbd5e1', background: '#f1f5f9', color: '#475569', cursor: 'pointer' }}>Today</button>
                )}
              </div>
              <button onClick={() => setWeekOffset(w => w + 1)} style={{ padding: '5px 14px', fontSize: 14, fontWeight: 700, borderRadius: 6, border: '1px solid #cbd5e1', background: '#f8fafc', color: '#1e3a5f', cursor: 'pointer', lineHeight: 1 }}>›</button>
            </div>
            {/* Calendar grid */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 8 }}>
              {calendarWeek().map(d => {
                const dayName = d.date.toLocaleDateString('en-US', { weekday: 'short' });
                const isToday = d.iso === new Date().toISOString().slice(0, 10);
                const isWeekend = d.date.getDay() === 0 || d.date.getDay() === 6;
                return (
                  <div key={d.iso} style={{ background: isToday ? '#eff6ff' : (isWeekend ? '#f8fafc' : '#fff'), border: `${isToday ? 2 : 1}px solid ${isToday ? '#3b82f6' : '#e2e8f0'}`, borderRadius: 8, padding: 12, minHeight: 260 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, paddingBottom: 8, borderBottom: '1px solid #e2e8f0' }}>
                      <div style={{ fontSize: 10, fontWeight: 700, color: isWeekend ? '#94a3b8' : '#64748b', textTransform: 'uppercase', letterSpacing: 0.5 }}>{dayName}</div>
                      <div style={{ fontSize: 15, fontWeight: 800, color: isToday ? '#3b82f6' : (isWeekend ? '#94a3b8' : '#1e3a5f') }}>{d.date.getDate()}</div>
                    </div>
                    {d.leads.map(l => {
                      const c = l.cadence?.stage === 'day14' || l.cadence?.stage === 'stale' ? { bg: '#dc262618', bd: '#dc2626', fg: '#dc2626' }
                        : l.cadence?.stage === 'day7' ? { bg: '#f59e0b18', bd: '#f59e0b', fg: '#b45309' }
                        : { bg: '#16a34a18', bd: '#16a34a', fg: '#15803d' };
                      return (
                        <div key={l.id} onClick={() => openLeadEmail(l.id)} style={{ fontSize: 11, padding: '6px 8px', borderRadius: 5, marginBottom: 6, cursor: 'pointer', lineHeight: 1.4, background: c.bg, borderLeft: `3px solid ${c.bd}`, color: c.fg }}>
                          <b style={{ display: 'block', marginBottom: 2 }}>{l.city_name}</b>
                          <span style={{ opacity: 0.85 }}>{CADENCE_LABEL[l.cadence.stage]} · {l.cadence.daysSince}d</span>
                        </div>
                      );
                    })}
                    {d.leads.length === 0 && (
                      <div style={{ fontSize: 11, color: '#cbd5e1', textAlign: 'center', paddingTop: 20 }}>—</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )
      }

      {/* Snooze modal */}
      {snoozeOpenFor && (
        <div onClick={() => setSnoozeOpenFor(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, padding: 20, maxWidth: 360, width: '90%' }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#1e3a5f', marginBottom: 10 }}>Snooze until…</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
              {[7, 14, 30].map(d => (
                <button key={d} onClick={() => setSnoozeDays(d)} style={{ padding: '6px 14px', borderRadius: 5, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer', background: snoozeDays === d ? '#1e3a5f' : '#f1f5f9', color: snoozeDays === d ? '#fff' : '#475569' }}>{d} days</button>
              ))}
              <input type="number" min="1" max="365" value={snoozeDays} onChange={e => setSnoozeDays(parseInt(e.target.value) || 7)} style={{ width: 70, padding: '6px 8px', border: '1px solid #cbd5e1', borderRadius: 5, fontSize: 12 }} />
            </div>
            <input value={snoozeNote} onChange={e => setSnoozeNote(e.target.value)} placeholder="Note (optional): Why are you snoozing?" style={{ width: '100%', padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 5, fontSize: 12, marginBottom: 12 }} maxLength={300} />
            <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
              <button onClick={() => setSnoozeOpenFor(null)} style={{ padding: '6px 14px', borderRadius: 5, fontSize: 12, fontWeight: 600, border: '1px solid #cbd5e1', background: '#fff', color: '#475569', cursor: 'pointer' }}>Cancel</button>
              <button onClick={doSnooze} style={{ padding: '6px 14px', borderRadius: 5, fontSize: 12, fontWeight: 700, border: 'none', background: '#1e3a5f', color: '#fff', cursor: 'pointer' }}>Snooze {snoozeDays} days</button>
            </div>
          </div>
        </div>
      )}
      </div>{/* /S.main */}
    </div>
  );
}

function LeadsPage() {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [stageFilter, setStageFilter] = useState('all');
  const [ownerFilter, setOwnerFilter] = useState('mine');
  const [leadsView, setLeadsView] = useState('list');
  const [dragLeadId, setDragLeadId] = useState(null);
  const [dragOverStage, setDragOverStage] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [createForm, setCreateForm] = useState({ cityName: '', cityState: '', contactName: '', contactEmail: '', contactPhone: '', contactTitle: '', stage: 'prospect', isCwPlan: false, planTier: 'starter', hasAnswers: false, notes: '', source: '', estimatedArr: '' });
  const [creating, setCreating] = useState(false);
  const [createError, setCreateError] = useState('');
  const [dupWarning, setDupWarning] = useState('');
  const [repList, setRepList] = useState([]);
  const [checkedLeadIds, setCheckedLeadIds] = useState(new Set());
  const [bulkStage, setBulkStage] = useState('contacted');
  const [bulkUpdating, setBulkUpdating] = useState(false);
  const [bulkMsg, setBulkMsg] = useState('');
  const [leadsOppClaimCount, setLeadsOppClaimCount] = useState(0);
  const [leadsOppClaimLimit, setLeadsOppClaimLimit] = useState(50);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [lRes, rRes, cRes] = await Promise.all([
        fetch(`${API}/api/sales/leads`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/sales/reps`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/sales/leads/opp-claim-count`, { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      const data = await lRes.json();
      const reps = await rRes.json();
      const cData = await cRes.json();
      if (Array.isArray(data)) setLeads(data);
      if (Array.isArray(reps)) setRepList(reps);
      if (cData && typeof cData.count === 'number') setLeadsOppClaimCount(cData.count);
      if (cData && typeof cData.limit === 'number') setLeadsOppClaimLimit(cData.limit);
    } catch (e) { console.error('[Leads]', e); }
    setLoading(false);
  }, [token]);

  useEffect(() => { load(); }, [load]);

  async function handleKanbanDrop(stageKey, leadId) {
    setDragLeadId(null); setDragOverStage(null);
    const lead = leads.find(l => l.id === leadId);
    if (!lead || lead.stage === stageKey) return;
    // Optimistic update — card moves instantly
    setLeads(prev => prev.map(l => l.id === leadId ? { ...l, stage: stageKey } : l));
    await fetch(`${API}/api/sales/leads/${leadId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ stage: stageKey }),
    });
    load(); // refresh to confirm server state
  }

  const filtered = leads.filter(l => {
    if (stageFilter !== 'all' && l.stage !== stageFilter) return false;
    if (ownerFilter === 'mine' && l.owner_rep_id !== user.id) return false;
    if (ownerFilter !== 'all' && ownerFilter !== 'mine' && l.owner_rep_id !== ownerFilter) return false;
    if (search) {
      const q = search.toLowerCase();
      if (!l.city_name?.toLowerCase().includes(q) && !l.contact_name?.toLowerCase().includes(q) && !l.contact_email?.toLowerCase().includes(q)) return false;
    }
    return true;
  });

  const stats = {
    total: leads.length,
    active: leads.filter(l => !['closed_won','closed_lost'].includes(l.stage)).length,
    mine: leads.filter(l => l.owner_rep_id === user.id).length,
    converted: leads.filter(l => l.converted_city_id).length,
    pipelineArr: leads.filter(l => !['closed_won','closed_lost'].includes(l.stage)).reduce((sum, l) => sum + (l.estimated_arr || calcLeadArr(l) || 0), 0),
    avgDeal: leads.length ? Math.round(leads.reduce((sum, l) => sum + (l.estimated_arr || calcLeadArr(l) || 0), 0) / leads.length) : 0,
    wonArr: leads.filter(l => l.stage === 'closed_won' || l.converted_city_id).reduce((sum, l) => sum + (l.estimated_arr || calcLeadArr(l) || 0), 0),
    winRate: (() => { const closed = leads.filter(l => l.stage === 'closed_won' || l.stage === 'closed_lost' || l.converted_city_id); return closed.length ? Math.round((leads.filter(l => l.stage === 'closed_won' || l.converted_city_id).length / closed.length) * 100) : null; })(),
    myLeads: leads.filter(l => l.owner_rep_id === user.id),
    myPipelineArr: leads.filter(l => l.owner_rep_id === user.id && !['closed_won','closed_lost'].includes(l.stage)).reduce((sum, l) => sum + (l.estimated_arr || calcLeadArr(l) || 0), 0),
    myWonArr: leads.filter(l => (l.stage === 'closed_won' || l.converted_city_id) && l.owner_rep_id === user.id).reduce((sum, l) => sum + (l.estimated_arr || calcLeadArr(l) || 0), 0),
    myAvgDeal: (() => { const mine = leads.filter(l => l.owner_rep_id === user.id); return mine.length ? Math.round(mine.reduce((sum, l) => sum + (l.estimated_arr || calcLeadArr(l) || 0), 0) / mine.length) : 0; })(),
    myWinRate: (() => { const closed = leads.filter(l => (l.stage === 'closed_won' || l.stage === 'closed_lost' || l.converted_city_id) && l.owner_rep_id === user.id); return closed.length ? Math.round((leads.filter(l => (l.stage === 'closed_won' || l.converted_city_id) && l.owner_rep_id === user.id).length / closed.length) * 100) : null; })(),
  };

  async function handleBulkStageUpdate() {
    const ids = [...checkedLeadIds];
    if (!ids.length || !bulkStage) return;
    setBulkUpdating(true); setBulkMsg('');
    let ok = 0, fail = 0;
    for (const leadId of ids) {
      const r = await fetch(`${API}/api/sales/leads/${leadId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ stage: bulkStage }),
      });
      r.ok ? ok++ : fail++;
    }
    setCheckedLeadIds(new Set());
    setBulkMsg(`Updated ${ok} lead${ok !== 1 ? 's' : ''} to "${STAGES.find(s => s.key === bulkStage)?.label}"${fail ? ` · ${fail} failed` : ''}.`);
    setBulkUpdating(false);
    load();
    setTimeout(() => setBulkMsg(''), 5000);
  }

  async function handleCreate(e) {
    e.preventDefault();
    setCreating(true); setCreateError('');
    try {
      const r = await fetch(`${API}/api/sales/leads`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ ...createForm, estimatedArr: createForm.estimatedArr ? parseFloat(createForm.estimatedArr) : null }),
      });
      const data = await r.json();
      if (!r.ok) { setCreateError(data.error || 'Failed to create'); setCreating(false); return; }
      setShowCreate(false);
      setCreateForm({ cityName: '', cityState: '', contactName: '', contactEmail: '', contactPhone: '', contactTitle: '', stage: 'prospect', isCwPlan: false, planTier: 'starter', hasAnswers: false, notes: '', source: '', estimatedArr: '' });
      setDupWarning('');
      navigate(`/leads/${data.id}`);
    } catch (e) { setCreateError('Network error'); }
    setCreating(false);
  }

  return (
    <div style={S.page}>
      <div className="cb-main" style={S.main}>
        <div style={{ ...S.spaceBetween, marginBottom: 24 }}>
          <div>
            <h1 style={S.h1}>Leads</h1>
            <p style={{ color: '#64748b', margin: 0, fontSize: 14 }}>Track and manage prospective cities</p>
          </div>
        </div>

        <div style={{ ...S.grid4, marginBottom: 16 }}>
          {[
            ['Total', stats.total, '#1e3a5f', 'All leads in the system across all reps and stages, including closed and released.'],
            ['Active', stats.active, '#3b82f6', 'Leads currently in the pipeline — not yet closed (won/lost) or released back to Opportunities.'],
            ['My Leads', stats.mine, '#f59e0b', 'Leads where you are the assigned rep, across all stages.'],
            ['Converted', stats.converted, '#16a34a', 'Leads that have been linked to a live CivicBot city via the Convert action.'],
          ].map(([label, val, color, tip]) => (
            <div key={label} style={{ ...S.statCard, background: color, textAlign: 'center' }}>
              <div style={{ fontSize: 28, fontWeight: 700 }}>{val}</div>
              <div style={{ fontSize: 12, opacity: 0.85, marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{label}<InfoTip text={tip} light /></div>
            </div>
          ))}
        </div>

        <div style={{ marginBottom: 6 }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#7c3aed', marginBottom: 8 }}>Team Financials</div>
          <div className="cb-grid4" style={S.grid4}>
            {[
              ['Total Pipeline', stats.pipelineArr, '#7c3aed', 'All active leads', 'Sum of estimated annual ARR across all active leads (all reps). Excludes closed and released leads.'],
              ['Avg Deal Size', stats.avgDeal, '#0891b2', 'All leads', 'Total estimated ARR of all leads ÷ total number of leads. Includes closed and open.'],
              ['Won ARR', stats.wonArr, '#15803d', 'Closed + converted', 'Sum of estimated ARR for leads marked Closed Won or converted to a live city.'],
              ['Win Rate', stats.winRate !== null ? `${stats.winRate}%` : '—', stats.winRate !== null && stats.winRate >= 50 ? '#166534' : '#92400e', `${leads.filter(l => l.stage === 'closed_won' || l.stage === 'closed_lost' || l.converted_city_id).length} closed deals`, 'Closed Won ÷ (Closed Won + Closed Lost). Only leads with a final outcome count — open leads are excluded.'],
            ].map(([label, val, color, sub, tip]) => (
              <div key={label} style={{ ...S.statCard, background: color, textAlign: 'center' }}>
                <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.5px' }}>
                  {typeof val === 'string' && val.endsWith('%') ? val : (val === '—' ? '—' : <>{formatCurrency(val)}<span style={{ fontSize: 13, fontWeight: 500, opacity: 0.8 }}>/yr</span></>)}
                </div>
                <div style={{ fontSize: 13, fontWeight: 600, marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{label}<InfoTip text={tip} light /></div>
                <div style={{ fontSize: 11, opacity: 0.65, marginTop: 2 }}>{sub}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#d97706', marginBottom: 8 }}>My Financials — {user?.name || 'You'}</div>
          <div className="cb-grid4" style={S.grid4}>
            {[
              ['My Pipeline', stats.myPipelineArr, '#b45309', `${stats.myLeads.filter(l => !['closed_won','closed_lost'].includes(l.stage)).length} active`, 'Sum of estimated annual ARR across your active leads only. Excludes closed and released.'],
              ['My Avg Deal', stats.myAvgDeal, '#c2410c', `${stats.myLeads.length} lead${stats.myLeads.length !== 1 ? 's' : ''}`, 'Total estimated ARR of all your leads ÷ number of leads assigned to you.'],
              ['My Won ARR', stats.myWonArr, '#15803d', 'Closed + converted', 'Sum of estimated ARR for your leads marked Closed Won or converted to a live city.'],
              ['My Win Rate', stats.myWinRate !== null ? `${stats.myWinRate}%` : '—', stats.myWinRate !== null && stats.myWinRate >= 50 ? '#166534' : (stats.myWinRate !== null ? '#92400e' : '#64748b'), stats.myWinRate !== null ? `${leads.filter(l => (l.stage === 'closed_won' || l.stage === 'closed_lost' || l.converted_city_id) && l.owner_rep_id === user.id).length} closed` : 'No closed deals yet', 'Your Closed Won ÷ (Closed Won + Closed Lost). Only your leads with a final outcome count.'],
            ].map(([label, val, color, sub, tip]) => (
              <div key={label} style={{ ...S.statCard, background: color, textAlign: 'center' }}>
                <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.5px' }}>
                  {typeof val === 'string' && val.endsWith('%') ? val : (val === '—' ? '—' : <>{formatCurrency(val)}<span style={{ fontSize: 13, fontWeight: 500, opacity: 0.8 }}>/yr</span></>)}
                </div>
                <div style={{ fontSize: 13, fontWeight: 600, marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{label}<InfoTip text={tip} light /></div>
                <div style={{ fontSize: 11, opacity: 0.65, marginTop: 2 }}>{sub}</div>
              </div>
            ))}
          </div>
          {/* Opportunity claim capacity bar */}
          {(() => {
            const oppCount = leadsOppClaimCount;
            const oppLimit = leadsOppClaimLimit;
            const pct = Math.min(100, Math.round((oppCount / oppLimit) * 100));
            const barColor = oppCount >= oppLimit ? '#dc2626' : oppCount >= oppLimit * 0.8 ? '#d97706' : '#16a34a';
            return (
              <div style={{ marginTop: 12, background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.06em' }}>⚡ Opportunity Claim Capacity</span>
                  <span style={{ fontSize: 13, fontWeight: 700, color: barColor }}>{oppCount} / {oppLimit}</span>
                </div>
                <div style={{ background: '#e2e8f0', borderRadius: 4, height: 8, overflow: 'hidden' }}>
                  <div style={{ width: `${pct}%`, height: '100%', background: barColor, borderRadius: 4, transition: 'width 0.3s' }} />
                </div>
                {oppCount >= oppLimit && <div style={{ fontSize: 11, color: '#dc2626', marginTop: 4 }}>At capacity — release or close a lead to claim more from Opportunities.</div>}
                {oppCount < oppLimit && <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>You can claim {oppLimit - oppCount} more from Opportunities.</div>}
              </div>
            );
          })()}
          {/* Potential Commission card */}
          {user?.commissionRate != null && (
            <div style={{ marginTop: 12, background: 'linear-gradient(135deg, #92400e 0%, #78350f 100%)', borderRadius: 10, padding: '14px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: '#fff' }}>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', opacity: 0.7, marginBottom: 4, display: 'flex', alignItems: 'center' }}>Potential Commission<InfoTip text={'Your active pipeline ARR × your commission rate. Assumes all leads close on annual plans at their current tier. Does not include speed bonuses.'} light /></div>
                <div style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.5px' }}>
                  {formatCurrency(Math.round(stats.myPipelineArr * user.commissionRate))}<span style={{ fontSize: 14, fontWeight: 500, opacity: 0.75 }}>/yr</span>
                </div>
                <div style={{ fontSize: 12, opacity: 0.65, marginTop: 2 }}>
                  {(user.commissionRate * 100).toFixed(1)}% rate on {formatCurrency(stats.myPipelineArr)} pipeline · If all close
                </div>
              </div>
              <div style={{ fontSize: 36, opacity: 0.25 }}>💰</div>
            </div>
          )}
        </div>

        {/* My EST ARR by Stage */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#d97706', marginBottom: 8, display: 'flex', alignItems: 'center' }}>
            My EST ARR by Stage
            <InfoTip text={'Estimated Annual Recurring Revenue for each pipeline stage, based on your leads only.\nCalculated from plan tier, Cityworks integration, and Answers add-on.'} />
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {PIPELINE_RAIL.filter(s => s.key !== 'closed_won').map(stage => {
              const stageLeads = leads.filter(l => l.stage === stage.key && l.owner_rep_id === user?.id);
              const stageArr = stageLeads.reduce((sum, l) => sum + (l.estimated_arr || calcLeadArr(l) || 0), 0);
              const color = STAGE_COLORS[stage.key];
              if (stageLeads.length === 0) return null;
              return (
                <div key={stage.key} onClick={() => setStageFilter(sf => sf === stage.key ? 'all' : stage.key)}
                  style={{ background: color + '15', border: `1px solid ${color}40`, borderRadius: 8, padding: '8px 14px', cursor: 'pointer', minWidth: 110, textAlign: 'center' }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 3 }}>{stage.label}</div>
                  <div style={{ fontSize: 15, fontWeight: 800, color: '#1e293b' }}>{formatCurrency(stageArr)}</div>
                  <div style={{ fontSize: 11, color: '#64748b', marginTop: 1 }}>{stageLeads.length} lead{stageLeads.length !== 1 ? 's' : ''}</div>
                </div>
              );
            })}
            {PIPELINE_RAIL.filter(s => s.key !== 'closed_won').every(stage => !leads.filter(l => l.stage === stage.key && l.owner_rep_id === user?.id).length) && (
              <div style={{ color: '#94a3b8', fontSize: 13, padding: '8px 0' }}>No active leads yet.</div>
            )}
          </div>
        </div>

        {/* Stage Pipeline Summary — clickable filter strip */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#64748b', marginBottom: 8, display: 'flex', alignItems: 'center' }}>
            Pipeline by Stage — click to filter
            <InfoTip text={'Total count of all leads in each stage across all reps. Click a stage to filter the list/board below.'} />
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {STAGES.map(stage => {
              const count = leads.filter(l => l.stage === stage.key && (ownerFilter === 'mine' ? l.owner_rep_id === user.id : ownerFilter !== 'all' ? l.owner_rep_id === ownerFilter : true)).length;
              const color = STAGE_COLORS[stage.key];
              const isActive = stageFilter === stage.key;
              return (
                <button key={stage.key}
                  onClick={() => setStageFilter(sf => sf === stage.key ? 'all' : stage.key)}
                  style={{ ...S.btn, ...S.btnSm, background: isActive ? color : color + '18', color: isActive ? '#fff' : color, border: `1px solid ${color}50`, fontWeight: 600, transition: 'all 0.15s' }}>
                  {stage.label} <span style={{ marginLeft: 5, opacity: 0.85 }}>{count}</span>
                </button>
              );
            })}
            {stageFilter !== 'all' && (
              <button onClick={() => setStageFilter('all')} style={{ ...S.btn, ...S.btnSm, ...S.btnSecondary }}>✕ Clear</button>
            )}
          </div>
        </div>

        <div style={{ ...S.card }}>
          <div style={{ ...S.row, marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
            <input style={{ ...S.input, width: 240 }} placeholder="Search city, contact…" value={search} onChange={e => setSearch(e.target.value)} />
            <select style={{ ...S.select, width: 160 }} value={stageFilter} onChange={e => setStageFilter(e.target.value)}>
              <option value="all">All Stages</option>
              {STAGES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
            </select>
            <select style={{ ...S.select, width: 160 }} value={ownerFilter} onChange={e => setOwnerFilter(e.target.value)}>
              <option value="all">All Reps</option>
              <option value="mine">My Leads</option>
              {repList.length > 0 && <option disabled>──────────</option>}
              {repList.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
            </select>
            <span style={{ color: '#64748b', fontSize: 13 }}>{filtered.length} of {leads.length}</span>
            {/* List / Kanban toggle */}
            <div style={{ marginLeft: 'auto', display: 'flex', border: '1px solid #e2e8f0', borderRadius: 8, overflow: 'hidden' }}>
              <button onClick={() => setLeadsView('list')} title="List view"
                style={{ ...S.btn, ...S.btnSm, borderRadius: 0, border: 'none', background: leadsView === 'list' ? '#1e3a5f' : '#fff', color: leadsView === 'list' ? '#fff' : '#64748b', padding: '5px 12px' }}>
                ☰ List
              </button>
              <button onClick={() => setLeadsView('kanban')} title="Kanban view"
                style={{ ...S.btn, ...S.btnSm, borderRadius: 0, border: 'none', borderLeft: '1px solid #e2e8f0', background: leadsView === 'kanban' ? '#1e3a5f' : '#fff', color: leadsView === 'kanban' ? '#fff' : '#64748b', padding: '5px 12px' }}>
                ⬛ Kanban
              </button>
            </div>
          </div>

          {loading ? <p style={{ color: '#64748b', textAlign: 'center', padding: 32 }}>Loading…</p> : filtered.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '48px 0', color: '#64748b' }}>
              <div style={{ fontSize: 32, marginBottom: 12 }}>📋</div>
              <p>No leads yet. Claim an Opportunity to get started.</p>
            </div>
          ) : leadsView === 'kanban' ? (
            /* ── Kanban Board ── */
            <div style={{ display: 'flex', gap: 12, overflowX: 'auto', alignItems: 'flex-start', paddingBottom: 8 }}>
              {STAGES.map(stage => {
                const col = filtered.filter(l => l.stage === stage.key);
                const color = STAGE_COLORS[stage.key];
                const colArr = col.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0);
                const isOver = dragOverStage === stage.key;
                const isDragSource = dragLeadId && leads.find(l => l.id === dragLeadId)?.stage === stage.key;
                return (
                  <div key={stage.key}
                    onDragOver={e => { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; if (dragOverStage !== stage.key) setDragOverStage(stage.key); }}
                    onDragLeave={e => { if (!e.currentTarget.contains(e.relatedTarget)) setDragOverStage(null); }}
                    onDrop={e => { e.preventDefault(); if (dragLeadId) handleKanbanDrop(stage.key, dragLeadId); }}
                    style={{ minWidth: 220, maxWidth: 220, background: isOver ? color + '12' : '#f8fafc', borderRadius: 10, border: `2px solid ${isOver ? color : '#e2e8f0'}`, flexShrink: 0, transition: 'border-color 0.15s, background 0.15s' }}>
                    {/* Column header */}
                    <div style={{ padding: '10px 12px', background: color + '18', borderRadius: '8px 8px 0 0', borderBottom: `2px solid ${color}40` }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontWeight: 700, fontSize: 13, color }}>{stage.label}</span>
                        <span style={{ background: color + '30', color, borderRadius: 10, padding: '1px 8px', fontSize: 11, fontWeight: 700 }}>{col.length}</span>
                      </div>
                      {col.length > 0 && <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>{formatCurrency(colArr)}/yr</div>}
                    </div>
                    {/* Drop zone hint */}
                    {isOver && !isDragSource && (
                      <div style={{ margin: '8px 8px 0', padding: '8px 0', background: color + '20', border: `2px dashed ${color}60`, borderRadius: 6, textAlign: 'center', fontSize: 12, fontWeight: 600, color }}>
                        Drop to move → {stage.label}
                      </div>
                    )}
                    {/* Cards */}
                    <div style={{ padding: 8, maxHeight: 520, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {col.map(l => {
                        const lArr = l.estimated_arr || calcLeadArr(l);
                        const isDragging = dragLeadId === l.id;
                        return (
                          <div key={l.id}
                            draggable
                            onDragStart={e => { setDragLeadId(l.id); e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', l.id); }}
                            onDragEnd={() => { setDragLeadId(null); setDragOverStage(null); }}
                            onClick={() => navigate(`/leads/${l.id}`)}
                            style={{ background: '#fff', borderRadius: 8, padding: '10px 12px', cursor: isDragging ? 'grabbing' : 'grab', border: '1px solid #e8edf3', boxShadow: isDragging ? '0 8px 24px rgba(0,0,0,0.18)' : '0 1px 3px rgba(0,0,0,0.05)', opacity: isDragging ? 0.5 : 1, transition: 'box-shadow 0.15s, opacity 0.15s', userSelect: 'none' }}
                            onMouseEnter={e => { if (!dragLeadId) { e.currentTarget.style.boxShadow = '0 3px 10px rgba(0,0,0,0.12)'; e.currentTarget.style.borderColor = color + '80'; } }}
                            onMouseLeave={e => { e.currentTarget.style.boxShadow = isDragging ? '0 8px 24px rgba(0,0,0,0.18)' : '0 1px 3px rgba(0,0,0,0.05)'; e.currentTarget.style.borderColor = '#e8edf3'; }}>
                            <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 3, letterSpacing: '0.03em' }}>⠿ drag to move</div>
                            <div style={{ fontWeight: 700, fontSize: 13, color: '#1e293b', marginBottom: 2 }}>{l.city_name}{l.city_state ? `, ${l.city_state}` : ''}</div>
                            {l.contact_name && <div style={{ fontSize: 12, color: '#64748b', marginBottom: 4 }}>{l.contact_name}</div>}
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                              <span style={{ fontSize: 12, fontWeight: 700, color: '#0f172a' }}>{formatCurrency(lArr)}/yr</span>
                              {l.is_cw_plan ? <span style={{ ...S.badge, background: '#f0fdf4', color: '#16a34a', fontSize: 10, padding: '0 5px' }}>CW</span> : null}
                              {l.has_answers ? <span style={{ ...S.badge, background: '#eff6ff', color: '#2563eb', fontSize: 10, padding: '0 5px' }}>+Ans</span> : null}
                            </div>
                            <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{l.owner_name || l.owner_rep_id}</div>
                          </div>
                        );
                      })}
                      {col.length === 0 && (
                        <div style={{ fontSize: 12, color: isOver ? color : '#94a3b8', textAlign: 'center', padding: '24px 0', fontWeight: isOver ? 600 : 400, transition: 'color 0.15s' }}>
                          {isOver ? `Drop here → ${stage.label}` : 'Empty'}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            /* ── List View ── */
            <>
              {/* Bulk action bar */}
              {checkedLeadIds.size > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '10px 14px', marginBottom: 10, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#1e40af' }}>{checkedLeadIds.size} selected</span>
                  <span style={{ fontSize: 13, color: '#3b82f6' }}>→ Move to stage:</span>
                  <select style={{ ...S.select, width: 180, fontSize: 13 }} value={bulkStage} onChange={e => setBulkStage(e.target.value)}>
                    {STAGES.filter(s => s.key !== 'closed_lost').map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
                  </select>
                  <button onClick={handleBulkStageUpdate} disabled={bulkUpdating}
                    style={{ ...S.btn, ...S.btnPrimary, ...S.btnSm, fontWeight: 700 }}>
                    {bulkUpdating ? 'Updating…' : `Update ${checkedLeadIds.size} Lead${checkedLeadIds.size !== 1 ? 's' : ''}`}
                  </button>
                  <button onClick={() => setCheckedLeadIds(new Set())} style={{ ...S.btn, ...S.btnSm, ...S.btnSecondary }}>✕ Clear</button>
                  {bulkMsg && <span style={{ fontSize: 13, color: '#16a34a', fontWeight: 600 }}>{bulkMsg}</span>}
                </div>
              )}
              {bulkMsg && checkedLeadIds.size === 0 && (
                <div style={{ ...S.success, marginBottom: 10 }}>{bulkMsg}</div>
              )}
              <div style={{ overflowX: 'auto' }}>
              <table style={S.table}>
                <thead>
                  <tr>
                    <th style={{ ...S.th, width: 36 }}>
                      <input type="checkbox"
                        checked={filtered.length > 0 && filtered.every(l => checkedLeadIds.has(l.id))}
                        onChange={e => {
                          if (e.target.checked) setCheckedLeadIds(new Set(filtered.map(l => l.id)));
                          else setCheckedLeadIds(new Set());
                        }}
                        title="Select all"
                      />
                    </th>
                    {['City', 'State', 'Contact', 'Source', 'Stage', 'Plan', 'Est. ARR', 'Owner', 'Created', 'Email'].map(h => <th key={h} style={S.th}>{h}</th>)}
                    <th style={S.th}></th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(l => {
                    const arr = l.estimated_arr || calcLeadArr(l);
                    const stageColor = STAGE_COLORS[l.stage] || '#6b7280';
                    const isChecked = checkedLeadIds.has(l.id);
                    // Follow-up cadence row highlight
                    const cad = l.cadence;
                    const cadBorder = cad && cad.color ? `3px solid ${cad.color}` : undefined;
                    const rowBg = isChecked ? '#eff6ff'
                      : (cad?.stage === 'replied' ? '#f0fdf4' : undefined);
                    return (
                      <tr key={l.id} style={{ cursor: 'pointer', background: rowBg, borderLeft: cadBorder, opacity: cad?.stage === 'snoozed' ? 0.7 : 1 }}
                        onClick={() => navigate(`/leads/${l.id}`)}>
                        <td style={{ ...S.td, width: 36 }} onClick={e => e.stopPropagation()}>
                          <input type="checkbox" checked={isChecked}
                            onChange={e => setCheckedLeadIds(prev => {
                              const next = new Set(prev);
                              e.target.checked ? next.add(l.id) : next.delete(l.id);
                              return next;
                            })}
                          />
                        </td>
                        <td style={{ ...S.td, fontWeight: 600, color: '#1e3a5f' }}>{l.city_name}</td>
                        <td style={S.td}>{l.city_state || '—'}</td>
                        <td style={{ ...S.td, maxWidth: 160, overflow: 'hidden' }}>
                          <div style={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.contact_name || '—'}</div>
                          {l.contact_email && <div style={{ fontSize: 12, color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.contact_email}</div>}
                          {l.primary_contact_linkedin && (
                            <a href={l.primary_contact_linkedin.startsWith('http') ? l.primary_contact_linkedin : `https://${l.primary_contact_linkedin}`}
                               target="_blank" rel="noopener noreferrer"
                               onClick={(e) => e.stopPropagation()}
                               title={l.primary_contact_linkedin}
                               style={{ fontSize: 11, color: '#0a66c2', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 3, marginTop: 2 }}>
                              <span style={{ fontWeight: 700, background: '#0a66c2', color: '#fff', padding: '1px 4px', borderRadius: 2, fontSize: 9, letterSpacing: 0.3 }}>in</span>
                              LinkedIn
                            </a>
                          )}
                          {cad && <div style={{ marginTop: 4 }}><CadenceChip cadence={cad} compact /></div>}
                        </td>
                        <td style={{ ...S.td, maxWidth: 70, fontSize: 12, color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.source || '—'}</td>
                        <td style={S.td}>
                          <span style={{ ...S.badge, background: stageColor + '20', color: stageColor }}>
                            {STAGES.find(s => s.key === l.stage)?.label || l.stage}
                          </span>
                        </td>
                        <td style={{ ...S.td, maxWidth: 100, overflow: 'hidden' }}>
                          <div style={{ fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.plan_tier?.charAt(0).toUpperCase() + l.plan_tier?.slice(1)}{l.is_cw_plan ? ' CW' : ''}</div>
                          {l.has_answers ? <span style={{ ...S.badge, background: '#eff6ff', color: '#2563eb', fontSize: 11 }}>+Answers</span> : null}
                        </td>
                        <td style={S.td}>{formatCurrency(arr)}/yr</td>
                        <td style={{ ...S.td, maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.owner_name || l.owner_rep_id}</td>
                        <td style={{ ...S.td, color: '#64748b', fontSize: 12 }}>{formatDate(l.created_at)}</td>
                        <td style={{ ...S.td, fontSize: 11, whiteSpace: 'nowrap' }}>
                          {l.next_scheduled_for
                            ? <div style={{ color: '#7c3aed', fontWeight: 600 }}>
                                📅 {new Date(l.next_scheduled_for + 'Z').toLocaleString([], { weekday: 'short', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
                              </div>
                            : l.last_email_sent_at
                              ? <div style={{ color: '#64748b' }}>
                                  ✉️ {new Date(l.last_email_sent_at + 'Z').toLocaleDateString([], { month: 'numeric', day: 'numeric', year: '2-digit' })}
                                </div>
                              : <span style={{ color: '#cbd5e1' }}>—</span>
                          }
                        </td>
                        <td style={S.td}>
                          <button style={{ ...S.btn, ...S.btnSm, ...S.btnSecondary }} onClick={e => { e.stopPropagation(); navigate(`/leads/${l.id}`); }}>View</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              </div>
            </>
          )}
        </div>
      </div>

      {showCreate && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: 20, overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 32, width: '100%', maxWidth: 600 }}>
            <div style={{ ...S.spaceBetween, marginBottom: 20 }}>
              <h2 style={{ ...S.h2, margin: 0 }}>New Lead</h2>
              <button onClick={() => { setShowCreate(false); setDupWarning(''); setCreateError(''); }} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#64748b' }}>✕</button>
            </div>
            {createError && <div style={S.error}>{createError}</div>}
            {dupWarning && <div style={{ background: '#fef9c3', border: '1px solid #fde047', borderRadius: 8, padding: '10px 14px', marginBottom: 12, fontSize: 13, color: '#92400e', display: 'flex', gap: 8, alignItems: 'flex-start' }}><span>⚠️</span><span>{dupWarning}</span></div>}
            <form onSubmit={handleCreate}>
              <div className="cb-grid2" style={S.grid2}>
                <div>
                  <label style={S.label}>City Name *</label>
                  <input style={S.input} required value={createForm.cityName} onChange={e => {
                    const val = e.target.value;
                    setCreateForm(f => ({ ...f, cityName: val }));
                    const q = val.trim().toLowerCase();
                    if (q.length > 2) {
                      const match = leads.find(l => l.city_name?.toLowerCase() === q);
                      setDupWarning(match ? `A lead for "${match.city_name}" already exists (stage: ${match.stage}). Avoid creating duplicates.` : '');
                    } else { setDupWarning(''); }
                  }} />
                </div>
                <div>
                  <label style={S.label}>State</label>
                  <input style={S.input} value={createForm.cityState} onChange={e => setCreateForm(f => ({ ...f, cityState: e.target.value }))} placeholder="CA" maxLength={2} />
                </div>
              </div>
              <div className="cb-grid2" style={S.grid2}>
                <div>
                  <label style={S.label}>Contact Name</label>
                  <input style={S.input} value={createForm.contactName} onChange={e => setCreateForm(f => ({ ...f, contactName: e.target.value }))} />
                </div>
                <div>
                  <label style={S.label}>Contact Title</label>
                  <input style={S.input} value={createForm.contactTitle} onChange={e => setCreateForm(f => ({ ...f, contactTitle: e.target.value }))} placeholder="IT Director" />
                </div>
              </div>
              <div className="cb-grid2" style={S.grid2}>
                <div>
                  <label style={S.label}>Contact Email</label>
                  <input style={S.input} type="email" value={createForm.contactEmail} onChange={e => setCreateForm(f => ({ ...f, contactEmail: e.target.value }))} />
                </div>
                <div>
                  <label style={S.label}>Contact Phone</label>
                  <input style={S.input} type="tel" value={createForm.contactPhone} onChange={e => setCreateForm(f => ({ ...f, contactPhone: e.target.value }))} />
                </div>
              </div>
              <div className="cb-grid2" style={S.grid2}>
                <div>
                  <label style={S.label}>Stage</label>
                  <select style={S.select} value={createForm.stage} onChange={e => setCreateForm(f => ({ ...f, stage: e.target.value }))}>
                    {STAGES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
                  </select>
                </div>
                <div>
                  <label style={S.label}>Source</label>
                  <input style={S.input} value={createForm.source} onChange={e => setCreateForm(f => ({ ...f, source: e.target.value }))} placeholder="Referral, conference, cold outreach…" />
                </div>
              </div>
              <div className="cb-grid2" style={S.grid2}>
                <div>
                  <label style={S.label}>Plan Tier</label>
                  <select style={S.select} value={createForm.planTier} onChange={e => setCreateForm(f => ({ ...f, planTier: e.target.value }))}>
                    <option value="starter">Starter</option>
                    <option value="growth">Growth</option>
                    <option value="professional">Professional</option>
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, justifyContent: 'flex-end' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, cursor: 'pointer' }}>
                    <input type="checkbox" checked={createForm.isCwPlan} onChange={e => setCreateForm(f => ({ ...f, isCwPlan: e.target.checked }))} />
                    Cityworks/Trimble Integration
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, cursor: 'pointer' }}>
                    <input type="checkbox" checked={createForm.hasAnswers} onChange={e => setCreateForm(f => ({ ...f, hasAnswers: e.target.checked }))} />
                    Add CivicBot Answers
                  </label>
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={S.label}>Notes</label>
                <textarea style={{ ...S.textarea, minHeight: 80 }} value={createForm.notes} onChange={e => setCreateForm(f => ({ ...f, notes: e.target.value }))} placeholder="Context about this lead…" />
              </div>
              <div style={{ marginBottom: 20, padding: 12, background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0' }}>
                <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>Estimated Annual Value</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: '#1e3a5f' }}>{formatCurrency(calcLeadArr(createForm))}/yr</div>
                <div style={{ fontSize: 12, color: '#94a3b8' }}>
                  {createForm.plan_tier?.charAt(0).toUpperCase()}{createForm.planTier?.slice(1)} {createForm.isCwPlan ? 'CW' : 'Email'}{createForm.hasAnswers ? ' + Answers' : ''} — Annual pricing only
                </div>
              </div>
              <div style={{ display: 'flex', gap: 12 }}>
                <button type="submit" style={{ ...S.btn, ...S.btnPrimary, flex: 1 }} disabled={creating}>{creating ? 'Creating…' : 'Create Lead'}</button>
                <button type="button" style={{ ...S.btn, ...S.btnSecondary }} onClick={() => setShowCreate(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function LeadDetail() {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [lead, setLead] = useState(null);
  const [activities, setActivities] = useState([]);
  const [emails, setEmails] = useState([]);
  const [salesUsers, setSalesUsers] = useState([]);
  const [tab, setTab] = useState(searchParams.get('tab') || 'overview');
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');
  const [actForm, setActForm] = useState({ type: 'call', title: '', body: '', followUpDate: '' });
  const [expandedEmails, setExpandedEmails] = useState({});
  const [addingAct, setAddingAct] = useState(false);
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [emailTo, setEmailTo] = useState('');
  const [emailCc, setEmailCc] = useState('');
  const [bounceWarning, setBounceWarning] = useState(null);
  const [forceOverride, setForceOverride] = useState(false);
  const [emailNotes, setEmailNotes] = useState('');
  const [emailContext, setEmailContext] = useState('cold_intro');
  const [genLoading, setGenLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [emailMsg, setEmailMsg] = useState('');
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [showSaveTpl, setShowSaveTpl] = useState(false);
  const [tplName, setTplName] = useState('');
  // 'composer' = save what's in the email composer; 'ai' = save the AI Generator result
  const [saveTplSource, setSaveTplSource] = useState('composer');
  const [savingTpl, setSavingTpl] = useState(false);
  const [deleteTplId, setDeleteTplId] = useState(null);
  const [deleteTplConfirm, setDeleteTplConfirm] = useState('');
  const [editTplId, setEditTplId] = useState(null);
  const [editTplName, setEditTplName] = useState('');
  const [editTplSubject, setEditTplSubject] = useState('');
  const [editTplBody, setEditTplBody] = useState('');
  const [savingEditTpl, setSavingEditTpl] = useState(false);
  const [delegateRepId, setDelegateRepId] = useState('');
  const [convertCityId, setConvertCityId] = useState('');
  const [convertMsg, setConvertMsg] = useState('');
  const [reassignId, setReassignId] = useState('');
  const [leadContacts, setLeadContacts] = useState([]);
  const [releasing, setReleasing] = useState(false);
  const [showSendLater, setShowSendLater] = useState(false);
  const [schedDate, setSchedDate] = useState('');
  const [schedTime, setSchedTime] = useState('');
  const [schedMsg, setSchedMsg] = useState('');
  const [schedulingEmail, setSchedulingEmail] = useState(false);
  const [scheduledEmails, setScheduledEmails] = useState([]);
  const [showSmartTips, setShowSmartTips] = useState(false);
  const [editingScheduledId, setEditingScheduledId] = useState(null);
  const [editSchedDate, setEditSchedDate] = useState('');
  const [editSchedTime, setEditSchedTime] = useState('');
  const [editSchedSubject, setEditSchedSubject] = useState('');
  const [editSchedBody, setEditSchedBody] = useState('');
  const [editSchedMsg, setEditSchedMsg] = useState('');
  const [rescheduling, setRescheduling] = useState(false);
  const [emailComposerTab, setEmailComposerTab] = useState(0);
  const [selectedLibTemplate, setSelectedLibTemplate] = useState(0);
  const [selectedAiPromptIdx, setSelectedAiPromptIdx] = useState(0);
  const [aiPromptText, setAiPromptText] = useState(AI_PROMPTS_LIB[0].prompt);
  const [aiResult, setAiResult] = useState(null);
  const [customPrompts, setCustomPrompts] = useState([]);
  const [savingCustomPrompt, setSavingCustomPrompt] = useState(false);
  const [showSaveCustomPrompt, setShowSaveCustomPrompt] = useState(false);
  const [customPromptName, setCustomPromptName] = useState('');
  const [deletingCustomPromptId, setDeletingCustomPromptId] = useState(null);
  const [showSmartTimingTips, setShowSmartTimingTips] = useState(false);
  const [showDeleteRequest, setShowDeleteRequest] = useState(false);
  const [deleteReason, setDeleteReason] = useState('');
  const [deletingRequest, setDeletingRequest] = useState(false);
  const [deleteMsg, setDeleteMsg] = useState('');
  const [showLinkCity, setShowLinkCity] = useState(false);
  const [cities, setCities] = useState([]);
  const [citySearch, setCitySearch] = useState('');
  const [linkMsg, setLinkMsg] = useState('');
  const [linkedCity, setLinkedCity] = useState(null);
  const [deletingLead, setDeletingLead] = useState(false);
  const [oppDetail, setOppDetail] = useState(null);

  const isSuperAdmin = user?.salesRole === 'super_admin';
  const isManager = ['super_admin','sales_director','sales_manager'].includes(user?.salesRole);
  const canEdit = lead ? (isSuperAdmin || lead.owner_rep_id === user?.id || (lead.delegated_rep_id && lead.delegated_rep_id === user?.id)) : false;
  const isOwner = lead ? (lead.owner_rep_id === user?.id || isSuperAdmin) : false;

  const load = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const [lRes, aRes, eRes, cRes] = await Promise.all([
        fetch(`${API}/api/sales/leads/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/sales/leads/${id}/activities`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/sales/leads/${id}/emails`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API}/api/sales/leads/${id}/contacts`, { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      const l = await lRes.json();
      const a = await aRes.json();
      const e = await eRes.json();
      const c = await cRes.json();
      if (l.id) {
        setLead(l); setForm({ ...l }); setEmailTo(l.contact_email || ''); setDelegateRepId(l.delegated_rep_id || '');
        // Fetch linked city via the opportunity
        if (l.opportunity_id) {
          try {
            const oRes = await fetch(`${API}/api/sales/opportunities/${l.opportunity_id}`, { headers: { Authorization: `Bearer ${token}` } });
            const o = await oRes.json();
            setLinkedCity(o.linkedCity || null);
            setOppDetail(o);
          } catch(e) { setLinkedCity(null); setOppDetail(null); }
        } else { setLinkedCity(null); setOppDetail(null); }
      }
      if (Array.isArray(a)) setActivities(a);
      if (Array.isArray(e)) setEmails(e);
      if (Array.isArray(c)) setLeadContacts(c);
    } catch (err) { console.error('[LeadDetail]', err); }
    setLoading(false);
  }, [id, token]);

  const loadTemplates = useCallback(async () => {
    try {
      const r = await fetch(`${API}/api/sales/email-templates`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await r.json();
      if (Array.isArray(data)) setEmailTemplates(data);
    } catch(e) {}
  }, [token]);

  const loadCustomPrompts = useCallback(async () => {
    try {
      const r = await fetch(`${API}/api/sales/ai-prompts`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await r.json();
      if (Array.isArray(data)) setCustomPrompts(data);
    } catch(e) {}
  }, [token]);

  const loadScheduled = useCallback(async () => {
    try {
      const r = await fetch(`${API}/api/sales/leads/${id}/scheduled-emails`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await r.json();
      if (Array.isArray(data)) setScheduledEmails(data);
    } catch(e) {}
  }, [id, token]);

  useEffect(() => { load(); loadTemplates(); loadScheduled(); loadCustomPrompts(); }, [load, loadTemplates, loadScheduled, loadCustomPrompts]);

  async function saveTemplate() {
    if (!tplName.trim()) return;
    setSavingTpl(true);
    try {
      // Source = 'composer' uses the composer's emailSubject/emailBody.
      // Source = 'ai' uses the AI Generator's aiResult directly (so reps can
      // save without overwriting whatever they had in the composer).
      const srcSubject = saveTplSource === 'ai' ? (aiResult?.subject || '') : emailSubject;
      const srcBody    = saveTplSource === 'ai' ? (aiResult?.body || '')    : emailBody;
      // 1. Strip AI closing ("Best,") then strip signature block
      let bodyToSave = stripAiClosing(srcBody);
      const sigIdx = bodyToSave.indexOf(SIG_SEPARATOR);
      bodyToSave = (sigIdx !== -1 ? bodyToSave.substring(0, sigIdx) : bodyToSave).trim();

      // 2. Tokenize contact name — use first name since AI uses first names in greetings
      const contactName = lead?.contact_name || '';
      const firstName = contactName.split(' ')[0];
      if (firstName) {
        const esc = firstName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        bodyToSave = bodyToSave
          .replace(new RegExp(`\\b(Hi|Dear|Hello)\\s+${esc}\\b`, 'gi'), '$1 [Contact Name]')
          .replace(new RegExp(`\\b${esc}\\b`, 'g'), '[Contact Name]');
      }

      // 3. Tokenize city name in both subject and body
      // Build list of variants: full name + bare name (strip "City of", "Town of", etc.)
      const cityName = lead?.city_name || '';
      const cityState = lead?.city_state || '';
      let subjectToSave = srcSubject;
      if (cityName) {
        const bareName = cityName.replace(/^(?:City|Town|Village|Township|Borough|County|District)\s+of\s+/i, '').trim();
        const variants = [...new Set([cityName, bareName].filter(Boolean))];
        variants.forEach(variant => {
          const esc = variant.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          // Try "Variant, ST" first, then bare variant
          if (cityState) {
            const escState = cityState.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const re = new RegExp(`${esc},?\\s+${escState}`, 'gi');
            subjectToSave = subjectToSave.replace(re, '[City Name]');
            bodyToSave = bodyToSave.replace(re, '[City Name]');
          }
          const re = new RegExp(esc, 'gi');
          subjectToSave = subjectToSave.replace(re, '[City Name]');
          bodyToSave = bodyToSave.replace(re, '[City Name]');
        });
      }

      const r = await fetch(`${API}/api/sales/email-templates`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ name: tplName.trim(), subject: subjectToSave, body: bodyToSave }),
      });
      if (r.ok) { setShowSaveTpl(false); setTplName(''); setSaveTplSource('composer'); loadTemplates(); setEmailMsg('Template saved!'); }
      else { const d = await r.json(); setEmailMsg(d.error || 'Failed to save'); }
    } catch(e) { setEmailMsg('Network error'); }
    setSavingTpl(false);
  }

  async function deleteTemplate(tplId) {
    try {
      const r = await fetch(`${API}/api/sales/email-templates/${tplId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      if (r.ok) { setDeleteTplId(null); setDeleteTplConfirm(''); loadTemplates(); }
      else { const d = await r.json(); alert(d.error || 'Failed to delete'); }
    } catch(e) { alert('Network error'); }
  }

  async function saveCustomPrompt() {
    if (!customPromptName.trim() || !aiPromptText.trim()) return;
    setSavingCustomPrompt(true);
    try {
      const r = await fetch(`${API}/api/sales/ai-prompts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ name: customPromptName.trim(), prompt_text: aiPromptText.trim() }),
      });
      if (r.ok) { setShowSaveCustomPrompt(false); setCustomPromptName(''); loadCustomPrompts(); }
      else { const d = await r.json(); alert(d.error || 'Failed to save prompt'); }
    } catch(e) { alert('Network error'); }
    setSavingCustomPrompt(false);
  }

  async function deleteCustomPrompt(promptId) {
    try {
      const r = await fetch(`${API}/api/sales/ai-prompts/${promptId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      if (r.ok) { setDeletingCustomPromptId(null); loadCustomPrompts(); }
      else { const d = await r.json(); alert(d.error || 'Failed to delete'); }
    } catch(e) { alert('Network error'); }
  }

  async function saveEditTemplate() {
    if (!editTplName.trim()) return;
    setSavingEditTpl(true);
    try {
      const r = await fetch(`${API}/api/sales/email-templates/${editTplId}`, {
        method: 'PATCH', headers: { ...apiHeaders(token) },
        body: JSON.stringify({ name: editTplName, subject: editTplSubject, body: editTplBody }),
      });
      if (r.ok) { setEditTplId(null); loadTemplates(); }
      else { const d = await r.json(); alert(d.error || 'Failed to save'); }
    } catch(e) { alert('Network error'); }
    setSavingEditTpl(false);
  }

  function applyTemplate(tpl) {
    const contactName = lead?.contact_name || '';
    const firstName = contactName.split(' ')[0] || contactName;
    const cityName = lead?.city_name || '';
    const bareCityName = cityName.replace(/^(?:City|Town|Village|Township|Borough|County|District)\s+of\s+/i, '').trim() || cityName;
    const subst = (str) => str
      .replace(/\[First Name\]/gi, firstName)
      .replace(/\[Contact Name\]/gi, firstName)
      .replace(/\[City Name\]/gi, bareCityName)
      .replace(/\[Your Name\]/gi, user?.name || '[Your Name]');
    // Strip any sig that may have been saved in the body, then append fresh sig
    const sigIdx = tpl.body.indexOf(SIG_SEPARATOR);
    const cleanBody = stripAiClosing(sigIdx !== -1 ? tpl.body.substring(0, sigIdx) : tpl.body).trim();
    setEmailSubject(subst(tpl.subject));
    setEmailBody(subst(cleanBody) + buildTextSig(user));
  }

  async function releaseLead() {
    if (!window.confirm('Release this lead back to Opportunities? All notes and email history will be preserved.')) return;
    setReleasing(true);
    const r = await fetch(`${API}/api/sales/leads/${id}/release`, { method: 'POST', headers: apiHeaders(token) }).then(r => r.json());
    setReleasing(false);
    if (r.ok) navigate('/opportunities');
    else alert(r.error || 'Failed to release');
  }

  async function submitDeleteRequest(e) {
    e.preventDefault();
    setDeletingRequest(true); setDeleteMsg('');
    try {
      const r = await fetch(`${API}/api/sales/leads/${id}/request-delete`, {
        method: 'POST', headers: apiHeaders(token),
        body: JSON.stringify({ reason: deleteReason }),
      });
      const d = await r.json();
      if (!r.ok) { setDeleteMsg(d.error || 'Failed to submit request'); }
      else { setDeleteMsg('success'); setDeleteReason(''); }
    } catch(e) { setDeleteMsg('Network error'); }
    setDeletingRequest(false);
  }

  async function openLinkPanel() {
    setLinkMsg(''); setCitySearch('');
    if (!cities.length) {
      const data = await fetch(`${API}/api/sales/cities`, { headers: apiHeaders(token) }).then(r => r.json());
      setCities(Array.isArray(data) ? data : []);
    }
    setShowLinkCity(true);
  }

  async function linkCity(cityId) {
    if (!lead?.opportunity_id) { setLinkMsg('This lead has no linked opportunity. Claim from Opportunities first.'); return; }
    setLinkMsg('Linking…');
    const r = await fetch(`${API}/api/sales/opportunities/${lead.opportunity_id}/link-city`, {
      method: 'POST', headers: apiHeaders(token), body: JSON.stringify({ cityId }),
    }).then(r => r.json());
    if (r.ok) { setLinkMsg('✅ Linked'); setShowLinkCity(false); load(); }
    else setLinkMsg(r.error || 'Failed to link');
  }

  async function unlinkCity() {
    if (!lead?.opportunity_id) return;
    if (!window.confirm('Remove the CivicBot city link from this lead\'s opportunity?')) return;
    await fetch(`${API}/api/sales/opportunities/${lead.opportunity_id}/link-city`, { method: 'DELETE', headers: apiHeaders(token) });
    load();
  }

  async function deleteLead() {
    if (!window.confirm(`Permanently delete lead "${lead.city_name}"? This cannot be undone.`)) return;
    setDeletingLead(true);
    const r = await fetch(`${API}/api/sales/leads/${id}`, { method: 'DELETE', headers: apiHeaders(token) });
    if (r.ok) navigate('/leads');
    else { alert('Failed to delete lead'); setDeletingLead(false); }
  }

  const loadUsers = useCallback(async () => {
    if (!isManager) return;
    try {
      const r = await fetch(`${API}/api/sales/users`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await r.json();
      if (Array.isArray(data)) {
        // Always include super_admin (Brandon Wright) as a selectable option
        setSalesUsers([{ id: 'super_admin', name: 'Brandon Wright', salesRole: 'super_admin', email: 'bwright@centricitygis.com' }, ...data]);
      }
    } catch(e) {}
  }, [isManager, token]);

  useEffect(() => { load(); loadUsers(); }, [load, loadUsers]);

  // Pre-fill signature when email tab first opens
  useEffect(() => {
    if (tab === 'email' && !emailSubject && !emailBody) {
      setEmailBody(buildTextSig(user));
    }
  }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true); setSaveMsg('');
    try {
      const r = await fetch(`${API}/api/sales/leads/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ cityName: form.city_name, cityState: form.city_state, contactName: form.contact_name, contactEmail: form.contact_email, contactPhone: form.contact_phone, contactTitle: form.contact_title, stage: form.stage, isCwPlan: form.is_cw_plan ? true : false, planTier: form.plan_tier, hasAnswers: form.has_answers ? true : false, notes: form.notes, source: form.source, estimatedArr: form.estimated_arr || null }),
      });
      const data = await r.json();
      if (r.ok) { setLead(data); setForm(data); setEditMode(false); setSaveMsg('Saved'); }
      else setSaveMsg(data.error || 'Failed to save');
    } catch(e) { setSaveMsg('Network error'); }
    setSaving(false);
  }

  async function handleAddActivity(e) {
    e.preventDefault();
    setAddingAct(true);
    try {
      const r = await fetch(`${API}/api/sales/leads/${id}/activities`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(actForm),
      });
      if (r.ok) { setActForm({ type: 'call', title: '', body: '', followUpDate: '' }); load(); }
    } catch(e) {}
    setAddingAct(false);
  }

  async function generateEmail() {
    setGenLoading(true); setEmailMsg('');
    try {
      const r = await fetch(`${API}/api/sales/generate-lead-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ leadId: id, customNotes: emailNotes, emailContext }),
      });
      const data = await r.json();
      if (r.ok) {
        setEmailSubject(data.subject);
        setEmailBody(stripAiClosing(data.body) + buildTextSig(user));
      }
      else setEmailMsg(data.error || 'Generation failed');
    } catch(e) { setEmailMsg('Network error'); }
    setGenLoading(false);
  }

  // Sync AI prompt text when sidebar selection changes. Index of -1 means
  // a saved template was picked instead — caller sets aiPromptText directly.
  React.useEffect(() => {
    if (selectedAiPromptIdx < 0 || selectedAiPromptIdx >= AI_PROMPTS_LIB.length) return;
    setAiPromptText(AI_PROMPTS_LIB[selectedAiPromptIdx].prompt);
  }, [selectedAiPromptIdx]); // eslint-disable-line react-hooks/exhaustive-deps

  async function generateAiEmail() {
    setGenLoading(true); setEmailMsg(''); setAiResult(null);
    try {
      const r = await fetch(`${API}/api/sales/generate-lead-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ leadId: id, customNotes: aiPromptText, emailContext: 'cold_intro' }),
      });
      const data = await r.json();
      if (r.ok) {
        setAiResult({ subject: data.subject, body: data.body });
      } else setEmailMsg(data.error || 'Generation failed');
    } catch(e) { setEmailMsg('Network error'); }
    setGenLoading(false);
  }

  function loadAiResult() {
    if (!aiResult) return;
    setEmailSubject(subLeadVars(aiResult.subject, lead, user));
    setEmailBody(subLeadVars(stripAiClosing(aiResult.body), lead, user) + buildTextSig(user));
    setEmailComposerTab(0);
  }

  function getSmartPicks(title) {
    const t = (title || '').toLowerCase();
    if (t.includes('it') || t.includes('technology') || t.includes('information')) {
      return [
        { label: 'Tue 10am', day: 2, hour: 10, reason: 'IT pros clear inbox Tue morning' },
        { label: 'Wed 2pm', day: 3, hour: 14, reason: 'Post-standup availability' },
        { label: 'Thu 9am', day: 4, hour: 9, reason: 'Start-of-day before meetings' },
      ];
    }
    if (t.includes('director') || t.includes('manager') || t.includes('chief') || t.includes('cio') || t.includes('cto')) {
      return [
        { label: 'Tue 8am', day: 2, hour: 8, reason: 'Execs check email before 9am' },
        { label: 'Wed 7am', day: 3, hour: 7, reason: 'Pre-meeting window' },
        { label: 'Thu 4pm', day: 4, hour: 16, reason: 'End-of-day review time' },
      ];
    }
    if (t.includes('public works') || t.includes('engineer') || t.includes('gis') || t.includes('operations')) {
      return [
        { label: 'Mon 7am', day: 1, hour: 7, reason: 'Field ops check email early' },
        { label: 'Tue 3pm', day: 2, hour: 15, reason: 'After field work wraps up' },
        { label: 'Thu 10am', day: 4, hour: 10, reason: 'Mid-week desk time' },
      ];
    }
    if (t.includes('clerk') || t.includes('admin') || t.includes('coordinator')) {
      return [
        { label: 'Wed 10am', day: 3, hour: 10, reason: 'Mid-week admin catch-up' },
        { label: 'Fri 9am', day: 5, hour: 9, reason: 'Wrap-up review day' },
        { label: 'Tue 2pm', day: 2, hour: 14, reason: 'Post-lunch productivity peak' },
      ];
    }
    // Default
    return [
      { label: 'Tue 10am', day: 2, hour: 10, reason: 'Best general open rate window' },
      { label: 'Wed 9am', day: 3, hour: 9, reason: 'Peak mid-week engagement' },
      { label: 'Thu 2pm', day: 4, hour: 14, reason: 'Post-lunch decision-making time' },
    ];
  }

  function applySmartPick(pick) {
    // Build next occurrence of this weekday at this hour (in local time)
    const now = new Date();
    const today = now.getDay(); // 0=Sun
    let daysAhead = pick.day - today;
    if (daysAhead <= 0) daysAhead += 7;
    const target = new Date(now);
    target.setDate(now.getDate() + daysAhead);
    target.setHours(pick.hour, 0, 0, 0);
    const yyyy = target.getFullYear();
    const mm = String(target.getMonth() + 1).padStart(2, '0');
    const dd = String(target.getDate()).padStart(2, '0');
    const hh = String(pick.hour).padStart(2, '0');
    setSchedDate(`${yyyy}-${mm}-${dd}`);
    setSchedTime(`${hh}:00`);
  }

  async function scheduleSend() {
    if (!emailSubject || !emailBody || !emailTo) { setSchedMsg('Subject, body, and recipient required'); return; }
    if (!schedDate || !schedTime) { setSchedMsg('Select a date and time'); return; }
    const localDt = new Date(`${schedDate}T${schedTime}:00`);
    if (isNaN(localDt.getTime()) || localDt <= new Date()) { setSchedMsg('Scheduled time must be in the future'); return; }
    // Convert to UTC ISO string for storage
    const scheduledFor = localDt.toISOString().replace('T', ' ').replace(/\.\d{3}Z$/, '');
    // For HTML body: replace plain-text sig with branded HTML sig
    const sigIdx = emailBody.indexOf(SIG_SEPARATOR);
    const bodyText = sigIdx !== -1 ? emailBody.substring(0, sigIdx) : emailBody;
    const finalBody = bodyText.replace(/\n/g, '<br>') + buildHtmlSig(user);
    setSchedulingEmail(true); setSchedMsg('');
    try {
      const r = await fetch(`${API}/api/sales/schedule-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ leadId: id, recipientEmail: emailTo, recipientName: lead.contact_name || '', subject: emailSubject, body: finalBody, aiGenerated: true, scheduledFor, ccEmails: emailCc }),
      });
      const data = await r.json();
      if (r.ok) {
        setShowSendLater(false);
        setSchedDate(''); setSchedTime('');
        setSchedMsg('');
        loadScheduled();
        setEmailMsg(`📅 Scheduled for ${localDt.toLocaleString([], { weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}`);
      } else {
        setSchedMsg(data.error || 'Failed to schedule');
      }
    } catch(e) { setSchedMsg('Network error'); }
    setSchedulingEmail(false);
  }

  async function cancelScheduled(seId) {
    if (!window.confirm('Cancel this scheduled email?')) return;
    try {
      const r = await fetch(`${API}/api/sales/scheduled-emails/${seId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      if (r.ok) loadScheduled();
    } catch(e) {}
  }

  function startEditScheduled(se) {
    // Parse stored UTC datetime back to local date+time inputs
    const dt = new Date(se.scheduled_for + 'Z');
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    const hh = String(dt.getHours()).padStart(2, '0');
    const min = String(dt.getMinutes()).padStart(2, '0');
    setEditSchedDate(`${yyyy}-${mm}-${dd}`);
    setEditSchedTime(`${hh}:${min}`);
    setEditSchedSubject(se.subject || '');
    setEditSchedBody(se.body || '');
    setEditSchedMsg('');
    setEditingScheduledId(se.id);
  }

  async function saveReschedule(seId) {
    if (!editSchedDate || !editSchedTime) { setEditSchedMsg('Select a date and time'); return; }
    const localDt = new Date(`${editSchedDate}T${editSchedTime}:00`);
    if (isNaN(localDt.getTime()) || localDt <= new Date()) { setEditSchedMsg('Must be in the future'); return; }
    const scheduledFor = localDt.toISOString().replace('T', ' ').replace(/\.\d{3}Z$/, '');
    setRescheduling(true); setEditSchedMsg('');
    try {
      const r = await fetch(`${API}/api/sales/scheduled-emails/${seId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ scheduledFor, subject: editSchedSubject, body: editSchedBody }),
      });
      const data = await r.json();
      if (r.ok) { setEditingScheduledId(null); loadScheduled(); }
      else setEditSchedMsg(data.error || 'Failed to save');
    } catch(e) { setEditSchedMsg('Network error'); }
    setRescheduling(false);
  }

  async function checkBounce(email) {
    if (!email || !email.includes('@')) { setBounceWarning(null); return; }
    try {
      const r = await fetch(`${API}/api/sales/check-bounce?email=${encodeURIComponent(email)}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await r.json();
      setBounceWarning(data.bounced ? data : null);
      if (data.bounced) setForceOverride(false);
    } catch(e) { setBounceWarning(null); }
  }

  async function sendEmail(method) {
    if (!emailSubject || !emailBody || !emailTo) { setEmailMsg('Subject, body, and recipient email required'); return; }
    setSendLoading(true); setEmailMsg('');
    try {
      // For SendGrid: replace plain-text sig block with branded HTML sig + logo
      let finalBody = emailBody;
      if (method === 'sendgrid') {
        const sigIdx = emailBody.indexOf(SIG_SEPARATOR);
        const bodyText = sigIdx !== -1 ? emailBody.substring(0, sigIdx) : emailBody;
        finalBody = bodyText.replace(/\n/g, '<br>') + buildHtmlSig(user);
      }
      const r = await fetch(`${API}/api/sales/send-lead-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ leadId: id, recipientEmail: emailTo, recipientName: lead.contact_name || '', subject: emailSubject, body: finalBody, aiGenerated: true, sendMethod: method, ccEmails: emailCc, forceOverride }),
      });
      const data = await r.json();
      if (r.ok) {
        if (method === 'copy') {
          await navigator.clipboard.writeText(`Subject: ${emailSubject}\n\n${emailBody}`);
          setEmailMsg('Copied to clipboard!');
        } else {
          // Auto-advance to "Contacted" if still at Prospect
          const stageOrder = ['prospect','contacted','demo_booked','trial_active','nurturing','negotiating','closed_won'];
          const currentIdx = stageOrder.indexOf(lead.stage);
          const contactedIdx = stageOrder.indexOf('contacted');
          if (currentIdx < contactedIdx) {
            await fetch(`${API}/api/sales/leads/${id}`, {
              method: 'PATCH',
              headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
              body: JSON.stringify({ stage: 'contacted' }),
            });
            setEmailMsg('Sent! Stage advanced to Contacted.');
          } else {
            setEmailMsg('Sent via SendGrid!');
          }
        }
        load();
      } else setEmailMsg(data.error || 'Failed');
    } catch(e) { setEmailMsg('Network error'); }
    setSendLoading(false);
  }

  async function handleDelegate(e) {
    e.preventDefault();
    try {
      await fetch(`${API}/api/sales/leads/${id}/delegate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ delegatedRepId: delegateRepId || null }),
      });
      load();
    } catch(e) {}
  }

  async function handleReassign(e) {
    e.preventDefault();
    if (!reassignId) return;
    try {
      await fetch(`${API}/api/sales/leads/${id}/owner`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ newOwnerId: reassignId }),
      });
      load();
    } catch(e) {}
  }

  async function handleConvert(e) {
    e.preventDefault();
    if (!convertCityId.trim()) { setConvertMsg('Enter a city ID'); return; }
    try {
      const r = await fetch(`${API}/api/sales/leads/${id}/convert`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ cityId: convertCityId.trim() }),
      });
      const data = await r.json();
      if (r.ok) { setConvertMsg('Converted! Lead owner assigned as city rep.'); load(); }
      else setConvertMsg(data.error || 'Failed');
    } catch(e) { setConvertMsg('Network error'); }
  }

  async function quickStageChange(stageKey) {
    if (!canEdit || stageKey === lead.stage) return;
    const label = STAGES.find(s => s.key === stageKey)?.label || stageKey;
    if (!window.confirm(`Move "${lead.city_name}" to "${label}"?`)) return;
    await fetch(`${API}/api/sales/leads/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ stage: stageKey }),
    });
    load();
  }

  if (loading) return <div style={S.page}><div className="cb-main" style={S.main}><p style={{ color: '#64748b', padding: 32 }}>Loading…</p></div></div>;
  if (!lead) return <div style={S.page}><div className="cb-main" style={S.main}><p>Lead not found.</p><button style={{ ...S.btn, ...S.btnSecondary }} onClick={() => navigate('/leads')}>Back to Leads</button></div></div>;

  const arr = lead.estimated_arr || calcLeadArr(lead);
  const stageColor = STAGE_COLORS[lead.stage] || '#6b7280';
  const stageLabel = STAGES.find(s => s.key === lead.stage)?.label || lead.stage;

  return (
    <div style={S.page}>
      <div className="cb-main" style={S.main}>
        <div style={{ ...S.row, marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
          <button style={{ ...S.btn, ...S.btnSm, ...S.btnSecondary }} onClick={() => navigate('/leads')}>← Back</button>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              <h1 style={{ ...S.h1, margin: 0 }}>{lead.city_name}{lead.city_state ? `, ${lead.city_state}` : ''}</h1>
              <span style={{ ...S.badge, background: stageColor + '20', color: stageColor, fontSize: 13 }}>{stageLabel}</span>
              {lead.converted_city_id && <span style={{ ...S.badge, background: '#dcfce7', color: '#16a34a' }}>Converted</span>}
            </div>
            <div style={{ color: '#64748b', fontSize: 13, marginTop: 4 }}>
              Owner: <strong>{lead.owner_name || lead.owner_rep_id}</strong>
              {lead.delegated_rep_name && <> · Delegate: <strong>{lead.delegated_rep_name}</strong></>}
              {' · '}{formatCurrency(arr)}/yr
            </div>
          </div>
          {isManager && !lead.converted_city_id && (
            <button style={{ ...S.btn, ...S.btnSm, ...S.btnSuccess }} onClick={() => setTab('convert')}>Convert to City</button>
          )}
        </div>

        {/* Stage Progress Rail */}
        <div style={{ ...S.card, padding: '14px 20px', marginBottom: 16 }}>
          <div style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#94a3b8', marginBottom: 10 }}>
            Pipeline Progress{canEdit ? ' — click any stage to advance' : ''}
          </div>
          <StageProgress currentStage={lead.stage} onStageClick={canEdit ? quickStageChange : null} />
        </div>

        <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '2px solid #e2e8f0', paddingBottom: 0 }}>
          {['overview','email','activity'].concat(isManager ? ['convert'] : []).map(t => (
            <button key={t} style={{ ...S.tab, ...(tab === t ? S.tabActive : {}), borderRadius: '8px 8px 0 0', textTransform: 'capitalize' }} onClick={() => setTab(t)}>{t}</button>
          ))}
        </div>

        {tab === 'overview' && (
          <div className="cb-grid2" style={S.grid2}>
            <div>
              <div style={S.card}>
                <div style={{ ...S.spaceBetween, marginBottom: 16 }}>
                  <h3 style={{ ...S.h3, margin: 0 }}>Lead Details</h3>
                  {canEdit && <button style={{ ...S.btn, ...S.btnSm, ...S.btnSecondary }} onClick={() => setEditMode(!editMode)}>{editMode ? 'Cancel' : 'Edit'}</button>}
                </div>
                {saveMsg && <div style={saveMsg.includes('aved') ? S.success : S.error}>{saveMsg}</div>}
                {editMode ? (
                  <form onSubmit={handleSave}>
                    {[['city_name','City Name','text'],['city_state','State','text'],['contact_name','Contact Name','text'],['contact_title','Contact Title','text'],['contact_email','Contact Email','email'],['contact_phone','Contact Phone','tel'],['source','Source','text']].map(([field, label, type]) => (
                      <div key={field} style={{ marginBottom: 12 }}>
                        <label style={S.label}>{label}</label>
                        <input style={S.input} type={type} value={form[field] || ''} onChange={e => setForm(f => ({ ...f, [field]: e.target.value }))} />
                      </div>
                    ))}
                    <div style={{ marginBottom: 12 }}>
                      <label style={S.label}>Stage</label>
                      <select style={S.select} value={form.stage || ''} onChange={e => setForm(f => ({ ...f, stage: e.target.value }))}>
                        {STAGES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
                      </select>
                    </div>
                    <div style={{ marginBottom: 12 }}>
                      <label style={S.label}>Plan Tier</label>
                      <select style={S.select} value={form.plan_tier || 'starter'} onChange={e => setForm(f => ({ ...f, plan_tier: e.target.value }))}>
                        <option value="starter">Starter</option>
                        <option value="growth">Growth</option>
                        <option value="professional">Professional</option>
                      </select>
                    </div>
                    <div style={{ marginBottom: 12, display: 'flex', gap: 16 }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, cursor: 'pointer' }}>
                        <input type="checkbox" checked={!!form.is_cw_plan} onChange={e => setForm(f => ({ ...f, is_cw_plan: e.target.checked ? 1 : 0 }))} />
                        Cityworks
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, cursor: 'pointer' }}>
                        <input type="checkbox" checked={!!form.has_answers} onChange={e => setForm(f => ({ ...f, has_answers: e.target.checked ? 1 : 0 }))} />
                        + Answers
                      </label>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={S.label}>Notes</label>
                      <textarea style={{ ...S.textarea, minHeight: 80 }} value={form.notes || ''} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} />
                    </div>
                    <button type="submit" style={{ ...S.btn, ...S.btnPrimary, width: '100%' }} disabled={saving}>{saving ? 'Saving…' : 'Save Changes'}</button>
                  </form>
                ) : (
                  <div>
                    {[
                      ['Owner', lead.owner_rep_id === 'super_admin' ? 'Brandon Wright (Super Admin)' : (lead.owner_name || lead.owner_rep_id)],
                      ['Delegated To', lead.delegated_rep_name || '—'],
                      ['Contact', lead.contact_name || '—'],
                      ['Title', lead.contact_title || '—'],
                      ['Email', lead.contact_email || '—'],
                      ['Phone', lead.contact_phone || '—'],
                      ['Population', oppDetail?.population ? oppDetail.population.toLocaleString() : '—'],
                      ['Website', oppDetail?.website || '—'],
                      ['Source', lead.source || '—'],
                      ['Stage', stageLabel],
                      ['Plan', `${lead.plan_tier?.charAt(0).toUpperCase()}${lead.plan_tier?.slice(1)} ${lead.is_cw_plan ? '(Cityworks)' : '(Email)'}`],
                      ['Answers', lead.has_answers ? 'Yes' : 'No'],
                      ['Notes', lead.notes || '—'],
                      ['Created', formatDate(lead.created_at)],
                    ].map(([k, v]) => (
                      <div key={k} style={{ display: 'flex', gap: 8, marginBottom: 10, fontSize: 14 }}>
                        <span style={{ color: '#64748b', minWidth: 90, flexShrink: 0 }}>{k}</span>
                        {k === 'Website' && v !== '—'
                          ? <a href={v.startsWith('http') ? v : 'https://' + v} target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', fontSize: 14 }}>{v.replace(/^https?:\/\//, '')}</a>
                          : <span style={{ color: k === 'Owner' ? '#1e3a5f' : '#1e293b', fontWeight: ['Owner','Stage'].includes(k) ? 600 : 400 }}>{v}</span>
                        }
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div>
              <div style={S.card}>
                <h3 style={S.h3}>Annual Value</h3>
                <div style={{ fontSize: 32, fontWeight: 700, color: '#1e3a5f', marginBottom: 8 }}>{formatCurrency(arr)}/yr</div>
                <div style={{ fontSize: 13, color: '#64748b' }}>
                  {lead.plan_tier?.charAt(0).toUpperCase()}{lead.plan_tier?.slice(1)} {lead.is_cw_plan ? 'CW' : 'Email'}
                  {lead.has_answers ? ' + Answers' : ''} — Annual pricing
                </div>
              </div>

              {/* Linked CivicBot City */}
              <div style={S.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: linkedCity ? 10 : 0 }}>
                  <h3 style={{ ...S.h3, margin: 0 }}>🏙 Linked CivicBot City</h3>
                  {isSuperAdmin && !linkedCity && lead.opportunity_id && (
                    <button onClick={openLinkPanel} style={{ ...S.btn, ...S.btnPrimary, ...S.btnSm }}>+ Link City</button>
                  )}
                  {isSuperAdmin && linkedCity && (
                    <button onClick={unlinkCity} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm }}>Unlink</button>
                  )}
                </div>
                {linkedCity ? (
                  <div style={{ fontSize: 13 }}>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>{linkedCity.name}{linkedCity.state ? `, ${linkedCity.state}` : ''}</div>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                      <span style={{ ...S.badge, background: linkedCity.billing_status === 'active' ? '#dcfce7' : '#fef9c3', color: linkedCity.billing_status === 'active' ? '#16a34a' : '#92400e' }}>
                        {linkedCity.billing_status === 'active' ? '✅ Active' : linkedCity.billing_status === 'trialing' ? '🎉 Trial' : linkedCity.billing_status || 'No Trial'}
                      </span>
                      {linkedCity.plan_name && <span style={S.badge}>{linkedCity.plan_name}</span>}
                      {linkedCity.trial_ends_at && <span style={{ ...S.badge, background: '#f1f5f9', color: '#64748b' }}>Trial: {new Date(linkedCity.trial_ends_at).toLocaleDateString()}</span>}
                    </div>
                  </div>
                ) : (
                  <p style={{ color: '#94a3b8', fontSize: 13, margin: 0 }}>
                    {!lead.opportunity_id ? 'Lead must be claimed from an opportunity to link a city.' : isSuperAdmin ? 'No city linked yet. Use "+ Link City" to connect to a CivicBot city.' : 'Not linked to a CivicBot city.'}
                  </p>
                )}
                {linkMsg && <div style={{ marginTop: 8, fontSize: 13, color: linkMsg.startsWith('✅') ? '#16a34a' : '#ef4444' }}>{linkMsg}</div>}
                {showLinkCity && (
                  <div style={{ marginTop: 12, borderTop: '1px solid #e2e8f0', paddingTop: 12 }}>
                    <input style={{ ...S.input, marginBottom: 8 }} placeholder="Search city name…" value={citySearch} onChange={e => setCitySearch(e.target.value)} autoFocus />
                    <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: 6 }}>
                      {cities.filter(c => !citySearch || c.name.toLowerCase().includes(citySearch.toLowerCase()) || (c.state || '').toLowerCase().includes(citySearch.toLowerCase()))
                        .slice(0, 30).map(c => (
                          <div key={c.id} onClick={() => linkCity(c.id)}
                            style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', fontSize: 13, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'} onMouseLeave={e => e.currentTarget.style.background = ''}>
                            <span>{c.name}{c.state ? `, ${c.state}` : ''}</span>
                            <span style={{ fontSize: 11, color: '#94a3b8' }}>{c.billingStatus === 'active' ? '✅ Active' : c.billingStatus === 'trialing' ? '🎉 Trial' : c.billingStatus || '—'}</span>
                          </div>
                        ))}
                      {!cities.length && <div style={{ padding: 12, color: '#94a3b8', fontSize: 13 }}>Loading cities…</div>}
                    </div>
                    <button onClick={() => setShowLinkCity(false)} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm, marginTop: 8 }}>Cancel</button>
                  </div>
                )}
              </div>

              {isOwner && (
                <div style={S.card}>
                  <h3 style={S.h3}>Delegation</h3>
                  <p style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>Grant temporary edit access to another rep. Only you can remove it.</p>
                  {lead.delegated_rep_name && (
                    <div style={{ ...S.info, marginBottom: 12 }}>Currently delegated to: <strong>{lead.delegated_rep_name}</strong></div>
                  )}
                  <form onSubmit={handleDelegate} style={{ display: 'flex', gap: 8 }}>
                    <select style={{ ...S.select, flex: 1 }} value={delegateRepId} onChange={e => setDelegateRepId(e.target.value)}>
                      <option value="">None (remove delegation)</option>
                      {salesUsers.filter(u => u.id !== lead.owner_rep_id).map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                    </select>
                    <button type="submit" style={{ ...S.btn, ...S.btnPrimary }}>Save</button>
                  </form>
                </div>
              )}

              {isSuperAdmin && (
                <div style={S.card}>
                  <h3 style={S.h3}>Reassign Owner</h3>
                  <p style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>Super admin only — permanently changes lead ownership.</p>
                  <form onSubmit={handleReassign} style={{ display: 'flex', gap: 8 }}>
                    <select style={{ ...S.select, flex: 1 }} value={reassignId} onChange={e => setReassignId(e.target.value)} required>
                      <option value="">Select new owner…</option>
                      {salesUsers.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                    </select>
                    <button type="submit" style={{ ...S.btn, ...S.btnAmber }}>Reassign</button>
                  </form>
                </div>
              )}

              {/* Contacts (multi-contact with drag-and-drop) */}
              <div style={S.card}>
                <h3 style={S.h3}>Contacts ({leadContacts.length})</h3>
                <p style={{ fontSize: 12, color: '#94a3b8', marginBottom: 12 }}>Drag to reorder · First contact is Primary</p>
                <ContactList contacts={leadContacts} entityType="lead" entityId={id} token={token} onRefresh={load} canEdit={canEdit} />
              </div>

              {/* Org Info from Opportunity */}
              {oppDetail && (
                <div style={S.card}>
                  <h3 style={S.h3}>Organization Info</h3>
                  {[
                    ['Employee Size', oppDetail.employee_size],
                    ['Population', oppDetail.population?.toLocaleString()],
                    ['Website', oppDetail.website],
                  ].map(([k, v]) => (
                    <div key={k} style={{ display: 'flex', gap: 8, marginBottom: 8, fontSize: 13 }}>
                      <span style={{ color: '#64748b', minWidth: 100 }}>{k}</span>
                      <span style={{ wordBreak: 'break-all', color: v ? '#1e293b' : '#cbd5e1' }}>{v || '—'}</span>
                    </div>
                  ))}
                  {(oppDetail.company_linkedin || oppDetail.company_facebook || oppDetail.company_twitter) ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4 }}>
                      {[
                        oppDetail.company_linkedin && { label: 'LinkedIn', url: oppDetail.company_linkedin.startsWith('http') ? oppDetail.company_linkedin : 'https://' + oppDetail.company_linkedin, bg: '#0a66c2', border: '#bfdbfe', tc: '#0a66c2' },
                        oppDetail.company_facebook && { label: 'Facebook', url: oppDetail.company_facebook.startsWith('http') ? oppDetail.company_facebook : 'https://' + oppDetail.company_facebook, bg: '#1877f2', border: '#bfdbfe', tc: '#1877f2' },
                        oppDetail.company_twitter && { label: 'X / Twitter', url: oppDetail.company_twitter.startsWith('http') ? oppDetail.company_twitter : 'https://' + oppDetail.company_twitter, bg: '#000', border: '#e2e8f0', tc: '#374151' },
                      ].filter(Boolean).map(({ label, url, bg, border, tc }) => (
                        <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <span style={{ fontSize: 11, color: '#94a3b8', width: 68, flexShrink: 0 }}>{label}:</span>
                          <a href={url} target="_blank" rel="noreferrer"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, fontWeight: 700, background: bg, color: '#fff', borderRadius: 5, padding: '4px 10px', textDecoration: 'none' }}>
                            Open ↗
                          </a>
                          <button onClick={() => navigator.clipboard.writeText(url).then(() => { const b = document.activeElement; b.textContent = 'Copied!'; setTimeout(() => { b.textContent = 'Copy URL'; }, 1500); })}
                            style={{ ...S.btn, ...S.btnSm, fontSize: 11, background: '#f8fafc', color: tc, border: `1px solid ${border}`, fontWeight: 600, padding: '4px 10px' }}>
                            Copy URL
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ fontSize: 12, color: '#cbd5e1' }}>No social links on file</div>
                  )}
                </div>
              )}

              {/* Release back to Opportunities */}
              {lead.opportunity_id && isOwner && lead.stage !== 'closed_won' && lead.stage !== 'converted' && (
                <div style={{ ...S.card, border: '1px solid #fecaca', background: '#fff5f5' }}>
                  <h3 style={{ ...S.h3, color: '#dc2626' }}>Release Lead</h3>
                  <p style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>Return this lead to the Opportunities pool. All notes and email history will be preserved and visible to the next rep who claims it.</p>
                  <button onClick={releaseLead} disabled={releasing} style={{ ...S.btn, background: '#dc2626', color: '#fff', width: '100%' }}>
                    {releasing ? 'Releasing…' : '↩ Release Back to Opportunities'}
                  </button>
                </div>
              )}

              {lead.opportunity_id && (
                <div style={{ ...S.cardSm, background: '#f0f9ff', border: '1px solid #bae6fd' }}>
                  <div style={{ fontSize: 12, color: '#0369a1' }}>
                    🔗 From Opportunities · <button onClick={() => navigate('/opportunities')} style={{ background: 'none', border: 'none', color: '#0369a1', cursor: 'pointer', padding: 0, fontSize: 12, textDecoration: 'underline' }}>View all opportunities</button>
                  </div>
                </div>
              )}

              {/* Super Admin: Direct Delete */}
              {isSuperAdmin && !lead.converted_city_id && (
                <div style={{ ...S.card, border: '1px solid #fecaca', background: '#fff5f5' }}>
                  <h3 style={{ ...S.h3, color: '#7f1d1d', marginBottom: 4 }}>🗑 Delete Lead</h3>
                  <p style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>Super admin only — permanently deletes this lead and all associated data. If linked to an opportunity, it will be returned to the pool.</p>
                  <button onClick={deleteLead} disabled={deletingLead} style={{ ...S.btn, background: '#dc2626', color: '#fff', width: '100%' }}>
                    {deletingLead ? 'Deleting…' : '🗑 Delete Lead Permanently'}
                  </button>
                </div>
              )}

              {/* Request Deletion (non-super-admin) */}
              {!isSuperAdmin && !lead.converted_city_id && (
                <div style={{ ...S.card, border: '1px solid #fecaca', background: '#fff5f5' }}>
                  <h3 style={{ ...S.h3, color: '#7f1d1d', marginBottom: 4 }}>Request Lead Deletion</h3>
                  <p style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>
                    Sends a deletion request to Super Admin for approval. The lead is not deleted until approved.
                  </p>
                  {!showDeleteRequest && deleteMsg !== 'success' && (
                    <button onClick={() => setShowDeleteRequest(true)} style={{ ...S.btn, background: '#7f1d1d', color: '#fff', width: '100%' }}>
                      🗑 Request Deletion of Lead
                    </button>
                  )}
                  {deleteMsg === 'success' && (
                    <div style={{ ...S.success, textAlign: 'center' }}>✅ Deletion request submitted — pending Super Admin approval.</div>
                  )}
                  {showDeleteRequest && deleteMsg !== 'success' && (
                    <form onSubmit={submitDeleteRequest}>
                      <label style={S.label}>Reason (optional)</label>
                      <textarea style={{ ...S.textarea, minHeight: 60, marginBottom: 10 }} value={deleteReason} onChange={e => setDeleteReason(e.target.value)} placeholder="Why should this lead be deleted?" />
                      {deleteMsg && deleteMsg !== 'success' && <div style={{ ...S.error, marginBottom: 8 }}>{deleteMsg}</div>}
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button type="button" onClick={() => { setShowDeleteRequest(false); setDeleteMsg(''); }} style={{ ...S.btn, ...S.btnSecondary, flex: 1 }}>Cancel</button>
                        <button type="submit" disabled={deletingRequest} style={{ ...S.btn, background: '#dc2626', color: '#fff', flex: 2 }}>{deletingRequest ? 'Submitting…' : 'Submit Deletion Request'}</button>
                      </div>
                    </form>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {tab === 'email' && (
          <div className="cb-grid2" style={S.grid2}>
            <div>
              {/* ── RECIPIENT BAR (always visible) ── */}
              <div style={{ ...S.card, marginBottom: 12 }}>
                {/* Contact context strip */}
                <div style={{ fontSize: 12, color: '#475569', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
                  <span style={{ fontWeight: 700, color: '#1e3a5f', fontSize: 13 }}>{lead?.contact_name || '—'}</span>
                  {lead?.contact_title && <><span style={{ color: '#cbd5e1' }}>·</span><span style={{ color: '#5b21b6', fontWeight: 600 }}>{lead.contact_title}</span></>}
                  {lead?.city_name && <><span style={{ color: '#cbd5e1' }}>·</span><span style={{ color: '#64748b' }}>{lead.city_name}{lead.city_state ? `, ${lead.city_state}` : ''}</span></>}
                  {oppDetail?.population && <><span style={{ color: '#cbd5e1' }}>·</span><span style={{ color: '#0891b2', fontWeight: 600 }}>pop. {oppDetail.population.toLocaleString()}</span></>}
                </div>
                {oppDetail?.website && (
                  <div style={{ marginBottom: 8, marginTop: -6 }}>
                    <a href={oppDetail.website.startsWith('http') ? oppDetail.website : 'https://' + oppDetail.website} target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, color: '#2563eb', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                      🌐 {oppDetail.website.replace(/^https?:\/\//, '')}
                    </a>
                  </div>
                )}
                <div style={{ display: 'flex', gap: 12 }}>
                  <div style={{ flex: 1 }}>
                    <label style={S.label}>To</label>
                    <input style={{ ...S.input, borderColor: bounceWarning ? '#ef4444' : undefined }} type="email" value={emailTo}
                      onChange={e => { setEmailTo(e.target.value); setBounceWarning(null); setForceOverride(false); }}
                      onBlur={e => checkBounce(e.target.value)}
                      placeholder={lead.contact_email || 'recipient@city.gov'} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={S.label}>CC <span style={{ fontWeight: 400, color: '#94a3b8' }}>(comma-separated)</span></label>
                    <input style={S.input} type="text" value={emailCc} onChange={e => setEmailCc(e.target.value)} placeholder="jane@city.gov, john@city.gov, …" />
                  </div>
                </div>
                {(() => {
                  const ccContacts = leadContacts.filter(c => c.email && c.email.trim() && c.email.trim().toLowerCase() !== (emailTo || '').trim().toLowerCase());
                  if (!ccContacts.length) return null;
                  const allCcEmails = ccContacts.map(c => c.email.trim()).join(', ');
                  const isChecked = ccContacts.every(c => emailCc.toLowerCase().includes(c.email.trim().toLowerCase()));
                  return (
                    <label style={{ display: 'flex', alignItems: 'center', gap: 7, marginTop: 6, cursor: 'pointer', fontSize: 12, color: '#5b21b6', userSelect: 'none' }}>
                      <input type="checkbox" checked={isChecked}
                        onChange={e => {
                          if (e.target.checked) {
                            const existing = emailCc.split(',').map(x => x.trim()).filter(Boolean);
                            const toAdd = ccContacts.map(c => c.email.trim()).filter(e => !existing.some(ex => ex.toLowerCase() === e.toLowerCase()));
                            setEmailCc([...existing, ...toAdd].join(', '));
                          } else {
                            const ccEmailSet = new Set(ccContacts.map(c => c.email.trim().toLowerCase()));
                            const remaining = emailCc.split(',').map(x => x.trim()).filter(x => x && !ccEmailSet.has(x.toLowerCase()));
                            setEmailCc(remaining.join(', '));
                          }
                        }}
                        style={{ accentColor: '#7c3aed', width: 14, height: 14 }} />
                      CC all additional contacts ({ccContacts.length})
                      <span style={{ color: '#94a3b8', fontWeight: 400 }}>— {ccContacts.map(c => c.name || c.email).join(', ')}</span>
                    </label>
                  );
                })()}
                {emailCc && emailCc.split(',').filter(x => x.trim()).length >= 1 && (
                  <div style={{ fontSize: 11, color: '#7c3aed', marginTop: 4 }}>{emailCc.split(',').filter(x => x.trim()).length} on CC</div>
                )}
                {bounceWarning && (
                  <div style={{ background: '#fff1f2', border: '1px solid #fca5a5', borderRadius: 10, padding: '12px 14px', marginTop: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                      <span style={{ fontSize: 18 }}>⚠️</span>
                      <span style={{ fontWeight: 700, color: '#dc2626', fontSize: 13 }}>This address has previously {bounceWarning.status === 'dropped' ? 'been dropped' : 'bounced'}</span>
                    </div>
                    <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8, lineHeight: 1.5 }}>
                      {bounceWarning.bouncedAt && <><strong>Date:</strong> {new Date(bounceWarning.bouncedAt).toLocaleDateString()}<br /></>}
                      {bounceWarning.reason && <><strong>Reason:</strong> {bounceWarning.reason}<br /></>}
                      Sending to a bounced address again will damage your sender reputation.
                    </div>
                    <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}><strong>Recommended:</strong> Verify the correct email before sending.</div>
                    {isSuperAdmin && (
                      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#dc2626', cursor: 'pointer' }}>
                        <input type="checkbox" checked={forceOverride} onChange={e => setForceOverride(e.target.checked)} />
                        Override and send anyway (super admin only — not recommended)
                      </label>
                    )}
                  </div>
                )}
              </div>

              {/* ── 5-TAB EMAIL COMPOSER ── */}
              <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden', marginBottom: 12 }}>
                {/* Tab nav */}
                <div style={{ display: 'flex', borderBottom: '2px solid #e2e8f0', background: '#f8fafc', overflowX: 'auto' }}>
                  {['✍️ Composer', '📄 Templates', '✨ AI Generator', '📬 Subject Lines', '📊 Stats & Quotes'].map((t, i) => (
                    <button key={i} onClick={() => setEmailComposerTab(i)} style={{
                      padding: '11px 16px', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: emailComposerTab === i ? 700 : 500,
                      background: emailComposerTab === i ? '#fff' : 'transparent',
                      color: emailComposerTab === i ? '#1e3a5f' : '#64748b',
                      borderBottom: emailComposerTab === i ? '2px solid #2563eb' : '2px solid transparent',
                      marginBottom: -2, whiteSpace: 'nowrap', transition: 'all 0.15s',
                    }}>{t}</button>
                  ))}
                </div>

                <div style={{ padding: '20px 20px 24px' }}>

                  {/* ── TAB 0: COMPOSER ── */}
                  {emailComposerTab === 0 && (
                    <div>
                      <div style={{ display: 'flex', gap: 20 }}>
                        {/* Left: subject + body + actions */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ marginBottom: 12 }}>
                            <label style={S.label}>Subject Line</label>
                            <div style={{ display: 'flex', gap: 8 }}>
                              <input style={{ ...S.input, flex: 1 }} value={emailSubject} onChange={e => setEmailSubject(e.target.value)} placeholder="Enter or load a subject line…" />
                              <button onClick={() => { if (emailSubject) { navigator.clipboard.writeText(subLeadVars(emailSubject, lead, user)); } }} style={{ ...S.btn, ...S.btnSecondary, flexShrink: 0, fontSize: 12 }}>Copy</button>
                            </div>
                          </div>
                          <div style={{ marginBottom: 12 }}>
                            <label style={S.label}>Email Body</label>
                            <textarea style={{ ...S.textarea, minHeight: 260 }} value={emailBody} onChange={e => setEmailBody(e.target.value)} placeholder="Write, load a template, or generate with AI…" />
                          </div>
                          {/* Action row */}
                          <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
                            <button onClick={() => { if (emailBody) navigator.clipboard.writeText(subLeadVars(emailBody, lead, user)); }} style={{ ...S.btn, background: '#2563eb', color: '#fff', fontSize: 12 }}>📋 Copy Body</button>
                            <button onClick={() => { if (emailSubject || emailBody) navigator.clipboard.writeText(`Subject: ${subLeadVars(emailSubject, lead, user)}\n\n${subLeadVars(emailBody, lead, user)}`); }} style={{ ...S.btn, ...S.btnSecondary, fontSize: 12 }}>Copy Full Email</button>
                            <button onClick={() => { setEmailSubject(''); setEmailBody(''); }} style={{ ...S.btn, ...S.btnSecondary, fontSize: 12 }}>Clear</button>
                          </div>
                          <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '0 0 14px' }} />
                          {/* Save as Template */}
                          {!showSaveTpl ? (
                            <button style={{ ...S.btn, background: '#f0fdf4', border: '1px solid #86efac', color: '#15803d', width: '100%', marginBottom: 14 }} onClick={() => setShowSaveTpl(true)}>💾 Save as Template</button>
                          ) : (
                            <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 10, padding: '12px 14px', marginBottom: 14 }}>
                              <div style={{ fontWeight: 600, color: '#15803d', marginBottom: 6, fontSize: 13 }}>Save as Team Template</div>
                              <p style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>Contact name &amp; city are auto-substituted when any rep loads this template.</p>
                              <input style={{ ...S.input, marginBottom: 8 }} value={tplName} onChange={e => setTplName(e.target.value)} placeholder="e.g. Cold Intro – Cityworks City" autoFocus />
                              <div style={{ display: 'flex', gap: 8 }}>
                                <button style={{ ...S.btn, ...S.btnSecondary, flex: 1 }} onClick={() => { setShowSaveTpl(false); setTplName(''); }}>Cancel</button>
                                <button style={{ ...S.btn, background: '#15803d', color: '#fff', flex: 1 }} disabled={!tplName.trim() || savingTpl} onClick={saveTemplate}>{savingTpl ? 'Saving…' : 'Save Template'}</button>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Right sidebar */}
                        <div style={{ width: 270, flexShrink: 0 }}>
                          {/* Email Sequence Guide */}
                          <div style={{ background: '#eff6ff', borderRadius: 10, padding: 14, marginBottom: 14, border: '1px solid #bfdbfe' }}>
                            <div style={{ fontWeight: 700, fontSize: 13, color: '#1e40af', marginBottom: 10 }}>📬 Email Sequence Guide</div>
                            {EMAIL_SEQ_GUIDE.map((row, i) => (
                              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8 }}>
                                <span style={{ background: row.bg, color: row.color, borderRadius: 4, padding: '2px 7px', fontSize: 11, fontWeight: 800, whiteSpace: 'nowrap', flexShrink: 0 }}>{row.day}</span>
                                <span style={{ fontSize: 12, color: '#374151', lineHeight: 1.4 }}>{row.text}</span>
                              </div>
                            ))}
                            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4, fontStyle: 'italic' }}>4–5 touch sequences get 3× more replies</div>
                          </div>
                          {/* Quick Stats */}
                          <div style={{ background: '#f8fafc', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
                            <div style={{ fontWeight: 700, fontSize: 13, color: '#1e293b', marginBottom: 6 }}>⚡ Quick Stats</div>
                            <div style={{ fontSize: 11, color: '#64748b', marginBottom: 10 }}>Click to append to body</div>
                            {[
                              { stat: '50%', label: 'staff workload reduction' },
                              { stat: '80%', label: 'faster response time' },
                              { stat: '$0.50–$2', label: 'per AI interaction vs $8–$15 live' },
                              { stat: '$2,000/yr', label: 'total annual cost' },
                            ].map((s, i) => (
                              <button key={i} onClick={() => setEmailBody(b => b + `\n\n${s.stat} — ${s.label}`)} style={{
                                display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '8px 10px', marginBottom: 5,
                                borderRadius: 7, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', textAlign: 'left',
                              }}>
                                <span style={{ fontWeight: 800, color: '#1e3a5f', fontSize: 14, minWidth: 56 }}>{s.stat}</span>
                                <span style={{ fontSize: 11, color: '#64748b' }}>{s.label}</span>
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* Send row */}
                      {emailMsg && <div style={{ ...(emailMsg.includes('opied') || emailMsg.includes('ent') || emailMsg.includes('hedule') ? S.success : S.error), marginBottom: 10 }}>{emailMsg}</div>}
                      <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
                        <button style={{ ...S.btn, ...S.btnSecondary }} onClick={() => sendEmail('copy')} disabled={sendLoading || !emailSubject || !emailBody || !emailTo}>📋 Copy</button>
                        <button style={{ ...S.btn, ...S.btnPrimary }} onClick={() => sendEmail('sendgrid')} disabled={sendLoading || schedulingEmail || !emailSubject || !emailBody || !emailTo || (bounceWarning && !forceOverride)}>
                          {sendLoading ? 'Sending…' : 'Send via Email'}
                        </button>
                        <button style={{ ...S.btn, background: '#7c3aed', color: '#fff', opacity: showSendLater ? 0.7 : 1 }} onClick={() => { setShowSendLater(v => !v); setSchedMsg(''); }} disabled={!!(bounceWarning && !forceOverride) || !emailSubject || !emailBody || !emailTo}>
                          🕐 Send Later…
                        </button>
                      </div>

                      {/* Send Later panel */}
                      {showSendLater && (
                        <div style={{ background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: 12, padding: '16px 18px', marginTop: 12 }}>
                          <div style={{ fontWeight: 700, color: '#5b21b6', fontSize: 14, marginBottom: 12 }}>📅 Schedule this email</div>
                          <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', color: '#7c3aed', marginBottom: 8 }}>
                              Smart Quick Picks{lead?.contact_title ? ` for ${lead.contact_title}` : ''}
                            </div>
                            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                              {getSmartPicks(lead?.contact_title).map((p, i) => (
                                <div key={i} style={{ position: 'relative' }}>
                                  {i === 0 && <span style={{ position: 'absolute', top: -9, left: '50%', transform: 'translateX(-50%)', background: '#f59e0b', color: '#fff', fontSize: 9, fontWeight: 800, padding: '1px 6px', borderRadius: 4, whiteSpace: 'nowrap', zIndex: 2, letterSpacing: '0.05em' }}>✦ BEST</span>}
                                  <button onClick={() => applySmartPick(p)} title={p.reason} style={{
                                    background: i === 0 ? '#7c3aed' : '#ede9fe',
                                    border: i === 0 ? '2px solid #6d28d9' : '1px solid #c4b5fd',
                                    color: i === 0 ? '#fff' : '#5b21b6',
                                    borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                                    boxShadow: i === 0 ? '0 0 0 3px #ddd6fe, 0 0 12px rgba(124,58,237,0.35)' : 'none',
                                    marginTop: i === 0 ? 6 : 0,
                                  }}>
                                    {p.label}
                                    <span style={{ display: 'block', fontSize: 10, color: i === 0 ? '#e9d5ff' : '#7c3aed', fontWeight: 400 }}>{p.reason}</span>
                                  </button>
                                </div>
                              ))}
                            </div>
                            <div style={{ fontSize: 11, color: '#7c3aed', marginTop: 6 }}>Hover a pick to see the reason · Click to apply</div>
                          </div>
                          <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
                            <div style={{ flex: 1 }}>
                              <label style={{ ...S.label, color: '#5b21b6' }}>Date</label>
                              <input type="date" style={S.input} value={schedDate} onChange={e => setSchedDate(e.target.value)} min={new Date().toISOString().split('T')[0]} />
                            </div>
                            <div style={{ flex: 1 }}>
                              <label style={{ ...S.label, color: '#5b21b6' }}>Time (your local time)</label>
                              <input type="time" style={S.input} value={schedTime} onChange={e => setSchedTime(e.target.value)} />
                            </div>
                          </div>
                          {schedDate && schedTime && (
                            <div style={{ background: '#ede9fe', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: 13, color: '#5b21b6', fontWeight: 600 }}>
                              📤 Will send: {new Date(`${schedDate}T${schedTime}:00`).toLocaleString([], { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                            </div>
                          )}
                          {schedMsg && <div style={S.error}>{schedMsg}</div>}
                          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                            <button style={{ ...S.btn, ...S.btnSecondary, flex: 1 }} onClick={() => { setShowSendLater(false); setSchedMsg(''); }}>Cancel</button>
                            <button style={{ ...S.btn, background: '#7c3aed', color: '#fff', flex: 1 }} onClick={scheduleSend} disabled={schedulingEmail || !schedDate || !schedTime}>{schedulingEmail ? 'Scheduling…' : '📅 Confirm & Schedule'}</button>
                          </div>
                        </div>
                      )}

                      {/* Smart Timing Tips */}
                      <div style={{ marginTop: 14 }}>
                        <button onClick={() => setShowSmartTimingTips(v => !v)} style={{ background: 'none', border: 'none', color: '#7c3aed', fontSize: 12, cursor: 'pointer', padding: 0, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 6 }}>
                          {showSmartTimingTips ? '▾' : '▸'} Smart Timing Tips by Job Title
                        </button>
                        {showSmartTimingTips && (
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 10, marginTop: 10 }}>
                            {TIMING_TIPS_LIB.map((tip, i) => (
                              <div key={i} style={{ background: '#f5f3ff', borderRadius: 10, padding: '12px 14px', border: '1px solid #ddd6fe' }}>
                                <div style={{ fontWeight: 700, fontSize: 12, color: '#5b21b6', marginBottom: 4 }}>{tip.title}</div>
                                <div style={{ fontSize: 12, color: '#7c3aed', fontWeight: 600, marginBottom: 4 }}>{tip.times}</div>
                                <div style={{ fontSize: 11, color: '#6b7280' }}>{tip.note}</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* ── TAB 1: SUBJECT LINES ── */}
                  {emailComposerTab === 3 && (
                    <div>
                      <p style={{ fontSize: 13, color: '#64748b', marginBottom: 14 }}>25 subject lines — click <strong>Use</strong> to load into the Composer tab.</p>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                        {SUBJECT_LINES_LIB.map((s, i) => {
                          const display = subLeadVars(s, lead, user);
                          return (
                            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f8fafc', borderRadius: 8, padding: '10px 12px', border: '1px solid #e2e8f0' }}>
                              <span style={{ flex: 1, fontSize: 12, color: '#1e293b', lineHeight: 1.4 }}>{display}</span>
                              <button onClick={() => { setEmailSubject(subLeadVars(s, lead, user)); setEmailComposerTab(0); }} style={{ ...S.btn, background: '#2563eb', color: '#fff', fontSize: 11, padding: '5px 10px', flexShrink: 0 }}>Use</button>
                              <button onClick={() => navigator.clipboard.writeText(display)} style={{ ...S.btn, ...S.btnSecondary, fontSize: 11, padding: '5px 10px', flexShrink: 0 }}>Copy</button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* ── TAB 2: TEMPLATES ── */}
                  {emailComposerTab === 1 && (
                    <div style={{ display: 'flex', gap: 16 }}>
                      {/* Sidebar */}
                      <div style={{ width: 200, flexShrink: 0 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8 }}>Library Templates</div>
                        {EMAIL_TEMPLATES_LIB.map((t, i) => (
                          <button key={i} onClick={() => setSelectedLibTemplate(i)} style={{
                            display: 'block', width: '100%', textAlign: 'left', padding: '10px 12px', marginBottom: 5,
                            borderRadius: 8, border: '1.5px solid', cursor: 'pointer', fontSize: 12, fontWeight: selectedLibTemplate === i ? 700 : 500,
                            borderColor: selectedLibTemplate === i ? '#2563eb' : '#e2e8f0',
                            background: selectedLibTemplate === i ? '#eff6ff' : '#f8fafc',
                            color: selectedLibTemplate === i ? '#1d4ed8' : '#374151',
                          }}>{t.label}</button>
                        ))}
                        {emailTemplates.length > 0 && (
                          <>
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.07em', margin: '14px 0 8px' }}>Team Templates</div>
                            {emailTemplates.map(tpl => (
                              <div key={tpl.id} style={{ marginBottom: 6 }}>
                                {editTplId === tpl.id ? (
                                  /* ── Inline edit form ── */
                                  <div style={{ background: '#fffbeb', border: '1.5px solid #fbbf24', borderRadius: 8, padding: '10px 12px' }}>
                                    <input style={{ ...S.input, marginBottom: 6, fontSize: 12 }} value={editTplName} onChange={e => setEditTplName(e.target.value)} placeholder="Template name" autoFocus />
                                    <input style={{ ...S.input, marginBottom: 6, fontSize: 12 }} value={editTplSubject} onChange={e => setEditTplSubject(e.target.value)} placeholder="Subject line" />
                                    <textarea style={{ ...S.input, minHeight: 80, fontSize: 12, resize: 'vertical', marginBottom: 8 }} value={editTplBody} onChange={e => setEditTplBody(e.target.value)} placeholder="Email body" />
                                    <div style={{ display: 'flex', gap: 6 }}>
                                      <button onClick={() => setEditTplId(null)} style={{ ...S.btn, ...S.btnSecondary, flex: 1, fontSize: 11 }}>Cancel</button>
                                      <button onClick={saveEditTemplate} disabled={!editTplName.trim() || savingEditTpl} style={{ ...S.btn, background: '#d97706', color: '#fff', flex: 1, fontSize: 11 }}>{savingEditTpl ? 'Saving…' : 'Save Changes'}</button>
                                    </div>
                                  </div>
                                ) : deleteTplId === tpl.id ? (
                                  /* ── Inline delete confirm ── */
                                  <div style={{ background: '#fff1f2', border: '1.5px solid #fca5a5', borderRadius: 8, padding: '10px 12px' }}>
                                    <div style={{ fontWeight: 600, color: '#dc2626', fontSize: 12, marginBottom: 6 }}>Delete "{tpl.name}"?</div>
                                    <input style={{ ...S.input, marginBottom: 8, fontSize: 12 }} value={deleteTplConfirm} onChange={e => setDeleteTplConfirm(e.target.value)} placeholder='Type "Delete" to confirm' autoFocus />
                                    <div style={{ display: 'flex', gap: 6 }}>
                                      <button onClick={() => { setDeleteTplId(null); setDeleteTplConfirm(''); }} style={{ ...S.btn, ...S.btnSecondary, flex: 1, fontSize: 11 }}>Cancel</button>
                                      <button disabled={deleteTplConfirm !== 'Delete'} onClick={() => deleteTemplate(tpl.id)} style={{ ...S.btn, background: '#dc2626', color: '#fff', flex: 1, fontSize: 11 }}>Delete</button>
                                    </div>
                                  </div>
                                ) : (
                                  /* ── Normal row ── */
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                    <button onClick={() => { applyTemplate(tpl); setEmailComposerTab(0); }} style={{
                                      flex: 1, textAlign: 'left', padding: '9px 10px', borderRadius: 8, border: '1.5px solid #86efac',
                                      background: '#f0fdf4', color: '#15803d', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                                    }}>
                                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tpl.name}</div>
                                      {tpl.created_by_name && <div style={{ fontSize: 10, color: '#86efac', fontWeight: 400, marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tpl.created_by_name}</div>}
                                    </button>
                                    {(isSuperAdmin || tpl.created_by === user?.id) && (<>
                                      {isSuperAdmin && <button onClick={() => { setEditTplId(tpl.id); setEditTplName(tpl.name); setEditTplSubject(tpl.subject || ''); setEditTplBody(tpl.body || ''); setDeleteTplId(null); }} style={{ background: 'none', border: '1px solid #cbd5e1', color: '#64748b', borderRadius: 6, padding: '4px 6px', fontSize: 11, cursor: 'pointer', flexShrink: 0 }}>✏</button>}
                                      <button onClick={() => { setDeleteTplId(tpl.id); setDeleteTplConfirm(''); setEditTplId(null); }} style={{ background: 'none', border: '1px solid #fca5a5', color: '#dc2626', borderRadius: 6, padding: '4px 6px', fontSize: 11, cursor: 'pointer', flexShrink: 0 }}>✕</button>
                                    </>)}
                                  </div>
                                )}
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                      {/* Preview */}
                      <div style={{ flex: 1 }}>
                        {(() => {
                          const tpl = EMAIL_TEMPLATES_LIB[selectedLibTemplate];
                          const sub = subLeadVars(tpl.subject, lead, user);
                          const bod = subLeadVars(tpl.body, lead, user);
                          return (
                            <>
                              <div style={{ marginBottom: 10 }}>
                                <span style={{ background: '#dbeafe', color: '#1d4ed8', padding: '4px 12px', borderRadius: 20, fontSize: 13, fontWeight: 700 }}>{sub}</span>
                              </div>
                              <div style={{ background: '#f8fafc', borderRadius: 10, padding: '14px 16px', fontSize: 13, color: '#374151', lineHeight: 1.7, whiteSpace: 'pre-wrap', marginBottom: 14, border: '1px solid #e2e8f0', minHeight: 180 }}>{bod}</div>
                              <div style={{ display: 'flex', gap: 10 }}>
                                <button onClick={() => { applyTemplate(tpl); setEmailComposerTab(0); }} style={{ ...S.btn, ...S.btnPrimary }}>Load into Composer</button>
                                <button onClick={() => navigator.clipboard.writeText(`Subject: ${sub}\n\n${bod}`)} style={{ ...S.btn, ...S.btnSecondary }}>Copy Full Email</button>
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  )}

                  {/* ── TAB 3: AI GENERATOR ── */}
                  {emailComposerTab === 2 && (
                    <div style={{ display: 'flex', gap: 16 }}>
                      {/* Prompt sidebar */}
                      <div style={{ width: 220, flexShrink: 0 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8 }}>Prompts</div>
                        {AI_PROMPTS_LIB.map((p, i) => (
                          <button key={i} onClick={() => setSelectedAiPromptIdx(i)} style={{
                            display: 'block', width: '100%', textAlign: 'left', padding: '10px 12px', marginBottom: 5,
                            borderRadius: 8, border: '1.5px solid', cursor: 'pointer', fontSize: 12, fontWeight: selectedAiPromptIdx === i ? 700 : 400,
                            borderColor: selectedAiPromptIdx === i ? '#7c3aed' : '#e2e8f0',
                            background: selectedAiPromptIdx === i ? '#f5f3ff' : '#f8fafc',
                            color: selectedAiPromptIdx === i ? '#5b21b6' : '#374151',
                          }}>{p.label}</button>
                        ))}
                        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 6, lineHeight: 1.5 }}>Select a prompt to pre-fill, then edit and generate.</div>

                        {/* Custom Prompts */}
                        <div style={{ marginTop: 18, paddingTop: 14, borderTop: '1px solid #e2e8f0' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#6d28d9', textTransform: 'uppercase', letterSpacing: '0.07em' }}>💾 Custom Prompts</div>
                            <button onClick={() => { setShowSaveCustomPrompt(s => !s); setCustomPromptName(''); }} style={{ background: '#f5f3ff', border: '1px solid #c4b5fd', color: '#6d28d9', borderRadius: 5, padding: '2px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>+ Save Current</button>
                          </div>
                          {showSaveCustomPrompt && (
                            <div style={{ background: '#f5f3ff', border: '1px solid #c4b5fd', borderRadius: 8, padding: '10px 12px', marginBottom: 8 }}>
                              <input
                                style={{ ...S.input, marginBottom: 8, fontSize: 12 }}
                                value={customPromptName}
                                onChange={e => setCustomPromptName(e.target.value)}
                                placeholder="Prompt name…"
                                autoFocus
                              />
                              <div style={{ display: 'flex', gap: 6 }}>
                                <button onClick={() => setShowSaveCustomPrompt(false)} style={{ ...S.btn, ...S.btnSecondary, flex: 1, fontSize: 11, padding: '5px 0' }}>Cancel</button>
                                <button onClick={saveCustomPrompt} disabled={!customPromptName.trim() || savingCustomPrompt} style={{ ...S.btn, background: '#6d28d9', color: '#fff', flex: 1, fontSize: 11, padding: '5px 0' }}>{savingCustomPrompt ? 'Saving…' : 'Save'}</button>
                              </div>
                            </div>
                          )}
                          {customPrompts.length === 0 && !showSaveCustomPrompt && (
                            <div style={{ fontSize: 11, color: '#94a3b8', lineHeight: 1.5 }}>No custom prompts yet. Edit a prompt above and click <b>+ Save Current</b> to save it for reuse.</div>
                          )}
                          {customPrompts.map(p => {
                            const canDelete = p.created_by === user.id || user.salesRole === 'super_admin';
                            return (
                              <div key={p.id} style={{ marginBottom: 4 }}>
                                {deletingCustomPromptId === p.id ? (
                                  <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 6, padding: '7px 10px', fontSize: 11 }}>
                                    <div style={{ color: '#dc2626', fontWeight: 600, marginBottom: 6 }}>Delete "{p.name}"?</div>
                                    <div style={{ display: 'flex', gap: 6 }}>
                                      <button onClick={() => setDeletingCustomPromptId(null)} style={{ ...S.btn, ...S.btnSecondary, flex: 1, fontSize: 11, padding: '4px 0' }}>Cancel</button>
                                      <button onClick={() => deleteCustomPrompt(p.id)} style={{ ...S.btn, background: '#dc2626', color: '#fff', flex: 1, fontSize: 11, padding: '4px 0' }}>Delete</button>
                                    </div>
                                  </div>
                                ) : (
                                  <div style={{ display: 'flex', gap: 4, alignItems: 'stretch' }}>
                                    <button onClick={() => { setAiPromptText(p.prompt_text); setSelectedAiPromptIdx(-1); }} style={{
                                      flex: 1, textAlign: 'left', padding: '8px 10px',
                                      borderRadius: 6, border: '1px solid #c4b5fd', cursor: 'pointer', fontSize: 12, fontWeight: 500,
                                      background: '#f5f3ff', color: '#6d28d9',
                                    }}>
                                      <div style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</div>
                                      {p.created_by_name && <div style={{ fontSize: 10, color: '#a78bfa', marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.created_by_name}</div>}
                                    </button>
                                    {canDelete && <button onClick={() => setDeletingCustomPromptId(p.id)} style={{ background: '#fef2f2', border: '1px solid #fca5a5', color: '#dc2626', borderRadius: 6, padding: '0 7px', fontSize: 12, cursor: 'pointer', flexShrink: 0 }}>✕</button>}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>

                        {/* Saved templates as AI starting points */}
                        {emailTemplates && emailTemplates.length > 0 && (
                          <div style={{ marginTop: 18, paddingTop: 14, borderTop: '1px solid #e2e8f0' }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8 }}>📋 Templates</div>
                            {emailTemplates.map(t => (
                              <button key={t.id} onClick={() => {
                                const instruction = `Adapt this email template for {{cityName}} ({{contactName}}, {{contactTitle}}). Keep the same structure and tone but personalize the details. Update the subject line if appropriate.\n\n---\nSUBJECT: ${t.subject || '(use the body to infer one)'}\n\nBODY:\n${t.body || ''}`;
                                setAiPromptText(instruction);
                                setSelectedAiPromptIdx(-1);
                              }} style={{
                                display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', marginBottom: 4,
                                borderRadius: 6, border: '1.5px solid #86efac', cursor: 'pointer', fontSize: 12, fontWeight: 500,
                                background: '#f0fdf4', color: '#15803d',
                              }} title={t.subject || 'No subject saved'}>
                                <div style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.name}</div>
                                {t.created_by_name && <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.created_by_name}</div>}
                              </button>
                            ))}
                            <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4, lineHeight: 1.5 }}>Click to load a template as the AI starting point — then edit the instruction and let AI personalize.</div>
                          </div>
                        )}
                      </div>
                      {/* Prompt area + result */}
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 6 }}>Prompt (editable)</div>
                        <textarea value={aiPromptText} onChange={e => setAiPromptText(e.target.value)}
                          style={{ ...S.textarea, minHeight: 130, border: '1.5px solid #ddd6fe' }} />
                        {emailMsg && !aiResult && <div style={{ ...S.error, marginTop: 6 }}>{emailMsg}</div>}
                        <button onClick={generateAiEmail} disabled={genLoading} style={{ ...S.btn, background: genLoading ? '#c4b5fd' : '#7c3aed', color: '#fff', marginTop: 10 }}>
                          {genLoading ? '⏳ Generating…' : '✨ Generate Email'}
                        </button>
                        {aiResult && (
                          <div style={{ marginTop: 16, background: '#f5f3ff', borderRadius: 10, padding: '16px 18px', border: '1.5px solid #c4b5fd' }}>
                            <div style={{ fontWeight: 700, fontSize: 13, color: '#7c3aed', marginBottom: 8 }}>AI Result</div>
                            <div style={{ background: '#ede9fe', borderRadius: 7, padding: '6px 12px', fontSize: 13, fontWeight: 700, color: '#5b21b6', marginBottom: 10 }}>
                              Subject: {subLeadVars(aiResult.subject, lead, user)}
                            </div>
                            <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.7, whiteSpace: 'pre-wrap', marginBottom: 14, maxHeight: 220, overflowY: 'auto' }}>
                              {subLeadVars(stripAiClosing(aiResult.body), lead, user)}
                            </div>
                            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                              <button onClick={loadAiResult} style={{ ...S.btn, background: '#7c3aed', color: '#fff' }}>Load into Composer</button>
                              <button onClick={() => navigator.clipboard.writeText(`Subject: ${subLeadVars(aiResult.subject, lead, user)}\n\n${subLeadVars(stripAiClosing(aiResult.body), lead, user)}`)} style={{ ...S.btn, ...S.btnSecondary }}>Copy Result</button>
                              {saveTplSource !== 'ai' && (
                                <button onClick={() => { setSaveTplSource('ai'); setTplName(suggestTemplateName(aiResult.subject)); }} style={{ ...S.btn, background: '#f0fdf4', border: '1px solid #86efac', color: '#15803d' }}>💾 Save as Template</button>
                              )}
                            </div>
                            {saveTplSource === 'ai' && (
                              <div style={{ marginTop: 12, padding: 12, background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8 }}>
                                <div style={{ fontSize: 12, fontWeight: 700, color: '#15803d', marginBottom: 6 }}>Save AI Result as Template</div>
                                <input style={{ ...S.input, marginBottom: 8 }} value={tplName} onChange={e => setTplName(e.target.value)} placeholder="Template name" autoFocus />
                                <div style={{ fontSize: 11, color: '#16a34a', marginBottom: 8, lineHeight: 1.5 }}>Suggested name from the subject line — edit if you want. The template will be saved with <code>[Contact Name]</code> and <code>[City Name]</code> placeholders so it reuses for any lead.</div>
                                <div style={{ display: 'flex', gap: 8 }}>
                                  <button style={{ ...S.btn, ...S.btnSecondary, flex: 1 }} onClick={() => { setSaveTplSource('composer'); setTplName(''); }}>Cancel</button>
                                  <button style={{ ...S.btn, background: '#15803d', color: '#fff', flex: 1 }} disabled={!tplName.trim() || savingTpl} onClick={saveTemplate}>{savingTpl ? 'Saving…' : 'Save Template'}</button>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* ── TAB 4: STATS & QUOTES ── */}
                  {emailComposerTab === 4 && (
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#1e293b', marginBottom: 12 }}>Key Statistics</div>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 28 }}>
                        {STAT_BLOCKS_LIB.map((s, i) => (
                          <div key={i} style={{ borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
                            <div style={{ background: '#1e3a5f', padding: '14px 16px', textAlign: 'center' }}>
                              <div style={{ fontSize: 26, fontWeight: 900, color: '#fff', lineHeight: 1 }}>{s.stat}</div>
                            </div>
                            <div style={{ background: '#fff', padding: '10px 12px' }}>
                              <div style={{ fontSize: 12, fontWeight: 700, color: '#1e293b', marginBottom: 3 }}>{s.label}</div>
                              <div style={{ fontSize: 11, color: '#64748b', marginBottom: 8, lineHeight: 1.4 }}>{s.tip}</div>
                              <button onClick={() => { setEmailBody(b => b + `\n\n${s.stat} — ${s.label}`); setEmailComposerTab(0); }} style={{ ...S.btn, background: '#2563eb', color: '#fff', fontSize: 11, width: '100%', padding: '6px 0' }}>Add to Email</button>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#1e293b', marginBottom: 12 }}>Reusable Snippets</div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        {SNIPPETS_LIB.map((s, i) => {
                          const display = subLeadVars(s.text, lead, user);
                          return (
                            <div key={i} style={{ background: '#fff', borderRadius: 10, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                              <div style={{ background: '#f8fafc', padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid #e2e8f0' }}>
                                <span style={{ flex: 1, fontSize: 12, fontWeight: 700, color: '#374151' }}>{s.label}</span>
                                <button onClick={() => { setEmailBody(b => b + '\n\n' + subLeadVars(s.text, lead, user)); setEmailComposerTab(0); }} style={{ ...S.btn, background: '#2563eb', color: '#fff', fontSize: 11, padding: '5px 10px' }}>Add to Email</button>
                                <button onClick={() => navigator.clipboard.writeText(display)} style={{ ...S.btn, ...S.btnSecondary, fontSize: 11, padding: '5px 10px' }}>Copy</button>
                              </div>
                              <div style={{ padding: '10px 14px', fontSize: 13, color: '#374151', lineHeight: 1.6 }}>{display}</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
            <div>
              {scheduledEmails.filter(se => se.status === 'pending').length > 0 && (
                <div style={{ ...S.card, marginBottom: 16, border: '1px solid #ddd6fe', background: '#f5f3ff' }}>
                  <h3 style={{ ...S.h3, margin: '0 0 12px', color: '#5b21b6' }}>📅 Scheduled Emails ({scheduledEmails.filter(se => se.status === 'pending').length})</h3>
                  {scheduledEmails.filter(se => se.status === 'pending').map(se => (
                    <div key={se.id} style={{ background: '#ede9fe', borderRadius: 8, marginBottom: 8, overflow: 'hidden', border: editingScheduledId === se.id ? '2px solid #7c3aed' : '1px solid #ddd6fe' }}>
                      {/* Row summary */}
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', gap: 10 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontWeight: 600, color: '#1e3a5f', fontSize: 13, marginBottom: 2 }}>{se.subject}</div>
                          <div style={{ fontSize: 11, color: '#7c3aed' }}>
                            To: {se.recipient_email} · Sends: <strong>{new Date(se.scheduled_for + 'Z').toLocaleString([], { weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</strong>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                          <button onClick={() => editingScheduledId === se.id ? setEditingScheduledId(null) : startEditScheduled(se)}
                            style={{ ...S.btn, background: editingScheduledId === se.id ? '#7c3aed' : '#fff', color: editingScheduledId === se.id ? '#fff' : '#7c3aed', border: '1px solid #c4b5fd', fontSize: 12, padding: '5px 10px' }}>
                            {editingScheduledId === se.id ? 'Close' : '✏️ Edit Time'}
                          </button>
                          <button onClick={() => cancelScheduled(se.id)}
                            style={{ ...S.btn, background: '#fff', border: '1px solid #fca5a5', color: '#dc2626', fontSize: 12, padding: '5px 10px' }}>
                            🗑 Cancel
                          </button>
                        </div>
                      </div>
                      {/* Inline edit panel */}
                      {editingScheduledId === se.id && (
                        <div style={{ borderTop: '1px solid #ddd6fe', background: '#f5f3ff', padding: '12px 14px' }}>
                          <div style={{ fontSize: 12, fontWeight: 700, color: '#5b21b6', marginBottom: 10 }}>Edit Scheduled Email</div>
                          {/* Subject */}
                          <label style={{ ...S.label, color: '#5b21b6' }}>Subject</label>
                          <input style={{ ...S.input, marginBottom: 10 }} value={editSchedSubject} onChange={e => setEditSchedSubject(e.target.value)} placeholder="Subject line" />
                          {/* Body */}
                          <label style={{ ...S.label, color: '#5b21b6' }}>Body</label>
                          <textarea style={{ ...S.input, minHeight: 160, resize: 'vertical', marginBottom: 10, fontSize: 13, lineHeight: 1.6 }}
                            value={editSchedBody} onChange={e => setEditSchedBody(e.target.value)} placeholder="Email body" />
                          {/* Send time */}
                          <label style={{ ...S.label, color: '#5b21b6' }}>Send Time (your local time)</label>
                          <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
                            <input type="date" style={{ ...S.input, flex: 1 }} value={editSchedDate} onChange={e => setEditSchedDate(e.target.value)} min={new Date().toISOString().split('T')[0]} />
                            <input type="time" style={{ ...S.input, flex: 1 }} value={editSchedTime} onChange={e => setEditSchedTime(e.target.value)} />
                          </div>
                          {editSchedDate && editSchedTime && (
                            <div style={{ background: '#ede9fe', borderRadius: 7, padding: '7px 10px', marginBottom: 10, fontSize: 12, color: '#5b21b6', fontWeight: 600 }}>
                              📤 Sends: {new Date(`${editSchedDate}T${editSchedTime}:00`).toLocaleString([], { weekday: 'long', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                            </div>
                          )}
                          {editSchedMsg && <div style={{ ...S.error, marginBottom: 8 }}>{editSchedMsg}</div>}
                          <div style={{ display: 'flex', gap: 8 }}>
                            <button style={{ ...S.btn, ...S.btnSecondary, flex: 1 }} onClick={() => setEditingScheduledId(null)}>Cancel</button>
                            <button style={{ ...S.btn, background: '#7c3aed', color: '#fff', flex: 1 }} onClick={() => saveReschedule(se.id)} disabled={rescheduling || !editSchedDate || !editSchedTime}>
                              {rescheduling ? 'Saving…' : '✅ Save Changes'}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              <div style={S.card}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                  <h3 style={{ ...S.h3, margin: 0 }}>Email History</h3>
                  {lead?.opportunity_id && (
                    <span style={{ fontSize: 11, background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 20, padding: '2px 10px', fontWeight: 600 }}>
                      🏙️ Org history — preserved across reps
                    </span>
                  )}
                </div>
                {emails.length === 0 ? <p style={{ color: '#64748b', fontSize: 14, marginTop: 8 }}>No emails sent yet.</p> : (() => {
                  const isOrgHistory = !!lead?.opportunity_id;
                  const sorted = [...emails].sort((a, b) => new Date(b.sent_at) - new Date(a.sent_at));
                  // Unread = inbound with no read_at; everything else = read
                  const unread = sorted.filter(e => e.direction === 'inbound' && !e.read_at);
                  const read = sorted.filter(e => !(e.direction === 'inbound' && !e.read_at));

                  // Strip HTML markup from inbound email bodies before display.
                  // Inbound replies come in as raw HTML (tables, br tags, signature
                  // wrappers) — render those as plain text with sensible line breaks.
                  function htmlToText(html) {
                    if (!html) return '';
                    // Skip if it's already plain text (no tags)
                    if (!/<[a-z][^>]*>/i.test(html)) return html;
                    let s = html;
                    // Drop scripts/styles entirely
                    s = s.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, '');
                    // <br> → newline
                    s = s.replace(/<br\s*\/?>/gi, '\n');
                    // Block elements close → double newline
                    s = s.replace(/<\/(p|div|tr|li|h[1-6]|blockquote)>/gi, '\n');
                    s = s.replace(/<\/(table|ul|ol)>/gi, '\n\n');
                    // Remove all remaining tags
                    s = s.replace(/<[^>]+>/g, '');
                    // Decode common HTML entities
                    s = s.replace(/&nbsp;/g, ' ')
                         .replace(/&amp;/g, '&')
                         .replace(/&lt;/g, '<')
                         .replace(/&gt;/g, '>')
                         .replace(/&quot;/g, '"')
                         .replace(/&#39;/g, "'")
                         .replace(/&rsquo;/g, '’')
                         .replace(/&lsquo;/g, '‘')
                         .replace(/&rdquo;/g, '”')
                         .replace(/&ldquo;/g, '“')
                         .replace(/&mdash;/g, '—')
                         .replace(/&ndash;/g, '–')
                         .replace(/&hellip;/g, '…')
                         .replace(/&#(\d+);/g, (_, n) => String.fromCharCode(parseInt(n, 10)));
                    // Collapse runs of blank lines + trim trailing whitespace per line
                    s = s.split('\n').map(l => l.replace(/[ \t]+$/g, '')).join('\n');
                    s = s.replace(/\n{3,}/g, '\n\n').trim();
                    return s;
                  }

                  // Some legacy bodies arrived already collapsed to a single line
                  // (before we fixed the backend cleanup). Add paragraph breaks
                  // at common Outlook reply-header markers so they're readable.
                  function reflowCollapsed(body) {
                    if (!body) return body;
                    let s = body;
                    // Inject a newline BEFORE common header markers + bullets
                    // when they appear inline with surrounding text
                    s = s.replace(/\s(From:|Sent:|To:|Subject:|Cc:|CC:)\s/g, '\n$1 ');
                    s = s.replace(/\s(CAUTION:|EXTERNAL:)\s/gi, '\n\n$1 ');
                    // Common reply-intro patterns
                    s = s.replace(/\s(On .{5,150}wrote:?)\s/gi, '\n\n$1\n');
                    // Bullet markers
                    s = s.replace(/\s•\s/g, '\n• ');
                    // Sentence-aware: split where ". X" runs into another sentence
                    // that starts with capital after a long sentence (only when
                    // we still have no newlines after these passes)
                    if (!/\n/.test(s) && s.length > 200) {
                      s = s.replace(/([.!?])\s+(?=[A-Z])/g, '$1\n');
                    }
                    return s;
                  }

                  function parseQuote(rawBody) {
                    let body = htmlToText(rawBody);
                    body = reflowCollapsed(body);
                    // Split on common quoted-reply patterns: "On <date>... wrote:", "-----Original Message-----",
                    // or an Outlook header block starting with "From: ..."
                    const quoteMatch = body.match(/^([\s\S]*?)\n{0,2}(On .{10,200}wrote:|[-]{4,}\s*Original Message\s*[-]{4,}|^From:\s+.+$)([\s\S]*)$/m);
                    if (quoteMatch) {
                      return { reply: quoteMatch[1].trim(), quote: (quoteMatch[2] + quoteMatch[3]).trim() };
                    }
                    return { reply: body, quote: null };
                  }

                  async function markRead(emailId) {
                    await fetch(`${API}/api/sales/emails/${emailId}/read`, { method: 'PATCH', headers: apiHeaders(token) });
                    load();
                  }

                  function emailDeliveryStatus(e) {
                    if (e.send_method !== 'sendgrid') return null;
                    if (e.bounce_status === 'bounced') return { color: '#ef4444', label: 'Bounced', tip: 'Bounced — the recipient\'s mail server permanently rejected this email. Follow up by phone or LinkedIn. Check the Bounces page for full details.' };
                    if (e.bounce_status === 'dropped') return { color: '#f97316', label: 'Dropped', tip: 'Dropped — SendGrid couldn\'t attempt delivery. The address may have been previously flagged as invalid or unsubscribed. Verify the email address.' };
                    if (e.clicked_at) return { color: '#22c55e', label: `Clicked${e.click_count > 1 ? ` (${e.click_count}×)` : ''}`, tip: `Clicked — the recipient opened and clicked a link. ${e.open_count > 1 ? `Opened ${e.open_count} times total.` : ''} This is a strong engagement signal — consider a follow-up call now.` };
                    if (e.opened_at) return { color: '#22c55e', label: `Opened${e.open_count > 1 ? ` (${e.open_count}×)` : ''}`, tip: `Opened — the recipient opened this email${e.open_count > 1 ? ` ${e.open_count} times` : ''}. They haven't clicked yet. Consider a follow-up.` };
                    if (e.delivered_at) return { color: '#22c55e', label: 'Delivered', tip: 'Delivered — the recipient\'s mail server confirmed receipt. No open tracked yet. They may not have read it yet, or their email client blocks open tracking.' };
                    if (e.deferred_at) return { color: '#f59e0b', label: 'Deferred', tip: 'Deferred — delivery temporarily delayed. SendGrid is retrying automatically. Check back in a few minutes.' };
                    return { color: '#94a3b8', label: 'Pending', tip: 'Pending — SendGrid accepted this email but hasn\'t confirmed delivery yet. This typically resolves within minutes. If it stays pending, the address may have been silently rejected.' };
                  }

                  function renderEmail(e) {
                    const isInbound = e.direction === 'inbound';
                    const expanded = !!expandedEmails[e.id];
                    const { reply, quote } = e.body ? parseQuote(e.body) : { reply: '', quote: null };
                    const delivStatus = !isInbound ? emailDeliveryStatus(e) : null;
                    const borderColor = isInbound ? '#3b82f6' : (delivStatus?.color === '#ef4444' || delivStatus?.color === '#f97316' ? delivStatus.color : '#16a34a');
                    return (
                      <div key={e.id} style={{ ...S.cardSm, marginBottom: 10, borderLeft: `3px solid ${borderColor}` }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
                              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: isInbound ? '#3b82f6' : '#16a34a' }}>
                                {isInbound ? '← Reply' : '→ Sent'}
                              </div>
                              {delivStatus && (
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                                  <span style={{ width: 7, height: 7, borderRadius: '50%', background: delivStatus.color, display: 'inline-block', flexShrink: 0 }} />
                                  <span style={{ fontSize: 11, color: delivStatus.color, fontWeight: 600 }}>{delivStatus.label}</span>
                                  <InfoTooltip text={delivStatus.tip} />
                                </span>
                              )}
                            </div>
                            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 3 }}>{e.subject}</div>
                            <div style={{ fontSize: 12, color: '#64748b' }}>
                              {isInbound ? `From: ${e.sent_by_name || e.sent_by}` : `To: ${e.recipient_name || e.recipient_email}`}
                              {!isInbound && e.cc_emails ? <span style={{ color: '#7c3aed' }}> · CC: {e.cc_emails}</span> : ''}
                              {' · '}{formatDateTime(e.sent_at)}
                              {!isInbound && e.send_method === 'copy' ? ' · Copied (no tracking)' : ''}
                              {!isInbound && e.ai_generated ? ' · AI' : ''}
                              {!isInbound && isOrgHistory && e.sent_by_name ? ` · by ${e.sent_by_name}` : ''}
                            </div>
                          </div>
                          {e.body ? (
                            <button onClick={() => {
                              setExpandedEmails(prev => ({ ...prev, [e.id]: !prev[e.id] }));
                              if (!expanded && isInbound && !e.read_at) markRead(e.id);
                            }} style={{ ...S.btn, ...S.btnSecondary, ...S.btnSm, flexShrink: 0 }}>
                              {expanded ? 'Hide' : 'View'}
                            </button>
                          ) : null}
                        </div>
                        {expanded && e.body && (
                          <div style={{ marginTop: 10 }}>
                            <div style={{ padding: '10px 12px', background: '#f8fafc', borderRadius: 6, fontSize: 13, color: '#374151', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                              {reply}
                            </div>
                            {quote && (
                              <details style={{ marginTop: 6 }}>
                                <summary style={{ fontSize: 12, color: '#94a3b8', cursor: 'pointer', userSelect: 'none', padding: '4px 0' }}>Show quoted message</summary>
                                <div style={{ padding: '8px 12px', background: '#f1f5f9', borderLeft: '3px solid #cbd5e1', borderRadius: '0 4px 4px 0', fontSize: 12, color: '#64748b', whiteSpace: 'pre-wrap', lineHeight: 1.5, marginTop: 4 }}>
                                  {quote}
                                </div>
                              </details>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  }

                  const bouncedInThread = emails.filter(e => e.bounce_status === 'bounced' || e.bounce_status === 'dropped');

                  return (
                    <div>
                      {bouncedInThread.length > 0 && (
                        <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '10px 14px', marginBottom: 12, fontSize: 13 }}>
                          <div style={{ fontWeight: 700, color: '#dc2626', marginBottom: 4 }}>⚠️ {bouncedInThread.length} email{bouncedInThread.length > 1 ? 's' : ''} in this thread {bouncedInThread.length > 1 ? 'were' : 'was'} not delivered</div>
                          {bouncedInThread.map(e => (
                            <div key={e.id} style={{ fontSize: 12, color: '#7f1d1d', marginBottom: 2 }}>
                              • <strong>{e.bounce_status === 'dropped' ? 'Dropped' : 'Bounced'}</strong>: "{e.subject}" → {e.recipient_email}
                              {e.bounce_reason ? <span style={{ color: '#94a3b8' }}> — {e.bounce_reason.slice(0, 80)}</span> : null}
                            </div>
                          ))}
                          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 6 }}>Try reaching this contact by phone or LinkedIn instead. <a href="/bounces" style={{ color: '#3b82f6', textDecoration: 'none' }}>View all bounces →</a></div>
                        </div>
                      )}
                      {unread.length > 0 && (
                        <div>
                          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#3b82f6', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                            Unread
                            <span style={{ background: '#3b82f6', color: '#fff', borderRadius: 10, padding: '1px 7px', fontSize: 10 }}>{unread.length}</span>
                          </div>
                          {unread.map(renderEmail)}
                        </div>
                      )}
                      {unread.length > 0 && read.length > 0 && (
                        <div style={{ margin: '16px 0' }}>
                          <hr style={{ border: 'none', borderTop: '3px solid #e2e8f0', margin: 0 }} />
                          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#94a3b8', marginTop: 12, marginBottom: 8 }}>Read</div>
                        </div>
                      )}
                      {unread.length === 0 && read.length > 0 && (
                        <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#94a3b8', marginBottom: 8 }}>Read</div>
                      )}
                      {read.map(renderEmail)}
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        )}

        {tab === 'activity' && (
          <div className="cb-grid2" style={S.grid2}>
            <div>
              <div style={S.card}>
                <h3 style={S.h3}>Log Activity</h3>
                {canEdit ? (
                  <form onSubmit={handleAddActivity}>
                    <div style={{ marginBottom: 12 }}>
                      <label style={S.label}>Type</label>
                      <select style={S.select} value={actForm.type} onChange={e => setActForm(f => ({ ...f, type: e.target.value }))}>
                        {ACTIVITY_TYPES.map(t => <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1).replace('_', ' ')}</option>)}
                      </select>
                    </div>
                    <div style={{ marginBottom: 12 }}>
                      <label style={S.label}>Title</label>
                      <input style={S.input} required value={actForm.title} onChange={e => setActForm(f => ({ ...f, title: e.target.value }))} placeholder="Called city IT director…" />
                    </div>
                    <div style={{ marginBottom: 12 }}>
                      <label style={S.label}>Notes</label>
                      <textarea style={{ ...S.textarea, minHeight: 80 }} value={actForm.body} onChange={e => setActForm(f => ({ ...f, body: e.target.value }))} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={S.label}>Follow-up Date</label>
                      <input style={S.input} type="date" value={actForm.followUpDate} onChange={e => setActForm(f => ({ ...f, followUpDate: e.target.value }))} />
                    </div>
                    <button type="submit" style={{ ...S.btn, ...S.btnPrimary, width: '100%' }} disabled={addingAct}>{addingAct ? 'Adding…' : 'Log Activity'}</button>
                  </form>
                ) : <p style={{ color: '#64748b', fontSize: 14 }}>Only the lead owner or delegate can log activities.</p>}
              </div>
            </div>
            <div>
              <div style={S.card}>
                <h3 style={S.h3}>Activity Timeline</h3>
                {activities.length === 0 ? <p style={{ color: '#64748b', fontSize: 14 }}>No activities yet.</p> : activities.map(a => {
                  const isInbound = a.type === 'inbound_reply';
                  const borderColor = isInbound ? '#16a34a' : '#1e3a5f';
                  const typeLabel = isInbound ? '↩ Reply Received' : a.type?.replace(/_/g, ' ');
                  const typeBg = isInbound ? '#dcfce7' : '#f1f5f9';
                  const typeColor = isInbound ? '#16a34a' : '#475569';
                  return (
                    <div key={a.id} style={{ borderLeft: `3px solid ${borderColor}`, paddingLeft: 12, marginBottom: 16 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontWeight: 600, fontSize: 14 }}>{a.title}</div>
                        <span style={{ ...S.badge, background: typeBg, color: typeColor, fontSize: 11 }}>{typeLabel}</span>
                      </div>
                      {a.body && <div style={{ fontSize: 13, color: '#374151', marginTop: 6, padding: '8px 10px', background: isInbound ? '#f0fdf4' : '#f8fafc', borderRadius: 6, whiteSpace: 'pre-wrap' }}>{a.body}</div>}
                      {a.follow_up_date && <div style={{ fontSize: 12, color: '#f59e0b', marginTop: 4 }}>📅 Follow up: {formatDate(a.follow_up_date)}</div>}
                      <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>{a.rep_name || a.rep_id} · {formatDate(a.created_at)}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {tab === 'convert' && isManager && (
          <div style={{ maxWidth: 560 }}>
            <div style={S.card}>
              <h3 style={S.h3}>Convert Lead to City</h3>
              {lead.converted_city_id ? (
                <div style={S.success}>This lead has already been converted. City ID: <strong>{lead.converted_city_id}</strong></div>
              ) : (
                <>
                  <p style={{ fontSize: 14, color: '#64748b', marginBottom: 16 }}>
                    First create the city in the admin portal, then paste the city ID here. The lead owner (<strong>{lead.owner_name || lead.owner_rep_id}</strong>) will be assigned as the city's sales rep.
                  </p>
                  {convertMsg && <div style={convertMsg.includes('onverted') ? S.success : S.error}>{convertMsg}</div>}
                  <form onSubmit={handleConvert}>
                    <div style={{ marginBottom: 16 }}>
                      <label style={S.label}>City ID (from Admin Portal)</label>
                      <input style={S.input} value={convertCityId} onChange={e => setConvertCityId(e.target.value)} placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" required />
                    </div>
                    <button type="submit" style={{ ...S.btn, ...S.btnSuccess, width: '100%' }}>Convert Lead → City</button>
                  </form>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── ACTIONS PAGE (super_admin only) ──────────────────────────────────────────

function ActionsPage() {
  const { token } = useAuth();
  const [actions, setActions] = useState([]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('pending');
  const [resolving, setResolving] = useState(null); // action id being resolved
  const [noteMap, setNoteMap] = useState({}); // id -> note text
  const [msg, setMsg] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [pRes, hRes] = await Promise.all([
        fetch(`${API}/api/sales/actions?status=pending`, { headers: apiHeaders(token) }),
        fetch(`${API}/api/sales/actions?status=approved`, { headers: apiHeaders(token) }),
      ]);
      const p = await pRes.json(); const h = await hRes.json();
      if (Array.isArray(p)) setActions(p);
      if (Array.isArray(h)) setHistory(h);
    } catch(e) {}
    setLoading(false);
  }, [token]);

  useEffect(() => { load(); }, [load]);

  async function handleApprove(action) {
    setResolving(action.id);
    const r = await fetch(`${API}/api/sales/actions/${action.id}/approve`, {
      method: 'POST', headers: apiHeaders(token),
      body: JSON.stringify({ note: noteMap[action.id] || '' }),
    }).then(r => r.json());
    setResolving(null);
    if (r.ok) { setMsg(`✅ Approved — ${action.entity_name} deleted.`); load(); setTimeout(() => setMsg(''), 5000); }
    else setMsg(r.error || 'Failed');
  }

  async function handleDeny(action) {
    setResolving(action.id);
    const r = await fetch(`${API}/api/sales/actions/${action.id}/deny`, {
      method: 'POST', headers: apiHeaders(token),
      body: JSON.stringify({ note: noteMap[action.id] || '' }),
    }).then(r => r.json());
    setResolving(null);
    if (r.ok) { setMsg(`Denied — ${action.entity_name} kept.`); load(); setTimeout(() => setMsg(''), 5000); }
    else setMsg(r.error || 'Failed');
  }

  const typeLabel = { lead_delete: 'Delete Lead' };
  const entityIcon = { lead: '📋' };

  return (
    <div className="cb-main" style={S.main}>
      <div style={{ ...S.spaceBetween, marginBottom: 20 }}>
        <div>
          <h1 style={S.h1}>Actions</h1>
          <p style={{ color: '#64748b', margin: 0, fontSize: 14 }}>Pending approvals and admin actions</p>
        </div>
        {actions.length > 0 && (
          <div style={{ background: '#dc2626', color: '#fff', borderRadius: 20, padding: '4px 14px', fontWeight: 700, fontSize: 14 }}>
            {actions.length} Pending
          </div>
        )}
      </div>

      {msg && <div style={{ ...S.success, marginBottom: 16 }}>{msg}</div>}

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[['pending', `Pending (${actions.length})`], ['history', `Resolved (${history.length})`]].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{ ...S.btn, ...(tab === key ? S.btnPrimary : S.btnSecondary), fontWeight: 600 }}>{label}</button>
        ))}
      </div>

      {loading ? <p style={{ color: '#64748b', textAlign: 'center', padding: 40 }}>Loading…</p> : (

        tab === 'pending' ? (
          actions.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '48px 0', color: '#64748b' }}>
              <div style={{ fontSize: 36, marginBottom: 12 }}>✅</div>
              <p style={{ fontWeight: 600 }}>No pending actions — all clear!</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {actions.map(action => (
                <div key={action.id} style={{ ...S.card, border: '1px solid #fecaca', background: '#fff' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                        <span style={{ fontSize: 18 }}>{entityIcon[action.entity_type] || '📄'}</span>
                        <span style={{ fontWeight: 700, fontSize: 15, color: '#1e293b' }}>{action.entity_name}</span>
                        <span style={{ ...S.badge, background: '#fee2e2', color: '#dc2626' }}>{typeLabel[action.type] || action.type}</span>
                      </div>
                      <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>
                        Requested by <strong>{action.requested_by_name}</strong> · {formatDateTime(action.created_at)}
                      </div>
                      {action.reason && (
                        <div style={{ fontSize: 13, color: '#374151', background: '#f8fafc', borderRadius: 6, padding: '6px 10px', marginTop: 6 }}>
                          <span style={{ fontWeight: 600 }}>Reason: </span>{action.reason}
                        </div>
                      )}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minWidth: 220 }}>
                      <div>
                        <label style={{ ...S.label, fontSize: 11 }}>Note (optional)</label>
                        <input style={{ ...S.input, fontSize: 13 }} placeholder="Add a resolution note…"
                          value={noteMap[action.id] || ''}
                          onChange={e => setNoteMap(m => ({ ...m, [action.id]: e.target.value }))} />
                      </div>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button onClick={() => handleDeny(action)} disabled={resolving === action.id}
                          style={{ ...S.btn, ...S.btnSecondary, flex: 1, fontWeight: 600 }}>
                          {resolving === action.id ? '…' : '✕ Deny'}
                        </button>
                        <button onClick={() => handleApprove(action)} disabled={resolving === action.id}
                          style={{ ...S.btn, background: '#dc2626', color: '#fff', flex: 2, fontWeight: 700 }}>
                          {resolving === action.id ? 'Processing…' : '🗑 Approve & Delete'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )
        ) : (
          <div style={{ ...S.card, padding: 0, overflow: 'hidden' }}>
            {history.length === 0 ? (
              <p style={{ color: '#64748b', padding: 24, textAlign: 'center' }}>No resolved actions yet.</p>
            ) : (
              <table style={S.table}>
                <thead><tr>{['Entity','Type','Requested By','Resolved By','Status','Resolved'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {history.map(a => (
                    <tr key={a.id}>
                      <td style={S.td}><span style={{ fontWeight: 600 }}>{a.entity_name}</span></td>
                      <td style={S.td}>{typeLabel[a.type] || a.type}</td>
                      <td style={S.td}>{a.requested_by_name}</td>
                      <td style={S.td}>{a.resolved_by_name || '—'}</td>
                      <td style={S.td}><span style={{ ...S.badge, background: a.status === 'approved' ? '#dcfce7' : '#fee2e2', color: a.status === 'approved' ? '#16a34a' : '#dc2626' }}>{a.status}</span></td>
                      <td style={S.td}>{formatDate(a.resolved_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )
      )}
    </div>
  );
}

// ─── REPORTS PAGE ─────────────────────────────────────────────────────────────

function ReportsPage() {
  const { user, token } = useAuth();
  const [leads, setLeads] = useState([]);
  const [reps, setReps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('my');
  const [period, setPeriod] = useState('all'); // 'month' | 'quarter' | 'year' | 'all'
  const isSuperAdmin = user?.salesRole === 'super_admin';

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const [lRes, rRes] = await Promise.all([
          fetch(`${API}/api/sales/leads?includeReleased=1`, { headers: apiHeaders(token) }),
          fetch(`${API}/api/sales/reps`, { headers: apiHeaders(token) }),
        ]);
        const l = await lRes.json(); const r = await rRes.json();
        if (Array.isArray(l)) setLeads(l);
        if (Array.isArray(r)) setReps(r);
      } catch(e) { console.error('[Reports]', e); }
      setLoading(false);
    }
    load();
  }, [token]);

  function inPeriod(dateStr) {
    if (period === 'all' || !dateStr) return true;
    const d = new Date(dateStr.includes('T') ? dateStr : dateStr + 'Z');
    const now = new Date();
    if (period === 'month') return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
    if (period === 'quarter') {
      const q = Math.floor(now.getMonth() / 3);
      return d.getFullYear() === now.getFullYear() && Math.floor(d.getMonth() / 3) === q;
    }
    if (period === 'year') return d.getFullYear() === now.getFullYear();
    return true;
  }

  const myLeads = leads.filter(l => l.owner_rep_id === user?.id || (user?.salesRole === 'super_admin' && l.owner_rep_id === 'super_admin'));
  const myActive = myLeads.filter(l => !['closed_won','closed_lost','released'].includes(l.stage));
  const myWon = myLeads.filter(l => (l.stage === 'closed_won' || l.converted_city_id) && inPeriod(l.updated_at));
  const myLost = myLeads.filter(l => l.stage === 'closed_lost' && inPeriod(l.updated_at));
  const myReleased = myLeads.filter(l => l.stage === 'released' && inPeriod(l.updated_at));
  const myClosed = [...myWon, ...myLost];
  const myWinRate = myClosed.length ? Math.round((myWon.length / myClosed.length) * 100) : null;
  const myPipelineArr = myActive.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0);
  const myWonArr = myWon.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0);
  const myAvgDeal = myWon.length ? Math.round(myWon.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0) / myWon.length) : 0;

  const allActive = leads.filter(l => !['closed_won','closed_lost','released'].includes(l.stage));
  const allWon = leads.filter(l => (l.stage === 'closed_won' || l.converted_city_id) && inPeriod(l.updated_at));
  const allLost = leads.filter(l => l.stage === 'closed_lost' && inPeriod(l.updated_at));
  const allReleased = leads.filter(l => l.stage === 'released' && inPeriod(l.updated_at));
  const allClosed = [...allWon, ...allLost];
  const teamWinRate = allClosed.length ? Math.round((allWon.length / allClosed.length) * 100) : null;
  const teamPipelineArr = allActive.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0);
  const teamWonArr = allWon.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0);

  // Per-rep breakdown
  const repBreakdown = reps.map(rep => {
    const rl = leads.filter(l => l.owner_rep_id === rep.id);
    const active = rl.filter(l => !['closed_won','closed_lost','released'].includes(l.stage));
    const won = rl.filter(l => (l.stage === 'closed_won' || l.converted_city_id) && inPeriod(l.updated_at));
    const lost = rl.filter(l => l.stage === 'closed_lost' && inPeriod(l.updated_at));
    const released = rl.filter(l => l.stage === 'released' && inPeriod(l.updated_at));
    const closed = [...won, ...lost];
    return {
      rep,
      activeCount: active.length,
      wonCount: won.length,
      lostCount: lost.length,
      releasedCount: released.length,
      pipelineArr: active.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0),
      wonArr: won.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0),
      winRate: closed.length ? Math.round((won.length / closed.length) * 100) : null,
      avgDeal: won.length ? Math.round(won.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0) / won.length) : 0,
    };
  }).sort((a, b) => b.wonArr - a.wonArr);

  // Pipeline by stage (team)
  const stageBreakdown = PIPELINE_RAIL.map(stage => {
    const sl = allActive.filter(l => l.stage === stage.key);
    return { stage, count: sl.length, arr: sl.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0) };
  }).filter(s => s.count > 0 || s.stage.key === 'prospect');

  const periodLabel = { all: 'All Time', month: 'This Month', quarter: 'This Quarter', year: 'This Year' }[period];

  if (loading) return <div className="cb-main" style={S.main}><p style={{ color: '#64748b', textAlign: 'center', padding: 48 }}>Loading reports…</p></div>;

  return (
    <div className="cb-main" style={S.main}>
      <div style={{ ...S.spaceBetween, marginBottom: 20 }}>
        <div>
          <h1 style={S.h1}>Reports</h1>
          <p style={{ color: '#64748b', margin: 0, fontSize: 14 }}>Sales analytics and performance metrics</p>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ fontSize: 12, color: '#64748b', fontWeight: 600 }}>Period:</span>
          {['month','quarter','year','all'].map(p => (
            <button key={p} onClick={() => setPeriod(p)}
              style={{ ...S.btn, ...S.btnSm, background: period === p ? '#1e3a5f' : '#f1f5f9', color: period === p ? '#fff' : '#374151', border: '1px solid #e2e8f0' }}>
              {periodLabel && p === period ? periodLabel : { month: 'Month', quarter: 'Quarter', year: 'Year', all: 'All Time' }[p]}
            </button>
          ))}
        </div>
      </div>

      {isSuperAdmin && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {[['my', '👤 My Sales'], ['team', '👥 Team Sales']].map(([key, label]) => (
            <button key={key} onClick={() => setTab(key)}
              style={{ ...S.btn, ...(tab === key ? S.btnPrimary : S.btnSecondary), fontWeight: 600 }}>{label}</button>
          ))}
        </div>
      )}

      {/* ── MY SALES TAB ── */}
      {tab === 'my' && (
        <div>
          {/* Key metrics */}
          <div style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#d97706', marginBottom: 8, display: 'flex', alignItems: 'center' }}>
              My Performance — {periodLabel}
              <InfoTip text={'Closed Won / Lost metrics are filtered by the selected period. Pipeline and active counts show your current open leads.'} />
            </div>
            <div className="cb-grid4" style={S.grid4}>
              {[
                ['Active Leads', myActive.length, '#1e3a5f', 'Currently in pipeline', 'Count of leads not yet closed or released.'],
                ['Pipeline ARR', myPipelineArr, '#7c3aed', 'Est. annual value', 'Sum of estimated annual recurring revenue across all your active leads.'],
                ['Won ARR', myWonArr, '#15803d', `${myWon.length} deals closed`, `Total annual value of deals you closed in the selected period.\nBased on plan tier × billing type.`],
                ['Win Rate', myWinRate !== null ? `${myWinRate}%` : '—', myWinRate !== null && myWinRate >= 50 ? '#166534' : '#92400e', `${myClosed.length} closed`, 'Won ÷ (Won + Lost) for closed deals in the period.'],
              ].map(([label, val, color, sub, tip]) => (
                <div key={label} style={{ ...S.statCard, background: color, textAlign: 'center' }}>
                  <div style={{ fontSize: 22, fontWeight: 800 }}>
                    {typeof val === 'string' ? val : (val === '—' ? '—' : typeof val === 'number' && label.includes('ARR') ? <>{formatCurrency(val)}<span style={{ fontSize: 12, fontWeight: 500, opacity: 0.8 }}>/yr</span></> : val)}
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 600, marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                    {label} <InfoTip text={tip} />
                  </div>
                  <div style={{ fontSize: 11, opacity: 0.65, marginTop: 2 }}>{sub}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Secondary stats */}
          <div className="cb-grid4" style={{ ...S.grid4, marginBottom: 20 }}>
            {[
              ['Avg Deal Size', myAvgDeal, '#0891b2', `${myWon.length} won`, 'Average ARR of your closed-won deals in the period.'],
              ['Released', myReleased.length, '#6b7280', 'Sent back to opps', 'Leads you released back to the Opportunities pool in the period.'],
              ['Lost', myLost.length, '#dc2626', 'Closed lost', 'Leads you marked Closed Lost in the period.'],
              ['Commission', user?.commissionRate != null ? formatCurrency(Math.round(myWonArr * user.commissionRate)) : '—', '#78350f', user?.commissionRate != null ? `${(user.commissionRate * 100).toFixed(1)}% rate` : 'No rate set', `15% base commission on annual ARR.\nSpeed bonus: +$150 (≤7 days to close), +$75 (≤14 days).\nVolume bonus: 3 deals=$250, 5=$750, 8+=$1,500.`],
            ].map(([label, val, color, sub, tip]) => (
              <div key={label} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 16px', textAlign: 'center' }}>
                <div style={{ fontSize: 20, fontWeight: 800, color }}>{((typeof val === 'number' && label.includes('ARR')) || label === 'Avg Deal Size') ? <>{formatCurrency(val)}<span style={{ fontSize: 11, color: '#64748b' }}>/yr</span></> : val}</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>{label} <InfoTip text={tip} /></div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{sub}</div>
              </div>
            ))}
          </div>

          {/* My pipeline by stage */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#64748b', marginBottom: 10, display: 'flex', alignItems: 'center' }}>
              My Pipeline by Stage
              <InfoTip text={'Active leads only. Each stage shows count and estimated ARR. Stage ARR = plan tier base + Cityworks premium + Answers add-on if applicable.'} />
            </div>
            <div style={{ ...S.card, padding: 0, overflow: 'hidden' }}>
              <table style={S.table}>
                <thead>
                  <tr>{['Stage','Leads','Est. ARR','% of Pipeline'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {PIPELINE_RAIL.map(stage => {
                    const sl = myActive.filter(l => l.stage === stage.key);
                    const arr = sl.reduce((s, l) => s + (l.estimated_arr || calcLeadArr(l) || 0), 0);
                    const pct = myPipelineArr > 0 ? Math.round((arr / myPipelineArr) * 100) : 0;
                    const color = STAGE_COLORS[stage.key];
                    return (
                      <tr key={stage.key}>
                        <td style={S.td}><span style={{ ...S.badge, color, background: color + '18' }}>{stage.label}</span></td>
                        <td style={S.td}>{sl.length}</td>
                        <td style={S.td}>{sl.length > 0 ? <>{formatCurrency(arr)}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></> : '—'}</td>
                        <td style={S.td}>
                          {sl.length > 0 ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <div style={{ flex: 1, height: 6, background: '#f1f5f9', borderRadius: 3, overflow: 'hidden', minWidth: 60 }}>
                                <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 3 }} />
                              </div>
                              <span style={{ fontSize: 12, color: '#64748b', minWidth: 32 }}>{pct}%</span>
                            </div>
                          ) : '—'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* My won deals table */}
          {myWon.length > 0 && (
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#15803d', marginBottom: 10, display: 'flex', alignItems: 'center' }}>
                Closed Won — {periodLabel}
                <InfoTip text={'Leads marked Closed Won or linked to a converted city. ARR is used to calculate commission.'} />
              </div>
              <div style={{ ...S.card, padding: 0, overflow: 'hidden' }}>
                <table style={S.table}>
                  <thead><tr>{['City','Plan','Est. ARR','Closed'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {myWon.map(l => (
                      <tr key={l.id}>
                        <td style={S.td}><div style={{ fontWeight: 600 }}>{l.city_name}{l.city_state ? `, ${l.city_state}` : ''}</div></td>
                        <td style={S.td}><span style={{ fontSize: 12 }}>{l.plan_tier || 'starter'}{l.is_cw_plan ? ' + CW' : ''}{l.has_answers ? ' + Ans' : ''}</span></td>
                        <td style={S.td}>{formatCurrency(l.estimated_arr || calcLeadArr(l))}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></td>
                        <td style={S.td}>{formatDate(l.updated_at)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── TEAM SALES TAB (super_admin only) ── */}
      {tab === 'team' && isSuperAdmin && (
        <div>
          {/* Team key metrics */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#7c3aed', marginBottom: 8, display: 'flex', alignItems: 'center' }}>
              Team Performance — {periodLabel}
              <InfoTip text={'Aggregated metrics across all sales reps. Closed Won / Lost filtered by selected period.'} />
            </div>
            <div className="cb-grid4" style={S.grid4}>
              {[
                ['Total Pipeline', teamPipelineArr, '#1e3a5f', `${allActive.length} active leads`, 'Sum of estimated ARR across all open leads.'],
                ['Won ARR', teamWonArr, '#15803d', `${allWon.length} deals`, 'Total closed-won ARR in the selected period.'],
                ['Team Win Rate', teamWinRate !== null ? `${teamWinRate}%` : '—', teamWinRate !== null && teamWinRate >= 50 ? '#166534' : '#92400e', `${allClosed.length} closed`, 'Won ÷ (Won + Lost) across all reps.'],
                ['Released', allReleased.length, '#6b7280', 'Back to Opportunities', 'Leads released back to the Opportunities pool in the period.'],
              ].map(([label, val, color, sub, tip]) => (
                <div key={label} style={{ ...S.statCard, background: color, textAlign: 'center' }}>
                  <div style={{ fontSize: 22, fontWeight: 800 }}>
                    {typeof val === 'string' ? val : (val === '—' ? '—' : typeof val === 'number' && label.includes('ARR') ? <>{formatCurrency(val)}<span style={{ fontSize: 12, fontWeight: 500, opacity: 0.8 }}>/yr</span></> : val)}
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 600, marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                    {label} <InfoTip text={tip} />
                  </div>
                  <div style={{ fontSize: 11, opacity: 0.65, marginTop: 2 }}>{sub}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Pipeline by stage */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#64748b', marginBottom: 10, display: 'flex', alignItems: 'center' }}>
              Team Pipeline by Stage
              <InfoTip text={'Active leads only. Shows how many leads are in each stage team-wide and their collective estimated ARR.'} />
            </div>
            <div style={{ ...S.card, padding: 0, overflow: 'hidden' }}>
              <table style={S.table}>
                <thead><tr>{['Stage','Leads','Est. ARR','% of Pipeline'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {stageBreakdown.map(({ stage, count, arr }) => {
                    const pct = teamPipelineArr > 0 ? Math.round((arr / teamPipelineArr) * 100) : 0;
                    const color = STAGE_COLORS[stage.key];
                    return (
                      <tr key={stage.key}>
                        <td style={S.td}><span style={{ ...S.badge, color, background: color + '18' }}>{stage.label}</span></td>
                        <td style={S.td}>{count}</td>
                        <td style={S.td}>{count > 0 ? <>{formatCurrency(arr)}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></> : '—'}</td>
                        <td style={S.td}>
                          {count > 0 ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <div style={{ flex: 1, height: 6, background: '#f1f5f9', borderRadius: 3, overflow: 'hidden', minWidth: 60 }}>
                                <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 3 }} />
                              </div>
                              <span style={{ fontSize: 12, color: '#64748b', minWidth: 32 }}>{pct}%</span>
                            </div>
                          ) : '—'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* Per-rep breakdown */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#64748b', marginBottom: 10, display: 'flex', alignItems: 'center' }}>
              Rep Performance
              <InfoTip text={'Per-rep breakdown. Active Leads = currently open. Won/Lost/Released filtered by period. Win Rate = Won ÷ (Won + Lost).'} />
            </div>
            <div style={{ ...S.card, padding: 0, overflow: 'hidden' }}>
              <table style={S.table}>
                <thead><tr>{['Rep','Active Leads','Pipeline ARR','Won ARR','Avg Deal','Win Rate','Released'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {repBreakdown.length === 0 ? (
                    <tr><td colSpan={7} style={{ ...S.td, textAlign: 'center', color: '#94a3b8' }}>No reps yet</td></tr>
                  ) : repBreakdown.map(({ rep, activeCount, wonArr, pipelineArr, winRate, avgDeal, releasedCount }) => (
                    <tr key={rep.id}>
                      <td style={S.td}><div style={{ fontWeight: 600 }}>{rep.name}</div><div style={{ fontSize: 11, color: '#94a3b8' }}>{rep.salesRole?.replace('sales_','').replace('_',' ')}</div></td>
                      <td style={S.td}>{activeCount}</td>
                      <td style={S.td}>{pipelineArr > 0 ? <>{formatCurrency(pipelineArr)}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></> : '—'}</td>
                      <td style={S.td}>{wonArr > 0 ? <>{formatCurrency(wonArr)}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></> : '—'}</td>
                      <td style={S.td}>{avgDeal > 0 ? <>{formatCurrency(avgDeal)}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></> : '—'}</td>
                      <td style={S.td}>
                        {winRate !== null ? (
                          <span style={{ fontWeight: 700, color: winRate >= 50 ? '#16a34a' : '#dc2626' }}>{winRate}%</span>
                        ) : <span style={{ color: '#94a3b8' }}>—</span>}
                      </td>
                      <td style={S.td}>{releasedCount > 0 ? <span style={{ color: '#6b7280' }}>{releasedCount}</span> : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Won deals detail */}
          {allWon.length > 0 && (
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#15803d', marginBottom: 10, display: 'flex', alignItems: 'center' }}>
                All Closed Won — {periodLabel}
                <InfoTip text={'Every closed-won deal in the selected period, sorted by ARR descending.'} />
              </div>
              <div style={{ ...S.card, padding: 0, overflow: 'hidden' }}>
                <table style={S.table}>
                  <thead><tr>{['City','Rep','Plan','Est. ARR','Closed'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {[...allWon].sort((a, b) => ((b.estimated_arr || calcLeadArr(b)) - (a.estimated_arr || calcLeadArr(a)))).map(l => (
                      <tr key={l.id}>
                        <td style={S.td}><div style={{ fontWeight: 600 }}>{l.city_name}{l.city_state ? `, ${l.city_state}` : ''}</div></td>
                        <td style={S.td}>{l.owner_name || l.owner_rep_id || '—'}</td>
                        <td style={S.td}><span style={{ fontSize: 12 }}>{l.plan_tier || 'starter'}{l.is_cw_plan ? ' + CW' : ''}{l.has_answers ? ' + Ans' : ''}</span></td>
                        <td style={S.td}>{formatCurrency(l.estimated_arr || calcLeadArr(l))}<span style={{ fontSize: 11, color: '#94a3b8' }}>/yr</span></td>
                        <td style={S.td}>{formatDate(l.updated_at)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ─── PLAYBOOK PAGE ────────────────────────────────────────────────────────────

const PLAYBOOK_NAV = [
  { section: 'Quick Access' },
  { key: 'overview',    label: '🗺 Overview & Quick Start' },
  { key: 'cold',        label: '📧 Cold Outreach Scripts' },
  { key: 'stages',      label: '📈 Stage-by-Stage Playbook' },
  { key: 'speed',       label: '⚡ Speed Bonus Strategies' },
  { section: 'Product' },
  { key: 'upsell',      label: '🔼 Upsell & CivicBot Answers' },
  { key: 'objections',  label: '🛡 Objection Handling' },
  { key: 'ai_email',    label: '✨ AI Email Generator Guide' },
  { section: 'Reference' },
  { key: 'commission',  label: '💰 Commission & Earnings' },
  { key: 'portal',      label: '🖥 Portal User Manual' },
];

function PlaybookScript({ tag, children }) {
  const [copied, setCopied] = React.useState(false);
  function copy() {
    navigator.clipboard.writeText(children).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
  }
  return (
    <div style={{ position: 'relative', background: '#1e293b', color: '#e2e8f0', borderRadius: 10, padding: '28px 20px 18px', fontSize: 13, lineHeight: 1.8, whiteSpace: 'pre-wrap', fontFamily: 'Georgia, serif', marginBottom: 16 }}>
      {tag && <span style={{ position: 'absolute', top: -10, left: 14, background: '#f59e0b', color: '#1e293b', borderRadius: 20, fontSize: 10, fontWeight: 800, padding: '2px 10px', textTransform: 'uppercase' }}>{tag}</span>}
      <button onClick={copy} style={{ position: 'absolute', top: 8, right: 10, background: 'rgba(255,255,255,0.1)', color: copied ? '#86efac' : '#94a3b8', border: 'none', borderRadius: 6, padding: '4px 10px', fontSize: 11, cursor: 'pointer' }}>{copied ? 'Copied!' : 'Copy'}</button>
      {children}
    </div>
  );
}

// ─── DOWNLOADS PAGE ───────────────────────────────────────────────────────────

function DownloadsPage() {
  const docs = [
    {
      category: 'Recruiting',
      items: [
        { label: 'Sales Rep Opportunity Packet', desc: 'Recruiting document for prospective sales reps — product overview, commission structure, why join us.', file: 'recruiting-packet.html', icon: '🤝' },
      ],
    },
    {
      category: 'Onboarding',
      items: [
        { label: 'New Hire Packet', desc: 'Complete onboarding guide — company overview, products, target market, 30/60/90-day plan, KPIs, tools.', file: 'new-hire-packet.html', icon: '📋' },
      ],
    },
    {
      category: 'Sales Training',
      items: [
        { label: 'Sales Techniques & Best Practices', desc: 'Public sector SaaS sales guide — cold outreach, LinkedIn, demo, trial management, objection handling, closing, upsell. Includes sample scripts.', file: 'sales-techniques.html', icon: '🎯' },
      ],
    },
    {
      category: 'Technology',
      items: [
        { label: 'Sales Portal User Guide', desc: 'Step-by-step guide to the CivicBot Sales Portal — every page, feature, and workflow explained for sales reps.', file: 'technology-portal-guide.html', icon: '🖥' },
      ],
    },
    {
      category: 'Product Reference',
      items: [
        { label: 'CivicBot Features Guide (Internal)', desc: 'Complete internal reference — every product feature, how to sell it, common prospect questions with answers, competitive differentiation.', file: 'features-internal.html', icon: '📚' },
        { label: 'CivicBot Features One-Pager (Customer-Facing)', desc: 'Leave-behind / email attachment for prospects — clean one-page overview of CivicBot and CivicBot Answers with pricing and CTA.', file: 'features-external.html', icon: '📄' },
      ],
    },
  ];

  return (
    <div style={S.main} className="cb-main">
      <div style={{ marginBottom: 28 }}>
        <h1 style={S.h1}>⬇ Downloads</h1>
        <p style={{ fontSize: 14, color: '#64748b', margin: 0 }}>
          Sales materials, training docs, and product references. Open any document, then use <strong>File → Print → Save as PDF</strong> to download.
        </p>
      </div>

      {docs.map(group => (
        <div key={group.category} style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#94a3b8', marginBottom: 12 }}>{group.category}</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {group.items.map(doc => (
              <div key={doc.file} style={{ ...S.card, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, padding: '16px 20px', marginBottom: 0 }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, flex: 1 }}>
                  <span style={{ fontSize: 28, lineHeight: 1, flexShrink: 0 }}>{doc.icon}</span>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#0f172a', marginBottom: 3 }}>{doc.label}</div>
                    <div style={{ fontSize: 13, color: '#64748b', lineHeight: 1.5 }}>{doc.desc}</div>
                  </div>
                </div>
                <a
                  href={`${process.env.PUBLIC_URL}/docs/${doc.file}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ ...S.btn, background: '#1e3a5f', color: '#fff', border: 'none', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap', flexShrink: 0 }}
                >
                  ⬇ Open Document
                </a>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div style={{ ...S.info, marginTop: 8 }}>
        <strong>Keeping documents current:</strong> These files are updated automatically when product features or portal changes are deployed. Always download fresh copies — don't save old versions locally for long-term use.
      </div>
    </div>
  );
}

// ─── PLAYBOOK PAGE ─────────────────────────────────────────────────────────────

function PlaybookPage() {
  const [activePanel, setActivePanel] = React.useState('overview');

  const sidebarStyle = { background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: 8, position: 'sticky', top: 80, alignSelf: 'start', minWidth: 200 };
  const sidebarItemBase = { padding: '10px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8, border: 'none', width: '100%', textAlign: 'left' };
  const sectionLabelStyle = { fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#94a3b8', padding: '10px 14px 4px', display: 'block' };
  const tipStyle = { background: '#fef3c7', borderLeft: '4px solid #f59e0b', borderRadius: '0 8px 8px 0', padding: '12px 16px', fontSize: 13, color: '#92400e', marginBottom: 16 };

  return (
    <div style={S.main} className="cb-main">
      <style>{`
        @media print {
          .playbook-sidebar, .cb-nav, .no-print { display: none !important; }
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      `}</style>
      {/* Header */}
      <div style={{ ...S.spaceBetween, marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={S.h1}>📖 Sales Playbook</h1>
          <p style={{ fontSize: 14, color: '#64748b', margin: 0 }}>Your complete field guide to selling CivicBot and CivicBot Answers</p>
        </div>
        <span style={{ ...S.badge, background: '#fef3c7', color: '#d97706', fontSize: 12 }}>Living document — updated with every release</span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: 24, alignItems: 'start' }}>
        {/* Sidebar */}
        <div style={sidebarStyle} className="playbook-sidebar no-print">
          {PLAYBOOK_NAV.map((item, i) => item.section
            ? <span key={i} style={sectionLabelStyle}>{item.section}</span>
            : <button key={item.key} onClick={() => setActivePanel(item.key)}
                style={{ ...sidebarItemBase, background: activePanel === item.key ? '#1e3a5f' : 'transparent', color: activePanel === item.key ? '#fff' : '#374151', fontWeight: activePanel === item.key ? 700 : 500 }}>
                {item.label}
              </button>
          )}
        </div>

        {/* Content */}
        <div>
          {/* Download / Print bar — always visible above the active panel */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
            <button
              onClick={() => window.print()}
              style={{ ...S.btn, ...S.btnSecondary, fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}
            >
              ⬇ Download / Print this section
            </button>
          </div>

          {/* ── OVERVIEW ── */}
          {activePanel === 'overview' && (
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, background: '#e0f2fe', color: '#0369a1', borderRadius: 20, padding: '3px 10px', marginBottom: 12 }}>🗺 Overview &amp; Quick Start</div>
              <h2 style={S.h2}>Welcome to the CivicBot Sales Playbook</h2>
              <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, marginBottom: 16 }}>This is your field guide. Every script, strategy, objection response, and commission breakdown lives here. Bookmark it, use it daily, and refer back whenever you're stuck.</p>

              <div style={{ background: '#1e3a5f', borderRadius: 12, padding: 20, marginBottom: 20 }}>
                <h3 style={{ color: '#fff', marginBottom: 12 }}>🎯 What You're Selling</h3>
                <div className="cb-grid2" style={S.grid2}>
                  <div>
                    <div style={{ color: '#f59e0b', fontWeight: 800, fontSize: 14, marginBottom: 6 }}>CivicBot (Base)</div>
                    <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13, lineHeight: 1.7, margin: 0 }}>311-style service request intake for municipalities. Replaces the $3.39/call phone channel with a flat-rate SaaS widget on the city website. SRs route to email or Cityworks/Trimble Unity.</p>
                  </div>
                  <div>
                    <div style={{ color: '#34d399', fontWeight: 800, fontSize: 14, marginBottom: 6 }}>CivicBot Answers (Add-On)</div>
                    <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13, lineHeight: 1.7, margin: 0 }}>AI-powered Q&A that crawls the city's website and answers resident questions with cited sources. Requires a base CivicBot plan. Cross-sell after CivicBot is live.</p>
                  </div>
                </div>
              </div>

              <h2 style={S.h2}>Your Pipeline in 5 Steps</h2>
              <div style={{ display: 'flex', alignItems: 'center', overflowX: 'auto', marginBottom: 20, gap: 0, paddingBottom: 4 }}>
                {[{n:1,l:'Claim Opp',c:'#64748b'},{n:2,l:'Cold Outreach',c:'#3b82f6'},{n:3,l:'Book Demo',c:'#8b5cf6'},{n:4,l:'Start Trial',c:'#f59e0b'},{n:5,l:'Close 🎉',c:'#16a34a'}].map((s, i, arr) => (
                  <React.Fragment key={s.n}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, minWidth: 80 }}>
                      <div style={{ width: 36, height: 36, borderRadius: '50%', background: s.c, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, color: '#fff', fontSize: 15 }}>{s.n}</div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: '#64748b', textAlign: 'center' }}>{s.l}</div>
                    </div>
                    {i < arr.length - 1 && <span style={{ color: '#cbd5e1', fontSize: 18, paddingBottom: 20, flexShrink: 0 }}>→</span>}
                  </React.Fragment>
                ))}
              </div>

              <div className="cb-grid3" style={S.grid3}>
                {[
                  { icon: '📌', title: 'Step 1 — Claim Your Opp', body: 'Go to Opportunities. Filter by state. Select cities and hit Claim. You can hold up to 50 active — be selective.' },
                  { icon: '📧', title: 'Step 2 — First Touch', body: 'Use the AI Email Generator. Pick Cold Intro context, personalize the output. Send within 24 hours of claiming.' },
                  { icon: '📞', title: 'Step 3 — Follow-Up Call', body: '3 days after email, make the cold call. Goal: one question — "Can I show you a 15-minute demo?"' },
                  { icon: '🖥', title: 'Step 4 — Demo', body: 'Live demo of the widget + Cityworks integration if applicable. End with: "Would you be open to a 30-day trial?"' },
                  { icon: '⚡', title: 'Step 5 — Trial → Close Fast', body: 'Speed bonus opens Day 1 of trial. Close by EOD Day 7 for +$150. Days 8–14 for +$75. Check Commission Dashboard daily.' },
                  { icon: '🔼', title: 'Step 6 — Upsell Answers', body: 'Once CivicBot is live 2–4 weeks, introduce Answers. Frame it as Phase 2. Use the Upsell section in this Playbook.' },
                ].map(s => (
                  <div key={s.title} style={S.cardSm}><div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>{s.icon} {s.title}</div><p style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, margin: 0 }}>{s.body}</p></div>
                ))}
              </div>

              <div style={tipStyle}><strong style={{ display: 'block', marginBottom: 2 }}>🏆 Top Rep Mindset</strong>Cities buy from people they trust. Your job is not to pitch — it's to educate. Every city manager has fielded the same 311 calls for years. Your opening line is not a feature, it's a number: $3.39 per call.</div>
            </div>
          )}

          {/* ── COLD OUTREACH ── */}
          {activePanel === 'cold' && (
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, background: '#e0f2fe', color: '#0369a1', borderRadius: 20, padding: '3px 10px', marginBottom: 12 }}>📧 Cold Outreach Scripts</div>
              <h2 style={S.h2}>Cold Email Scripts</h2>
              <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, marginBottom: 16 }}>These are starting points. Always personalize the city name, state, and any known context. Use the AI Email Generator for dynamic personalization.</p>

              <h3 style={{ ...S.h3, marginTop: 20 }}>Email 1 — Cold Introduction (no prior contact)</h3>
              <PlaybookScript tag="Subject line">{`Cutting [City Name]'s 311 call costs — quick idea

Hi [First Name],

My name is [Your Name] with Centricity GIS. I work with municipalities across [State] to reduce the volume and cost of 311 phone calls — the Pew Research benchmark puts the average at $3.39 per call.

We built CivicBot, a 311-style service request tool that embeds directly on your city website. Residents submit requests online, staff get notified by email or directly inside Cityworks — no phone tag, no after-hours calls.

Cities your size typically handle 500–2,000 SR calls per month. At $3.39 each, that's $1,700–$6,800/month in staff time just to answer the phone.

CivicBot starts at $2,000/year — a fraction of that.

Would it be worth a 15-minute walkthrough? I can show you exactly how Lincoln, CA is using it right now.

[Your Name]
[Phone] | Centricity GIS`}</PlaybookScript>

              <h3 style={{ ...S.h3, marginTop: 20 }}>Email 2 — Follow-Up (no response, Day 4)</h3>
              <PlaybookScript tag="Follow-Up #1">{`Re: Cutting [City Name]'s 311 call costs

Hi [First Name],

Following up on my note from earlier this week. I'll keep this short.

One question: Does [City Name] currently route service requests through phone calls, and does your team spend meaningful time fielding them?

If yes, I think I can show you something worth 15 minutes. If no, I'll leave you alone entirely.

Either way, a quick reply saves us both time.

[Your Name]`}</PlaybookScript>

              <h3 style={{ ...S.h3, marginTop: 20 }}>Email 3 — Cityworks-Specific</h3>
              <PlaybookScript tag="Cityworks Angle">{`[City Name] + Cityworks — resident-facing intake

Hi [First Name],

Quick question: does [City Name] use Cityworks or Trimble Unity for work order management?

If so, CivicBot might be a natural fit. We built a direct integration — residents submit service requests through a widget on your website, and they automatically become SR records inside Cityworks. No manual entry, no phone calls, no duplicates.

We're live in a few cities in [State] already. Happy to show you a 10-minute demo of the Cityworks integration specifically.

[Your Name]`}</PlaybookScript>

              <hr style={S.divider} />
              <h2 style={S.h2}>Cold Call Scripts</h2>

              <h3 style={{ ...S.h3, marginTop: 20 }}>Opening — IT Director / City Manager</h3>
              <PlaybookScript tag="Cold Call — Opener">{`"Hi, is this [Name]?

Great — this is [Your Name] from Centricity GIS. I'll be upfront — this is a cold call, and I'll keep it under 60 seconds.

We help cities reduce the staff time spent fielding 311-style phone calls. I work with a number of cities in [State] and wanted to see if that's a pain point for [City Name] at all.

Is fielding service request calls something your team deals with regularly?"

[If YES:]
"Perfect — I'm not going to pitch you right now. I'd just love 15 minutes to show you how Lincoln, CA is handling it. Would [Day] or [Day] work for a quick screen share?"

[If NO / busy:]
"Totally understand. Can I send you a two-minute overview by email and you can tell me if it's even relevant? What's the best address?"`}</PlaybookScript>

              <h3 style={{ ...S.h3, marginTop: 20 }}>Voicemail Script</h3>
              <PlaybookScript tag="Voicemail">{`"Hi [Name], this is [Your Name] from Centricity GIS — [phone number].

Quick message: we built a tool that cuts the cost of 311 phone calls for cities like [City Name]. The Pew benchmark puts that cost at $3.39 per call — we get it down to pennies.

I'll send you a short email as well. If it's not relevant, just let me know — no hard feelings. Again, [Your Name], [phone]. Thanks."`}</PlaybookScript>

              <div style={tipStyle}><strong style={{ display: 'block', marginBottom: 2 }}>💡 The Single Most Important Cold Call Rule:</strong>Never pitch on a cold call. Ask one qualifying question. If they say yes, book the demo. That's the entire goal of the first call.</div>
            </div>
          )}

          {/* ── STAGES ── */}
          {activePanel === 'stages' && (
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, background: '#e0f2fe', color: '#0369a1', borderRadius: 20, padding: '3px 10px', marginBottom: 12 }}>📈 Stage-by-Stage Playbook</div>
              <h2 style={S.h2}>Moving Through the Pipeline</h2>
              <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, marginBottom: 16 }}>Each stage has a clear entry condition, a primary action, and an exit trigger. Don't skip stages — the system tracks engagement so you know where to focus.</p>

              {[
                { color: '#64748b', title: '🔵 Prospect', badge: 'Entry: Lead claimed', body: "You've claimed the opportunity and created the lead. No contact has been made yet.", steps: ['Verify the contact info in the Lead — look up the city website if needed', 'Use the AI Email Generator → Cold Introduction context → send', 'Stage auto-advances to Contacted when the email sends ✓'] },
                { color: '#3b82f6', title: '✉️ Contacted', badge: 'Entry: Email sent or call made', body: "You've made first contact. Now you're waiting for a response or scheduling your follow-up.", steps: ['Log a follow-up activity (call or email) 3–4 days after first contact', 'Second touch: use Follow-Up email script or make the cold call', 'Goal: get a "yes, show me more" or "not interested" — either is better than silence'] },
                { color: '#8b5cf6', title: '📅 Demo Booked', badge: 'Entry: Demo scheduled', body: 'They said yes to a demo. This is a high-value stage — treat it with care.', steps: ['Research the city: population, current 311 process, whether they use Cityworks', 'Send a calendar invite with the join link + a one-line agenda', 'Prepare a live demo with the city\'s name in the widget if possible'] },
                { color: '#f59e0b', title: '⚡ Trial Active', badge: 'Entry: City on trial in Admin', body: 'The city is live. Your speed bonus clock is ticking. Highest-priority stage.', steps: ['Day 1–3: onboarding check-in, make sure widget is live, send a how\'s it going email', 'Day 4–5: send SR count → quantify displaced phone calls at $3.39/call', 'Day 6–7: TIER 1 CLOSE WINDOW — make the direct ask for annual plan', 'Day 8–14: TIER 2 CLOSE — address specific objection, ask what\'s blocking the decision'] },
                { color: '#f97316', title: '🤝 Negotiating', badge: 'Entry: Active pricing discussion', body: "They're interested but have questions. Focus on removing blockers.", steps: ['Price: frame annual savings vs. monthly — "Annual saves $400 and locks in the rate"', 'IT approval: offer to join a call with their IT director, provide security one-pager', 'Council approval: provide budget justification doc, quantify 311 call volume × $3.39', 'Competitors: "We\'re purpose-built for municipalities. Our Cityworks integration is native, not bolted on."'] },
              ].map(s => (
                <div key={s.title} style={{ ...S.cardSm, borderLeft: `4px solid ${s.color}`, marginBottom: 16 }}>
                  <div style={{ ...S.spaceBetween, marginBottom: 8 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#1e293b' }}>{s.title}</div>
                    <span style={{ ...S.badge, background: '#f1f5f9', color: '#374151', fontSize: 11 }}>{s.badge}</span>
                  </div>
                  <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, marginBottom: 10 }}>{s.body}</p>
                  <ol style={{ paddingLeft: 18, fontSize: 13, lineHeight: 1.8, color: '#475569', margin: 0 }}>
                    {s.steps.map((step, i) => <li key={i}>{step}</li>)}
                  </ol>
                </div>
              ))}
            </div>
          )}

          {/* ── SPEED BONUS ── */}
          {activePanel === 'speed' && (
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, background: '#e0f2fe', color: '#0369a1', borderRadius: 20, padding: '3px 10px', marginBottom: 12 }}>⚡ Speed Bonus Strategies</div>
              <h2 style={S.h2}>How to Earn Speed Bonuses Consistently</h2>

              <div className="cb-grid2" style={{ ...S.grid2, marginBottom: 20 }}>
                <div style={{ ...S.statCard, background: '#16a34a' }}>
                  <div style={{ fontSize: 32, fontWeight: 800 }}>+$150</div>
                  <div style={{ fontSize: 12, opacity: 0.85, marginTop: 4 }}>Tier 1 · Close by EOD Day 7</div>
                </div>
                <div style={{ ...S.statCard, background: '#d97706' }}>
                  <div style={{ fontSize: 32, fontWeight: 800 }}>+$75</div>
                  <div style={{ fontSize: 12, opacity: 0.85, marginTop: 4 }}>Tier 2 · Close by EOD Day 14</div>
                </div>
              </div>

              <div style={tipStyle}><strong style={{ display: 'block', marginBottom: 2 }}>The clock starts on Trial Day 1 — not demo day, not when you send the contract.</strong>Day 1 = the day the city appears in trial status in CivicBot Admin. Check your Commission Dashboard → Estimated Commissions to see exactly where each trial is.</div>

              <h3 style={S.h3}>The 5-Day Trial Close Framework</h3>
              <div style={S.cardSm}>
                <div className="cb-grid2" style={S.grid2}>
                  {[
                    { day: 'Day 1 — Set the Expectation', body: '"The trial is now live. I\'ll check in with you in a few days to review the numbers together. In the meantime, here\'s how to share the link with residents."' },
                    { day: 'Day 3 — The Value Check-In', body: 'Pull their SR count from the admin portal. Email: "You\'ve captured [X] service requests digitally this week. That\'s [X × $3.39] in phone call costs already displaced."' },
                    { day: 'Day 5 — The Soft Close', body: '"Based on what you\'ve seen, does moving to an annual plan make sense? The Starter Annual is $2,000 — that\'s about what your phone calls cost in a few weeks."' },
                    { day: 'Day 7 — The Direct Ask', body: '"Today is the last day I can lock in the speed pricing on my end. Are there any open questions I can answer right now to help you decide?"' },
                  ].map(f => (
                    <div key={f.day}>
                      <div style={{ fontWeight: 700, fontSize: 13, color: '#1e293b', marginBottom: 5 }}>{f.day}</div>
                      <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, margin: 0 }}>{f.body}</p>
                    </div>
                  ))}
                </div>
              </div>

              <h3 style={{ ...S.h3, marginTop: 20 }}>Speed Bonus Email — Day 6 Template</h3>
              <PlaybookScript tag="Day 6 — Trial">{`Subject: [City Name] — quick question before tomorrow

Hi [Name],

You're 6 days into your CivicBot trial and I wanted to check in before the week closes.

Here's what I'm seeing on my end:
• [X] service requests submitted through the widget
• [X] that would have been phone calls to your office
• Estimated call-handling cost displaced: $[X × $3.39]

Based on that, I think the Starter Annual plan at $2,000/year is the right fit for [City Name].

Do you have 10 minutes tomorrow morning to talk through the final step? I want to make sure any questions get answered so you're not left on a trial that expires without a decision.

[Your Name]`}</PlaybookScript>

              <div style={tipStyle}><strong style={{ display: 'block', marginBottom: 2 }}>💡 Never surprise a city with urgency on Day 7.</strong>Seed the timeline on Day 1. Tell them upfront: "I'll check in on Day 7 as that's when we typically lock in the best rate." Then Day 7 feels like a natural next step, not a pressure tactic.</div>
            </div>
          )}

          {/* ── UPSELL ── */}
          {activePanel === 'upsell' && (
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, background: '#e0f2fe', color: '#0369a1', borderRadius: 20, padding: '3px 10px', marginBottom: 12 }}>🔼 Upsell &amp; CivicBot Answers</div>
              <h2 style={S.h2}>Upselling CivicBot Answers</h2>
              <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, marginBottom: 16 }}>CivicBot Answers is your highest-value add-on. Wait until the city has been live for 2–4 weeks with CivicBot before introducing it — you want them to have felt the SR intake value first.</p>

              <div className="cb-grid2" style={{ ...S.grid2, marginBottom: 20 }}>
                <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: 18 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#1e3a5f', marginBottom: 8 }}>When to Introduce Answers</div>
                  <ul style={{ paddingLeft: 16, fontSize: 13, color: '#475569', lineHeight: 1.8, margin: 0 }}>
                    <li>City has been live 2–4 weeks</li>
                    <li>SR volume is visible in their portal</li>
                    <li>You've had at least one positive check-in</li>
                    <li>They mention staff fielding repetitive questions</li>
                  </ul>
                </div>
                <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: 18 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#166534', marginBottom: 8 }}>The Upsell Pitch (1 Sentence)</div>
                  <p style={{ fontSize: 14, fontWeight: 600, color: '#166534', lineHeight: 1.6, margin: 0 }}>"You've already stopped 311 SR calls with CivicBot — Answers stops the 'what are your park hours?' calls too, using AI that reads your own website."</p>
                </div>
              </div>

              <h3 style={S.h3}>Answers Upsell Email</h3>
              <PlaybookScript tag="Answers Upsell">{`Subject: Phase 2 for [City Name] — AI Q&A for residents

Hi [Name],

You've been live with CivicBot for [X] weeks now, and I wanted to introduce Phase 2.

CivicBot Answers is an AI layer that reads your city website and answers resident questions directly through the same widget — with cited sources so residents can verify the answer themselves.

Think: "What are the park hours?" "When is my trash pickup?" "How do I apply for a permit?" — all answered instantly, 24/7, without a phone call or staff response.

For a Starter plan city like [City Name], it's an additional $3,500/year.

Given that you're already using CivicBot, there's no new setup — I can turn it on this week.

Worth a quick conversation?

[Your Name]`}</PlaybookScript>

              <h3 style={{ ...S.h3, marginTop: 20 }}>Plan Upgrade Matrix</h3>
              <div style={{ borderRadius: 10, overflow: 'hidden', border: '1px solid #e2e8f0', marginBottom: 16 }}>
                <table style={S.table}>
                  <thead><tr><th style={S.th}>Plan</th><th style={S.th}>Base (Email)</th><th style={S.th}>Base (CW)</th><th style={S.th}>+Answers (Email)</th><th style={S.th}>+Answers (CW)</th></tr></thead>
                  <tbody>
                    {[['Starter · 100 SR/mo','$2,000/yr','$2,500/yr','+$3,500/yr','+$4,000/yr'],['Growth · 250 SR/mo','$4,000/yr','$5,000/yr','+$6,000/yr','+$7,000/yr'],['Professional · 500 SR/mo','$6,000/yr','$7,500/yr','+$9,000/yr','+$10,500/yr']].map(row => (
                      <tr key={row[0]}>{row.map((cell, i) => <td key={i} style={{ ...S.td, fontWeight: i === 0 ? 600 : 400 }}>{cell}</td>)}</tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={tipStyle}><strong style={{ display: 'block', marginBottom: 2 }}>💡 Upsell timing matters:</strong>Introducing Answers on Day 1 of a trial dilutes the message. Let CivicBot prove its value first. When the city manager says "this is really useful," that's your upsell moment.</div>
            </div>
          )}

          {/* ── OBJECTIONS ── */}
          {activePanel === 'objections' && (
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, background: '#e0f2fe', color: '#0369a1', borderRadius: 20, padding: '3px 10px', marginBottom: 12 }}>🛡 Objection Handling</div>
              <h2 style={S.h2}>Common Objections &amp; Responses</h2>

              {[
                { q: '❌ "We don\'t have budget for this right now."', a: 'I completely understand budget constraints. Here\'s a way to look at it: if your city handles even 100 phone-based service requests per month at $3.39 each, that\'s $4,068 per year in staff time — just to answer calls. CivicBot Starter is $2,000/year. It actually reduces your existing cost rather than adding to it. Is there a budget cycle coming up where I could help you build a cost-justification case?' },
                { q: '❌ "We already have a system for that."', a: 'That\'s great to hear — can you tell me a little about it? [Listen.] A few questions: Is it resident-facing with a widget on your website? Does it route directly into Cityworks? Does it handle AI-based Q&A? Most systems I run into are internal tools that still rely on a phone call to initiate the request. CivicBot is the resident-facing front door.' },
                { q: '❌ "Our residents won\'t use an online tool — they call."', a: "That's exactly what Lincoln, CA thought. Within 30 days of going live, over 40% of their service requests were coming through the widget — no marketing, no push. Residents default to whatever is easiest. If it's faster to tap a button on your website than to wait on hold, they'll use it. We can prove it with a free 30-day trial — no risk." },
                { q: '❌ "I need to get IT/Council approval."', a: 'Totally normal. I can help make that easy. I have a one-page security overview and a simple ROI calculation you can take to IT. And if it helps, I\'m happy to join a 15-minute call with whoever needs to sign off. What\'s their main concern usually — security, cost, or complexity?' },
                { q: '❌ "We\'re a small city — this feels like overkill."', a: "Small cities often benefit most. You probably have a small staff doing a lot — every call you can eliminate frees up time. The Starter plan is $2,000/year. If it deflects even 60 calls a month, it's paying for itself. And the setup is fully managed — your IT team doesn't have to do anything." },
              ].map(o => (
                <div key={o.q} style={{ ...S.cardSm, marginBottom: 16 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#1e293b', marginBottom: 8 }}>{o.q}</div>
                  <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.7, margin: 0 }}><strong>Response: </strong>{o.a}</p>
                </div>
              ))}
            </div>
          )}

          {/* ── AI EMAIL GUIDE ── */}
          {activePanel === 'ai_email' && (
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, background: '#e0f2fe', color: '#0369a1', borderRadius: 20, padding: '3px 10px', marginBottom: 12 }}>✨ AI Email Generator Guide</div>
              <h2 style={S.h2}>Getting the Most Out of the AI Email Generator</h2>
              <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, marginBottom: 20 }}>The AI Email Generator is on the Email tab of any Lead. Pick a context, optionally add a sample prompt or custom note, and generate. Here's how to use it well.</p>

              <div className="cb-grid2" style={{ ...S.grid2, marginBottom: 20 }}>
                <div>
                  <h3 style={S.h3}>Step 1 — Choose a Context</h3>
                  <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, marginBottom: 12 }}>Each context produces a fundamentally different email. Match it to your actual situation.</p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    {EMAIL_CONTEXTS.map(ctx => <span key={ctx.key} style={{ border: '2px solid #e2e8f0', borderRadius: 8, padding: '7px 13px', fontSize: 12, fontWeight: 600, color: '#374151' }}>{ctx.label}</span>)}
                  </div>
                </div>
                <div>
                  <h3 style={S.h3}>Step 2 — Add Context Notes</h3>
                  <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, marginBottom: 8 }}>The "Additional Context" field is where you add specifics. Examples:</p>
                  <ul style={{ paddingLeft: 16, fontSize: 13, lineHeight: 1.8, color: '#475569', margin: 0 }}>
                    <li>"Spoke briefly at ESRI conference in June"</li>
                    <li>"City uses Cityworks — emphasize native integration"</li>
                    <li>"They mentioned budget approval coming in October"</li>
                    <li>"City manager mentioned residents complain about SR response times"</li>
                    <li>"Had a demo 2 weeks ago — they liked it but need council approval"</li>
                  </ul>
                </div>
              </div>

              <h3 style={S.h3}>Sample Prompts by Context</h3>
              <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, marginBottom: 16 }}>In the Live Email Generator, clicking any of these fills the Additional Context field instantly. Here's a reference of all of them:</p>

              {Object.entries(EMAIL_SAMPLE_PROMPTS).map(([ctxKey, prompts]) => {
                const ctx = EMAIL_CONTEXTS.find(c => c.key === ctxKey);
                return (
                  <div key={ctxKey} style={{ marginBottom: 20 }}>
                    <div style={{ fontWeight: 700, fontSize: 13, color: '#1e3a5f', marginBottom: 10 }}>{ctx?.label}</div>
                    {prompts.map((p, i) => (
                      <div key={i} style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '9px 12px', fontSize: 12, display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 6 }}>
                        <span style={{ fontSize: 15, flexShrink: 0 }}>{p.icon}</span>
                        <div><div style={{ fontWeight: 700, fontSize: 11, textTransform: 'uppercase', color: '#3b82f6', marginBottom: 2 }}>{p.label}</div><div style={{ lineHeight: 1.5, color: '#1e40af' }}>{p.text}</div></div>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          )}

          {/* ── COMMISSION ── */}
          {activePanel === 'commission' && (
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, background: '#e0f2fe', color: '#0369a1', borderRadius: 20, padding: '3px 10px', marginBottom: 12 }}>💰 Commission &amp; Earnings</div>
              <h2 style={S.h2}>How You Get Paid — Simple Breakdown</h2>

              <div style={{ background: '#1e3a5f', borderRadius: 12, padding: 20, marginBottom: 20 }}>
                <h3 style={{ color: '#fff', marginBottom: 4 }}>The Formula</h3>
                <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, marginBottom: 16 }}>Commission is calculated on <strong style={{ color: '#f59e0b' }}>Annual plans only</strong>. Monthly plans do not generate commission. Always pitch annual.</p>
                <div style={{ fontSize: 20, fontWeight: 800, color: '#fff', textAlign: 'center', padding: '14px 20px', background: 'rgba(255,255,255,0.1)', borderRadius: 10 }}>
                  Payout = (ARR × 15%) + Speed Bonus + Volume Bonus
                </div>
              </div>

              <h3 style={S.h3}>Earnings Examples</h3>
              <div style={{ borderRadius: 10, overflow: 'hidden', border: '1px solid #e2e8f0', marginBottom: 20 }}>
                <table style={S.table}>
                  <thead><tr>{['Plan','Type','Annual ARR','Base (15%)','+ Speed T1','+ Speed T2','With Answers'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {[
                      ['Starter','Email','$2,000','$300','$450','$375','$5,500 ARR → $825'],
                      ['Starter','Cityworks','$2,500','$375','$525','$450','$6,500 ARR → $975'],
                      ['Growth','Email','$4,000','$600','$750','$675','$10,000 ARR → $1,500'],
                      ['Growth','Cityworks','$5,000','$750','$900','$825','$12,000 ARR → $1,800'],
                      ['Professional','Email','$6,000','$900','$1,050','$975','$15,000 ARR → $2,250'],
                      ['Pro + CW + Answers','CW','$18,000','$2,700','$2,850','$2,775','Best possible deal 🏆'],
                    ].map((row, ri) => (
                      <tr key={ri} style={{ background: ri === 5 ? '#f0fdf4' : 'transparent' }}>
                        {row.map((cell, ci) => <td key={ci} style={{ ...S.td, fontWeight: ci === 0 || ri === 5 ? 600 : 400, color: ri === 5 && ci === 6 ? '#16a34a' : S.td.color }}>{cell}</td>)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <h3 style={S.h3}>Speed Bonus Windows</h3>
              <div className="cb-grid2" style={{ ...S.grid2, marginBottom: 20 }}>
                <div>
                  {[
                    { label: '⚡ Tier 1 — Close by EOD Day 7', val: '+$150', color: '#16a34a', pct: '100%', note: 'Day 1 = Trial start. This is your priority close window.' },
                    { label: '⚡ Tier 2 — Close Days 8–14', val: '+$75', color: '#d97706', pct: '50%', note: 'Still meaningful. If Day 7 slips, make Day 14 your new hard deadline.' },
                    { label: 'No Bonus — After Day 14', val: '$0', color: '#94a3b8', pct: '0%', note: 'Base commission only. Still worth closing — every deal builds pipeline ARR.' },
                  ].map(b => (
                    <div key={b.label} style={{ background: '#f1f5f9', borderRadius: 8, padding: '12px 16px', marginBottom: 10 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, fontWeight: 600, marginBottom: 6 }}><span>{b.label}</span><span style={{ color: b.color, fontWeight: 700 }}>{b.val}</span></div>
                      <div style={{ height: 10, background: '#e2e8f0', borderRadius: 5, overflow: 'hidden', marginBottom: 6 }}><div style={{ height: '100%', width: b.pct, background: b.color, borderRadius: 5 }} /></div>
                      <div style={{ fontSize: 11, color: '#94a3b8' }}>{b.note}</div>
                    </div>
                  ))}
                </div>
                <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: 18 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#1e3a5f', marginBottom: 10 }}>💡 Speed Bonus Tips</div>
                  <ul style={{ paddingLeft: 16, fontSize: 13, lineHeight: 1.8, color: '#475569', margin: 0 }}>
                    <li>Check Commission Dashboard → Estimated Commissions every morning during an active trial</li>
                    <li>The day counter shows exactly where you are: "Day 5 of 7 — Tier 1 open"</li>
                    <li>Set a personal calendar reminder on Day 5 and Day 12 of every trial</li>
                    <li>Never surprise a city with urgency on Day 7 — seed the timeline on Day 1</li>
                    <li>Speed bonus applies to the initial trial only</li>
                  </ul>
                </div>
              </div>

              <h3 style={S.h3}>Volume Bonus Thresholds</h3>
              <p style={{ color: '#64748b', fontSize: 13, marginBottom: 12 }}>Close enough deals in a calendar month and you earn a volume bonus on top of base and speed bonuses. Thresholds reset on the 1st of every month.</p>
              <div className="cb-grid3" style={{ ...S.grid3, marginBottom: 20 }}>
                {[
                  { deals: 3, bonus: '$250', color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0', note: 'Attainable every month with consistent pipeline.' },
                  { deals: 5, bonus: '$750', color: '#d97706', bg: '#fffbeb', border: '#fde68a', note: 'Strong month. Keep 8–10 active trials at a time to hit this.' },
                  { deals: '8+', bonus: '$1,500', color: '#7c3aed', bg: '#faf5ff', border: '#e9d5ff', note: 'Elite month. Requires deep pipeline and fast closes.' },
                ].map(t => (
                  <div key={t.deals} style={{ background: t.bg, border: `1px solid ${t.border}`, borderRadius: 10, padding: '14px 16px', textAlign: 'center' }}>
                    <div style={{ fontSize: 28, fontWeight: 800, color: t.color }}>{t.bonus}</div>
                    <div style={{ fontWeight: 700, fontSize: 13, color: '#1e3a5f', marginTop: 4, marginBottom: 6 }}>{t.deals} deals closed</div>
                    <div style={{ fontSize: 11, color: '#64748b', lineHeight: 1.5 }}>{t.note}</div>
                  </div>
                ))}
              </div>
              <div style={{ background: '#f1f5f9', borderRadius: 10, padding: '14px 16px', marginBottom: 20 }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: '#1e3a5f', marginBottom: 8 }}>📅 Volume Bonus stacks with Speed Bonus</div>
                <p style={{ fontSize: 13, color: '#475569', margin: 0, lineHeight: 1.7 }}>
                  If you close 3 deals in a month and 2 of them were within the Day 7 window, your payout looks like:<br />
                  <strong>Base + ($150 × 2 speed bonuses) + $250 volume bonus</strong><br />
                  Close 5 deals with 3 speed bonuses: <strong>Base + $450 speed + $750 volume = big month.</strong>
                </p>
              </div>

              <div style={tipStyle}><strong style={{ display: 'block', marginBottom: 2 }}>Monthly plans pay $0 commission.</strong>Always lead with annual pricing. The ROI case is stronger (city locks in the rate, saves ~17% vs monthly), and it's the only plan that generates commission. If a city pushes back on annual: "Start annual — if it's not working after 90 days, I'll make it right."</div>
            </div>
          )}

          {/* ── PORTAL MANUAL ── */}
          {activePanel === 'portal' && (
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 700, background: '#e0f2fe', color: '#0369a1', borderRadius: 20, padding: '3px 10px', marginBottom: 12 }}>🖥 Portal User Manual</div>
              <h2 style={S.h2}>Using the CivicBot Sales Portal</h2>

              {[
                { icon: '📋', title: 'Opportunities Page', body: 'All available cities to claim. Use filters (state, search) to find targets. Select cities and click Claim All Checked. You can hold up to 50 active at a time — the capacity bar shows your current count.', bullets: ['+ Add Manually — for cities not in the imported list. Set the plan level, Cityworks toggle, and Answers add-on at creation time. Check "Claim immediately" to jump straight to a Lead.', 'Bulk claim — filter your target state, search by name, check multiple, claim at once.'] },
                { icon: '📈', title: 'Leads Page', body: 'Your active pipeline. Defaults to "My Leads" — use the owner filter to see all reps (managers only). Toggle between List and Kanban view. Drag Kanban cards to update stage.', bullets: ['Bulk stage update — check multiple leads in list view, pick a stage, click Update.', 'Stage summary strip — click any stage pill above the table to filter to that stage.', 'My EST ARR by Stage — shows your estimated ARR in each stage, clickable to filter.'] },
                { icon: '📧', title: 'Email Tab (Lead Detail)', body: 'The AI Email Generator is on the Email tab of any Lead. Pick a context, optionally click a sample prompt to fill the context field, then generate, review, and send.', bullets: ['Context selector — sets the tone and purpose of the email (Cold Intro, Follow-Up, Demo Ask, Trial Check-In, Close, Upsell, Objection).', 'Sample prompts — pre-written context chips you click to fill the Additional Context field instantly.', 'Stage auto-advances to Contacted when you send via the portal.', 'Email history tied to the Organization — preserved across reps if a lead is released and re-claimed.'] },
                { icon: '💰', title: 'Commission Dashboard', body: 'Shows actual commissions by period and the Estimated Commissions section at the top.', bullets: ['Estimated Commissions — forward-looking: pipeline by stage + active trials with speed window countdown.', 'Mine / Full Team toggle — switch between your estimates and the whole team.', 'Mark Paid — super admin can check deals as paid once commission is disbursed.'] },
                { icon: '📊', title: 'Reports Page', body: 'Available to all reps. Shows My Sales tab (your pipeline metrics, won deals, commission estimate) and Team Sales tab (super admin / director only).', bullets: ['Period filter — Month, Quarter, Year, or All Time.', 'Pipeline by stage table with ARR totals.', 'Closed Won deals list sorted by ARR.'] },
                { icon: '🗑', title: 'Requesting Lead Deletion', body: 'On any Lead Detail page, scroll to the Settings tab. Click Request Deletion of Lead. Add a reason (optional). This sends a request to Super Admin — the lead is NOT deleted until approved in the Actions page.', bullets: [] },
                { icon: '⚙️', title: 'Actions Page (Super Admin only)', body: 'Pending admin approvals. Handles lead deletion requests. Approve deletes the lead and frees the linked opportunity. Deny keeps the lead intact. All actions are logged in the Resolved tab.', bullets: [] },
              ].map(s => (
                <div key={s.title} style={{ ...S.cardSm, marginBottom: 16 }}>
                  <h3 style={{ ...S.h3, marginBottom: 8 }}>{s.icon} {s.title}</h3>
                  <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, marginBottom: s.bullets.length > 0 ? 10 : 0 }}>{s.body}</p>
                  {s.bullets.length > 0 && (
                    <ul style={{ paddingLeft: 16, fontSize: 13, lineHeight: 1.8, color: '#475569', margin: 0 }}>
                      {s.bullets.map((b, i) => <li key={i}>{b}</li>)}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

// ─── ANALYTICS PAGE ───────────────────────────────────────────────────────────

const STAGE_ORDER = ['prospect','contacted','demo','proposal','negotiation','closed-won','closed-lost'];
const STAGE_LABELS = { prospect:'Prospect', contacted:'Contacted', demo:'Demo', proposal:'Proposal', negotiation:'Negotiation', 'closed-won':'Closed Won', 'closed-lost':'Closed Lost' };
const ACTIVITY_COLORS = { email:'#3b82f6', call:'#22c55e', note:'#94a3b8', meeting:'#f59e0b', demo:'#818cf8', task:'#f97316' };

function SparkLine({ data, color = '#3b82f6', height = 60 }) {
  if (!data || data.length === 0) return <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#cbd5e1', fontSize: 12 }}>No data</div>;
  const vals = data.map(d => d.cnt);
  const max = Math.max(...vals, 1);
  const w = 400, h = height;
  const pts = vals.map((v, i) => {
    const x = vals.length === 1 ? w / 2 : (i / (vals.length - 1)) * w;
    const y = h - (v / max) * (h - 8) - 4;
    return `${x},${y}`;
  }).join(' ');
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{ width: '100%', height }} preserveAspectRatio="none">
      <defs>
        <linearGradient id={`sg-${color.replace('#','')}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.2" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon points={`0,${h} ${pts} ${w},${h}`} fill={`url(#sg-${color.replace('#','')})`} />
      <polyline points={pts} fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function HBar({ label, value, max, color = '#3b82f6', subLabel }) {
  const pct = max > 0 ? Math.max((value / max) * 100, 1) : 0;
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3, fontSize: 12 }}>
        <span style={{ color: '#475569', fontWeight: 500, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
        <span style={{ color: '#1e3a5f', fontWeight: 700 }}>{value.toLocaleString()}{subLabel ? <span style={{ fontWeight: 400, color: '#94a3b8', marginLeft: 4 }}>{subLabel}</span> : null}</span>
      </div>
      <div style={{ background: '#f1f5f9', borderRadius: 4, height: 8, overflow: 'hidden' }}>
        <div style={{ background: color, height: '100%', width: `${pct}%`, borderRadius: 4, transition: 'width 0.6s ease' }} />
      </div>
    </div>
  );
}

function InfoTooltip({ text }) {
  const [show, setShow] = React.useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-block', marginLeft: 5, verticalAlign: 'middle' }}
      onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <span style={{ color: '#94a3b8', cursor: 'help', fontSize: 13, lineHeight: 1 }}>ⓘ</span>
      {show && (
        <div style={{ position: 'absolute', bottom: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)', background: '#1e293b', color: '#f1f5f9', fontSize: 11.5, padding: '8px 12px', borderRadius: 8, zIndex: 200, width: 230, lineHeight: 1.5, boxShadow: '0 4px 16px rgba(0,0,0,0.25)', pointerEvents: 'none' }}>
          {text}
          <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', width: 0, height: 0, borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '5px solid #1e293b' }} />
        </div>
      )}
    </span>
  );
}

function KPICard({ label, value, sub, color = '#1e3a5f', bg = '#fff', icon, tooltip }) {
  return (
    <div style={{ background: bg, border: '1px solid #e2e8f0', borderRadius: 14, padding: '20px 22px', flex: '1 1 150px', minWidth: 140 }}>
      {icon && <div style={{ fontSize: 22, marginBottom: 6 }}>{icon}</div>}
      <div style={{ fontSize: 26, fontWeight: 800, color, letterSpacing: '-0.5px', lineHeight: 1 }}>{value}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginTop: 4, fontWeight: 500 }}>{label}{tooltip && <InfoTooltip text={tooltip} />}</div>
      {sub && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

function AnalyticsPage() {
  const { token, user } = useAuth();
  const isSuperOrDir = user?.salesRole === 'super_admin' || user?.salesRole === 'sales_director';
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/sales/analytics`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { if (d.error) setErr(d.error); else setData(d); setLoading(false); })
      .catch(e => { setErr(e.message); setLoading(false); });
  }, [token]);

  if (loading) return <div style={{ padding: 60, textAlign: 'center', color: '#64748b' }}>Loading analytics…</div>;
  if (err) return <div style={{ padding: 40, color: '#dc2626' }}>Error: {err}</div>;
  if (!data) return null;

  const { leadStages, leadSources, emailStats, emailsByDay, allTimeBounces, pipeline, winLoss, activities, topReps, leadsByDay, recentBounces } = data;

  // Derived
  const stageMap = Object.fromEntries((leadStages||[]).map(r => [r.stage, r.cnt]));
  const totalLeads = (leadStages||[]).reduce((a, r) => a + r.cnt, 0);
  const won = winLoss.find(r => r.stage === 'closed-won')?.cnt || 0;
  const lost = winLoss.find(r => r.stage === 'closed-lost')?.cnt || 0;
  const winRate = (won + lost) > 0 ? Math.round((won / (won + lost)) * 100) : null;
  const bounceRate = (emailStats?.total_sent || 0) > 0 ? ((emailStats.total_bounced / emailStats.total_sent) * 100).toFixed(1) : '0.0';
  const activeLeads = STAGE_ORDER.filter(s => !['closed-won','closed-lost'].includes(s)).reduce((a, s) => a + (stageMap[s] || 0), 0);
  const maxStage = Math.max(...STAGE_ORDER.map(s => stageMap[s] || 0), 1);
  const maxSource = Math.max(...(leadSources||[]).map(r => r.cnt), 1);
  const maxActivity = Math.max(...(activities||[]).map(r => r.cnt), 1);
  const maxRep = Math.max(...(topReps||[]).map(r => r.emails_sent), 1);

  const card = { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 14, padding: '20px 22px' };
  const sectionTitle = { fontSize: 13, fontWeight: 700, color: '#1e3a5f', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 16 };

  return (
    <div style={{ ...S.container, maxWidth: 1200 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={S.h1}>Analytics</h1>
        <div style={{ fontSize: 13, color: '#64748b' }}>{isSuperOrDir ? 'All reps · Full pipeline view' : `Your activity · ${user?.name}`}</div>
      </div>

      {/* KPI Row */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 24 }}>
        <KPICard icon="🎯" label="Active Leads" value={activeLeads.toLocaleString()} sub={`${totalLeads.toLocaleString()} total`} />
        <KPICard icon="💰" label="Pipeline ARR" value={`$${Math.round((pipeline?.total_arr||0)/1000)}K`} sub={`${pipeline?.total || 0} active deals`} color="#166534" />
        <KPICard icon="📧" label="Emails Sent (30d)" value={(emailStats?.total_sent||0).toLocaleString()} sub={`${emailStats?.via_sendgrid||0} via SendGrid`} />
        <KPICard icon="↩️" label="Bounce Rate (30d)" value={`${bounceRate}%`} sub={`${allTimeBounces?.cnt||0} all-time bounces`} color={parseFloat(bounceRate) > 5 ? '#dc2626' : '#1e3a5f'} />
        {winRate !== null && <KPICard icon="🏆" label="Win Rate" value={`${winRate}%`} sub={`${won} won · ${lost} lost`} color={winRate >= 50 ? '#166534' : '#92400e'} />}
        <KPICard icon="👥" label="Total Leads" value={totalLeads.toLocaleString()} sub="all time" />
      </div>

      {/* Row 2: Pipeline + Sources */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div style={card}>
          <div style={sectionTitle}>Lead Pipeline by Stage</div>
          {STAGE_ORDER.map(stage => (stageMap[stage] || 0) > 0 ? (
            <HBar key={stage} label={STAGE_LABELS[stage]} value={stageMap[stage]||0} max={maxStage} color={STAGE_COLORS[stage]} />
          ) : null)}
          {STAGE_ORDER.every(s => !stageMap[s]) && <div style={{ color: '#94a3b8', fontSize: 13 }}>No leads yet</div>}
        </div>
        <div style={card}>
          <div style={sectionTitle}>Leads by Source</div>
          {(leadSources||[]).length === 0 ? <div style={{ color: '#94a3b8', fontSize: 13 }}>No source data</div> :
            (leadSources||[]).map(r => <HBar key={r.source} label={r.source} value={r.cnt} max={maxSource} color="#6366f1" />)}
        </div>
      </div>

      {/* Row 3: Email Trend + Leads Trend */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
            <div style={sectionTitle}>Emails Sent — Last 30 Days</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: '#3b82f6' }}>{(emailStats?.total_sent||0).toLocaleString()}</div>
          </div>
          <SparkLine data={emailsByDay} color="#3b82f6" height={80} />
          <div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
            <div style={{ fontSize: 12, color: '#22c55e' }}>✓ {(emailStats?.total_sent||0) - (emailStats?.total_bounced||0)} delivered</div>
            <div style={{ fontSize: 12, color: '#dc2626' }}>↩ {emailStats?.total_bounced||0} bounced</div>
          </div>
        </div>
        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
            <div style={sectionTitle}>Leads Added — Last 30 Days</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: '#6366f1' }}>{(leadsByDay||[]).reduce((a,d)=>a+d.cnt,0)}</div>
          </div>
          <SparkLine data={leadsByDay} color="#6366f1" height={80} />
        </div>
      </div>

      {/* Row 4: Activities + Win/Loss + Top Reps */}
      <div style={{ display: 'grid', gridTemplateColumns: isSuperOrDir ? '1fr 1fr 1fr' : '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div style={card}>
          <div style={sectionTitle}>Activity Types (30d)</div>
          {(activities||[]).length === 0 ? <div style={{ color: '#94a3b8', fontSize: 13 }}>No activity logged</div> :
            (activities||[]).map(r => <HBar key={r.type} label={r.type.charAt(0).toUpperCase()+r.type.slice(1)} value={r.cnt} max={maxActivity} color={ACTIVITY_COLORS[r.type]||'#94a3b8'} />)}
        </div>
        <div style={card}>
          <div style={sectionTitle}>Win / Loss</div>
          {won === 0 && lost === 0 ? <div style={{ color: '#94a3b8', fontSize: 13 }}>No closed deals yet</div> : (<>
            <HBar label="Closed Won 🏆" value={won} max={Math.max(won,lost,1)} color="#22c55e" />
            <HBar label="Closed Lost" value={lost} max={Math.max(won,lost,1)} color="#f43f5e" />
            {winRate !== null && <div style={{ marginTop: 12, fontSize: 28, fontWeight: 800, color: winRate >= 50 ? '#166534' : '#92400e', textAlign: 'center' }}>{winRate}% <span style={{ fontSize: 13, fontWeight: 500 }}>win rate</span></div>}
          </>)}
        </div>
        {isSuperOrDir && (
          <div style={card}>
            <div style={sectionTitle}>Top Reps — Emails (30d)</div>
            {(topReps||[]).length === 0 ? <div style={{ color: '#94a3b8', fontSize: 13 }}>No sends yet</div> :
              (topReps||[]).map(r => <HBar key={r.rep} label={r.rep} value={r.emails_sent} max={maxRep} color="#f59e0b" subLabel={r.bounced > 0 ? `${r.bounced} bounced` : null} />)}
          </div>
        )}
      </div>

      {/* Recent Bounces */}
      {recentBounces?.length > 0 && (
        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <div style={sectionTitle}>Recent Bounces</div>
            <a href="/bounces" style={{ fontSize: 12, color: '#3b82f6', textDecoration: 'none' }}>View all →</a>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                <th style={{ ...S.th, fontSize: 11, padding: '6px 8px' }}>Contact</th>
                <th style={{ ...S.th, fontSize: 11, padding: '6px 8px' }}>Email</th>
                <th style={{ ...S.th, fontSize: 11, padding: '6px 8px' }}>Org</th>
                {isSuperOrDir && <th style={{ ...S.th, fontSize: 11, padding: '6px 8px' }}>Sent By</th>}
                <th style={{ ...S.th, fontSize: 11, padding: '6px 8px' }}>Reason</th>
              </tr>
            </thead>
            <tbody>
              {recentBounces.map((b, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f8fafc' }}>
                  <td style={{ ...S.td, padding: '6px 8px', fontWeight: 600 }}>{b.recipient_name||'—'}</td>
                  <td style={{ ...S.td, padding: '6px 8px', color: '#3b82f6' }}>{b.recipient_email}</td>
                  <td style={{ ...S.td, padding: '6px 8px', color: '#64748b' }}>{b.org_name||'—'}</td>
                  {isSuperOrDir && <td style={{ ...S.td, padding: '6px 8px', color: '#64748b' }}>{b.sent_by_name||'—'}</td>}
                  <td style={{ ...S.td, padding: '6px 8px', color: '#dc2626', fontSize: 11 }}>{(b.bounce_reason||'').slice(0,60)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ─── MESSAGE ANALYTICS PAGE ───────────────────────────────────────────────────

function FunnelStep({ label, value, total, color, icon, tooltip }) {
  const pct = total > 0 ? ((value / total) * 100).toFixed(1) : '0.0';
  const width = total > 0 ? Math.max((value / total) * 100, 2) : 0;
  return (
    <div style={{ marginBottom: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3, fontSize: 13 }}>
        <span style={{ fontWeight: 600, color: '#1e3a5f' }}>{icon} {label}{tooltip && <InfoTooltip text={tooltip} />}</span>
        <span style={{ color: '#475569' }}>{value.toLocaleString()} <span style={{ color: '#94a3b8', fontSize: 12 }}>({pct}% of sent)</span></span>
      </div>
      <div style={{ background: '#f1f5f9', borderRadius: 6, height: 12, overflow: 'hidden' }}>
        <div style={{ background: color, height: '100%', width: `${width}%`, borderRadius: 6, transition: 'width 0.8s ease' }} />
      </div>
    </div>
  );
}

function MultiSparkLine({ data, keys, colors, height = 80 }) {
  if (!data || data.length === 0) return <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#cbd5e1', fontSize: 12 }}>No data yet</div>;
  const allVals = data.flatMap(d => keys.map(k => d[k] || 0));
  const max = Math.max(...allVals, 1);
  const w = 500, h = height;
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{ width: '100%', height }} preserveAspectRatio="none">
      {keys.map((key, ki) => {
        const pts = data.map((d, i) => {
          const x = data.length === 1 ? w / 2 : (i / (data.length - 1)) * w;
          const y = h - ((d[key] || 0) / max) * (h - 8) - 4;
          return `${x},${y}`;
        }).join(' ');
        return <polyline key={key} points={pts} fill="none" stroke={colors[ki]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
      })}
    </svg>
  );
}

function ScheduledQueuePage() {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('pending');
  const [search, setSearch] = useState('');
  const [cancelling, setCancelling] = useState(null);

  const load = React.useCallback(async () => {
    setLoading(true);
    try {
      const url = `${API}/api/sales/scheduled-emails${statusFilter ? `?status=${statusFilter}` : ''}`;
      const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      const data = await r.json();
      if (Array.isArray(data)) setEmails(data);
    } catch(e) {}
    setLoading(false);
  }, [token, statusFilter]);

  React.useEffect(() => { load(); }, [load]);

  async function cancelEmail(id) {
    if (!window.confirm('Cancel this scheduled email? It will not be sent.')) return;
    setCancelling(id);
    try {
      const r = await fetch(`${API}/api/sales/scheduled-emails/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      if (r.ok) load();
    } catch(e) {}
    setCancelling(null);
  }

  const filtered = emails.filter(e => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (e.sent_by_name || '').toLowerCase().includes(q)
      || (e.recipient_email || '').toLowerCase().includes(q)
      || (e.subject || '').toLowerCase().includes(q)
      || (e.city_name || '').toLowerCase().includes(q);
  });

  const STATUS_COLORS = { pending: '#f59e0b', sent: '#22c55e', failed: '#ef4444', sending: '#3b82f6' };

  return (
    <div style={S.page}>
      <div className="cb-main" style={S.main}>
        <div style={{ ...S.spaceBetween, marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
          <div>
            <h1 style={S.h1}>📅 Scheduled Email Queue</h1>
            <p style={{ color: '#64748b', fontSize: 14, margin: 0 }}>All scheduled outbound emails across every rep — super admin view.</p>
          </div>
          <button style={{ ...S.btn, ...S.btnSecondary }} onClick={load}>↻ Refresh</button>
        </div>

        {/* Filters */}
        <div style={{ ...S.card, marginBottom: 16, padding: '12px 16px' }}>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: 6 }}>
              {['pending','sent','failed',''].map(s => (
                <button key={s} onClick={() => setStatusFilter(s)}
                  style={{ ...S.btn, ...S.btnSm, background: statusFilter === s ? '#1e3a5f' : '#f1f5f9', color: statusFilter === s ? '#fff' : '#475569', border: '1px solid #e2e8f0' }}>
                  {s === '' ? 'All' : s.charAt(0).toUpperCase() + s.slice(1)}
                </button>
              ))}
            </div>
            <input style={{ ...S.input, flex: 1, minWidth: 200, marginBottom: 0 }} value={search} onChange={e => setSearch(e.target.value)} placeholder="Search rep, recipient, subject, city…" />
          </div>
        </div>

        {loading ? <p style={{ color: '#64748b', padding: 32 }}>Loading…</p> : filtered.length === 0 ? (
          <div style={{ ...S.card, textAlign: 'center', padding: 48, color: '#64748b' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📭</div>
            <div style={{ fontWeight: 600 }}>No {statusFilter} emails found</div>
            <div style={{ fontSize: 13, marginTop: 4 }}>Reps schedule emails from the Email tab on any lead.</div>
          </div>
        ) : (
          <div style={S.card}>
            {/* Summary strip */}
            <div style={{ display: 'flex', gap: 20, marginBottom: 16, flexWrap: 'wrap' }}>
              {['pending','sending','sent','failed'].map(s => {
                const count = emails.filter(e => e.status === s).length;
                if (!count) return null;
                return <div key={s} style={{ fontSize: 13 }}>
                  <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: STATUS_COLORS[s], marginRight: 5 }} />
                  <strong>{count}</strong> {s}
                </div>;
              })}
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
                    {['Status','Scheduled For','Rep','To','Subject','Lead','CC'].map(h => (
                      <th key={h} style={{ textAlign: 'left', padding: '8px 12px', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#94a3b8', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                    <th style={{ width: 80 }} />
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(e => {
                    const schedDt = new Date(e.scheduled_for + 'Z');
                    const isPast = schedDt < new Date();
                    const statusColor = STATUS_COLORS[e.status] || '#94a3b8';
                    return (
                      <tr key={e.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap' }}>
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: statusColor + '15', color: statusColor, borderRadius: 20, padding: '2px 10px', fontWeight: 700, fontSize: 11 }}>
                            <span style={{ width: 6, height: 6, borderRadius: '50%', background: statusColor, display: 'inline-block' }} />
                            {e.status}
                          </span>
                        </td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', color: isPast && e.status === 'pending' ? '#ef4444' : '#1e293b', fontWeight: isPast && e.status === 'pending' ? 700 : 400 }}>
                          {schedDt.toLocaleString([], { weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                          {isPast && e.status === 'pending' && <div style={{ fontSize: 10, color: '#ef4444' }}>overdue</div>}
                        </td>
                        <td style={{ padding: '10px 12px' }}>
                          <div style={{ fontWeight: 600, color: '#1e293b' }}>{e.sent_by_name || e.sent_by}</div>
                          <div style={{ fontSize: 11, color: '#94a3b8' }}>{e.sent_by_email}</div>
                        </td>
                        <td style={{ padding: '10px 12px' }}>
                          <div style={{ color: '#1e293b' }}>{e.recipient_name || '—'}</div>
                          <div style={{ fontSize: 11, color: '#94a3b8' }}>{e.recipient_email}</div>
                        </td>
                        <td style={{ padding: '10px 12px', maxWidth: 220 }}>
                          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#1e293b' }}>{e.subject}</div>
                        </td>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap' }}>
                          {e.city_name ? (
                            <button onClick={() => navigate(`/leads/${e.lead_id}`)} style={{ background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', padding: 0, fontSize: 13, textDecoration: 'underline' }}>
                              {e.city_name}{e.city_state ? `, ${e.city_state}` : ''}
                            </button>
                          ) : <span style={{ color: '#94a3b8' }}>—</span>}
                        </td>
                        <td style={{ padding: '10px 12px', fontSize: 11, color: '#7c3aed', maxWidth: 150 }}>
                          {e.cc_emails || <span style={{ color: '#cbd5e1' }}>—</span>}
                        </td>
                        <td style={{ padding: '10px 12px', textAlign: 'right' }}>
                          {e.status === 'pending' && (
                            <button onClick={() => cancelEmail(e.id)} disabled={cancelling === e.id}
                              style={{ ...S.btn, background: '#fff', border: '1px solid #fca5a5', color: '#dc2626', fontSize: 11, padding: '4px 10px' }}>
                              {cancelling === e.id ? '…' : 'Cancel'}
                            </button>
                          )}
                          {e.status === 'failed' && e.error && (
                            <span title={e.error} style={{ color: '#ef4444', fontSize: 11, cursor: 'help' }}>⚠️ hover</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Sortable table helpers (Email Analytics) ────────────────────────────────
function useSortableTable(defaultKey, defaultDir) {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [sortDir, setSortDir] = useState(defaultDir || 'desc');
  const toggle = (key) => {
    if (key === sortKey) setSortDir(d => (d === 'asc' ? 'desc' : 'asc'));
    else { setSortKey(key); setSortDir('asc'); }
  };
  const apply = (rows, cols) => {
    const col = (cols || []).find(c => c.key === sortKey);
    if (!col) return rows || [];
    const valOf = (r) => (col.get ? col.get(r) : r[col.key]);
    return [...(rows || [])].sort((a, b) => {
      let av = valOf(a), bv = valOf(b);
      if (av == null) av = ''; if (bv == null) bv = '';
      let cmp;
      if (typeof av === 'number' && typeof bv === 'number') cmp = av - bv;
      else cmp = String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: 'base' });
      return sortDir === 'asc' ? cmp : -cmp;
    });
  };
  return { sortKey, sortDir, toggle, apply };
}
function SortTh({ col, sorter, thStyle }) {
  const active = sorter.sortKey === col.key;
  return (
    <th onClick={() => sorter.toggle(col.key)} style={{ ...thStyle, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }} title="Click to sort">
      {col.label}<span style={{ marginLeft: 4, fontSize: 10, opacity: active ? 1 : 0.3 }}>{active ? (sorter.sortDir === 'asc' ? '▲' : '▼') : '↕'}</span>
    </th>
  );
}
const maCellLink = { background: 'none', border: 'none', padding: 0, font: 'inherit', cursor: 'pointer', color: '#1e3a5f', fontWeight: 600, textDecoration: 'underline' };
const MA_REP_COLS = [
  { label: 'Rep', key: 'rep' },
  { label: 'Sent', key: 'sent' },
  { label: 'Delivered', key: 'delivered' },
  { label: 'Delivery %', key: 'delivery_pct', get: r => (r.sent > 0 ? r.delivered / r.sent : 0) },
  { label: 'Opened', key: 'opened' },
  { label: 'Open %', key: 'open_pct', get: r => (r.delivered > 0 ? r.opened / r.delivered : 0) },
  { label: 'Clicked', key: 'clicked' },
  { label: 'Click %', key: 'click_pct', get: r => (r.opened > 0 ? r.clicked / r.opened : 0) },
  { label: 'Bounced', key: 'bounced' },
  { label: 'Bounce %', key: 'bounce_pct', get: r => (r.sent > 0 ? r.bounced / r.sent : 0) },
  { label: 'Spam', key: 'spam' },
  { label: 'Total Opens', key: 'total_opens' },
];
const MA_OPEN_COLS = [
  { label: 'Opened At', key: 'opened_at' },
  { label: 'Contact', key: 'recipient_name' },
  { label: 'Organization', key: 'org_name' },
  { label: 'Email', key: 'recipient_email' },
  { label: 'Subject', key: 'subject' },
  { label: 'Sent By', key: 'sent_by_name' },
  { label: '# Opens', key: 'open_count', get: r => r.open_count || 1 },
];
const MA_CLICK_COLS = [
  { label: 'Clicked At', key: 'clicked_at' },
  { label: 'Contact', key: 'recipient_name' },
  { label: 'Organization', key: 'org_name' },
  { label: 'Email', key: 'recipient_email' },
  { label: 'Subject', key: 'subject' },
  { label: 'Sent By', key: 'sent_by_name' },
  { label: '# Clicks', key: 'click_count', get: r => r.click_count || 1 },
];
const MA_SPAM_COLS = [
  { label: 'Reported At', key: 'spam_reported_at' },
  { label: 'Contact', key: 'recipient_name' },
  { label: 'Organization', key: 'org_name' },
  { label: 'Email', key: 'recipient_email' },
  { label: 'Subject', key: 'subject' },
  { label: 'Sent By', key: 'sent_by_name' },
];
const MA_BOUNCE_COLS = [
  { label: 'Bounced At', key: 'bounced_at' },
  { label: 'Contact', key: 'recipient_name' },
  { label: 'Organization', key: 'org_name' },
  { label: 'To Email', key: 'recipient_email' },
  { label: 'Subject', key: 'subject' },
  { label: 'Sent By', key: 'sent_by', get: r => r.sent_by_name || r.sent_by || '' },
  { label: 'Reason', key: 'bounce_reason' },
  { label: 'Sent At', key: 'sent_at' },
];

function MessageAnalyticsPage() {
  const { user, token } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [bounces, setBounces] = useState([]);
  const [bounceSearch, setBounceSearch] = useState('');
  const [limit, setLimit] = useState(100);
  const [scope, setScope] = useState('mine'); // 'mine' | 'all'
  const navigate = useNavigate();
  const isManager = user && ['super_admin', 'sales_director', 'sales_manager'].includes(user.salesRole);
  const sortReps = useSortableTable('sent', 'desc');
  const sortOpens = useSortableTable('opened_at', 'desc');
  const sortClicks = useSortableTable('clicked_at', 'desc');
  const sortSpam = useSortableTable('spam_reported_at', 'desc');
  const sortBounces = useSortableTable('bounced_at', 'desc');

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ limit: String(limit) });
    if (isManager) params.set('scope', scope);
    fetch(`${API}/api/sales/message-analytics?${params}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { if (d.error) setErr(d.error); else setData(d); setLoading(false); })
      .catch(e => { setErr(e.message); setLoading(false); });
    fetch(`${API}/api/sales/bounces`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { if (Array.isArray(d)) setBounces(d); })
      .catch(() => {});
  }, [token, limit, scope, isManager]);

  if (loading) return <div style={{ padding: 60, textAlign: 'center', color: '#64748b' }}>Loading message analytics…</div>;
  if (err) return <div style={{ padding: 40, color: '#dc2626' }}>Error: {err}</div>;
  if (!data) return null;

  const { overall, trend30, repStats, recentOpens, recentClicks, spamReports } = data;
  const o = overall || {};
  const sent = o.total_sent || 0;
  const delivered = o.total_delivered || 0;
  const opened = o.total_opened || 0;
  const clicked = o.total_clicked || 0;
  const bounced = o.total_bounced || 0;
  const dropped = o.total_dropped || 0;
  const spam = o.total_spam || 0;
  const deferred = o.total_deferred || 0;

  const deliveryRate = sent > 0 ? ((delivered / sent) * 100).toFixed(1) : '—';
  const openRate = delivered > 0 ? ((opened / delivered) * 100).toFixed(1) : '—';
  const clickRate = opened > 0 ? ((clicked / opened) * 100).toFixed(1) : '—';
  const bounceRate = sent > 0 ? ((bounced / sent) * 100).toFixed(1) : '—';

  const card = { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 14, padding: '20px 22px' };
  const sectionTitle = { fontSize: 13, fontWeight: 700, color: '#1e3a5f', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 16 };

  function fmtDate(s) {
    if (!s) return '—';
    // Normalize SQLite "YYYY-MM-DD HH:MM:SS" UTC -> proper Date in browser local tz
    const normalized = s.includes('T') ? s : (s.length >= 10 ? s.replace(' ', 'T') + 'Z' : s);
    const d = new Date(normalized);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  }

  function pct(num, denom) {
    if (!denom || denom === 0) return '—';
    return ((num / denom) * 100).toFixed(1) + '%';
  }

  const tabs = [
    { id: 'overview', label: '📊 Overview' },
    { id: 'reps', label: '👥 By Rep' },
    { id: 'opens', label: `📬 Opens (${recentOpens?.length || 0})` },
    { id: 'clicks', label: `🖱️ Clicks (${recentClicks?.length || 0})` },
    { id: 'spam', label: `🚨 Spam (${spamReports?.length || 0})` },
    { id: 'bounces', label: `↩️ Bounces (${bounces.length})`, alert: bounces.length > 0 },
  ];

  const filteredBounces = bounces.filter(b => {
    if (!bounceSearch) return true;
    const q = bounceSearch.toLowerCase();
    return [b.recipient_name, b.recipient_email, b.org_name, b.subject, b.sent_by_name, b.bounce_reason].some(v => (v||'').toLowerCase().includes(q));
  });

  function fmtBounceDate(s) {
    if (!s) return '—';
    const d = new Date(s);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + ' ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  }

  return (
    <div style={{ ...S.container, maxWidth: 1200 }}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={S.h1}>📊 Email Analytics</h1>
          <div style={{ fontSize: 13, color: '#64748b' }}>
            SendGrid delivery intelligence ·
            {isManager
              ? (scope === 'mine' ? ' Your emails only' : ' All reps')
              : ' Your emails only'}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          {isManager && (
            <div style={{ display: 'flex', gap: 4, padding: 3, background: '#f1f5f9', borderRadius: 6 }}>
              <button onClick={() => setScope('mine')} style={{ padding: '5px 12px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer', background: scope === 'mine' ? '#1e3a5f' : 'transparent', color: scope === 'mine' ? '#fff' : '#475569' }}>My Emails</button>
              <button onClick={() => setScope('all')} style={{ padding: '5px 12px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer', background: scope === 'all' ? '#1e3a5f' : 'transparent', color: scope === 'all' ? '#fff' : '#475569' }}>All Reps</button>
            </div>
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#64748b' }}>
            <span>Show:</span>
            {[{ val: 100, label: '100' }, { val: 200, label: '200' }, { val: 0, label: 'All' }].map(({ val, label }) => (
              <button key={val} onClick={() => setLimit(val)} style={{ padding: '4px 10px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: '1px solid ' + (limit === val ? '#1e3a5f' : '#cbd5e1'), cursor: 'pointer', background: limit === val ? '#1e3a5f' : '#fff', color: limit === val ? '#fff' : '#475569' }}>{label}</button>
            ))}
          </div>
        </div>
      </div>

      {/* Historical data warning */}
      <div style={{ background: '#fefce8', border: '1px solid #fde68a', borderRadius: 10, padding: '12px 16px', marginBottom: 20, fontSize: 13, color: '#92400e', display: 'flex', gap: 10, alignItems: 'flex-start' }}>
        <span style={{ fontSize: 16 }}>⚠️</span>
        <div>
          <strong>Tracking started May 16, 2026.</strong> Emails sent before the SendGrid webhook was configured will show 0 for delivery, opens, and clicks — those events weren't captured. All emails sent from today forward are fully tracked. Bounce counts reflect all historical bounces since those were tracked separately.
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 24 }}>
        <KPICard icon="📤" label="Total Sent" value={sent.toLocaleString()} sub="all time via SendGrid"
          tooltip="Total emails sent through SendGrid from this portal. Does not include emails where the rep copied the text manually." />
        <KPICard icon="✅" label="Delivery Rate" value={deliveryRate === '—' ? '—' : `${deliveryRate}%`} sub={`${delivered.toLocaleString()} delivered`} color={deliveryRate !== '—' && parseFloat(deliveryRate) >= 95 ? '#166534' : '#92400e'}
          tooltip="% of sent emails confirmed as received by the recipient's mail server. A 0% rate means the webhook wasn't yet configured when those emails were sent — not that delivery failed. Target: 95–98%." />
        <KPICard icon="👁️" label="Open Rate" value={openRate === '—' ? '—' : `${openRate}%`} sub={`${opened.toLocaleString()} unique opens`} color={openRate !== '—' && parseFloat(openRate) >= 20 ? '#166534' : '#92400e'}
          tooltip="% of delivered emails opened by the recipient (unique opens only — one person opening 5 times counts as 1). Calculated as: Unique Opens ÷ Delivered. Industry benchmark: 20–25%." />
        <KPICard icon="🖱️" label="Click Rate" value={clickRate === '—' ? '—' : `${clickRate}%`} sub={`${clicked.toLocaleString()} clicked`}
          tooltip="% of opened emails where the recipient clicked at least one link. Calculated as: Unique Clicks ÷ Unique Opens. Only tracked if your email contains links. Industry benchmark: 8–12%." />
        <KPICard icon="↩️" label="Bounce Rate" value={bounceRate === '—' ? '—' : `${bounceRate}%`} sub={`${bounced.toLocaleString()} bounced`} color={bounceRate !== '—' && parseFloat(bounceRate) > 5 ? '#dc2626' : '#166534'}
          tooltip="% of sent emails that permanently failed delivery — the recipient's server rejected them. Common causes: invalid address, government mail server blocks, or sender reputation issues. Keep below 2% to protect deliverability." />
        <KPICard icon="🚨" label="Spam Reports" value={spam.toLocaleString()} sub={sent > 0 ? `${((spam/sent)*100).toFixed(2)}% rate` : 'none'} color={spam > 0 ? '#dc2626' : '#166534'}
          tooltip="Number of recipients who marked your email as spam. Even a single spam report can hurt your sender reputation with email providers. Keep at 0. If this rises, review your subject lines and personalization." />
      </div>

      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '2px solid #e2e8f0' }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px 16px', fontSize: 13, fontWeight: activeTab === t.id ? 700 : 400, color: activeTab === t.id ? '#1e3a5f' : (t.alert ? '#dc2626' : '#64748b'), borderBottom: `2px solid ${activeTab === t.id ? '#1e3a5f' : 'transparent'}`, marginBottom: -2, whiteSpace: 'nowrap' }}>
            {t.label}
          </button>
        ))}
      </div>

      {activeTab === 'overview' && (<>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
          <div style={card}>
            <div style={sectionTitle}>Delivery Funnel — All Time</div>
            <FunnelStep icon="📤" label="Sent" value={sent} total={sent} color="#94a3b8" tooltip="Total emails submitted to SendGrid for delivery. This is your starting number — everything else is measured against it." />
            <FunnelStep icon="✅" label="Delivered" value={delivered} total={sent} color="#22c55e" tooltip="Emails confirmed as accepted by the recipient's mail server. Note: 'Delivered' means the server accepted it — not necessarily that it landed in the inbox vs. spam folder." />
            <FunnelStep icon="👁️" label="Opened (unique)" value={opened} total={sent} color="#3b82f6" tooltip="Unique recipients who opened the email at least once. Multiple opens by the same person count as 1 here. Total open count (including re-opens) is shown in the Opens tab." />
            <FunnelStep icon="🖱️" label="Clicked" value={clicked} total={sent} color="#6366f1" tooltip="Unique recipients who clicked at least one link in the email. Only tracked if the email contains links." />
            <FunnelStep icon="↩️" label="Bounced" value={bounced} total={sent} color="#f43f5e" tooltip="Permanent delivery failures — the recipient's server definitively rejected the email. Common causes: address doesn't exist, or the government mail server blocks outside senders. These contacts need follow-up by phone or LinkedIn." />
            {dropped > 0 && <FunnelStep icon="🗑️" label="Dropped" value={dropped} total={sent} color="#f97316" tooltip="Emails SendGrid dropped before even attempting delivery — usually because the address was previously marked as bounced, unsubscribed, or flagged as invalid. SendGrid suppresses these automatically to protect your reputation." />}
            {deferred > 0 && <FunnelStep icon="⏳" label="Deferred" value={deferred} total={sent} color="#f59e0b" tooltip="Temporary delivery failures — the recipient's server asked SendGrid to try again later. Most deferred emails are eventually delivered. If deferred emails never resolve, they'll become bounces." />}
            {spam > 0 && <FunnelStep icon="🚨" label="Spam Reports" value={spam} total={sent} color="#dc2626" tooltip="Recipients who clicked 'Mark as Spam.' This is serious — even a handful of spam reports can cause email providers to filter all your future emails into spam folders." />}
            {sent === 0 && <div style={{ color: '#94a3b8', fontSize: 13, textAlign: 'center', padding: 16 }}>No SendGrid emails sent yet</div>}
          </div>
          <div style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
              <div style={sectionTitle}>30-Day Trend</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 3, fontSize: 11 }}>
                {[['Sent','#94a3b8'],['Delivered','#22c55e'],['Opened','#3b82f6'],['Bounced','#f43f5e']].map(([l,c]) => (
                  <div key={l} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <div style={{ width: 12, height: 2, background: c, borderRadius: 1 }} />
                    <span style={{ color: '#64748b' }}>{l}</span>
                  </div>
                ))}
              </div>
            </div>
            <MultiSparkLine data={trend30} keys={['sent','delivered','opened','bounced']} colors={['#94a3b8','#22c55e','#3b82f6','#f43f5e']} height={130} />
            {trend30.length === 0 && <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 12, marginTop: 8 }}>No SendGrid sends in last 30 days</div>}
          </div>
        </div>
        <div style={{ ...card, marginBottom: 16 }}>
          <div style={sectionTitle}>Your Rates vs. Industry Benchmarks</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16 }}>
            {[
              { label: 'Delivery Rate', yours: deliveryRate, benchmark: '95–98%', good: deliveryRate !== '—' && parseFloat(deliveryRate) >= 95, note: 'Source: SendGrid 2024 Email Benchmarks. Government (.gov) servers often have stricter filters, which can lower this.' },
              { label: 'Open Rate', yours: openRate, benchmark: '20–25%', good: openRate !== '—' && parseFloat(openRate) >= 20, note: 'Cold outreach to government IT/public works contacts. Personalized subject lines and known sender names significantly improve this.' },
              { label: 'Click Rate', yours: clickRate, benchmark: '8–12%', good: clickRate !== '—' && parseFloat(clickRate) >= 8, note: 'Calculated as clicks ÷ opens. Only applies if emails contain links. A lower rate here is normal for plain-text sales emails.' },
              { label: 'Bounce Rate', yours: bounceRate, benchmark: '< 2%', good: bounceRate !== '—' && parseFloat(bounceRate) < 2, note: 'Above 5% will trigger SendGrid warnings. Above 10% risks account suspension. Verify bounced addresses immediately.' },
            ].map(m => (
              <div key={m.label} style={{ textAlign: 'center', padding: '14px 8px', background: m.yours === '—' ? '#f8fafc' : m.good ? '#f0fdf4' : '#fef3c7', borderRadius: 10 }}>
                <div style={{ fontSize: 24, fontWeight: 800, color: m.yours === '—' ? '#94a3b8' : m.good ? '#166534' : '#92400e' }}>{m.yours === '—' ? '—' : `${m.yours}%`}</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#475569', marginTop: 4 }}>{m.label}{m.note && <InfoTooltip text={m.note} />}</div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>Benchmark: {m.benchmark}</div>
                {m.yours !== '—' && <div style={{ fontSize: 11, marginTop: 4 }}>{m.good ? '✅ On target' : '⚠️ Below target'}</div>}
              </div>
            ))}
          </div>
        </div>
      </>)}

      {activeTab === 'reps' && (
        <div style={card}>
          <div style={sectionTitle}>Per-Rep Performance — All Time SendGrid Sends</div>
          {(repStats||[]).length === 0 ? <div style={{ color: '#94a3b8', fontSize: 13 }}>No SendGrid sends yet</div> : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                    {MA_REP_COLS.map(c => <SortTh key={c.key} col={c} sorter={sortReps} thStyle={{ ...S.th, whiteSpace: 'nowrap' }} />)}
                  </tr>
                </thead>
                <tbody>
                  {sortReps.apply(repStats, MA_REP_COLS).map((r, i) => (
                    <tr key={r.rep} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#fafbfc' }}>
                      <td style={{ ...S.td, fontWeight: 600, whiteSpace: 'nowrap' }}>{r.rep}</td>
                      <td style={S.td}>{r.sent}</td>
                      <td style={S.td}>{r.delivered}</td>
                      <td style={{ ...S.td, color: r.sent > 0 && (r.delivered/r.sent) >= 0.95 ? '#166534' : '#92400e', fontWeight: 600 }}>{pct(r.delivered, r.sent)}</td>
                      <td style={S.td}>{r.opened}</td>
                      <td style={{ ...S.td, color: r.delivered > 0 && (r.opened/r.delivered) >= 0.20 ? '#166534' : '#92400e', fontWeight: 600 }}>{pct(r.opened, r.delivered)}</td>
                      <td style={S.td}>{r.clicked}</td>
                      <td style={{ ...S.td, fontWeight: 600 }}>{pct(r.clicked, r.opened)}</td>
                      <td style={S.td}>{r.bounced}</td>
                      <td style={{ ...S.td, color: r.bounced > 0 ? '#dc2626' : '#166534', fontWeight: 600 }}>{pct(r.bounced, r.sent)}</td>
                      <td style={{ ...S.td, color: r.spam > 0 ? '#dc2626' : '#64748b', fontWeight: r.spam > 0 ? 700 : 400 }}>{r.spam}</td>
                      <td style={{ ...S.td, color: '#3b82f6', fontWeight: 600 }}>{r.total_opens || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {activeTab === 'opens' && (
        <div style={card}>
          <div style={sectionTitle}>Recently Opened Emails (last 10)</div>
          {(recentOpens||[]).length === 0 ? (
            <div style={{ color: '#94a3b8', fontSize: 13, padding: 32, textAlign: 'center' }}>No opens tracked yet — make sure "Opened" is checked in SendGrid webhook settings.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead><tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                {MA_OPEN_COLS.map(c => <SortTh key={c.key} col={c} sorter={sortOpens} thStyle={S.th} />)}
              </tr></thead>
              <tbody>
                {sortOpens.apply(recentOpens, MA_OPEN_COLS).map((r, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#f0fdf4' }}>
                    <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#166534', fontWeight: 600 }}>{fmtDate(r.opened_at)}</td>
                    <td style={{ ...S.td, fontWeight: 600 }}>{r.recipient_name||'—'}</td>
                    <td style={S.td}>{r.lead_id
                      ? <button onClick={() => navigate(`/leads/${r.lead_id}?tab=email`)} style={maCellLink}>{r.org_name||'—'}</button>
                      : <span style={{ color: '#64748b' }}>{r.org_name||'—'}</span>}</td>
                    <td style={S.td}><a href={`mailto:${r.recipient_email}`} style={{ color: '#3b82f6', textDecoration: 'none' }}>{r.recipient_email}</a></td>
                    <td style={{ ...S.td, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.subject}>{r.subject}</td>
                    <td style={{ ...S.td, color: '#64748b' }}>{r.sent_by_name||'—'}</td>
                    <td style={{ ...S.td, fontWeight: 700, textAlign: 'center' }}>{r.lead_id
                      ? <button onClick={() => navigate(`/leads/${r.lead_id}?tab=email`)} style={{ ...maCellLink, color: '#3b82f6' }}>{r.open_count || 1}</button>
                      : <span style={{ color: '#3b82f6' }}>{r.open_count || 1}</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {activeTab === 'clicks' && (
        <div style={card}>
          <div style={sectionTitle}>Recently Clicked Emails (last 10)</div>
          {(recentClicks||[]).length === 0 ? (
            <div style={{ color: '#94a3b8', fontSize: 13, padding: 32, textAlign: 'center' }}>No clicks tracked yet — make sure "Clicked" is checked in SendGrid webhook settings.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead><tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                {MA_CLICK_COLS.map(c => <SortTh key={c.key} col={c} sorter={sortClicks} thStyle={S.th} />)}
              </tr></thead>
              <tbody>
                {sortClicks.apply(recentClicks, MA_CLICK_COLS).map((r, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#eff6ff' }}>
                    <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#4f46e5', fontWeight: 600 }}>{fmtDate(r.clicked_at)}</td>
                    <td style={{ ...S.td, fontWeight: 600 }}>{r.recipient_name||'—'}</td>
                    <td style={S.td}>{r.lead_id
                      ? <button onClick={() => navigate(`/leads/${r.lead_id}?tab=email`)} style={maCellLink}>{r.org_name||'—'}</button>
                      : <span style={{ color: '#64748b' }}>{r.org_name||'—'}</span>}</td>
                    <td style={S.td}><a href={`mailto:${r.recipient_email}`} style={{ color: '#3b82f6', textDecoration: 'none' }}>{r.recipient_email}</a></td>
                    <td style={{ ...S.td, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.subject}>{r.subject}</td>
                    <td style={{ ...S.td, color: '#64748b' }}>{r.sent_by_name||'—'}</td>
                    <td style={{ ...S.td, fontWeight: 700, textAlign: 'center' }}>{r.lead_id
                      ? <button onClick={() => navigate(`/leads/${r.lead_id}?tab=email`)} style={{ ...maCellLink, color: '#6366f1' }}>{r.click_count || 1}</button>
                      : <span style={{ color: '#6366f1' }}>{r.click_count || 1}</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {activeTab === 'spam' && (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <div style={sectionTitle}>Spam Reports</div>
            {(spamReports||[]).length > 0 && <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 6, padding: '4px 10px', fontSize: 12, color: '#dc2626', fontWeight: 600 }}>⚠️ High spam rates hurt deliverability for everyone</div>}
          </div>
          {(spamReports||[]).length === 0 ? (
            <div style={{ background: '#f0fdf4', borderRadius: 10, padding: 36, textAlign: 'center' }}>
              <div style={{ fontSize: 32 }}>✅</div>
              <div style={{ fontWeight: 700, color: '#166534', fontSize: 15, marginTop: 8 }}>No spam reports</div>
              <div style={{ fontSize: 12, color: '#4ade80', marginTop: 4 }}>Keep personalization high and blast volume low.</div>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead><tr style={{ background: '#fef2f2', borderBottom: '2px solid #fecaca' }}>
                {MA_SPAM_COLS.map(c => <SortTh key={c.key} col={c} sorter={sortSpam} thStyle={S.th} />)}
              </tr></thead>
              <tbody>
                {sortSpam.apply(spamReports, MA_SPAM_COLS).map((r, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#dc2626', fontWeight: 600 }}>{fmtDate(r.spam_reported_at)}</td>
                    <td style={{ ...S.td, fontWeight: 600 }}>{r.recipient_name||'—'}</td>
                    <td style={S.td}>{r.lead_id
                      ? <button onClick={() => navigate(`/leads/${r.lead_id}?tab=email`)} style={maCellLink}>{r.org_name||'—'}</button>
                      : <span style={{ color: '#64748b' }}>{r.org_name||'—'}</span>}</td>
                    <td style={S.td}><a href={`mailto:${r.recipient_email}`} style={{ color: '#3b82f6', textDecoration: 'none' }}>{r.recipient_email}</a></td>
                    <td style={{ ...S.td, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.subject}>{r.subject}</td>
                    <td style={{ ...S.td, color: '#64748b' }}>{r.sent_by_name||'—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {activeTab === 'bounces' && (
        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
            <div>
              <div style={sectionTitle}>All Email Bounces — All Reps</div>
              <div style={{ fontSize: 12, color: '#64748b', marginTop: -10 }}>{bounces.length} total · {bounces.filter(b => b.bounce_status === 'dropped').length} dropped</div>
            </div>
            <input
              style={{ ...S.input, width: 260, marginBottom: 0 }}
              placeholder="Search name, email, org, rep…"
              value={bounceSearch}
              onChange={e => setBounceSearch(e.target.value)}
            />
          </div>
          {filteredBounces.length === 0 ? (
            <div style={{ background: '#f0fdf4', borderRadius: 10, padding: 36, textAlign: 'center' }}>
              <div style={{ fontSize: 32 }}>{bounceSearch ? '🔍' : '✅'}</div>
              <div style={{ fontWeight: 700, color: '#166534', fontSize: 15, marginTop: 8 }}>{bounceSearch ? 'No results' : 'No bounces recorded'}</div>
              <div style={{ fontSize: 12, color: '#4ade80', marginTop: 4 }}>{bounceSearch ? 'Try a different search.' : 'All tracked emails have delivered successfully so far.'}</div>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#fef2f2', borderBottom: '2px solid #fecaca' }}>
                    {MA_BOUNCE_COLS.map(c => <SortTh key={c.key} col={c} sorter={sortBounces} thStyle={{ ...S.th, whiteSpace: 'nowrap' }} />)}
                  </tr>
                </thead>
                <tbody>
                  {sortBounces.apply(filteredBounces, MA_BOUNCE_COLS).map((b, i) => (
                    <tr key={b.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#fffbfb' }}>
                      <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#dc2626', fontWeight: 600 }}>{fmtBounceDate(b.bounced_at)}</td>
                      <td style={{ ...S.td, whiteSpace: 'nowrap', fontWeight: 600 }}>
                        {b.resolved_lead_id
                          ? <button onClick={() => navigate(`/leads/${b.resolved_lead_id}`)} style={{ background: 'none', border: 'none', color: '#1e3a5f', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline', padding: 0, fontSize: 13 }}>{b.recipient_name || '—'}</button>
                          : (b.recipient_name || '—')}
                      </td>
                      <td style={{ ...S.td, color: '#475569', maxWidth: 160 }}>{b.org_name || '—'}</td>
                      <td style={{ ...S.td, whiteSpace: 'nowrap' }}><a href={`mailto:${b.recipient_email}`} style={{ color: '#3b82f6', textDecoration: 'none' }}>{b.recipient_email}</a></td>
                      <td style={{ ...S.td, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={b.subject}>{b.subject}</td>
                      <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#64748b' }}>{b.sent_by_name || b.sent_by || '—'}</td>
                      <td style={{ ...S.td, maxWidth: 240, color: '#dc2626', fontSize: 12 }} title={b.bounce_reason}>{(b.bounce_reason || '').slice(0, 60)}{(b.bounce_reason||'').length > 60 ? '…' : ''}</td>
                      <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#94a3b8', fontSize: 12 }}>{fmtBounceDate(b.sent_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div style={{ marginTop: 16, padding: '10px 14px', background: '#f8fafc', borderRadius: 8, fontSize: 12, color: '#64748b', border: '1px solid #e2e8f0' }}>
            💡 <strong>Next steps:</strong> Verify the email address, try phone or LinkedIn, or remove invalid contacts. Government (.gov) servers often block cold outreach regardless of address validity.
          </div>
        </div>
      )}
    </div>
  );
}

// ─── QUOTES PAGE ──────────────────────────────────────────────────────────────

const PRICING_PRESETS = [
  { name: 'CivicBot SR — Email Plan (Starter)', defaultMonthly: 200, defaultAnnual: 2000 },
  { name: 'CivicBot SR — Email Plan (Growth)', defaultMonthly: 400, defaultAnnual: 4000 },
  { name: 'CivicBot SR — Email Plan (Professional)', defaultMonthly: 600, defaultAnnual: 6000 },
  { name: 'CivicBot SR — Cityworks Plan (Starter)', defaultMonthly: 250, defaultAnnual: 2500 },
  { name: 'CivicBot SR — Cityworks Plan (Growth)', defaultMonthly: 500, defaultAnnual: 5000 },
  { name: 'CivicBot SR — Cityworks Plan (Professional)', defaultMonthly: 750, defaultAnnual: 7500 },
  { name: 'CivicBot Answers Add-on (Starter)', defaultMonthly: 150, defaultAnnual: 1500 },
  { name: 'CivicBot Answers Add-on (Growth)', defaultMonthly: 200, defaultAnnual: 2000 },
  { name: 'CivicBot Answers Add-on (Professional)', defaultMonthly: 300, defaultAnnual: 3000 },
  { name: 'Custom / Other', defaultMonthly: 0, defaultAnnual: 0 },
];

function fmtCurrency(n) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n || 0);
}

function fmtDate(d) {
  if (!d) return '';
  return new Date(d + 'Z').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function termLabel(length, unit) {
  const l = parseInt(length) || 1;
  if (unit === 'month') return l === 1 ? '1 Month' : `${l} Months`;
  return l === 1 ? '1 Year' : `${l} Years`;
}

// Build and open the PDF print window
function openQuotePDF(quote, repName) {
  const billingLabel = quote.billing_period === 'annual' ? 'Annual' : 'Monthly';
  const term = termLabel(quote.term_length, quote.term_unit);
  const lineItems = Array.isArray(quote.lineItems) ? quote.lineItems : (JSON.parse(quote.line_items || '[]'));
  const today = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  const contractDate = fmtDate(quote.created_at) || today;
  const validThru = (() => {
    const d = new Date(quote.created_at + 'Z');
    d.setDate(d.getDate() + 30);
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  })();

  // Compute term dates
  const startDate = (quote.start_date || quote.startDate)
    ? new Date(quote.start_date || quote.startDate)
    : new Date();
  const endDate = new Date(startDate);
  if (quote.term_unit === 'month') endDate.setMonth(endDate.getMonth() + (parseInt(quote.term_length) || 1));
  else endDate.setFullYear(endDate.getFullYear() + (parseInt(quote.term_length) || 1));
  const fmtD = (d) => d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

  // Line items HTML
  const liRows = lineItems.map(item => `
    <tr>
      <td style="padding:8px 12px; border-bottom:1px solid #e2e8f0; font-size:13px;">${item.name || ''}</td>
      <td style="padding:8px 12px; border-bottom:1px solid #e2e8f0; font-size:13px; color:#475569;">${item.description || ''}</td>
      <td style="padding:8px 12px; border-bottom:1px solid #e2e8f0; font-size:13px; text-align:center;">${item.quantity || 1}</td>
      <td style="padding:8px 12px; border-bottom:1px solid #e2e8f0; font-size:13px; text-align:right;">${fmtCurrency(item.unit_price)}</td>
      <td style="padding:8px 12px; border-bottom:1px solid #e2e8f0; font-size:13px; text-align:right; font-weight:600;">${fmtCurrency(item.amount)}</td>
    </tr>`).join('');

  const discountRow = (quote.discount_amount > 0) ? `
    <tr>
      <td colspan="4" style="padding:6px 12px; text-align:right; font-size:13px; color:#64748b;">Discount${quote.discount_pct > 0 ? ` (${quote.discount_pct}%)` : ''}:</td>
      <td style="padding:6px 12px; text-align:right; font-size:13px; color:#dc2626;">-${fmtCurrency(quote.discount_amount)}</td>
    </tr>` : '';

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>CivicBot Quote ${quote.quote_number} v${quote.version}</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Georgia', serif; color: #1e293b; background: #fff; font-size: 13px; line-height: 1.6; }
  .page { max-width: 780px; margin: 0 auto; padding: 40px 48px; }
  h1 { font-size: 22px; font-weight: 700; color: #0f172a; }
  h2 { font-size: 15px; font-weight: 700; color: #1e3a5f; margin-bottom: 6px; }
  h3 { font-size: 13px; font-weight: 700; color: #334155; margin-bottom: 4px; }
  p { margin-bottom: 10px; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 3px solid #1e3a5f; padding-bottom: 20px; margin-bottom: 28px; }
  .header-left { display: flex; align-items: center; gap: 14px; }
  .header-right { text-align: right; font-size: 11px; color: #475569; line-height: 1.8; }
  .quote-badge { background: #1e3a5f; color: #fff; padding: 4px 12px; border-radius: 4px; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; display: inline-block; margin-bottom: 4px; }
  .parties { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 28px; }
  .party-box { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px; }
  .party-box .label { font-size: 10px; font-weight: 700; color: #94a3b8; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 6px; }
  .party-name { font-size: 15px; font-weight: 700; color: #0f172a; margin-bottom: 4px; }
  .party-detail { font-size: 12px; color: #475569; line-height: 1.7; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
  table th { background: #1e3a5f; color: #fff; padding: 8px 12px; font-size: 11px; font-weight: 700; text-align: left; letter-spacing: 0.3px; }
  table th:last-child, table th:nth-child(3), table th:nth-child(4) { text-align: right; }
  table th:nth-child(3) { text-align: center; }
  .total-row { background: #f0f9ff; }
  .total-row td { padding: 10px 12px; font-size: 15px; font-weight: 700; color: #1e3a5f; border-top: 2px solid #1e3a5f; }
  .section { margin-bottom: 24px; }
  .section-title { font-size: 12px; font-weight: 700; color: #94a3b8; letter-spacing: 1px; text-transform: uppercase; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px; margin-bottom: 12px; }
  .legal p { font-size: 11.5px; color: #334155; margin-bottom: 8px; text-align: justify; }
  .legal ol { padding-left: 20px; font-size: 11.5px; color: #334155; }
  .legal ol li { margin-bottom: 8px; }
  .sig-block { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; margin-top: 36px; padding-top: 24px; border-top: 2px solid #e2e8f0; }
  .sig-line { border-top: 1px solid #334155; margin-top: 48px; margin-bottom: 4px; }
  .sig-label { font-size: 11px; color: #475569; }
  .sig-name { font-size: 13px; font-weight: 700; margin-top: 2px; }
  .sig-title { font-size: 11px; color: #64748b; }
  .watermark-draft { display: none; }
  .notes-box { background: #fffbeb; border-left: 4px solid #f59e0b; padding: 12px 16px; border-radius: 4px; font-size: 12px; color: #78350f; }
  .version-badge { font-size: 10px; background: #e0f2fe; color: #0369a1; padding: 2px 8px; border-radius: 10px; font-weight: 700; vertical-align: middle; margin-left: 8px; }
  @media print {
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .page { padding: 24px 32px; }
    .no-print { display: none !important; }
  }
</style>
</head>
<body>
<div class="page">

  <!-- Header -->
  <div class="header">
    <div class="header-left">
      <img src="${CENTRICITY_LOGO_DATA_URI}" alt="Centricity GIS" style="height:52px; width:auto;" />
      <div>
        <div style="font-size:11px; color:#64748b; font-weight:600; letter-spacing:0.5px;">CIVICBOT · A CENTRICITY GIS PRODUCT</div>
        <div style="font-size:22px; font-weight:800; color:#1e3a5f; line-height:1;">Software Subscription</div>
        <div style="font-size:13px; color:#475569;">Proposal &amp; Service Agreement</div>
      </div>
    </div>
    <div class="header-right">
      <div class="quote-badge">QUOTE ${quote.quote_number} <span class="version-badge">v${quote.version}</span></div>
      <div style="margin-top:6px;"><strong>Prepared:</strong> ${contractDate}</div>
      <div><strong>Start Date:</strong> ${fmtD(startDate)}</div>
      <div><strong>Valid Through:</strong> ${validThru}</div>
      <div><strong>Billing:</strong> ${billingLabel}</div>
      <div><strong>Term:</strong> ${term}</div>
      ${repName ? `<div style="margin-top:4px;"><strong>Rep:</strong> ${repName}</div>` : ''}
    </div>
  </div>

  <!-- Parties -->
  <div class="parties">
    <div class="party-box">
      <div class="label">Customer ("Client")</div>
      <div class="party-name">${quote.city_name || ''}</div>
      <div class="party-detail">
        ${quote.contact_name ? `${quote.contact_name}${quote.contact_title ? ', ' + quote.contact_title : ''}<br>` : ''}
        ${quote.city_address ? quote.city_address + '<br>' : ''}
        ${quote.city_city ? quote.city_city + ', ' : ''}${[quote.city_state, quote.city_zip].filter(Boolean).join(' ')}${(quote.city_city || quote.city_state || quote.city_zip) ? '<br>' : ''}
        ${quote.contact_email ? quote.contact_email + '<br>' : ''}
        ${quote.contact_phone ? quote.contact_phone : ''}
      </div>
    </div>
    <div class="party-box">
      <div class="label">Service Provider ("Centricity GIS")</div>
      <div class="party-name">Centricity GIS, LLC</div>
      <div class="party-detail">
        Brandon Wright, President<br>
        10659 N Sahalee St<br>
        Cedar Hills, UT 84062<br>
        bwright@centricitygis.com<br>
        centricitygis.com
      </div>
    </div>
  </div>

  <!-- Services & Pricing -->
  <div class="section">
    <div class="section-title">Services &amp; Pricing</div>
    <table>
      <thead>
        <tr>
          <th style="width:30%;">Service</th>
          <th>Description</th>
          <th style="width:8%; text-align:center;">Qty</th>
          <th style="width:14%; text-align:right;">Unit Price</th>
          <th style="width:14%; text-align:right;">Amount</th>
        </tr>
      </thead>
      <tbody>
        ${liRows}
        ${discountRow}
        <tr class="total-row">
          <td colspan="4" style="text-align:right;">Total (${billingLabel}):</td>
          <td style="text-align:right;">${fmtCurrency(quote.total)}</td>
        </tr>
      </tbody>
    </table>
    <p style="font-size:11px; color:#64748b; margin-top:6px;">All amounts in USD. Prices are for the ${billingLabel.toLowerCase()} billing period specified above.</p>
  </div>

  ${quote.notes ? `<div class="section"><div class="section-title">Quote Notes</div><div class="notes-box">${quote.notes}</div></div>` : ''}

  <!-- Legal Agreement -->
  <div class="section legal">
    <div class="section-title">CivicBot SaaS Subscription Agreement</div>

    <p>This CivicBot Software-as-a-Service Subscription Agreement (the <strong>"Agreement"</strong>) is entered into as of ${fmtD(startDate)} (the <strong>"Effective Date"</strong>) by and between <strong>Centricity GIS, LLC</strong>, a Utah limited liability company (<strong>"Provider"</strong>), and the Client identified above (<strong>"Client"</strong>).</p>

    <p><strong>RECITALS.</strong> Provider has developed and operates a cloud-based, AI-powered civic service request and resident engagement platform marketed under the brand name "CivicBot" (the <strong>"Platform"</strong>); Client desires to obtain a subscription to the Platform for use in connection with Client's municipal operations; and Provider is willing to grant such subscription on the terms and conditions set forth herein.</p>

    <p>NOW, THEREFORE, in consideration of the mutual covenants and agreements set forth herein, and for other good and valuable consideration, the receipt and sufficiency of which are hereby acknowledged, the parties agree as follows:</p>

    <ol>
      <li><strong>Subscription Grant.</strong> Subject to the terms of this Agreement and Client's timely payment of all fees, Provider grants Client a limited, non-exclusive, non-transferable, non-sublicensable right to access and use the Platform solely for Client's internal municipal service request intake and resident communication purposes during the Subscription Term. This right is limited to the service tier(s), feature set(s), and service request volume limits specified in the pricing schedule above.</li>

      <li><strong>Subscription Term &amp; Renewal.</strong> The initial Subscription Term shall commence on the Effective Date and continue for <strong>${term}</strong> (the <strong>"Initial Term"</strong>), corresponding to the period ${fmtD(startDate)} through ${fmtD(endDate)}. Unless either party provides written notice of non-renewal at least thirty (30) days prior to the end of the then-current term, this Agreement shall automatically renew for successive terms of equal length at the pricing in effect at the time of renewal. Provider shall provide at least thirty (30) days' advance written notice of any pricing changes prior to a renewal term.</li>

      <li><strong>Fees &amp; Payment.</strong> Client shall pay Provider the subscription fees set forth in the pricing schedule above. For annual billing, the full annual fee is due and payable at the commencement of each Subscription Term or renewal. For monthly billing, fees are due and payable on the same day each month as the Effective Date. All fees are non-refundable. No refunds will be issued for any reason, including early termination, partial use, or cancellation. Provider reserves the right to suspend access to the Platform upon any overdue payment that remains uncured for more than fifteen (15) days after written notice to Client. All amounts are exclusive of any applicable taxes, which Client shall be solely responsible for remitting.</li>

      <li><strong>Scope of Services.</strong> The Platform includes the services described in the applicable pricing line items above. Additional services, integrations, or features beyond the subscribed tier may be purchased at Provider's then-current rates. Provider may update, modify, or discontinue features of the Platform from time to time; however, Provider will not materially reduce the core service request intake functionality during a paid Subscription Term without Client's consent or a corresponding adjustment in fees.</li>

      <li><strong>Acceptable Use.</strong> Client shall use the Platform only for lawful municipal operations and in compliance with all applicable federal, state, and local laws and regulations. Client shall not: (a) reverse engineer, decompile, or disassemble the Platform or any portion thereof; (b) resell or sublicense access to the Platform to any third party; (c) introduce malicious code, bots, or automated scraping tools; (d) use the Platform in a manner that materially disrupts the Provider's infrastructure; or (e) remove or obscure any proprietary notices.</li>

      <li><strong>Data Ownership &amp; Privacy.</strong> As between the parties, Client owns all resident data and service request data submitted through the Platform (<strong>"Client Data"</strong>). Provider processes Client Data solely to deliver the contracted services and as described in Provider's Privacy Policy. Provider will not sell or disclose Client Data to third parties except as required by law or necessary to provide the services (e.g., CMMS integrations configured by Client). Provider implements industry-standard technical and administrative safeguards to protect Client Data, including encryption at rest and in transit.</li>

      <li><strong>Intellectual Property.</strong> As between the parties, Provider retains all right, title, and interest in and to the Platform, including all underlying software, algorithms, AI models, user interface designs, and documentation (collectively, <strong>"Provider IP"</strong>). No rights in Provider IP are granted to Client except the limited subscription license set forth in Section 1. Client retains all right, title, and interest in Client Data and Client's pre-existing materials. Any feedback, suggestions, or enhancement requests provided by Client may be used by Provider to improve the Platform without obligation to Client.</li>

      <li><strong>Limited Warranty &amp; Remedies.</strong> Provider warrants that the Platform will perform materially in accordance with its published documentation under normal use conditions. Provider's sole obligation and Client's exclusive remedy for a breach of this warranty is Provider's use of commercially reasonable efforts to correct the non-conformance within a reasonable time after receiving written notice. EXCEPT AS EXPRESSLY SET FORTH HEREIN, THE PLATFORM IS PROVIDED "AS IS" AND PROVIDER DISCLAIMS ALL OTHER WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</li>

      <li><strong>Limitation of Liability.</strong> IN NO EVENT SHALL EITHER PARTY BE LIABLE TO THE OTHER FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES (INCLUDING LOST PROFITS OR DATA) ARISING OUT OF OR RELATED TO THIS AGREEMENT, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. PROVIDER'S TOTAL CUMULATIVE LIABILITY TO CLIENT FOR ANY CLAIMS ARISING UNDER OR RELATED TO THIS AGREEMENT SHALL NOT EXCEED THE TOTAL SUBSCRIPTION FEES PAID BY CLIENT DURING THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE CLAIM. THE FOREGOING LIMITATIONS SHALL APPLY REGARDLESS OF THE FORM OF ACTION.</li>

      <li><strong>Termination.</strong> Either party may terminate this Agreement for cause upon thirty (30) days' written notice if the other party materially breaches this Agreement and fails to cure such breach within the notice period. Upon any termination or expiration: (a) all subscription rights granted herein shall immediately cease; (b) each party shall promptly return or destroy the other party's Confidential Information upon request; and (c) Client may request an export of Client Data within thirty (30) days of termination, after which Provider has no obligation to retain Client Data.</li>

      <li><strong>Confidentiality.</strong> Each party agrees to maintain the confidentiality of the other party's non-public business information disclosed under this Agreement (<strong>"Confidential Information"</strong>) using at least the same degree of care it uses to protect its own confidential information (but no less than reasonable care), and not to disclose such information to any third party without prior written consent, except to employees or contractors with a need to know who are bound by equivalent confidentiality obligations. This obligation shall survive termination of this Agreement for three (3) years.</li>

      <li><strong>Force Majeure.</strong> Neither party shall be liable for delays or failures in performance resulting from circumstances beyond the affected party's reasonable control, including but not limited to acts of God, natural disasters, government actions, internet or telecommunications disruptions, or third-party service outages, provided the affected party provides prompt notice and uses commercially reasonable efforts to resume performance.</li>

      <li><strong>Governing Law &amp; Dispute Resolution.</strong> This Agreement shall be governed by and construed in accordance with the laws of the State of Utah, without regard to conflicts of law principles. Any dispute arising out of or related to this Agreement that the parties are unable to resolve informally shall be submitted to binding arbitration in Salt Lake County, Utah, conducted by a single arbitrator under the commercial rules of the American Arbitration Association. The prevailing party in any dispute shall be entitled to recover its reasonable attorneys' fees and costs.</li>

      <li><strong>Marketing and Brand Recognition.</strong> Client acknowledges that Centricity GIS, LLC may benefit from public recognition of its technology partnerships. To support this, Client agrees that upon request by Provider, Client will make reasonable good-faith efforts to display the CivicBot name and/or a link to <a href="https://civicbot.centricitygis.com" style="color:#1e3a5f;">https://civicbot.centricitygis.com</a> on Client's public-facing website (such as on a footer, vendor acknowledgment page, or resident services page). Such display is subject to Client's applicable policies and approval processes. Provider will not require placement that conflicts with Client's branding guidelines or governing body requirements. Either party may mutually agree in writing to modify or waive this provision.</li>

      <li><strong>General Provisions.</strong> This Agreement constitutes the entire agreement between the parties with respect to the subject matter hereof and supersedes all prior negotiations, representations, and understandings. No amendment shall be valid unless made in writing and signed by authorized representatives of both parties. If any provision is found unenforceable, the remaining provisions shall continue in full force. Neither party may assign this Agreement without the other's written consent, except that Provider may assign this Agreement in connection with a merger, acquisition, or sale of substantially all of its assets. Notices shall be delivered by email with confirmation to the addresses set forth above, effective upon receipt.</li>
    </ol>
  </div>

  <!-- Signature Blocks -->
  <div class="sig-block">
    <div>
      <div style="font-size:12px; font-weight:700; color:#1e3a5f; margin-bottom:8px;">CENTRICITY GIS, LLC (Provider)</div>
      <div style="font-family: 'Brush Script MT', 'Segoe Script', cursive; font-size:32px; color:#1e3a5f; line-height:1.1; margin-top:8px; margin-bottom:4px;">Brandon Wright</div>
      <div class="sig-line"></div>
      <div class="sig-name">Brandon Wright</div>
      <div class="sig-title">President, Centricity GIS, LLC</div>
      <div style="font-size:11px; color:#334155; margin-top:4px;">Date: ${contractDate}</div>
    </div>
    <div>
      <div style="font-size:12px; font-weight:700; color:#1e3a5f; margin-bottom:8px;">CLIENT (${quote.city_name || 'Customer'})</div>
      <div style="height:42px;"></div>
      <div class="sig-line"></div>
      <div class="sig-name">${quote.contact_name || '_____________________________'}</div>
      <div class="sig-title">${quote.contact_title || 'Title: ___________________________'}</div>
      <div style="font-size:11px; color:#94a3b8; margin-top:4px;">Date: ___________________________</div>
    </div>
  </div>

  <div style="margin-top:32px; padding-top:16px; border-top:1px solid #e2e8f0; font-size:10px; color:#94a3b8; text-align:center;">
    CivicBot is a product of Centricity GIS, LLC · 10659 N Sahalee St, Cedar Hills, UT 84062 · centricitygis.com<br>
    Quote ${quote.quote_number} · Version ${quote.version} · Generated ${today}
  </div>

</div>
<script>window.onload = function() { window.print(); }</script>
</body>
</html>`;

  const w = window.open('', '_blank', 'width=900,height=700');
  if (w) { w.document.write(html); w.document.close(); }
}

function QuoteFormModal({ quote, onSave, onClose, defaultBillingPeriod }) {
  const { token } = useAuth();
  const isEdit = !!quote;
  const DRAFT_KEY_INIT = 'civicbot_quote_draft';
  const [draftRestored, setDraftRestored] = React.useState(false);
  const [form, setForm] = useState(() => {
    if (!quote) {
      try {
        const saved = localStorage.getItem(DRAFT_KEY_INIT);
        if (saved) { const d = JSON.parse(saved); if (d.form) { setDraftRestored(true); return d.form; } }
      } catch(e) {}
    }
    return {
    cityName: quote?.city_name || '',
    contactName: quote?.contact_name || '',
    contactTitle: quote?.contact_title || '',
    contactEmail: quote?.contact_email || '',
    contactPhone: quote?.contact_phone || '',
    cityAddress: quote?.city_address || '',
    cityCity: quote?.city_city || '',
    cityState: quote?.city_state || '',
    cityZip: quote?.city_zip || '',
    billingPeriod: quote?.billing_period || defaultBillingPeriod || 'annual',
    termLength: quote?.term_length || 1,
    termUnit: quote?.term_unit || 'year',
    startDate: quote?.start_date || '',
    notes: quote?.notes || '',
    internalNotes: quote?.internal_notes || '',
    changeNotes: '',
  };
  });
  const [lineItems, setLineItems] = useState(() => {
    if (!quote) {
      try {
        const saved = localStorage.getItem('civicbot_quote_draft');
        if (saved) { const d = JSON.parse(saved); if (d.lineItems?.length) return d.lineItems; }
      } catch(e) {}
    }
    const li = Array.isArray(quote?.lineItems) ? quote.lineItems : (quote?.line_items ? JSON.parse(quote.line_items) : []);
    return li.length ? li : [{ name: '', description: '', quantity: 1, unit_price: 0, amount: 0 }];
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const DRAFT_KEY = 'civicbot_quote_draft';
  const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // Draft auto-save (new quotes only)
  const draftTimerRef = React.useRef(null);
  const [draftSaved, setDraftSaved] = React.useState(false);
  React.useEffect(() => {
    if (isEdit) return;
    clearTimeout(draftTimerRef.current);
    draftTimerRef.current = setTimeout(() => {
      try {
        localStorage.setItem(DRAFT_KEY, JSON.stringify({ form, lineItems, savedAt: new Date().toISOString() }));
        setDraftSaved(true);
        setTimeout(() => setDraftSaved(false), 2000);
      } catch(e) {}
    }, 800);
    return () => clearTimeout(draftTimerRef.current);
  }, [form, lineItems, isEdit]);

  function updateLI(idx, key, val) {
    setLineItems(items => items.map((it, i) => {
      if (i !== idx) return it;
      const updated = { ...it, [key]: val };
      if (key === 'quantity' || key === 'unit_price') {
        updated.amount = (parseFloat(updated.quantity) || 0) * (parseFloat(updated.unit_price) || 0);
      }
      if (key === 'amount') updated.amount = parseFloat(val) || 0;
      return updated;
    }));
  }

  function applyPreset(idx, presetName) {
    const preset = PRICING_PRESETS.find(p => p.name === presetName);
    if (!preset) return;
    const price = form.billingPeriod === 'annual' ? preset.defaultAnnual : preset.defaultMonthly;
    setLineItems(items => items.map((it, i) => {
      if (i !== idx) return it;
      const qty = parseFloat(it.quantity) || 1;
      return { ...it, name: preset.name, unit_price: price, amount: qty * price };
    }));
  }

  function addLine() {
    setLineItems(items => [...items, { name: '', description: '', quantity: 1, unit_price: 0, amount: 0 }]);
  }
  function removeLine(idx) {
    setLineItems(items => items.filter((_, i) => i !== idx));
  }

  const subtotal = lineItems.reduce((s, it) => s + (parseFloat(it.amount) || 0), 0);
  const total = subtotal; // discount handled separately in future

  async function handleSave() {
    if (!form.cityName.trim()) { setError('City name is required.'); return; }
    if (isEdit && !form.changeNotes.trim()) { setError('Please describe what changed in this version.'); return; }
    setSaving(true); setError('');
    try {
      const body = { ...form, lineItems, subtotal, discountPct: 0, discountAmount: 0, total };
      let url, method;
      if (isEdit) {
        url = `${API}/api/sales/quotes/${quote.id}/version`;
        method = 'POST';
        body.changeNotes = form.changeNotes;
      } else {
        url = `${API}/api/sales/quotes`;
        method = 'POST';
      }
      const r = await fetch(url, { method, headers: { ...apiHeaders(token), 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Save failed');
      try { localStorage.removeItem('civicbot_quote_draft'); } catch(e) {}
      onSave(d);
    } catch (e) { setError(e.message); } finally { setSaving(false); }
  }

  const inp = { border: '1px solid #e2e8f0', borderRadius: 6, padding: '7px 10px', fontSize: 13, width: '100%', outline: 'none' };
  const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '20px 16px', overflowY: 'auto' }}>
      <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 820, padding: 28, position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#94a3b8' }}>✕</button>
        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#0f172a', marginBottom: draftRestored ? 10 : 20 }}>{isEdit ? `New Version — ${quote.quote_number}` : '📄 New Quote'}</h2>

        {/* Draft banner (new quotes only) */}
        {!isEdit && draftRestored && (
          <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '8px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, fontSize: 13 }}>
            <span style={{ color: '#92400e' }}>📝 Draft restored from your last session</span>
            <button onClick={() => { try { localStorage.removeItem('civicbot_quote_draft'); } catch(e) {} setDraftRestored(false); setForm({ cityName:'', contactName:'', contactTitle:'', contactEmail:'', contactPhone:'', cityAddress:'', cityCity:'', cityState:'', cityZip:'', billingPeriod: defaultBillingPeriod||'annual', termLength:1, termUnit:'year', startDate:'', notes:'', internalNotes:'', changeNotes:'' }); setLineItems([{ name:'', description:'', quantity:1, unit_price:0, amount:0 }]); }} style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>✕ Discard draft</button>
          </div>
        )}
        {!isEdit && draftSaved && !draftRestored && (
          <div style={{ fontSize: 11, color: '#16a34a', textAlign: 'right', marginTop: -16, marginBottom: 10 }}>✓ Draft saved</div>
        )}

        {/* Billing toggle */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20, background: '#f1f5f9', borderRadius: 8, padding: 4, width: 'fit-content' }}>
          {['monthly', 'annual'].map(bp => (
            <button key={bp} onClick={() => setF('billingPeriod', bp)} style={{ padding: '6px 20px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: 13, background: form.billingPeriod === bp ? '#1e3a5f' : 'transparent', color: form.billingPeriod === bp ? '#fff' : '#64748b', transition: 'all 0.15s' }}>
              {bp === 'annual' ? 'Annual' : 'Monthly'}
            </button>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
          <div style={{ gridColumn: '1/-1' }}>
            <label style={lbl}>City / Organization Name *</label>
            <input style={inp} value={form.cityName} onChange={e => setF('cityName', e.target.value)} placeholder="e.g. City of Lincoln, CA" />
          </div>
          <div>
            <label style={lbl}>Contact Name</label>
            <input style={inp} value={form.contactName} onChange={e => setF('contactName', e.target.value)} placeholder="First Last" />
          </div>
          <div>
            <label style={lbl}>Title</label>
            <input style={inp} value={form.contactTitle} onChange={e => setF('contactTitle', e.target.value)} placeholder="IT Director" />
          </div>
          <div>
            <label style={lbl}>Contact Email</label>
            <input style={inp} value={form.contactEmail} onChange={e => setF('contactEmail', e.target.value)} placeholder="email@city.gov" />
          </div>
          <div>
            <label style={lbl}>Contact Phone</label>
            <input style={inp} value={form.contactPhone} onChange={e => setF('contactPhone', e.target.value)} placeholder="(555) 555-5555" />
          </div>
          <div>
            <label style={lbl}>Street Address</label>
            <input style={inp} value={form.cityAddress} onChange={e => setF('cityAddress', e.target.value)} placeholder="100 City Hall Way" />
          </div>
          <div>
            <label style={lbl}>City</label>
            <input style={inp} value={form.cityCity} onChange={e => setF('cityCity', e.target.value)} placeholder="Lincoln" />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 8 }}>
            <div>
              <label style={lbl}>State</label>
              <input style={inp} value={form.cityState} onChange={e => setF('cityState', e.target.value)} placeholder="CA" />
            </div>
            <div>
              <label style={lbl}>ZIP</label>
              <input style={inp} value={form.cityZip} onChange={e => setF('cityZip', e.target.value)} placeholder="95648" />
            </div>
          </div>
          <div>
            <label style={lbl}>Contract Term</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <input type="number" min="1" style={{ ...inp, width: 80 }} value={form.termLength} onChange={e => setF('termLength', parseInt(e.target.value) || 1)} />
              <select style={{ ...inp, width: 100 }} value={form.termUnit} onChange={e => setF('termUnit', e.target.value)}>
                <option value="year">Year(s)</option>
                <option value="month">Month(s)</option>
              </select>
            </div>
          </div>
          <div>
            <label style={lbl}>Contract Start Date</label>
            <input type="date" style={inp} value={form.startDate} onChange={e => setF('startDate', e.target.value)} />
          </div>
        </div>

        {/* Line Items */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: '#374151', marginBottom: 8 }}>Line Items</div>
          {lineItems.map((item, idx) => (
            <div key={idx} style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 12, marginBottom: 8, background: '#fafafa' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 8, marginBottom: 8 }}>
                <select style={inp} value={item.name} onChange={e => { setLineItems(items => items.map((it, i) => i === idx ? { ...it, name: e.target.value } : it)); applyPreset(idx, e.target.value); }}>
                  <option value="">— Select or type below —</option>
                  {PRICING_PRESETS.map(p => <option key={p.name} value={p.name}>{p.name}</option>)}
                </select>
                {lineItems.length > 1 && <button onClick={() => removeLine(idx)} style={{ background: '#fee2e2', border: 'none', borderRadius: 6, padding: '0 10px', cursor: 'pointer', color: '#dc2626', fontWeight: 700 }}>✕</button>}
              </div>
              <div style={{ marginBottom: 8 }}>
                <input style={inp} value={item.name} onChange={e => updateLI(idx, 'name', e.target.value)} placeholder="Product / service name" />
              </div>
              <div style={{ marginBottom: 8 }}>
                <input style={inp} value={item.description} onChange={e => updateLI(idx, 'description', e.target.value)} placeholder="Description (optional)" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr 1fr', gap: 8 }}>
                <div>
                  <label style={{ ...lbl, fontSize: 11 }}>Qty</label>
                  <input type="number" min="1" style={inp} value={item.quantity} onChange={e => updateLI(idx, 'quantity', e.target.value)} />
                </div>
                <div>
                  <label style={{ ...lbl, fontSize: 11 }}>Unit Price</label>
                  <input type="number" min="0" step="0.01" style={inp} value={item.unit_price} onChange={e => updateLI(idx, 'unit_price', e.target.value)} />
                </div>
                <div>
                  <label style={{ ...lbl, fontSize: 11 }}>Amount</label>
                  <input type="number" min="0" step="0.01" style={{ ...inp, fontWeight: 700 }} value={item.amount} onChange={e => updateLI(idx, 'amount', e.target.value)} />
                </div>
              </div>
            </div>
          ))}
          <button onClick={addLine} style={{ background: '#eff6ff', border: '1px dashed #93c5fd', borderRadius: 8, padding: '8px 16px', fontSize: 13, cursor: 'pointer', color: '#1d4ed8', fontWeight: 600, width: '100%' }}>+ Add Line Item</button>
        </div>

        {/* Total summary */}
        <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8, padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <span style={{ fontWeight: 700, fontSize: 14, color: '#1e3a5f' }}>Total ({form.billingPeriod === 'annual' ? 'Annual' : 'Monthly'})</span>
          <span style={{ fontWeight: 800, fontSize: 20, color: '#1e3a5f' }}>{fmtCurrency(total)}</span>
        </div>

        {/* Notes */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
          <div>
            <label style={lbl}>Quote Notes <span style={{ fontWeight: 400, color: '#94a3b8' }}>(visible on PDF)</span></label>
            <textarea style={{ ...inp, minHeight: 72, resize: 'vertical' }} value={form.notes} onChange={e => setF('notes', e.target.value)} placeholder="Additional terms, notes for client..." />
          </div>
          <div>
            <label style={lbl}>Internal Notes <span style={{ fontWeight: 400, color: '#94a3b8' }}>(not on PDF)</span></label>
            <textarea style={{ ...inp, minHeight: 72, resize: 'vertical' }} value={form.internalNotes} onChange={e => setF('internalNotes', e.target.value)} placeholder="Internal rep notes..." />
          </div>
        </div>

        {isEdit && (
          <div style={{ marginBottom: 16 }}>
            <label style={lbl}>What changed in this version? *</label>
            <input style={inp} value={form.changeNotes} onChange={e => setF('changeNotes', e.target.value)} placeholder="e.g. Updated pricing, changed term to 2 years..." />
          </div>
        )}

        {error && <div style={{ background: '#fee2e2', color: '#dc2626', padding: '8px 12px', borderRadius: 6, fontSize: 13, marginBottom: 12 }}>{error}</div>}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '8px 20px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: 13, color: '#64748b' }}>Cancel</button>
          <button onClick={handleSave} disabled={saving} style={{ padding: '8px 24px', borderRadius: 8, border: 'none', background: '#1e3a5f', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
            {saving ? 'Saving…' : isEdit ? '📄 Save New Version' : '📄 Create Quote'}
          </button>
        </div>
      </div>
    </div>
  );
}

function QuotesPage() {
  const { token, user } = useAuth();
  const canSeeAll = ['super_admin','sales_director','sales_manager'].includes(user?.salesRole);
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editQuote, setEditQuote] = useState(null);
  const [versionView, setVersionView] = useState(null); // quote_number
  const [versions, setVersions] = useState([]);
  const [versionsLoading, setVersionsLoading] = useState(false);
  const [filterWon, setFilterWon] = useState('all'); // 'all' | 'won' | 'open'
  const [search, setSearch] = useState('');

  async function loadQuotes() {
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/sales/quotes`, { headers: apiHeaders(token) });
      const d = await r.json();
      setQuotes(Array.isArray(d) ? d.filter(q => q.status !== 'deleted') : []);
    } catch(e) {} finally { setLoading(false); }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadQuotes(); }, [token]);

  async function toggleWon(quote) {
    try {
      const r = await fetch(`${API}/api/sales/quotes/${quote.id}`, { method: 'PATCH', headers: { ...apiHeaders(token), 'Content-Type': 'application/json' }, body: JSON.stringify({ won: !quote.won }) });
      const d = await r.json();
      if (r.ok) setQuotes(qs => qs.map(q => q.id === d.id ? { ...d, lineItems: d.lineItems || [] } : q));
    } catch(e) {}
  }

  async function loadVersions(quoteNumber) {
    setVersionsLoading(true);
    setVersionView(quoteNumber);
    try {
      const r = await fetch(`${API}/api/sales/quotes/number/${encodeURIComponent(quoteNumber)}`, { headers: apiHeaders(token) });
      const d = await r.json();
      setVersions(Array.isArray(d) ? d : []);
    } catch(e) { setVersions([]); } finally { setVersionsLoading(false); }
  }

  // Group by quote_number — show only latest version in main list
  const latestByNumber = {};
  quotes.forEach(q => {
    if (!latestByNumber[q.quote_number] || q.version > latestByNumber[q.quote_number].version) {
      latestByNumber[q.quote_number] = q;
    }
  });

  let displayed = Object.values(latestByNumber);
  if (filterWon === 'won') displayed = displayed.filter(q => q.won);
  if (filterWon === 'open') displayed = displayed.filter(q => !q.won);
  if (search.trim()) {
    const s = search.toLowerCase();
    displayed = displayed.filter(q => q.city_name?.toLowerCase().includes(s) || q.quote_number?.toLowerCase().includes(s) || q.contact_name?.toLowerCase().includes(s));
  }
  displayed.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  const totalWon = Object.values(latestByNumber).filter(q => q.won).reduce((s, q) => s + (q.total || 0), 0);
  const totalPipeline = Object.values(latestByNumber).filter(q => !q.won).reduce((s, q) => s + (q.total || 0), 0);

  const inp = { border: '1px solid #e2e8f0', borderRadius: 6, padding: '7px 10px', fontSize: 13, outline: 'none' };

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: '28px 16px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0f172a', margin: 0 }}>📄 Quotes</h1>
          <p style={{ fontSize: 13, color: '#64748b', margin: '4px 0 0' }}>Generate professional CivicBot subscription proposals &amp; contracts</p>
        </div>
        <button onClick={() => { setEditQuote(null); setShowForm(true); }} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: '#1e3a5f', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>+ New Quote</button>
      </div>

      {/* Summary cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 24 }}>
        {[
          { label: 'Total Quotes', value: Object.values(latestByNumber).length, color: '#1e3a5f' },
          { label: 'Won', value: Object.values(latestByNumber).filter(q => q.won).length, color: '#16a34a', sub: fmtCurrency(totalWon) },
          { label: 'Open Pipeline', value: Object.values(latestByNumber).filter(q => !q.won).length, color: '#d97706', sub: fmtCurrency(totalPipeline) },
        ].map(card => (
          <div key={card.label} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 18px' }}>
            <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{card.label}</div>
            <div style={{ fontSize: 28, fontWeight: 800, color: card.color, lineHeight: 1.2 }}>{card.value}</div>
            {card.sub && <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{card.sub}</div>}
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        <input style={{ ...inp, width: 240 }} value={search} onChange={e => setSearch(e.target.value)} placeholder="Search city, quote #, contact…" />
        <div style={{ display: 'flex', gap: 0, border: '1px solid #e2e8f0', borderRadius: 8, overflow: 'hidden' }}>
          {[['all', 'All'], ['open', 'Open'], ['won', '✅ Won']].map(([v, l]) => (
            <button key={v} onClick={() => setFilterWon(v)} style={{ padding: '7px 16px', border: 'none', borderRight: v !== 'won' ? '1px solid #e2e8f0' : 'none', cursor: 'pointer', background: filterWon === v ? '#1e3a5f' : '#fff', color: filterWon === v ? '#fff' : '#64748b', fontWeight: filterWon === v ? 700 : 500, fontSize: 13 }}>{l}</button>
          ))}
        </div>
      </div>

      {loading ? <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>Loading…</div> : displayed.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8', background: '#f8fafc', borderRadius: 12, border: '1px dashed #e2e8f0' }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>📄</div>
          <div style={{ fontWeight: 700, fontSize: 15, color: '#64748b' }}>No quotes yet</div>
          <div style={{ fontSize: 13, marginTop: 4 }}>Click <strong>+ New Quote</strong> to create your first proposal</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {displayed.map(q => (
            <div key={q.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
              {/* Won checkbox */}
              <input type="checkbox" checked={!!q.won} onChange={() => toggleWon(q)} style={{ width: 18, height: 18, cursor: 'pointer', accentColor: '#16a34a', flexShrink: 0 }} title={q.won ? 'Mark as open' : 'Mark as won'} />

              {/* Quote info */}
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <span style={{ fontWeight: 700, fontSize: 15, color: '#0f172a' }}>{q.city_name}</span>
                  <span style={{ fontSize: 11, background: '#f1f5f9', color: '#64748b', padding: '2px 8px', borderRadius: 10, fontWeight: 600 }}>{q.quote_number}</span>
                  <span style={{ fontSize: 11, background: q.billing_period === 'annual' ? '#e0f2fe' : '#fef9c3', color: q.billing_period === 'annual' ? '#0369a1' : '#92400e', padding: '2px 8px', borderRadius: 10, fontWeight: 600 }}>{q.billing_period === 'annual' ? 'Annual' : 'Monthly'}</span>
                  {q.won && <span style={{ fontSize: 11, background: '#dcfce7', color: '#16a34a', padding: '2px 8px', borderRadius: 10, fontWeight: 700 }}>✅ Won</span>}
                  {q.versionCount > 1 && <button onClick={() => loadVersions(q.quote_number)} style={{ fontSize: 11, background: '#ede9fe', color: '#7c3aed', padding: '2px 8px', borderRadius: 10, fontWeight: 600, border: 'none', cursor: 'pointer' }}>v{q.version} · {q.versionCount} versions</button>}
                </div>
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 3 }}>
                  {q.contact_name && <span>{q.contact_name}{q.contact_title ? `, ${q.contact_title}` : ''} · </span>}
                  {termLabel(q.term_length, q.term_unit)} · {fmtDate(q.created_at)}
                  {canSeeAll && q.rep_name && <span> · <span style={{ color: '#7c3aed' }}>{q.rep_name}</span></span>}
                </div>
              </div>

              {/* Total */}
              <div style={{ textAlign: 'right', minWidth: 110 }}>
                <div style={{ fontWeight: 800, fontSize: 18, color: '#1e3a5f' }}>{fmtCurrency(q.total)}</div>
                <div style={{ fontSize: 11, color: '#94a3b8' }}>{q.billing_period === 'annual' ? '/yr' : '/mo'}</div>
              </div>

              {/* Actions */}
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <button onClick={() => openQuotePDF(q, q.rep_name)} style={{ padding: '6px 12px', borderRadius: 7, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: 12, color: '#1e3a5f', fontWeight: 600 }} title="View / Print PDF">🖨 PDF</button>
                <button onClick={() => { setEditQuote(q); setShowForm(true); }} style={{ padding: '6px 12px', borderRadius: 7, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: 12, color: '#374151', fontWeight: 600 }} title="Create new version">✏️ Revise</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Version History Modal */}
      {versionView && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 640, padding: 24, position: 'relative', maxHeight: '85vh', overflowY: 'auto' }}>
            <button onClick={() => setVersionView(null)} style={{ position: 'absolute', top: 14, right: 14, background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#94a3b8' }}>✕</button>
            <h3 style={{ fontWeight: 700, fontSize: 16, marginBottom: 16 }}>Version History — {versionView}</h3>
            {versionsLoading ? <div style={{ textAlign: 'center', padding: 24, color: '#94a3b8' }}>Loading…</div> : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {[...versions].reverse().map(v => (
                  <div key={v.id} style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 14 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                      <span style={{ fontWeight: 700, color: '#0f172a' }}>Version {v.version}</span>
                      <span style={{ fontSize: 12, color: '#94a3b8' }}>{fmtDate(v.created_at)}</span>
                    </div>
                    <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>{v.change_notes || 'No change notes'}</div>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                      <span style={{ fontWeight: 700, color: '#1e3a5f' }}>{fmtCurrency(v.total)}</span>
                      <span style={{ fontSize: 11, color: '#94a3b8' }}>· {v.billing_period} · {termLabel(v.term_length, v.term_unit)}</span>
                      <button onClick={() => openQuotePDF(v, v.rep_name)} style={{ marginLeft: 'auto', padding: '4px 10px', borderRadius: 6, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: 11, color: '#1e3a5f', fontWeight: 600 }}>🖨 PDF</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {showForm && (
        <QuoteFormModal
          quote={editQuote}
          onSave={(saved) => { setShowForm(false); setEditQuote(null); setQuotes(prev => [...prev.filter(q => q.id !== saved.id), { ...saved }]); loadQuotes(); }}
          onClose={() => { setShowForm(false); setEditQuote(null); }}
          defaultBillingPeriod="annual"
        />
      )}
    </div>
  );
}

// ─── BOUNCES PAGE ─────────────────────────────────────────────────────────────

function BouncesPage() {
  const { token, user } = useAuth();
  const isSuperOrDir = user?.salesRole === 'super_admin' || user?.salesRole === 'sales_director';
  const [bounces, setBounces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [apiError, setApiError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setApiError(null);
    fetch(`${API}/api/sales/bounces`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) setBounces(data);
        else setApiError(data?.error || 'Unexpected response');
        setLoading(false);
      })
      .catch(e => { setApiError(e.message); setLoading(false); });
  }, [token]);

  const filtered = bounces.filter(b => {
    if (!search) return true;
    const q = search.toLowerCase();
    return [b.recipient_name, b.recipient_email, b.org_name, b.subject, b.sent_by_name, b.bounce_reason].some(v => (v||'').toLowerCase().includes(q));
  });

  function fmtDate(s) {
    if (!s) return '—';
    const normalized = s.includes('T') ? s : (s.length >= 10 ? s.replace(' ', 'T') + 'Z' : s);
    const d = new Date(normalized);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + ' ' +
      d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  }

  function goToLead(b) {
    if (b.resolved_lead_id) navigate(`/leads/${b.resolved_lead_id}`);
  }

  return (
    <div style={S.container}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={S.h1}>Email Bounces</h1>
          <div style={{ fontSize: 13, color: '#64748b' }}>
            {bounces.length} bounced {bounces.length === 1 ? 'email' : 'emails'}{isSuperOrDir ? ' across all reps' : ' from your sends'}
          </div>
        </div>
        <input
          style={{ ...S.input, width: 280, marginBottom: 0 }}
          placeholder="Search name, email, org, subject…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {apiError && <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '12px 16px', marginBottom: 16, color: '#dc2626', fontSize: 13 }}>Error: {apiError}</div>}

      {loading ? (
        <div style={{ color: '#64748b', padding: 40, textAlign: 'center' }}>Loading…</div>
      ) : filtered.length === 0 ? (
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: 48, textAlign: 'center' }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
          <div style={{ fontWeight: 600, color: '#166534', fontSize: 16 }}>{search ? 'No results' : 'No bounces'}</div>
          <div style={{ color: '#4ade80', fontSize: 13, marginTop: 4 }}>{search ? 'Try a different search term.' : 'All emails have been delivered successfully.'}</div>
        </div>
      ) : (
        <div style={{ overflowX: 'auto', borderRadius: 12, border: '1px solid #e2e8f0', background: '#fff' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#fef2f2', borderBottom: '2px solid #fecaca' }}>
                <th style={S.th}>Bounced At</th>
                <th style={S.th}>Contact</th>
                <th style={S.th}>Organization</th>
                <th style={S.th}>To Email</th>
                <th style={S.th}>Subject</th>
                {isSuperOrDir && <th style={S.th}>Sent By</th>}
                <th style={S.th}>Bounce Reason</th>
                <th style={S.th}>Sent At</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((b, i) => (
                <tr key={b.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#fffbfb' }}>
                  <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#dc2626', fontWeight: 600 }}>{fmtDate(b.bounced_at)}</td>
                  <td style={{ ...S.td, whiteSpace: 'nowrap' }}>
                    {b.resolved_lead_id ? (
                      <button onClick={() => goToLead(b)} style={{ background: 'none', border: 'none', color: '#1e3a5f', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline', padding: 0, fontSize: 13 }}>
                        {b.recipient_name || '—'}
                      </button>
                    ) : (b.recipient_name || '—')}
                  </td>
                  <td style={{ ...S.td, maxWidth: 180, color: '#475569' }}>{b.org_name || '—'}</td>
                  <td style={{ ...S.td, whiteSpace: 'nowrap' }}>
                    <a href={`mailto:${b.recipient_email}`} style={{ color: '#3b82f6', textDecoration: 'none' }}>{b.recipient_email}</a>
                  </td>
                  <td style={{ ...S.td, maxWidth: 220, color: '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={b.subject}>{b.subject}</td>
                  {isSuperOrDir && <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#64748b' }}>{b.sent_by_name || b.sent_by || '—'}</td>}
                  <td style={{ ...S.td, maxWidth: 260, color: '#dc2626', fontSize: 12 }} title={b.bounce_reason}>{(b.bounce_reason || '').slice(0, 80)}{b.bounce_reason?.length > 80 ? '…' : ''}</td>
                  <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#94a3b8', fontSize: 12 }}>{fmtDate(b.sent_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ marginTop: 20, padding: '12px 16px', background: '#f8fafc', borderRadius: 8, fontSize: 12, color: '#64748b', border: '1px solid #e2e8f0' }}>
        <strong>💡 Next steps for bounces:</strong> Verify the email address is correct, try reaching out by phone, or check LinkedIn. Government (.gov) servers often block unknown senders — if the address is valid, a warm intro or phone call may be the better path.
      </div>
    </div>
  );
}

// ─── CONTACTS PAGE ────────────────────────────────────────────────────────────

function ContactsPage() {
  const { token } = useAuth();
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [sort, setSort] = useState('name');
  const [dir, setDir] = useState('asc');
  const [search, setSearch] = useState('');

  useEffect(() => {
    setLoading(true);
    setApiError(null);
    fetch(`${API}/api/sales/contacts/all?sort=${sort}&dir=${dir}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) { setContacts(data); }
        else { setApiError(data?.error || JSON.stringify(data)); }
        setLoading(false);
      })
      .catch(e => { setApiError(e.message); setLoading(false); });
  }, [sort, dir, token]);

  function toggleSort(col) {
    if (sort === col) setDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSort(col); setDir('asc'); }
  }

  const filtered = contacts.filter(c => {
    if (!search) return true;
    const q = search.toLowerCase();
    return [c.name, c.title, c.email, c.phone, c.org_name, c.org_state, c.tier, c.rep_name, c.linkedin].some(v => (v || '').toLowerCase().includes(q));
  });

  const cols = [
    { key: 'name', label: 'Name' },
    { key: 'org_name', label: 'Organization' },
    { key: 'org_state', label: 'State' },
    { key: 'title', label: 'Title' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'tier', label: 'Tier' },
    { key: 'rep_name', label: 'Sales Rep' },
    { key: 'emails_sent', label: 'Emails Sent' },
    { key: 'linkedin', label: 'LinkedIn' },
  ];

  function SortIcon({ col }) {
    if (sort !== col) return <span style={{ color: '#cbd5e1', marginLeft: 4 }}>↕</span>;
    return <span style={{ color: '#1e3a5f', marginLeft: 4 }}>{dir === 'asc' ? '↑' : '↓'}</span>;
  }

  return (
    <div style={S.container}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={S.h1}>Contacts</h1>
          <div style={{ fontSize: 13, color: '#64748b' }}>{contacts.length.toLocaleString()} total contacts across all organizations</div>
        </div>
        <input
          style={{ ...S.input, width: 260, marginBottom: 0 }}
          placeholder="Search name, org, email, title…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {apiError && <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '12px 16px', marginBottom: 16, color: '#dc2626', fontSize: 13 }}>API Error: {apiError}</div>}
      {loading ? <div style={{ color: '#64748b', padding: 40, textAlign: 'center' }}>Loading contacts…</div> : (
        <div style={{ overflowX: 'auto', borderRadius: 12, border: '1px solid #e2e8f0', background: '#fff' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                {cols.map(c => {
                  const unsortable = c.key === 'linkedin';
                  return (
                    <th key={c.key}
                      onClick={() => !unsortable && toggleSort(c.key)}
                      style={{ ...S.th, cursor: !unsortable ? 'pointer' : 'default', userSelect: 'none', whiteSpace: 'nowrap' }}>
                      {c.label}{!unsortable && <SortIcon col={c.key} />}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={cols.length} style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>No contacts found</td></tr>
              ) : filtered.map((c, i) => (
                <tr key={c.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#fafbfc' }}>
                  <td style={{ ...S.td, fontWeight: 600, color: '#1e3a5f', whiteSpace: 'nowrap' }}>{c.name || '—'}</td>
                  <td style={{ ...S.td, maxWidth: 200 }}>
                    {c.entity_type === 'lead'
                      ? <a href={`/leads/${c.entity_id}`} style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 500 }}>{c.org_name || '—'}</a>
                      : <a href={`/opportunities?id=${c.entity_id}`} style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 500 }}>{c.org_name || '—'}</a>
                    }
                  </td>
                  <td style={{ ...S.td, whiteSpace: 'nowrap' }}>{c.org_state || '—'}</td>
                  <td style={{ ...S.td, color: '#64748b' }}>{c.title || '—'}</td>
                  <td style={S.td}>{c.email ? <a href={`mailto:${c.email}`} style={{ color: '#2563eb', textDecoration: 'none' }}>{c.email}</a> : '—'}</td>
                  <td style={{ ...S.td, whiteSpace: 'nowrap' }}>{c.phone || '—'}</td>
                  <td style={S.td}>{c.tier ? <span style={{ ...S.badge, background: '#eff6ff', color: '#1d4ed8' }}>{c.tier}</span> : '—'}</td>
                  <td style={{ ...S.td, whiteSpace: 'nowrap', color: '#334155' }}>{c.rep_name || <span style={{ color: '#94a3b8' }}>—</span>}</td>
                  <td style={{ ...S.td, textAlign: 'center' }}>
                    {c.emails_sent > 0
                      ? <span style={{ ...S.badge, background: '#f0fdf4', color: '#16a34a', fontWeight: 700 }}>{c.emails_sent}</span>
                      : <span style={{ color: '#94a3b8' }}>0</span>}
                  </td>
                  <td style={S.td}>
                    {c.linkedin
                      ? <a href={c.linkedin.startsWith('http') ? c.linkedin : `https://${c.linkedin}`} target="_blank" rel="noopener noreferrer"
                          style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#0077b5', color: '#fff', borderRadius: 6, padding: '4px 10px', fontSize: 12, fontWeight: 600, textDecoration: 'none' }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                          Connect
                        </a>
                      : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ─── APP ──────────────────────────────────────────────────────────────────────

function AppShell() {

  return (
    <div style={S.page}>
      <GlobalStyles />
      <Nav />
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/cities" element={<Protected><CitiesList /></Protected>} />
        <Route path="/cities/:id" element={<Protected><CityDetail /></Protected>} />
        <Route path="/opportunities" element={<Protected><OpportunitiesPage /></Protected>} />
        <Route path="/leads" element={<Protected><LeadsPage /></Protected>} />
        <Route path="/follow-ups" element={<Protected><FollowUpsPage /></Protected>} />
        <Route path="/inbox" element={<Protected><InboxPage /></Protected>} />
        <Route path="/leads/:id" element={<Protected><LeadDetail /></Protected>} />
        <Route path="/customers" element={<Protected><CustomersPage /></Protected>} />
        <Route path="/users" element={<Protected roles={['super_admin','sales_director','sales_manager']}><UsersPage /></Protected>} />
        <Route path="/commission" element={<Protected roles={['super_admin','sales_director']}><CommissionPage /></Protected>} />
        <Route path="/contacts" element={<Protected roles={['super_admin']}><ContactsPage /></Protected>} />
        <Route path="/analytics" element={<Protected><AnalyticsPage /></Protected>} />
        <Route path="/message-analytics" element={<Protected><MessageAnalyticsPage /></Protected>} />
        <Route path="/quotes" element={<Protected><QuotesPage /></Protected>} />
        <Route path="/scheduled-queue" element={<Protected roles={['super_admin']}><ScheduledQueuePage /></Protected>} />
        <Route path="/bounces" element={<Protected><BouncesPage /></Protected>} />
        <Route path="/payout" element={<Protected roles={['super_admin']}><PayoutPage /></Protected>} />
        <Route path="/actions" element={<Protected roles={['super_admin']}><ActionsPage /></Protected>} />
        <Route path="/reports" element={<Protected><ReportsPage /></Protected>} />
        <Route path="/playbook" element={<Protected><PlaybookPage /></Protected>} />
        <Route path="/downloads" element={<Protected><DownloadsPage /></Protected>} />
        <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/*" element={<AppShell />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
